import React__default, { useState, useMemo, useRef, useEffect, useContext, memo, useImperativeHandle, useCallback, createElement } from 'react';
import { TYPE, TYPE_FACEBOOK, TYPE_INSTAGRAM, TYPE_TWITTER, TYPE_THREADS, TYPE_LINKEDIN, TYPE_GOOGLE_MY_BUSINESS, TYPE_PINTEREST, TYPE_YOUTUBE, TYPE_TIKTOK } from '@kontentino/kontentino-constants/Pages';
import { FACEBOOK, IG_TRUNCATED_TEXT } from '@kontentino/kontentino-constants/PostPreview';
import classNames from 'classnames';
import anchorme from 'anchorme';
import { REGEX_HASHTAG, REGEX, REGEX_NETWORK_MENTION, REGEX_URL } from '@kontentino/kontentino-constants/Regex';
import { TYPE as TYPE$1, SUBTYPE, TYPE_COMMENT } from '@kontentino/kontentino-constants/Posts';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { extendTailwindMerge } from 'tailwind-merge';
import { formatDateTimeAsSocialNetworkPost, formatTime, formatDate } from '@kontentino/kontentino-utils/date';
import { LightBox } from '@kontentino/ui';
import ReactPlayer from 'react-player/file';
import { VIDEO_STATUS } from '@kontentino/kontentino-constants/Video';
import { faPause } from '@fortawesome/pro-solid-svg-icons/faPause';
import { faPlay } from '@fortawesome/pro-solid-svg-icons/faPlay';
import isEqual from 'lodash.isequal';
import { CTA_DATA } from '@kontentino/kontentino-constants/FacebookCTA';
import { getHostnameFromUrl } from '@kontentino/kontentino-utils/url';
import NukaCarousel from 'nuka-carousel';
import { useElementSize } from '@kontentino/kontentino-utils/hooks';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { faBatteryFull } from '@fortawesome/pro-solid-svg-icons/faBatteryFull';
import { faSignalBars } from '@fortawesome/pro-solid-svg-icons/faSignalBars';
import { faWifi } from '@fortawesome/pro-solid-svg-icons/faWifi';
import { faEllipsis } from '@fortawesome/pro-regular-svg-icons/faEllipsis';
import { faThreads } from '@fortawesome/free-brands-svg-icons/faThreads';
import { faImageSlash } from '@fortawesome/pro-regular-svg-icons/faImageSlash';
import { faEllipsisV } from '@fortawesome/pro-regular-svg-icons/faEllipsisV';
import { faShareNodes } from '@fortawesome/pro-regular-svg-icons/faShareNodes';
import { CTA_LABEL } from '@kontentino/kontentino-constants/GoogleMyBusinessCTA';
import { faTag } from '@fortawesome/pro-solid-svg-icons/faTag';
import { faArrowUpRight } from '@fortawesome/pro-regular-svg-icons/faArrowUpRight';
import { faThumbsUp } from '@fortawesome/pro-regular-svg-icons/faThumbsUp';
import { faThumbsDown } from '@fortawesome/pro-regular-svg-icons/faThumbsDown';
import { faComment } from '@fortawesome/pro-regular-svg-icons/faComment';
import { faShare } from '@fortawesome/pro-regular-svg-icons/faShare';

var e=[],t=[];function n(n,r){if(n&&"undefined"!=typeof document){var a,s=!0===r.prepend?"prepend":"append",d=!0===r.singleTag,i="string"==typeof r.container?document.querySelector(r.container):document.getElementsByTagName("head")[0];if(d){var u=e.indexOf(i);-1===u&&(u=e.push(i)-1,t[u]={}),a=t[u]&&t[u][s]?t[u][s]:t[u][s]=c();}else a=c();65279===n.charCodeAt(0)&&(n=n.substring(1)),a.styleSheet?a.styleSheet.cssText+=n:a.appendChild(document.createTextNode(n));}function c(){var e=document.createElement("style");if(e.setAttribute("type","text/css"),r.attributes)for(var t=Object.keys(r.attributes),n=0;n<t.length;n++)e.setAttribute(t[n],r.attributes[t[n]]);var a="prepend"===s?"afterbegin":"beforeend";return i.insertAdjacentElement(a,e),e}}

var css = ".TextContent_module_textContent__80ba6e57{font-size:14px;font-weight:400;line-height:18px;margin-bottom:12px;padding:0 16px}.TextContent_module_textContent__80ba6e57.TextContent_module_largeText__80ba6e57{font-size:24px;line-height:28px}.TextContent_module_seeMore__80ba6e57{cursor:pointer;display:inline-block;font-weight:600}.TextContent_module_seeMore__80ba6e57:hover{text-decoration:underline}";
var modules_82161d99 = {"textContent":"TextContent_module_textContent__80ba6e57","largeText":"TextContent_module_largeText__80ba6e57","seeMore":"TextContent_module_seeMore__80ba6e57"};
n(css,{});

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var css$1 = ".HyperText_module_textWrapper__eeae21e8{overflow-y:hidden;position:relative}.HyperText_module_textWrapper__eeae21e8 .HyperText_module_showMore__eeae21e8{background-color:#fff;bottom:0;cursor:pointer;font-weight:500;padding-left:.2rem;position:absolute;right:0}.HyperText_module_parsedText__eeae21e8{overflow-wrap:break-word;overflow-y:hidden;white-space:pre-wrap}.HyperText_module_parsedText__eeae21e8[data-page-type=\"1\"] a{color:#6182b1}.HyperText_module_parsedText__eeae21e8[data-page-type=\"2\"] a{color:#00376b}.HyperText_module_parsedText__eeae21e8[data-page-type=\"3\"] a{color:#1b95e0}.HyperText_module_parsedText__eeae21e8[data-page-type=\"4\"] a{color:#0a66c2;font-weight:600}.HyperText_module_parsedText__eeae21e8[data-page-type=\"5\"] a{color:#0074e8;font-weight:600}.HyperText_module_parsedText__eeae21e8[data-page-type=\"6\"] a,.HyperText_module_parsedText__eeae21e8[data-page-type=\"7\"] a{color:inherit;font-weight:600}.HyperText_module_parsedText__eeae21e8[data-page-type=\"8\"] a{color:#1b95e0;font-weight:600}.HyperText_module_parsedText__eeae21e8[data-page-type=\"10\"] a,.HyperText_module_parsedText__eeae21e8[data-page-type=\"11\"] a,.HyperText_module_parsedText__eeae21e8[data-page-type=\"9\"] a{color:inherit;font-weight:600}.HyperText_module_parsedText__eeae21e8 a{color:#2c5de5}.HyperText_module_refHeightText__eeae21e8{overflow-y:hidden;position:absolute;visibility:hidden;width:100%;z-index:-1}";
var modules_b9b7c56f = {"textWrapper":"HyperText_module_textWrapper__eeae21e8","showMore":"HyperText_module_showMore__eeae21e8","parsedText":"HyperText_module_parsedText__eeae21e8","refHeightText":"HyperText_module_refHeightText__eeae21e8"};
n(css$1,{});

function truncateHtmlString(content, _ref) {
  var maxLength = _ref.maxLength,
    _ref$ellipsis = _ref.ellipsis,
    ellipsis = _ref$ellipsis === void 0 ? true : _ref$ellipsis;
  if (!maxLength) return content;
  var parser = new window.DOMParser();
  var _parser$parseFromStri = parser.parseFromString(content, 'text/html'),
    body = _parser$parseFromStri.body;
  var limit = false;
  var textLength = 0;
  var nodeHandler = function nodeHandler(node) {
    if (limit) {
      node.remove();
      return;
    }
    var childNodes = Array.from(node.childNodes);
    if (childNodes.length) {
      childNodes.forEach(function (childNode) {
        return nodeHandler(childNode);
      });
    } else {
      var _node$textContent$len, _node$textContent;
      textLength += (_node$textContent$len = node == null ? void 0 : (_node$textContent = node.textContent) == null ? void 0 : _node$textContent.length) != null ? _node$textContent$len : 0;
      if (textLength >= maxLength) {
        limit = true;
        if (textLength > maxLength) {
          var _node$textContent2;
          node.textContent = ((_node$textContent2 = node == null ? void 0 : node.textContent) != null ? _node$textContent2 : '').slice(0, -(textLength - maxLength));
        }
        if (!!ellipsis) {
          node.textContent += '...';
        }
      }
    }
  };
  nodeHandler(body);
  return body.innerHTML;
}

function recordToHtmlAttributes(record) {
  return Object.keys(record).map(function (key) {
    return key + "=\"" + record[key] + "\"";
  }).join(' ');
}

var hashtagExtension = function hashtagExtension(_ref) {
  var pageType = _ref.pageType,
    addAttributes = _ref.addAttributes;
  function getUrl(input) {
    var hashtagKeyword = input.trim().replace('#', '');
    switch (pageType) {
      case TYPE.FACEBOOK:
      case TYPE.FACEBOOK_AD:
        return "https://facebook.com/hashtag/" + hashtagKeyword;
      case TYPE.INSTAGRAM:
        return "https://instagram.com/explore/tags/" + hashtagKeyword + "/";
      case TYPE.LINKEDIN:
        return "https://linkedin.com/feed/hashtag/?keywords=" + hashtagKeyword + "/";
      case TYPE.TWITTER:
        return "https://twitter.com/hashtag/" + hashtagKeyword + "/";
      case TYPE.PINTEREST:
        return "https://pinterest.com/search/pins/?q=" + hashtagKeyword;
      case TYPE.YOUTUBE:
        return "https://youtube.com/hashtag/" + hashtagKeyword + "/";
      case TYPE.TIKTOK:
        return "https://www.tiktok.com/tag/" + hashtagKeyword + "/";
    }
    return undefined;
  }
  return {
    test: new RegExp(REGEX_HASHTAG, 'gi'),
    transform: function transform(rawInput) {
      var input = cleanAnchors(rawInput);
      var url = getUrl(input);
      if (!url) return input;
      return "<a " + recordToHtmlAttributes(_extends({
        href: url,
        rel: 'noopener',
        target: '_blank'
      }, addAttributes == null ? void 0 : addAttributes({
        source: input,
        type: 'hashtag',
        data: {
          input: input
        }
      }))) + ">" + input + "</a>";
    }
  };
};
var commentMentionExtension = function commentMentionExtension(_ref2) {
  var mentionedUsers = _ref2.mentionedUsers,
    addAttributes = _ref2.addAttributes;
  function getUser(input) {
    var userId = parseInt(input.replace('@', '').replace('[', '').replace(']', ''));
    return mentionedUsers.find(function (user) {
      return user.id === userId;
    });
  }
  return {
    test: new RegExp(REGEX.COMMENT_USER_MENTION, 'gi'),
    transform: function transform(input) {
      var _user$name;
      var user = getUser(input);
      return "<strong " + recordToHtmlAttributes(_extends({}, addAttributes == null ? void 0 : addAttributes({
        source: input,
        type: 'user-mention',
        data: {
          input: input,
          user: user
        }
      }))) + ">@" + ((_user$name = user == null ? void 0 : user.name) != null ? _user$name : '(unknown user)') + "</strong>";
    }
  };
};
var mentionExtension = function mentionExtension(_ref3) {
  var pageType = _ref3.pageType,
    addAttributes = _ref3.addAttributes;
  function getRegex() {
    if ([TYPE.FACEBOOK, TYPE.FACEBOOK_AD, TYPE.LINKEDIN].includes(pageType)) {
      return new RegExp(REGEX_NETWORK_MENTION, 'gi');
    }
    return new RegExp(REGEX.MENTION, 'gi');
  }
  function getUrl(input) {
    switch (pageType) {
      case TYPE.FACEBOOK:
      case TYPE.FACEBOOK_AD:
        {
          var _input$match$toString, _input$match;
          var id = (_input$match$toString = (_input$match = input.match(/\(page:\d+\)/gi)) == null ? void 0 : _input$match.toString().slice(1, -1).replace('page:', '')) != null ? _input$match$toString : '';
          return "https://facebook.com/" + id;
        }
      case TYPE.THREADS:
        return "https://threads.net/" + input + "/";
      case TYPE.INSTAGRAM:
        return "https://instagram.com/" + input.slice(1) + "/";
      case TYPE.LINKEDIN:
        {
          var userUrlMatch = input.match(REGEX_URL);
          if (userUrlMatch && userUrlMatch[0]) {
            return userUrlMatch[0];
          }
          var companyMatch = input.match(/\((?:company:([^)]+)|urn:organization:(\d+))\)/i);
          var _id = companyMatch ? companyMatch[1] || companyMatch[2] || '' : '';
          return "https://www.linkedin.com/company/" + _id;
        }
      case TYPE.TWITTER:
        return "https://twitter.com/" + input.slice(1) + "/";
      case TYPE.PINTEREST:
        return "https://pinterest.com/" + input.slice(1) + "/";
      case TYPE.YOUTUBE:
        return "https://www.youtube.com/" + input;
      case TYPE.TIKTOK:
        return "https://www.tiktok.com/" + input;
    }
    return undefined;
  }
  function getInput(input) {
    if ([TYPE.FACEBOOK, TYPE.FACEBOOK_AD, TYPE.LINKEDIN].includes(pageType)) {
      var _input$match$toString2, _input$match2, _input$match2$toStrin;
      return (_input$match$toString2 = (_input$match2 = input.match(new RegExp(/(\[.*])/, 'gi'))) == null ? void 0 : (_input$match2$toStrin = _input$match2.toString()) == null ? void 0 : _input$match2$toStrin.slice(1, -1)) != null ? _input$match$toString2 : 'Unknown mention';
    }
    return input;
  }
  return {
    test: getRegex(),
    transform: function transform(rawInput) {
      var input = cleanAnchors(rawInput);
      var url = getUrl(input);
      if (!url) return input;
      return "<a " + recordToHtmlAttributes(_extends({
        href: url,
        rel: 'noopener',
        target: '_blank'
      }, addAttributes == null ? void 0 : addAttributes({
        source: input,
        type: 'page-mention',
        data: {
          input: input
        }
      }))) + ">" + getInput(input) + "</a>";
    }
  };
};
var getOwnExtensions = function getOwnExtensions(options) {
  var hasPageType = function hasPageType(options) {
    return typeof options.pageType === 'number';
  };
  if (hasPageType(options)) {
    return [mentionExtension(options), hashtagExtension(options)];
  }
  var hasMentionedUsers = function hasMentionedUsers(options) {
    return Array.isArray(options.mentionedUsers);
  };
  if (hasMentionedUsers(options)) {
    return [commentMentionExtension(options)];
  }
  return [];
};
function parseTextToHyperText(input, options) {
  var parsed = anchorme({
    input: input,
    options: {
      attributes: function attributes(string) {
        var defaultAttributes = {
          target: '_blank',
          rel: 'noopener'
        };
        var additionalAttributes = (options.addAttributes == null ? void 0 : options.addAttributes({
          type: 'link',
          source: string
        })) || {};
        return _extends({}, defaultAttributes, additionalAttributes);
      },
      exclude: function exclude() {
        return (options == null ? void 0 : options.pageType) === TYPE.PINTEREST || (options == null ? void 0 : options.pageType) === TYPE.INSTAGRAM;
      }
    }
  });
  var ownExtensions = getOwnExtensions(options);
  ownExtensions.forEach(function (extension) {
    parsed = parsed.replace(extension.test, function (match) {
      return extension.transform(match);
    });
  });
  return parsed;
}
function truncateParsedHyperText(input, options) {
  return truncateHtmlString(input, {
    maxLength: options == null ? void 0 : options.maxLength,
    ellipsis: options == null ? void 0 : options.ellipsis
  });
}
function isParsedTextShorterThanMaxLength(input, maxLength) {
  var _doc$body, _doc$body2;
  var parser = new DOMParser();
  var doc = parser.parseFromString(input, 'text/html');
  return maxLength && (_doc$body = doc.body) != null && _doc$body.textContent ? ((_doc$body2 = doc.body) == null ? void 0 : _doc$body2.textContent.length) < maxLength : true;
}
function cleanAnchors(input) {
  var regexToRemoveExistingAnchors = /<a[^>]*>(.*?)<\/a>/gi;
  return input.replace(regexToRemoveExistingAnchors, '$1');
}

var HyperTextCharBreak = function HyperTextCharBreak(props) {
  var _props$options, _props$options4, _ref, _props$options5, _props$options5$expan, _ref2, _props$options6, _props$options6$expan;
  var _useState = useState(!((_props$options = props.options) != null && _props$options.expandable)),
    showFullText = _useState[0],
    setShowFullText = _useState[1];
  var _useMemo = useMemo(function () {
      var _props$options2, _props$options3;
      var parsedText = parseTextToHyperText(props.children, _extends({
        pageType: props.pageType
      }, props.options));
      var options = _extends({}, props.options);
      var isShorterThanMaxLength = isParsedTextShorterThanMaxLength(parsedText, (_props$options2 = props.options) == null ? void 0 : _props$options2.maxLength);
      if ((_props$options3 = props.options) != null && _props$options3.expandable) {
        options = isShorterThanMaxLength || showFullText ? _extends({}, options, {
          maxLength: undefined,
          ellipsis: false
        }) : options;
      }
      return {
        text: truncateParsedHyperText(parsedText, options),
        isShorterThanMaxLength: isShorterThanMaxLength
      };
    }, [props.children, props.pageType, props.options, showFullText]),
    text = _useMemo.text,
    isShorterThanMaxLength = _useMemo.isShorterThanMaxLength;
  return React__default.createElement(React__default.Fragment, null, React__default.createElement("span", {
    "data-page-type": props.pageType,
    className: classNames(modules_b9b7c56f.parsedText, props.className),
    dangerouslySetInnerHTML: {
      __html: text
    }
  }), !isShorterThanMaxLength && ((_props$options4 = props.options) == null ? void 0 : _props$options4.expandable) && React__default.createElement("span", {
    onClick: function onClick() {
      return setShowFullText(function (old) {
        return !old;
      });
    }
  }, (_ref = showFullText && ((_props$options5 = props.options) == null ? void 0 : (_props$options5$expan = _props$options5.expandableTrigger) == null ? void 0 : _props$options5$expan.less)) != null ? _ref : '..show less', (_ref2 = !showFullText && ((_props$options6 = props.options) == null ? void 0 : (_props$options6$expan = _props$options6.expandableTrigger) == null ? void 0 : _props$options6$expan.more)) != null ? _ref2 : '..show more'));
};

var HyperTextLineBreak = function HyperTextLineBreak(props) {
  var _props$options, _ref, _props$options5, _props$options5$expan, _ref2, _props$options6, _props$options6$expan;
  var textWrapperRef = useRef(null);
  var sampleTextRef = useRef(null);
  var textRef = useRef(null);
  var _useState = useState(false),
    canShowMore = _useState[0],
    setCanShowMore = _useState[1];
  var _useState2 = useState(false),
    showFullText = _useState2[0],
    setShowFullText = _useState2[1];
  var _useMemo = useMemo(function () {
      var options = _extends({}, props.options, {
        ellipsis: false,
        maxLength: undefined,
        expandable: undefined
      });
      var parsedText = parseTextToHyperText(props.children, _extends({
        pageType: props.pageType
      }, options));
      return {
        text: truncateParsedHyperText(parsedText, options)
      };
    }, [props.children, props.pageType, props.options, (_props$options = props.options) == null ? void 0 : _props$options.maxLines]),
    text = _useMemo.text;
  var setMaxHeight = function setMaxHeight(value) {
    var _sampleTextRef$curren, _props$options2;
    if (value) {
      var _textWrapperRef$curre;
      (_textWrapperRef$curre = textWrapperRef.current) == null ? void 0 : _textWrapperRef$curre.style.setProperty('max-height', "" + value);
      return;
    }
    var lineHeightClient = ((_sampleTextRef$curren = sampleTextRef.current) == null ? void 0 : _sampleTextRef$curren.getBoundingClientRect().height) / 3;
    if ((_props$options2 = props.options) != null && _props$options2.maxLines && lineHeightClient) {
      var _props$options3, _textWrapperRef$curre2;
      var lineHeight = lineHeightClient;
      var maxHeight = ((_props$options3 = props.options) == null ? void 0 : _props$options3.maxLines) * lineHeight;
      (_textWrapperRef$curre2 = textWrapperRef.current) == null ? void 0 : _textWrapperRef$curre2.style.setProperty('max-height', maxHeight + "px");
    }
  };
  useEffect(function () {
    var _props$options4;
    if ((_props$options4 = props.options) != null && _props$options4.maxLines) {
      setMaxHeight();
    }
    if (!textWrapperRef.current) return;
    var resizeObserver = new ResizeObserver(function () {
      var _textWrapperRef$curre3, _textRef$current;
      var textWrapperHeight = (_textWrapperRef$curre3 = textWrapperRef.current) == null ? void 0 : _textWrapperRef$curre3.getBoundingClientRect().height;
      var textHeight = (_textRef$current = textRef.current) == null ? void 0 : _textRef$current.getBoundingClientRect().height;
      if (textWrapperHeight && textHeight && textHeight > textWrapperHeight) {
        setCanShowMore(true);
      }
    });
    resizeObserver.observe(textWrapperRef.current);
    return function () {
      return resizeObserver.disconnect();
    };
  }, []);
  useEffect(function () {
    setMaxHeight(showFullText ? 'none' : undefined);
  }, [showFullText]);
  return React__default.createElement("div", {
    ref: textWrapperRef,
    className: modules_b9b7c56f.textWrapper
  }, React__default.createElement("span", {
    ref: sampleTextRef,
    className: classNames(modules_b9b7c56f.parsedText, props.className, modules_b9b7c56f.refHeightText)
  }, "Ref ", React__default.createElement("br", null), "height ", React__default.createElement("br", null), "text"), React__default.createElement("span", {
    ref: textRef,
    "data-page-type": props.pageType,
    className: classNames(modules_b9b7c56f.parsedText, props.className),
    dangerouslySetInnerHTML: {
      __html: text
    }
  }), canShowMore && React__default.createElement("span", {
    className: modules_b9b7c56f.showMore,
    onClick: function onClick() {
      return setShowFullText(function (old) {
        return !old;
      });
    }
  }, (_ref = showFullText && ((_props$options5 = props.options) == null ? void 0 : (_props$options5$expan = _props$options5.expandableTrigger) == null ? void 0 : _props$options5$expan.less)) != null ? _ref : '...show less', (_ref2 = !showFullText && ((_props$options6 = props.options) == null ? void 0 : (_props$options6$expan = _props$options6.expandableTrigger) == null ? void 0 : _props$options6$expan.more)) != null ? _ref2 : '...show more'));
};

var HyperText = function HyperText(props) {
  var _props$options;
  var shouldBreakLines = (_props$options = props.options) == null ? void 0 : _props$options.maxLines;
  return shouldBreakLines ? React__default.createElement(HyperTextLineBreak, Object.assign({}, props)) : React__default.createElement(HyperTextCharBreak, Object.assign({}, props));
};

function getSegmentedAttachments(content) {
  var images = content.attachments.cards.filter(function (a) {
    var _a$medium;
    return ((_a$medium = a.medium) == null ? void 0 : _a$medium.type) === 'image';
  });
  var videos = content.attachments.cards.filter(function (a) {
    var _a$medium2;
    return ((_a$medium2 = a.medium) == null ? void 0 : _a$medium2.type) === 'video';
  });
  return {
    images: images,
    hasImages: !!images.length,
    videos: videos,
    hasVideos: !!videos.length,
    all: content.attachments.cards,
    hasAll: !!content.attachments.cards.length,
    hasMultiShareEndCard: content.attachments.multi_share_end_card
  };
}
function isLinkPost(content, options) {
  if (options === void 0) {
    options = {
      autoLink: false
    };
  }
  var isLinkType = options.autoLink ? true : [TYPE$1.LINK, TYPE$1.AD].includes(content.type);
  return isLinkType && content.attachments.cards.length === 1;
}
function isCarouselPost(content) {
  return [TYPE$1.LINK, TYPE$1.AD].includes(content.type) && content.attachments.cards.length > 1;
}
function isStory(content) {
  return content.subtype === SUBTYPE.INSTAGRAM_STORY;
}
function isReel(content) {
  return content.subtype === SUBTYPE.REEL;
}

var PostPreviewContext = /*#__PURE__*/React__default.createContext(undefined);
var PostPreviewProvider = function PostPreviewProvider(props) {
  var defaultVideoPlayer = useRef(null);
  var value = useMemo(function () {
    var _props$value$enableLi, _props$value$videoPla, _props$value$videoPla2;
    var segmentedAttachments = getSegmentedAttachments(props.value.content);
    return _extends({}, props.value, {
      enableLightbox: (_props$value$enableLi = props.value.enableLightbox) != null ? _props$value$enableLi : true,
      videoPlayer: _extends({}, props.value.videoPlayer, {
        ref: (_props$value$videoPla = (_props$value$videoPla2 = props.value.videoPlayer) == null ? void 0 : _props$value$videoPla2.ref) != null ? _props$value$videoPla : defaultVideoPlayer
      }),
      segmentedAttachments: segmentedAttachments
    });
  }, [props.value]);
  return React__default.createElement(PostPreviewContext.Provider, {
    value: value
  }, props.children);
};
var usePostPreview = function usePostPreview() {
  var context = useContext(PostPreviewContext);
  if (!context) {
    throw new Error('usePostPreview must be within PostPreviewProvider');
  }
  return context;
};

var PostTextContentWrapper = function PostTextContentWrapper(_ref) {
  var className = _ref.className,
    children = _ref.children,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'div' : _ref$as;
  var _usePostPreview = usePostPreview(),
    dataCy = _usePostPreview.dataCy;
  var TextWrapperElement = as;
  return React__default.createElement(TextWrapperElement, {
    className: className,
    "data-cy": dataCy == null ? void 0 : dataCy.postText
  }, children);
};

var TextContent = function TextContent(_ref) {
  var _ref$content = _ref.content,
    text = _ref$content.text,
    attachments = _ref$content.attachments,
    variant = _ref.variant;
  var _useState = useState(false),
    showWholeText = _useState[0],
    setShowWholeText = _useState[1];
  if (!text) {
    return null;
  }
  function getHasLargeText() {
    if (attachments.cards.length > 0) {
      return false;
    }
    return (text == null ? void 0 : text.length) && text.length <= FACEBOOK.LARGER_FONTSIZE_LIMIT;
  }
  function getCharacterLimit() {
    if (variant === 'mobile' && text && text.length > FACEBOOK.TRUNCATED_TEXT_LENGTH_MOBILE) {
      return FACEBOOK.TRUNCATED_TEXT_LENGTH_MOBILE;
    }
    if (text && text.length > FACEBOOK.TRUNCATED_TEXT_LENGTH_WEB) {
      return FACEBOOK.TRUNCATED_TEXT_LENGTH_WEB;
    }
    return undefined;
  }
  var characterLimit = getCharacterLimit();
  var hasLargeText = getHasLargeText();
  var canSeeShowWholeText = (text == null ? void 0 : text.length) && text.length > truncateHtmlString(text, {
    maxLength: characterLimit,
    ellipsis: false
  }).length && !showWholeText;
  return React__default.createElement(PostTextContentWrapper, {
    className: classNames(modules_82161d99.textContent, hasLargeText && modules_82161d99.largeText)
  }, React__default.createElement(HyperText, {
    pageType: TYPE_FACEBOOK,
    options: {
      maxLength: showWholeText ? undefined : characterLimit
    }
  }, text), canSeeShowWholeText && React__default.createElement("span", {
    className: modules_82161d99.seeMore,
    onClick: function onClick() {
      return setShowWholeText(true);
    }
  }, "See More"));
};

var css$2 = ".Header_module_header__66f4b575{display:flex;padding:16px 16px 10px}.Header_module_header__66f4b575 .Header_module_title__66f4b575{color:#181b1f;cursor:pointer;font-size:14px;font-weight:600;text-decoration:none}.Header_module_header__66f4b575 .Header_module_title__66f4b575:hover{text-decoration:underline}.Header_module_header__66f4b575 .Header_module_photo__66f4b575{margin-right:10px}.Header_module_header__66f4b575 .Header_module_meta__66f4b575{align-items:center;color:#7a869a;display:flex;font-size:12px}.Header_module_header__66f4b575 .Header_module_meta__66f4b575 .Header_module_time__66f4b575{align-items:center;display:flex}.Header_module_header__66f4b575 .Header_module_meta__66f4b575 .Header_module_globe__66f4b575{background-image:url(\"data:image/png;base64,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\");background-position:-13px -301px;background-repeat:no-repeat;background-size:auto;display:inline-block;height:12px;opacity:.6;width:12px}";
var modules_773fac34 = {"header":"Header_module_header__66f4b575","title":"Header_module_title__66f4b575","photo":"Header_module_photo__66f4b575","meta":"Header_module_meta__66f4b575","time":"Header_module_time__66f4b575","globe":"Header_module_globe__66f4b575"};
n(css$2,{});

function getInitials(input, options) {
  var _input$replace, _input$replace$match;
  if (options === void 0) {
    options = {
      lettersCount: 2
    };
  }
  var initials = (_input$replace = input.replace(/[^a-zA-Z- ]/g, '')) == null ? void 0 : (_input$replace$match = _input$replace.match(/\b\w/g)) == null ? void 0 : _input$replace$match.splice(0, options.lettersCount);
  return Array.isArray(initials) ? initials.join('').toUpperCase() : '';
}

var _excluded = ["name", "src", "size"],
  _excluded2 = ["style", "className"];
var LARGE_AVATAR_BREAKPOINT = 32;
var INITIALS_BREAKPOINT = 24;
var MAX_INITIALS_LETTERS_COUNT = 2;
var MIN_INITIALS_LETTER_COUNT = 1;
var Avatar = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var name = _ref.name,
    src = _ref.src,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 20 : _ref$size,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var style = props.style,
    className = props.className,
    rest = _objectWithoutPropertiesLoose(props, _excluded2);
  return React__default.createElement("div", Object.assign({
    ref: ref,
    style: _extends({
      width: size,
      height: size,
      minWidth: size,
      minHeight: size,
      backgroundImage: src ? "url(" + src + ")" : undefined
    }, style),
    className: clsx('tw-box-border tw-flex tw-select-none tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-full tw-border tw-border-grayscale-10 tw-bg-grayscale-5 tw-bg-cover tw-bg-center tw-bg-no-repeat tw-text-grayscale-100', className)
  }, rest), !!name && !src && React__default.createElement("span", {
    className: clsx('tw-font-medium', {
      '!tw-text-xs': size < LARGE_AVATAR_BREAKPOINT,
      '!tw-text-sm': size >= LARGE_AVATAR_BREAKPOINT
    })
  }, getInitials(name, {
    lettersCount: size < INITIALS_BREAKPOINT ? MIN_INITIALS_LETTER_COUNT : MAX_INITIALS_LETTERS_COUNT
  })));
});
Avatar.displayName = 'Avatar';

var _excluded$1 = ["size", "withoutBoundary", "icon", "iconProps", "className", "onClick", "style"];
var GRID_SIZE = 4;
var Icon = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    withoutBoundary = _ref.withoutBoundary,
    icon = _ref.icon,
    iconProps = _ref.iconProps,
    className = _ref.className,
    onClick = _ref.onClick,
    style = _ref.style,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  var styleProps = props;
  var spanProps = {};
  if (styleProps['data-cy']) {
    spanProps['data-cy'] = styleProps['data-cy'];
    delete styleProps['data-cy'];
  }
  if (styleProps['data-name']) {
    spanProps['data-name'] = styleProps['data-name'];
    delete styleProps['data-name'];
  }
  if (size === 'inherit') {
    return React__default.createElement("span", Object.assign({
      className: clsx('tw-inline', className),
      ref: ref,
      onClick: onClick,
      style: _extends({}, style, styleProps)
    }, spanProps), React__default.createElement(FontAwesomeIcon, Object.assign({
      icon: icon
    }, iconProps)));
  }
  var fontSize = getFontSize(size);
  var boundarySize = withoutBoundary ? fontSize : fontSize + GRID_SIZE;
  return React__default.createElement("span", Object.assign({
    ref: ref,
    className: clsx('tw-inline-flex tw-items-center tw-justify-center', className),
    style: _extends({
      width: boundarySize,
      height: boundarySize
    }, style, styleProps),
    onClick: onClick
  }, spanProps), React__default.createElement(FontAwesomeIcon, Object.assign({
    icon: icon,
    fontSize: fontSize
  }, iconProps)));
});
function getFontSize(size) {
  switch (size) {
    case 'sm':
      return GRID_SIZE * 3;
    case 'md':
      return GRID_SIZE * 4;
    case 'lg':
      return GRID_SIZE * 5;
    case 'xl':
      return GRID_SIZE * 6;
    default:
      return size;
  }
}
Icon.displayName = 'Icon';

var mergeTailwindClasses = /*#__PURE__*/extendTailwindMerge({
  prefix: 'tw-'
});

var _excluded$2 = ["href", "children"];
var ExternalLink = function ExternalLink(_ref) {
  var href = _ref.href,
    children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  if (href) {
    return React__default.createElement("a", Object.assign({
      href: href,
      target: "_blank",
      rel: "noreferrer"
    }, props), children);
  }
  return React__default.createElement("span", Object.assign({}, props), children);
};

var css$3 = ".DateTooltip_module_underline__48ab3a1c:hover{cursor:pointer;text-decoration:underline}.DateTooltip_module_tooltipWrapper__48ab3a1c{display:flex}.DateTooltip_module_dateTooltipContent__48ab3a1c{word-wrap:break-word;color:#fff;display:flex;flex-direction:column;line-height:1;padding:9px 10px;text-align:center;white-space:nowrap;word-break:normal}.DateTooltip_module_tooltipText__48ab3a1c{font-weight:600;margin-bottom:14px}.DateTooltip_module_button__48ab3a1c{background-color:transparent;border:none;color:#fff;font-size:12px;line-height:1;outline:none}";
var modules_a81bb501 = {"underline":"DateTooltip_module_underline__48ab3a1c","tooltipWrapper":"DateTooltip_module_tooltipWrapper__48ab3a1c","dateTooltipContent":"DateTooltip_module_dateTooltipContent__48ab3a1c","tooltipText":"DateTooltip_module_tooltipText__48ab3a1c","button":"DateTooltip_module_button__48ab3a1c"};
n(css$3,{});

var DateTooltip = function DateTooltip(_ref) {
  var onEditDateTimeClick = _ref.onEditDateTimeClick,
    children = _ref.children;
  return React__default.createElement("div", {
    className: modules_a81bb501.tooltipWrapper + " tw-relative tw-inline-block tw-group"
  }, React__default.createElement("div", {
    className: modules_a81bb501.underline,
    onClick: onEditDateTimeClick
  }, children), React__default.createElement("div", {
    role: "tooltip",
    className: "tw-absolute tw-z-10 tw-invisible tw-inline-block tw-p-1 tw-text-sm tw-font-medium tw-text-white tw-transition-opacity tw-duration-300 tw-bg-black tw-rounded tw-shadow-xs tw-opacity-0 group-hover:tw-visible group-hover:tw-opacity-100 tooltip tw-left-1/2 -tw-translate-x-1/2 tw-mt-2"
  }, React__default.createElement("div", {
    className: modules_a81bb501.dateTooltipContent
  }, React__default.createElement("span", {
    className: modules_a81bb501.button,
    onClick: onEditDateTimeClick
  }, "Edit")), React__default.createElement("div", {
    className: "tooltip-arrow",
    "data-popper-arrow": true
  })));
};

var DATA_CY_NAMES = {
  IMAGE_GALLERY: 'post-preview_gallery',
  IMAGE_GALLERY_WRAPPER: 'post-preview_gallery-media-wrapper',
  VIDEO: {
    PLAYER_WRAPPER: 'post-preview_video-player-wrapper',
    THUMB: 'post-preview_video-custom-thumb'
  },
  POST_PREVIEW_DATE: 'post-preview_date',
  CAROUSEL: {
    GALLERY_WRAPPER: 'carousel-gallery_wrapper',
    GALLERY_IMAGE: 'carousel-gallery_image',
    GALLERY_ITEM: 'carousel-gallery_item',
    ARROW: {
      PREVIOUS: 'carousel-arrow_previous',
      NEXT: 'carousel-arrow_next'
    }
  },
  OFFER_INFO: {
    OFFER_TITLE: 'offer-info_title',
    CODE_INFO: 'offer-info_code-info',
    OFFER_CODE: 'offer-info_offer-code',
    OFFER_DATE: 'offer-info_offer-date',
    OFFER_LINK: 'offer-info_offer-link',
    OFFER_TERMS_AND_CONDITIONS: 'offer-footer_terms-and-coditions'
  }
};

var DateTime = function DateTime(_ref) {
  var time = _ref.time,
    date = _ref.date,
    use12hourFormat = _ref.use12hourFormat,
    formatDateTime = _ref.formatDateTime,
    className = _ref.className;
  return React__default.createElement("div", {
    className: className,
    "data-cy": DATA_CY_NAMES.POST_PREVIEW_DATE
  }, (time || date) && (typeof formatDateTime === 'function' ? formatDateTime({
    date: date,
    time: time
  }) : formatDateTimeAsSocialNetworkPost({
    date: date,
    time: time,
    use12hourFormat: use12hourFormat
  })));
};

var Header = function Header(_ref) {
  var _ref$content = _ref.content,
    date = _ref$content.date,
    _ref$content$page = _ref$content.page,
    logo_src = _ref$content$page.logo_src,
    name = _ref$content$page.name,
    username = _ref$content$page.username,
    time = _ref$content.time,
    use12hourFormat = _ref.use12hourFormat,
    formatDateTime = _ref.formatDateTime,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var renderDateTime = function renderDateTime() {
    return React__default.createElement(DateTime, Object.assign({}, {
      time: time,
      date: date,
      use12hourFormat: use12hourFormat,
      formatDateTime: formatDateTime,
      className: modules_773fac34.time
    }));
  };
  return React__default.createElement("div", {
    className: modules_773fac34.header
  }, React__default.createElement(Avatar, {
    size: 40,
    name: name,
    src: logo_src != null ? logo_src : undefined,
    color: "blue",
    className: modules_773fac34.photo
  }), React__default.createElement("div", {
    className: modules_773fac34.content
  }, React__default.createElement(ExternalLink, {
    className: modules_773fac34.title,
    href: username ? "https://www.facebook.com/" + username : undefined
  }, name), React__default.createElement("div", {
    className: modules_773fac34.meta
  }, onEditDateTimeClick ? React__default.createElement(DateTooltip, Object.assign({}, {
    time: time,
    date: date,
    use12hourFormat: use12hourFormat,
    onEditDateTimeClick: onEditDateTimeClick
  }), renderDateTime()) : renderDateTime(), (time || date) && React__default.createElement("div", {
    className: modules_773fac34.divider
  }, "\xA0\xB7\xA0"), React__default.createElement("div", {
    className: modules_773fac34.globe
  }))));
};

var css$4 = ".PostWrapper_module_postWrapper__47f3ed7f{background:#fff;border-radius:max(0px,min(8px,(100vw - 4px - 100%) * 9999))/8px;box-shadow:0 1px 2px rgba(16,24,40,.05);box-sizing:border-box;color:#181b1f;display:flex;flex-direction:column;font-family:system-ui,-apple-system,\\.SFNSText-Regular,sans-serif;font-size:14px;line-height:1.34;max-width:500px;overflow:hidden;width:100%}.PostWrapper_module_postWrapper__47f3ed7f[data-preview-variant=mobile]{border-radius:0;margin:8px 0;max-width:100%}.PostWrapper_module_postWrapper__47f3ed7f a{color:inherit}.PostWrapper_module_postWrapper__47f3ed7f a:hover{color:inherit;text-decoration:none}";
var modules_6850efbf = {"postWrapper":"PostWrapper_module_postWrapper__47f3ed7f"};
n(css$4,{});

var PostWrapper = function PostWrapper(props) {
  return React__default.createElement("div", {
    className: modules_6850efbf.postWrapper,
    "data-preview-variant": props.variant,
    "data-content-type": props.contentType,
    style: props.style,
    "data-content-subtype": props.contentSubtype
  }, props.children);
};
PostWrapper.defaultProps = {
  variant: 'desktop'
};

var css$5 = ".Footer_module_footerWrapper__59a23d8f{container-type:inline-size;margin:0 16px}.Footer_module_footer__59a23d8f{border-top:1px solid #d7dbe1;color:#7a869a;display:flex;padding:6px}.Footer_module_footer__59a23d8f .Footer_module_btn__59a23d8f{align-items:center;border-radius:4px;cursor:pointer;display:flex;flex:1;font-size:14px;font-weight:600;gap:8px;justify-content:center;line-height:20px;padding:6px 2px}.Footer_module_footer__59a23d8f .Footer_module_btn__59a23d8f:hover{background-color:rgba(0,0,0,.05)}.Footer_module_footer__59a23d8f .Footer_module_btn__59a23d8f .Footer_module_likeIcon__59a23d8f{background-position:-38px -169px}.Footer_module_footer__59a23d8f .Footer_module_btn__59a23d8f .Footer_module_commentIcon__59a23d8f,.Footer_module_footer__59a23d8f .Footer_module_btn__59a23d8f .Footer_module_likeIcon__59a23d8f{background-image:url(\"data:image/png;base64,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\");background-repeat:no-repeat;background-size:auto;filter:invert(39%) sepia(21%) saturate(200%) saturate(109.5%) hue-rotate(174deg) brightness(94%) contrast(86%);height:18px;width:18px}.Footer_module_footer__59a23d8f .Footer_module_btn__59a23d8f .Footer_module_commentIcon__59a23d8f{background-position:0 -169px}.Footer_module_footer__59a23d8f .Footer_module_btn__59a23d8f .Footer_module_shareIcon__59a23d8f{background-image:url(\"data:image/png;base64,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\");background-position:0 -188px;background-repeat:no-repeat;background-size:auto;filter:invert(39%) sepia(21%) saturate(200%) saturate(109.5%) hue-rotate(174deg) brightness(94%) contrast(86%);height:18px;width:18px}.Footer_module_statsBar__59a23d8f{align-items:center;display:flex;height:43px;justify-content:space-between;padding:10px 0;width:100%}.Footer_module_statsBar__59a23d8f .Footer_module_commentIcon__59a23d8f{background-position:0 -169px}.Footer_module_statsBar__59a23d8f .Footer_module_commentIcon__59a23d8f,.Footer_module_statsBar__59a23d8f .Footer_module_shareIcon__59a23d8f{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEkAAAFUCAMAAABfkuEfAAADAFBMVEVMaXEAAAAEBAUAAAAAAAAAAAAAAAAAAAAEBAUAAAAAAAAAAAAAAAAAAAABAQEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAQEAAAAAAAAAAAAAAAAAAAAAAAAAAAC3t7cAAAD///8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD///8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD///8AAAAAAAD///8AAAAAAAAAAAAAAAAAAAD///8AAAAAAAAAAAAAAAAAAAAAAAAEBAT///8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADyKkkAAAD///8AAAD////GxsYAAAAAAAAAAAD///8AAAAAAAAAAAAAAAAAAAAAAAAWFhYAAAAAAAAAAAAPDw8+Pj4AAAD8/Pz39/cAAACvr6////8AAAD///+FhYUdHR7////U1NRTU1MKCgoAAAD///////8AAAAcHiHOzs7///////////+8vLwAAAD///////8AAACrq6v///////////8cHiH////////xKUrxKEnxKUr0LVDwKUnV1dXm5ubyKEv////xKEr4+PjR0dE1NTX5+fn19fX////////Q0NB6enr///8cHiGhoaEcHiEcHiEcHiEAAAAAAAD////a2tr///////////8cHiEcHiH9/f0cHiEcHiEcHiEcHiEcHiEcHiEcHiH///////+cnJz////////u7u7j4+PMzMwqKir/QGBwcHD///8cHiEcHiEcHiEcHiHv7++Dg4NmZmZWVla+vr7y8vLy8vLY2Nj///8cHiH///////////8cHiEcHiEcHiEcHiH////////////r6+vr6+uZmZn///////////////8cHiH///8AAAD////wKEkcHiHyRGD84OX2ipz1d4z6wsvwMVD0aYD0Z37zVW8AjIAxAAAA83RSTlMA+wwEgf3zZgLx1fX5pwaP4+ccON3rFIXpvclaLO0SEJVIeOX379eLCnAYjUylk8CzajiZu9mcftskiOEOJgisKjDh0jtTAhqgBMbN37fP/am1s5FOHmbxQFDDNiIoubE0IFxybqWDj79kPhandGGvREIya2x8o2h3y/nzeq3ndg2VbHjLfmhGbrEu88dm3gi3SnAQaKnXaiwETC6n5Y8W883dMlBY9cl09/Fg08ePMPuj+dqmVnIY0cNebIvW/fZQalTdKnD1haE/Qufaw3AIitvp7Vy+6ZOFfrjt68/NfPMzJJ6RZELqtBLl4586BnzusfmToHMuAAAWEElEQVR4XqyYy4oaQRRAa1e/E2bbX+DKXf+B2HsXiqLgEwVhZEQdcKWIjm/ciUKvJ2MSZmUyM8kPJFmeDwgikcGmu6qGOh9wuqu4t+5DRHPbH+325fJ+N+rfig9zX284vMNp1O+FOetkgSAUkmsjTWy+4Ix/3Da9Vstrbo8+ZxbzmLan5wCQq2yqNXmhVt1UcgA4PT3XUxcgu1y5MoC7WmYBup/VnnYCYJYvyRBK+RlAoq0Q3TjAtJOSEaQ6U8C5iRTdxYHJg1TwMAHidxGiJDAuSg2KYyAZ5oklgGFGapEZAomQeEgAg7TUJD0AEqFH81ypjeuFHPAO8KQRHhC89ps4DFwzkzuA+HUwtB0YpqUh6SE47cBtjzPSmMz4+tafgKL8AEXgfQ7GujCRH2IC3XdR1YNpMEVSzxrnfZhC7yKKOdAJiB59/K/flKoOOJefmsMskP0/AMj9VZlSM5j/Ny0gL6/Jc+ZLVaHKw0KcWUM2+LB94gx+KxVpKmVhfUm4pQw3wc/vkarlJf0KsIo0wa+oqF1B4VwgIecqTGQ7tfD0y8H9yVSHilSZ4M9zqKoC9ZOpARsNE4QG1wYaJ5MDVaUpMriq4Jy6EfBrSlNkcNV8uBWiDwepNEUH1wH6QoxgqzZFB9cWRkLsoGligkqg/jRhJ8QePDNT8Mse7IUoQ8vQlL3+qRaU7Znsnc7ejZtHwVsxJApMI/M1JYMcoW+aLS+h2WKWwY9uaAbbe1UMXrrfipdO+/XNK15fuxVBXaXeisoqpVc5X/Uqp7qav2hVc3WH8ejqdBjKrieu2/UoOrGSdidmrzu01rFa66LtdfbWpg1rE5Ddqcz+pGh/ejWfqG1O+fY3D/a3IeYbmid7WyPzTdbh/ybroNpkmW/XLG38/rFnbzFRnG0cwP/uht2hK4cVhFXr2hVWZDkYRXBL6GdqgVpO9ZQo8KWCcKM9KKY1MWmU1AsPGzBtTVtoQRM/7wmQEFsIgqd4ZTzdeq5tL9ra73kZPLZ9F3eGeWcWx+6Q9MbfxYYZyJ99nn2ed5NdxML6p5DWHT/R1HTiOF7Ip5jS0e6usQld3UdhjjCVpmNjqmNNMEqpWghzuPjdmOC7i4ageErHJBJVQsGDdFHGoAQJAtJwqqUpAY8eKVFNJkGkTXLYlGYrPXrK2FOlV0cNQVMnFSCiW6npIWMPlZ+7DUFTJ+1ERJdaHGNqeV2GIPOk42OKPxn7U704rg8yr+6EmvQXY3+pFyeEIINoHW9Sk8YZGx8TXz1v9CASOfVJTxh7ElNSpVgd9/jxWPTqTIgdF5l3XKCfgvEHD8ZfeAoEliZTIGyL+JzMt0UgbLDIfIMFFk6VLMsnnZH109dellfocBTmldmtvSOgNpU8a3Jy1ngotdbKu5SURTU+CZzkq6EsCTHLony1KHs+ZSFWtZQPjXyqRWzsqTUSAgX71euaVDv0lrXvg97CqhQIysgHrKRXoPBRmSFoIzsPvXSKF6PyPBIwn0i9K3nyjEEflENPStBFFa4BECRPAIo1hVGDTKMcOQD2UjVUOY5oQeZR/vUAEiupWUgyBplH7V4LblYGFdtLlqR7heqEINOoPLcdXGOQVi0i8igdF4NMosQX3ZYzg4jeU24Yg8yjCnfjmUB2UfZiYTJ/UYJMoryYsD0Z+m2JLcnuKNDeVzY4hup20IdLV86ptQunSkwdTyKiVavIvXm9cNLFMAXLV3/UCOnzhBq/cPrGMJlmzLfFQpRJkFmUtSDzk85MDKfvtHvJthfT5LUcTI/G+V5Mj10rYGqxc3uqy1W1+YgNUdSvWFLlykye61gAE/albqrLDQRy68jTnAidskqionqbt7SqKKnCh+f57yKidAmclE4UfANas5YTuVvANWT8J4NoTgBTSplNVCehxOksgVRHNL8Uk7bxX9JEEJY7kUtEnk0I8yUn+8RHvOogolyUpBKllkz8reMQFL5M4qUBicVu/2w7UEBEmfvBJRMli4+oJC4AJ3FOBIRPCxpcxNUDxUS0ogVIIS5zZ/SkoJD0NnFBRFRSmA1wE8Uf8gAlFFYTvbptM/XVzdiEiCCFeQHerY/XuQEbCf9JJ9cldty1AYr9ccSVAlk0O4WKgXri4nIxhZ0Z2ilwN2DSlrhIx/3z8ooTgSLinJjS4oV+ZTLjPxGnfEMm0cwGbJ2DsJZwv+fheUqa11XxbVmbbdiH15cQryyjYSLITfTWm4jZlrkUN/f9BbZ6XlrwiAQrDrlKqzNdqyqKW2DRil2YHl5/I6ZHVgGmyV4bXgI6Rvv7QqG+/tEOWHPqtBxx+hQskAZleejsGZvtzNkhWR6U8A94K/xboRqUe0ekSOhIrzwIo8NtB9vPnWs/+HUrRM1E/snS5N57gNQfCv0hAfd65VPGLzP2sJOdAwOdJ9lPB36D1g6iCrXZp+URAP28ScODAEbk07q23/6KsfPl4MrPM3bpthjV7EXEqDwkAZDDrgCQhuRRaC37ibGT5Whta2tF+UnG7v+K6Prls+B6ZK4H3Fm5Hxrf3GSMdaK1nbH2VnTyi5vfIiI76N+eBkWffAbcZTkM3Bm5DxrXGTeANsa1YYBx1/FMWlIC0XooQrINHH/R5N7PwNnkEDQuGZMuQbGBqFqfhBuhKzcQJenC//XVvXsBigqi1WJ1KmN16Dwndvzc/7RPiXLFjnfc7eMt7+m7m2joOHBrj3YK9tyCarUyTeoU2ORhecLwlcWGKQAO77uvTObG37VTXk20AdBO5rUeOaJnSJlMQeuBn8Pb8vMXX0JrPVFeUppmW3pCsmq4R90Wc2nb/cFsaDdYMIiYSXdkjTsSLPhxWC3uKqzpuHrtcm/v5WtXO/BvKNu1Azp/l2+nPWl1ex/HvxuEMilCAQHBCcRxiHE2zkM0tjZaNbGt1WoaEzV2im3SxKQPr6TPmlxvpX1jvzdwtyuw2eyovXvac66TnM+D3fjkG9Zi/TcI1ns9On2BQX9MZYV+jMXRoCqCo4tUzEXkX6VWk7LFpVaMmGwFTCiyFK2riC5F7JQnIk1SayfIu0gfhoyhNRokAEaXWqlqXRqlLOCTIl5qTEdgNOEs5YByKRjFKRqkLBeWwhfUGA9DX8RZCpBWuaQ6nOpkr8SSLC9OqeI4zIfretq9IAP0s5I3KMOXX/dQVuebhZIkhVqqBc/tJUliN6iySBscSdLj/GuMhl3fdLU09ZNSSLYh0FBd3ZD0jLKxeefq7i6pKgOqgwmdUDaT3v6XSpFKCVu0k0K1VLjlFLhL1kd3iedjj+g3KTDTcvPJdJf8u+4Sb9SMm5mW93G4P2FPi6sU/uwuNXRpAafqBL9v6PLZE+wqFetwl3a1zs00H9JIN0alVLJkKLxgl0rrZs6nx279VEEq/AW1pd76sAnl70HlPG3GTNt6sM8txj604i7VMmf8iH+QDIUTgzkMb082b5mF5bM9XoyFaMjvD0UXcGOsj4q/lwHwPO9IRr2AN6NsW1Pdd01tWWW8QEObb2z61avpMV9bAy7SCGUB6yUGno8loEdXlDUcv1QPNGQiHQGAQEck405pSesBjPHLOSoUhWyWinUdZ7PQFnlB2YtIG7VUd60tL8Dnwgw2TzJHvg2I18di9fEv6w1teRZ8HexvdWN0+BawXXQ87dR7enTUAETrcOgYxGqCeD44MhLMx6HJIjoWIKQzjMBYlLLAp6KWBybi8LcO52DsOQ7PE6gO6oMHcBCshzoRmoag+jCYDlVCA8pUVv3KN9SNfwbZ8MiUYiMAIzFT8r+CdeUweOXHYESX2EZ0RthD4wLGguCGUuc9SBU+egg0OEormgacjynxnK2/Mf7eAuFeHR+7gMX8WPtI8rK6uo9LcxD/ctZh79NgB7N6t51Ob7/rnAXdsOMPA8DshqRGe8enNMzqqE+qPne5pIevxfEXz8a1Csh5CoC2PAe+rwD0r3/I2afgUgvzmrx+sVY9T4wL9jOxdOYNgJwnE3NOG/zDuE8mj2OTVo/rjFP66MFoWQQ5pwV+TMtbPT//gmtaHsl/3z13eMeTHc89qfNr+UC4J5ioitLD6bOaCU7qieteYOQGE+HOjZH7kpLuuwrma6DZvkedNXeV0jX/a+w7669KlSzJKqUAMHdWGY4761+DDfzMxZv+seYABJrH+t+kgIaMbPad9Yke/yzVro3RyriODmkB2kzj0SOTaqPs3k9ThXc4vBILZmnF7u6IWeDC/zvlA4gfptOHHlYf4SOqHyyw9EOUW1KpjY0UTgI8eh+P7ygeX0WEZLS2yghxcyoVkkIpd+lwB+D9ISD8MmZnZfhxpgYcoVCoNiUgHQeIp52l8/M7SiaUMpc7SiEZy8t3rW7je8P0Nlyrew+wY1ZX3nHf50XfHTu+bXabi43t2lJcO/H4e80A5hSY0mffL54CeQHPj1MQB7yRysn0+X71ZGrIi807NPSvT0v3UEQO3XdO8K/LmbvKzgL/MPfrgXmX+Tvs1yjzLhOj+XWoEPuuEDo64VfYr5selbzAuppzvWvf9eZW9YGyt42Nb7nbeAzbxyhc+7uxdWsYWrLBeyxLy9wLZlu4TS7pqX2XmfkCASrah2BYSlKUiiSlYW4z2AHb22CudAyytBeYV6kFIYm9JbgnxchKWWLSPWzNzTWXxHNn6XkCvye6kXpmSoDHD92Z/FfeTU6+42s+010NSc2OC2EPDp4wljfWC5RLAQuXXylpDUYRkgj42BuNhOiZlCZ7CEVG9+5a3ZM5gLkn5dXVK3Wg6upGpeEeGT1X0uhdO74b2l1b+34xOx7cCwzmG18gJoC9JYrS3qSMyT0pfOcpONlMJjdPyqegHYf2DDs+PxEZEQq+HW4z/hGbxuFKzpPpvwZg2pIka5q7eEuqTMtACeBD49dcasbrnUnlmjXBr7AneNwLwMnrUNpvWf506HXzb9xV/jnPB1wz3asmnBoWT/oOY9LFz0Lp5B61FLanfLZjqxRZru/4suYZTO9xpwHJN/QGJyl8grGWHGzOeTFYH+Z20WWepzvHGzUYqCmpuAqAuqj6e5yKuCLU6NKp2SfPuPowaNg9DMr+iwXN2HH41klZThJOz3xtlNXrBQBrJb8Mhc+BQhykcuk6jMFsp7u03mkPQ0u+HmAmb6ki/AI2+0HCeC8L4yDvc5eS49iO8kBAPjlAVwfVX75X0hiNPrlK3fqEbULd0FFUVfgSTuorodDh3Er2tpJXfdj65IWYM9QBLC7Dp1ZgehBGLm9dXWII21ACXvglRcIRE7oGaIh4uUy0kkrusZZfu3XHu6xFyhatLtixVCy8n2qVFJ7AKOVgoouvR7A8TUUu6Cpd+Je7MbqX/ReQVVANgBQ+xWC+GYDoZWB7PYBt1lXiiW9yBWBl0vcESEYeBgBUbHJ8SAN0J4aHXnu5y5ekEltbCSW/AEgzAK3aoWI2OT0T71NsaZifmLkcamwcujQFdILhpWpNaizM73v5R7WGplv/TOjB1dWD21LPQnIIPbs71Ad9durtW5xCqlHCQZp1h4C+R90Yfr/pFe5hyKW2FMxRVTIhiMoLgATwRhp2lLKRm0vqnKWiVbICgCW1AhBTHGC4nJIRmNq8ueTLH1DmmSMxC1MJ5jDqtelMyQB2EzeV5GukavMLtB9SFs/L9sZRYurm0hJVgz3wsg07VR9zldyPyb0621WbqbmY1bn26c4dB9pHYXP3ptDPn7scTlNp0CK22lPggkNEcWoEzOPHZp/Mu8+42wTQAB5g4vfmTtjEbyn9/JEzJmOSf5OzrN+fPQPgscoeAzs+Gb4dYGE+kf4uMT8LQFNEijRRozcjI9OLi08awLxJgym/yvxTAJEWaIlQIyN1vnvXKWUA2Vw/DMg2QEfY8WpvO1N//yZs9vfrDNyl4shI0ZQeSlJjoyQlKMpWxJbV7Gx4YSE8O6ssSI+PV1aOH1dKq7BqSuEW76fXgcDrKabCyAGbX52dkn5c/SC1A7RXSh7wmJKP9Fzu9DQn5CMsaaOlZUNS2FHqOnm4EgisPDzpMqVTgNNK6QAOyiVezD19OmdK85JOc7lTSfPYsq1HXwG+HrWa1RXfwbtipbQZj2+aUph8Q/kxhWkZCKruOwWdvw+czae/AXxLz59BUers7++UioBskGgJXP3YJ03pIey3Qi4Hrfs4ZFSWAa4rh/EakPUpBalPlmCg+twNQFDKHhxkpeDtJzO3LUmbOQBfHUad+2RykpaRPrl1WoD9bHYfo+0Y47gNmJ1PdFpWMLG1wD9q7t69OWyfO7VPxcFjv397CpcuSZrGDealebrj3RiSxswVYEiSNnDRBVwIgGZLhtUM4Jf8LO4v2iVRFrAkyefF4YNsH3id2k9KUnI/9RoISSFW9lcwYqZkLgQikvuPUEZ9KvONoqXF42Vp+XhxScDKw4cr7K3sYUwpv0fZhYw4Dr0tzfWdUn6guaUXqbjavbXVvVqUuJkkgKwkPQrgYBVGdgGejBcsJH+7JxDwtPslvE0FqdDkfXaea4Bn5vuPxBQGUz7Jd4yTJCGV/40tTiWGhhJTizHRJKOpd38/x5TKnmGQlT6Cu9QCLab0dG8lL0n5lb2nFGQUGvb3V0g4X7e8V6GO9lhj+1XopRebHOCvooziX1A5EJyfH2CpzAL6JOsq1fvNknZuOQU1+kzK6gNANiAmW55fNaKyEWBdtvX/xJy+3E6nMy/5ZfacTn2bAvA8HX0SX2sryoPByQkG38b8j1Opx/7SN4BXD19Ry57Tp3oKoBFgqiTrAdCVmH0rvZ1NdMFw9ZuTYTz1ZkrdzJwSVBB4GYMZJiQFeyBpPmzsGVbS9U4oJKlxxfXAKnP6KfgJ2MjA6+VM+d4TjR30hkK9B7EohGULIynbYh5YvYeb+dML8K0Qk+SnxrJsy0iqI+T6isie01J4PkVQit2HwIhPfnZj68cZy8ocr8d26ZGtx5SQISrsOT2R5nkq6RRgR1li+mzWmVlUjDl7o0pzhG4q2XPaK3XSE5RCF8CHcA9blrd8Z7S2IBeUEcwB6KW75JjTcKQJPlqStU13UED5lXcA4zxsfyAFT3Dtk3tO8Sgs6XL5kQc3nsWk2DOqLo7EHV4+DQaHerjJ2uHhGjWe8B/RUHL8v8SZxmDyqIWKRw+o6uig1pujXpy2tzyreofhKZz29m5pDmCvqTUlpVqb9jCOLeuYGgOyDQH4u+HLXxhn8wCHZwBNSmakTFJN9q1vhBovFGqWoQ2AfAu20/cA75sAWpMykq1Ay/lwRIpcnbdQNSnrTMZSL8BoO7aJuuo1lTFvOpVJ3Xb3nThSMipJnQtAVGVR1w+PJMUhLukBL2V7icOD8KwlRc4BZJur+aG2xKXKLnH6Kuup1Ay3/97iWp39cKPUCCSCLf5L7iq5d9y+g1BjUpoc5O6S+xTMy5inxsRpWm+Au/bJfTKXFW5qCmsZl6vSC4A7njv3tIyPrMHayA7/RqeN/fwRXVIk9WdCPmn1/p8IhdceSJH+3w9JRxcPpMY/EJKO1nw65becylBYXfyeRpX9boj+yB8KQWr1D4XgfuQPhaC/8ZT/Jv8HYIJ8SHQtTz0AAAAASUVORK5CYII=\");background-repeat:no-repeat;background-size:auto;filter:invert(39%) sepia(21%) saturate(200%) saturate(109.5%) hue-rotate(174deg) brightness(94%) contrast(86%);height:18px;margin-right:4px;width:18px}.Footer_module_statsBar__59a23d8f .Footer_module_shareIcon__59a23d8f{background-position:0 -188px;margin-left:8px}.Footer_module_statsBar__59a23d8f div{align-items:center;display:flex;justify-content:space-between}.Footer_module_statsBar__59a23d8f span{color:#7a869a;font-size:14px;margin-left:8px}.Footer_module_statsBar__59a23d8f img{height:43px;margin-right:8px;width:auto}.Footer_module_statsBar__59a23d8f .Footer_module_statLabel__59a23d8f{margin-left:4px}.Footer_module_statsBar__59a23d8f .Footer_module_statLabel__59a23d8f:not(:last-of-type){margin-right:8px}.Footer_module_statsBar__59a23d8f .Footer_module_statsIconShorthand__59a23d8f{display:none}[data-preview-variant=mobile] .Footer_module_footer__59a23d8f .Footer_module_btn__59a23d8f,[data-preview-variant=mobile] .Footer_module_statsBar__59a23d8f span{font-size:12px}@container (max-width: 280px){.Footer_module_statsBar__59a23d8f .Footer_module_statLabel__59a23d8f{display:none}.Footer_module_statsBar__59a23d8f .Footer_module_statsIconShorthand__59a23d8f{display:inline-block}.Footer_module_statsBar__59a23d8f span{font-size:12px}.Footer_module_footer__59a23d8f{padding-left:0;padding-right:0}.Footer_module_footer__59a23d8f .Footer_module_btn__59a23d8f{font-size:12px;gap:3px}}";
var modules_93eb7477 = {"footerWrapper":"Footer_module_footerWrapper__59a23d8f","footer":"Footer_module_footer__59a23d8f","btn":"Footer_module_btn__59a23d8f","likeIcon":"Footer_module_likeIcon__59a23d8f","commentIcon":"Footer_module_commentIcon__59a23d8f","shareIcon":"Footer_module_shareIcon__59a23d8f","statsBar":"Footer_module_statsBar__59a23d8f","statLabel":"Footer_module_statLabel__59a23d8f","statsIconShorthand":"Footer_module_statsIconShorthand__59a23d8f"};
n(css$5,{});

var img = "data:image/png;base64,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";

var Footer = function Footer(props) {
  return React__default.createElement("div", {
    className: modules_93eb7477.footerWrapper
  }, React__default.createElement("div", {
    className: modules_93eb7477.statsBar
  }, React__default.createElement("div", null, React__default.createElement("img", {
    src: img,
    className: modules_93eb7477.statsBar
  }), React__default.createElement("span", null, "3.2K")), React__default.createElement("div", null, React__default.createElement("div", {
    className: classNames(modules_93eb7477.commentIcon, modules_93eb7477.statsIconShorthand)
  }), React__default.createElement("span", null, "320"), React__default.createElement("span", {
    className: modules_93eb7477.statLabel
  }, "comments"), React__default.createElement("div", {
    className: classNames(modules_93eb7477.shareIcon, modules_93eb7477.statsIconShorthand)
  }), React__default.createElement("span", null, "130"), React__default.createElement("span", {
    className: modules_93eb7477.statLabel
  }, "shares"))), React__default.createElement("div", {
    className: modules_93eb7477.footer
  }, React__default.createElement("div", {
    className: modules_93eb7477.btn
  }, React__default.createElement("div", {
    className: modules_93eb7477.likeIcon
  }), React__default.createElement("span", null, "Like")), React__default.createElement("div", {
    className: modules_93eb7477.btn
  }, React__default.createElement("div", {
    className: modules_93eb7477.commentIcon
  }), React__default.createElement("span", null, "Comment")), React__default.createElement("div", {
    className: modules_93eb7477.btn
  }, React__default.createElement("div", {
    className: modules_93eb7477.shareIcon
  }), React__default.createElement("span", null, "Share"))));
};

var css$6 = ".ImageGallery_module_imageGallery__c5e12cd0{border-bottom:1px solid #eef0f2;border-top:1px solid #eef0f2;cursor:pointer;display:flex}.ImageGallery_module_oneImage__c5e12cd0{height:auto;width:100%}.ImageGallery_module_oneImageLink__c5e12cd0{aspect-ratio:1.9;object-fit:cover}.ImageGallery_module_squareAspectRatio__c5e12cd0{flex:1;height:0;overflow:hidden;padding-bottom:100%;position:relative}.ImageGallery_module_exceededCounter__c5e12cd0{align-items:center;background:rgba(0,0,0,.4);border:0 solid #fff;color:#fff;display:flex;font-size:32px;justify-content:center;position:absolute;z-index:1}[data-aspect-ratio-preset=portrait].ImageGallery_module_twoImageGallery__c5e12cd0{flex:1;height:0;overflow:hidden;padding-bottom:100%;position:relative}[data-aspect-ratio-preset=portrait].ImageGallery_module_twoImageGallery__c5e12cd0 img{border:0 solid #fff;object-fit:cover;object-position:center;position:absolute}[data-aspect-ratio-preset=portrait].ImageGallery_module_twoImageGallery__c5e12cd0 img:first-child{border-right-width:1px;height:100%;left:0;top:0;width:50%}[data-aspect-ratio-preset=portrait].ImageGallery_module_twoImageGallery__c5e12cd0 img:nth-child(2){border-left-width:1px;height:100%;left:50%;top:0;width:50%}[data-aspect-ratio-preset=portrait].ImageGallery_module_threeImageGallery__c5e12cd0{flex:1;height:0;overflow:hidden;padding-bottom:100%;position:relative}[data-aspect-ratio-preset=portrait].ImageGallery_module_threeImageGallery__c5e12cd0 img{border:0 solid #fff;object-fit:cover;object-position:center;position:absolute}[data-aspect-ratio-preset=portrait].ImageGallery_module_threeImageGallery__c5e12cd0 img:first-child{border-right-width:1px;height:100%;left:0;top:0;width:50%}[data-aspect-ratio-preset=portrait].ImageGallery_module_threeImageGallery__c5e12cd0 img:nth-child(2){border-bottom-width:1px;border-left-width:1px;height:50%;right:0;top:0;width:50%}[data-aspect-ratio-preset=portrait].ImageGallery_module_threeImageGallery__c5e12cd0 img:nth-child(3){border-left-width:1px;border-top-width:1px;bottom:0;height:50%;right:0;width:50%}[data-aspect-ratio-preset=portrait].ImageGallery_module_fourImagesGallery__c5e12cd0{flex:1;height:0;overflow:hidden;padding-bottom:100%;position:relative}[data-aspect-ratio-preset=portrait].ImageGallery_module_fourImagesGallery__c5e12cd0 img{border:0 solid #fff;object-fit:cover;object-position:center;position:absolute}[data-aspect-ratio-preset=portrait].ImageGallery_module_fourImagesGallery__c5e12cd0 img:first-child{border-right-width:1px;height:100%;left:0;top:0;width:66.6667%}[data-aspect-ratio-preset=portrait].ImageGallery_module_fourImagesGallery__c5e12cd0 img:nth-child(2){border-bottom-width:1px;border-left-width:1px;height:33.3%;right:0;top:0;width:33.3%}[data-aspect-ratio-preset=portrait].ImageGallery_module_fourImagesGallery__c5e12cd0 img:nth-child(3){border-left-width:1px;border-top-width:1px;height:33.3%;right:0;top:33.3%;width:33.3%}[data-aspect-ratio-preset=portrait].ImageGallery_module_fourImagesGallery__c5e12cd0 img:nth-child(4){border-left-width:1px;border-top-width:1px;bottom:0;height:33.3%;right:0;width:33.3%}[data-aspect-ratio-preset=square].ImageGallery_module_twoImageGallery__c5e12cd0{flex:1;height:0;overflow:hidden;padding-bottom:50%;position:relative}[data-aspect-ratio-preset=square].ImageGallery_module_twoImageGallery__c5e12cd0 img{border:0 solid #fff;object-fit:cover;object-position:center;position:absolute}[data-aspect-ratio-preset=square].ImageGallery_module_twoImageGallery__c5e12cd0 img:first-child{border-right-width:1px;height:100%;left:0;top:0;width:50%}[data-aspect-ratio-preset=square].ImageGallery_module_twoImageGallery__c5e12cd0 img:nth-child(2){border-left-width:1px;height:100%;left:50%;top:0;width:50%}[data-aspect-ratio-preset=square].ImageGallery_module_threeImageGallery__c5e12cd0{flex:1;height:0;overflow:hidden;padding-bottom:33.3%;position:relative}[data-aspect-ratio-preset=square].ImageGallery_module_threeImageGallery__c5e12cd0 img{border:0 solid #fff;object-fit:cover;object-position:center;position:absolute}[data-aspect-ratio-preset=square].ImageGallery_module_threeImageGallery__c5e12cd0 img:first-child{border-right-width:1px;height:100%;left:0;top:0;width:33.3%}[data-aspect-ratio-preset=square].ImageGallery_module_threeImageGallery__c5e12cd0 img:nth-child(2){border-left-width:1px;border-right-width:1px;height:100%;left:33.3%;top:0;width:33.3%}[data-aspect-ratio-preset=square].ImageGallery_module_threeImageGallery__c5e12cd0 img:nth-child(3){border-left-width:1px;height:100%;left:66.6667%;top:0;width:33.3%}[data-aspect-ratio-preset=square].ImageGallery_module_fourImagesGallery__c5e12cd0{flex:1;height:0;overflow:hidden;padding-bottom:100%;position:relative}[data-aspect-ratio-preset=square].ImageGallery_module_fourImagesGallery__c5e12cd0 img{border:0 solid #fff;object-fit:cover;object-position:center;position:absolute}[data-aspect-ratio-preset=square].ImageGallery_module_fourImagesGallery__c5e12cd0 img:first-child{border-bottom-width:1px;border-right-width:1px;height:50%;left:0;top:0;width:50%}[data-aspect-ratio-preset=square].ImageGallery_module_fourImagesGallery__c5e12cd0 img:nth-child(2){border-bottom-width:1px;border-left-width:1px;height:50%;left:50%;top:0;width:50%}[data-aspect-ratio-preset=square].ImageGallery_module_fourImagesGallery__c5e12cd0 img:nth-child(3){border-right-width:1px;border-top-width:1px;bottom:0;height:50%;left:0;width:50%}[data-aspect-ratio-preset=square].ImageGallery_module_fourImagesGallery__c5e12cd0 img:nth-child(4){border-left-width:1px;border-top-width:1px;bottom:0;height:50%;left:50%;width:50%}[data-aspect-ratio-preset=landscape].ImageGallery_module_twoImageGallery__c5e12cd0{flex:1;height:0;overflow:hidden;padding-bottom:100%;position:relative}[data-aspect-ratio-preset=landscape].ImageGallery_module_twoImageGallery__c5e12cd0 img{border:0 solid #fff;object-fit:cover;object-position:center;position:absolute}[data-aspect-ratio-preset=landscape].ImageGallery_module_twoImageGallery__c5e12cd0 img:first-child{border-bottom-width:1px;height:50%;left:0;top:0;width:100%}[data-aspect-ratio-preset=landscape].ImageGallery_module_twoImageGallery__c5e12cd0 img:nth-child(2){border-top-width:1px;bottom:0;height:50%;left:0;width:100%}[data-aspect-ratio-preset=landscape].ImageGallery_module_threeImageGallery__c5e12cd0{flex:1;height:0;overflow:hidden;padding-bottom:100%;position:relative}[data-aspect-ratio-preset=landscape].ImageGallery_module_threeImageGallery__c5e12cd0 img{border:0 solid #fff;object-fit:cover;object-position:center;position:absolute}[data-aspect-ratio-preset=landscape].ImageGallery_module_threeImageGallery__c5e12cd0 img:first-child{border-bottom-width:1px;height:50%;left:0;top:0;width:100%}[data-aspect-ratio-preset=landscape].ImageGallery_module_threeImageGallery__c5e12cd0 img:nth-child(2){border-right-width:1px;border-top-width:1px;bottom:0;height:50%;left:0;width:50%}[data-aspect-ratio-preset=landscape].ImageGallery_module_threeImageGallery__c5e12cd0 img:nth-child(3){border-left-width:1px;border-top-width:1px;bottom:0;height:50%;left:50%;width:50%}[data-aspect-ratio-preset=landscape].ImageGallery_module_fourImagesGallery__c5e12cd0{flex:1;height:0;overflow:hidden;padding-bottom:100%;position:relative}[data-aspect-ratio-preset=landscape].ImageGallery_module_fourImagesGallery__c5e12cd0 img{border:0 solid #fff;object-fit:cover;object-position:center;position:absolute}[data-aspect-ratio-preset=landscape].ImageGallery_module_fourImagesGallery__c5e12cd0 img:first-child{border-bottom-width:1px;height:66.6667%;left:0;top:0;width:100%}[data-aspect-ratio-preset=landscape].ImageGallery_module_fourImagesGallery__c5e12cd0 img:nth-child(2){border-right-width:1px;border-top-width:1px;bottom:0;height:33.3%;left:0;width:33.3%}[data-aspect-ratio-preset=landscape].ImageGallery_module_fourImagesGallery__c5e12cd0 img:nth-child(3){border-left-width:1px;border-right-width:1px;border-top-width:1px;bottom:0;height:33.3%;left:33.3%;width:33.3%}[data-aspect-ratio-preset=landscape].ImageGallery_module_fourImagesGallery__c5e12cd0 img:nth-child(4){border-left-width:1px;border-top-width:1px;bottom:0;height:33.3%;right:0;width:33.3%}.ImageGallery_module_manyImagesGallery__c5e12cd0{flex:1;height:0;overflow:hidden;padding-bottom:83.6%;position:relative}.ImageGallery_module_manyImagesGallery__c5e12cd0 img{border:0 solid #fff;object-fit:cover;object-position:center;position:absolute}.ImageGallery_module_manyImagesGallery__c5e12cd0 img:first-child{border-bottom-width:1px;border-right-width:1px;height:59.81%;left:0;top:0;width:50%}.ImageGallery_module_manyImagesGallery__c5e12cd0 img:nth-child(2){border-bottom-width:1px;border-left-width:1px;height:59.81%;left:50%;top:0;width:50%}.ImageGallery_module_manyImagesGallery__c5e12cd0 img:nth-child(3){border-right-width:1px;border-top-width:1px;bottom:0;height:40.19%;left:0;width:33.3%}.ImageGallery_module_manyImagesGallery__c5e12cd0 img:nth-child(4){border-left-width:1px;border-right-width:1px;border-top-width:1px;bottom:0;height:40.19%;left:33.3%;width:33.3%}.ImageGallery_module_manyImagesGallery__c5e12cd0 .ImageGallery_module_exceededCounter__c5e12cd0,.ImageGallery_module_manyImagesGallery__c5e12cd0 img:nth-child(5){border-left-width:1px;border-top-width:1px;bottom:0;height:40.19%;right:0;width:33.3%}";
var modules_ccc28e88 = {"imageGallery":"ImageGallery_module_imageGallery__c5e12cd0","oneImage":"ImageGallery_module_oneImage__c5e12cd0","oneImageLink":"ImageGallery_module_oneImageLink__c5e12cd0","squareAspectRatio":"ImageGallery_module_squareAspectRatio__c5e12cd0","exceededCounter":"ImageGallery_module_exceededCounter__c5e12cd0","twoImageGallery":"ImageGallery_module_twoImageGallery__c5e12cd0","threeImageGallery":"ImageGallery_module_threeImageGallery__c5e12cd0","fourImagesGallery":"ImageGallery_module_fourImagesGallery__c5e12cd0","manyImagesGallery":"ImageGallery_module_manyImagesGallery__c5e12cd0"};
n(css$6,{});

var AspectRatioPreset;
(function (AspectRatioPreset) {
  AspectRatioPreset["square"] = "square";
  AspectRatioPreset["landscape"] = "landscape";
  AspectRatioPreset["portrait"] = "portrait";
})(AspectRatioPreset || (AspectRatioPreset = {}));
function calculateImageOrientation(_ref) {
  var width = _ref.width,
    height = _ref.height,
    _ref$buffer = _ref.buffer,
    buffer = _ref$buffer === void 0 ? 0 : _ref$buffer;
  var aspectRatio = width / height;
  if (aspectRatio >= 1 + buffer / 100) {
    return AspectRatioPreset.landscape;
  } else if (aspectRatio <= 1 - buffer / 100) {
    return AspectRatioPreset.portrait;
  } else {
    return AspectRatioPreset.square;
  }
}
var FACEBOOK_IMAGE_ORIENTATION_BUFFER = 17;
function determineAspectRatioPreset(images) {
  if (images.length > 4) return AspectRatioPreset.square;
  if (images.length) {
    var first = images[0];
    return calculateImageOrientation({
      width: first.medium.sizes.original.width,
      height: first.medium.sizes.original.height,
      buffer: FACEBOOK_IMAGE_ORIENTATION_BUFFER
    });
  }
  return AspectRatioPreset.portrait;
}

function attachmentsToGalleryItems(attachments) {
  return attachments.map(function (attachment) {
    var _attachment$medium, _attachment$medium2;
    if (((_attachment$medium = attachment.medium) == null ? void 0 : _attachment$medium.type) === 'image') {
      var _attachment$medium$si;
      return {
        src: attachment.medium.sizes.lightbox.src,
        thumb: (_attachment$medium$si = attachment.medium.sizes.thumb.src) != null ? _attachment$medium$si : ''
      };
    }
    if (((_attachment$medium2 = attachment.medium) == null ? void 0 : _attachment$medium2.type) === 'video') {
      var _attachment$medium$or, _attachment$medium$or2, _attachment$medium$or3, _attachment$medium$or4, _attachment$medium$si2, _attachment$medium$si3;
      return {
        poster: (_attachment$medium$or = (_attachment$medium$or2 = attachment.medium.original_thumb) == null ? void 0 : _attachment$medium$or2.src) != null ? _attachment$medium$or : '',
        thumb: (_attachment$medium$or3 = (_attachment$medium$or4 = attachment.medium.original_thumb) == null ? void 0 : _attachment$medium$or4.src) != null ? _attachment$medium$or3 : '',
        video: {
          source: [{
            src: (_attachment$medium$si2 = (_attachment$medium$si3 = attachment.medium.sizes.medium) == null ? void 0 : _attachment$medium$si3.src) != null ? _attachment$medium$si2 : '',
            type: 'video/mp4'
          }],
          tracks: [],
          //@ts-ignore
          //opened PR https://github.com/sachinchoolur/lightGallery/pull/1424
          attributes: {
            controls: true
          }
        }
      };
    }
    return {};
  });
}

var _excluded$3 = ["attachments"];
var AttachmentsLightBox = function AttachmentsLightBox(_ref) {
  var attachments = _ref.attachments,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  return React__default.createElement(LightBox, Object.assign({}, props, {
    galleryId: "post-preview-gallery",
    dynamic: true,
    dynamicEl: attachmentsToGalleryItems(attachments)
  }));
};
var AttachmentsLightBox$1 = /*#__PURE__*/React__default.memo(AttachmentsLightBox);

function useLightbox(lightboxEnabledOverride) {
  if (lightboxEnabledOverride === void 0) {
    lightboxEnabledOverride = true;
  }
  var postPreview = usePostPreview();
  var lightbox = useRef();
  function handleOpenLightbox(index) {
    if (lightboxEnabledOverride && postPreview.enableLightbox) {
      var _lightbox$current;
      (_lightbox$current = lightbox.current) == null ? void 0 : _lightbox$current.openGallery(index);
    }
  }
  return {
    lightbox: lightbox,
    enableLightbox: lightboxEnabledOverride && postPreview.enableLightbox,
    handleOpenLightbox: handleOpenLightbox
  };
}

var ImageGallery = function ImageGallery(_ref) {
  var _images$0$medium$size;
  var images = _ref.images,
    _ref$lightboxEnabled = _ref.lightboxEnabled,
    lightboxEnabled = _ref$lightboxEnabled === void 0 ? true : _ref$lightboxEnabled;
  var _useLightbox = useLightbox(lightboxEnabled),
    handleOpenLightbox = _useLightbox.handleOpenLightbox,
    lightbox = _useLightbox.lightbox,
    enableLightbox = _useLightbox.enableLightbox;
  return React__default.createElement("div", {
    className: modules_ccc28e88.imageGallery,
    "data-cy": DATA_CY_NAMES.IMAGE_GALLERY
  }, images.length === 1 && (images[0].medium.meta.is_animated_gif && (_images$0$medium$size = images[0].medium.sizes.original) != null && _images$0$medium$size.src ? React__default.createElement("img", {
    src: images[0].medium.sizes.original.src,
    className: classNames(modules_ccc28e88.oneImage, !!images[0].url && modules_ccc28e88.oneImageLink),
    onClick: function onClick() {
      return handleOpenLightbox();
    }
  }) : React__default.createElement("img", {
    src: images[0].medium.sizes.lightbox.src,
    className: classNames(modules_ccc28e88.oneImage, !!images[0].url && modules_ccc28e88.oneImageLink),
    onClick: function onClick() {
      return handleOpenLightbox();
    }
  })), images.length > 1 && React__default.createElement("div", {
    "data-cy": DATA_CY_NAMES.IMAGE_GALLERY_WRAPPER,
    "data-aspect-ratio-preset": determineAspectRatioPreset(images),
    className: classNames(images.length === 2 && modules_ccc28e88.twoImageGallery, images.length === 3 && modules_ccc28e88.threeImageGallery, images.length === 4 && modules_ccc28e88.fourImagesGallery, images.length >= 5 && modules_ccc28e88.manyImagesGallery)
  }, images.slice(0, 5).map(function (image, i) {
    return React__default.createElement("img", {
      src: image.medium.sizes.lightbox.src,
      key: image.medium.id + "-" + i,
      onClick: function onClick() {
        return handleOpenLightbox(i);
      }
    });
  }), images.length > 5 && React__default.createElement("div", {
    className: modules_ccc28e88.exceededCounter
  }, "+", images.length - 3)), enableLightbox && React__default.createElement(AttachmentsLightBox$1, {
    onInit: function onInit(_ref2) {
      var instance = _ref2.instance;
      return lightbox.current = instance;
    },
    attachments: images
  }));
};

var css$7 = ".VideoPlayer_module_mockedVideoPlayer__5af80c12{align-items:center;background:#000;display:flex;flex-direction:row;height:100%;justify-content:center;width:100%}.VideoPlayer_module_mockedVideoPlayer__5af80c12 .VideoPlayer_module_alertMessage__5af80c12{margin:64px 12px}.VideoPlayer_module_playerWrapper__5af80c12{align-items:center;cursor:pointer;display:flex;height:100%;position:relative;width:100%}.VideoPlayer_module_playerWrapper__5af80c12>div{display:flex}.VideoPlayer_module_playerWrapper__5af80c12 .VideoPlayer_module_thumbnail__5af80c12{align-items:center;background-position:50%;background-size:cover;display:flex;flex-direction:row;height:100%;justify-content:center;left:0;position:absolute;top:0;width:100%}.VideoPlayer_module_playerWrapper__5af80c12:hover [data-visible-on-player-hover=true]{opacity:1;visibility:visible}.VideoPlayer_module_playerWrapper__5af80c12 .VideoPlayer_module_playbackIcon__5af80c12{align-items:center;background:rgba(0,0,0,.5);border-radius:50%;color:#fff;cursor:pointer;display:flex;flex-direction:row;height:125px;justify-content:center;left:50%;opacity:0;pointer-events:none;position:absolute;top:50%;transform:translate(-50%,-50%);transition:transform .07s ease-in-out,visibility .07s linear,background-color .2s cubic-bezier(0,0,.21,1.11),opacity .07s ease-in-out;visibility:hidden;width:125px;z-index:9999}.VideoPlayer_module_playerWrapper__5af80c12 .VideoPlayer_module_playbackIcon__5af80c12[data-visible=true]{opacity:1;visibility:visible}.VideoPlayer_module_playerWrapper__5af80c12 .VideoPlayer_module_playbackIcon__5af80c12 svg{fill:currentColor}.VideoPlayer_module_playerWrapper__5af80c12 .VideoPlayer_module_playbackIcon__5af80c12:hover{background:#000}@media (max-width:991.98px){.VideoPlayer_module_playerWrapper__5af80c12 .VideoPlayer_module_playbackIcon__5af80c12{height:80px;width:80px}.VideoPlayer_module_playerWrapper__5af80c12 .VideoPlayer_module_playbackIcon__5af80c12 svg{height:50px;width:50px}}@media (max-width:575.98px){.VideoPlayer_module_playerWrapper__5af80c12 .VideoPlayer_module_playbackIcon__5af80c12{height:60px;width:60px}.VideoPlayer_module_playerWrapper__5af80c12 .VideoPlayer_module_playbackIcon__5af80c12 svg{height:30px;width:30px}}.VideoPlayer_module_playerWrapper__5af80c12 .VideoPlayer_module_playerProgressBar__5af80c12{background-color:hsla(0,0%,100%,.4);bottom:0;height:3px;left:0;position:absolute;right:0;width:100%;z-index:10}.VideoPlayer_module_playerWrapper__5af80c12 .VideoPlayer_module_playerProgressBarValue__5af80c12{height:100%;transition:width .1s linear}[data-preview-variant=mobile] .VideoPlayer_module_playbackIcon__5af80c12{height:60px;width:60px}[data-preview-variant=mobile] .VideoPlayer_module_playbackIcon__5af80c12 svg{height:30px;left:1px;width:30px}[data-content-type=\"4\"] [data-fullscreen-controls=false] video::-webkit-media-controls-timeline,[data-content-type=\"4\"] [data-fullscreen-controls=false] video::-webkit-media-controls-toggle-closed-captions-button{display:none}";
var modules_7d7d7f29 = {"mockedVideoPlayer":"VideoPlayer_module_mockedVideoPlayer__5af80c12","alertMessage":"VideoPlayer_module_alertMessage__5af80c12","playerWrapper":"VideoPlayer_module_playerWrapper__5af80c12","thumbnail":"VideoPlayer_module_thumbnail__5af80c12","playbackIcon":"VideoPlayer_module_playbackIcon__5af80c12","playerProgressBar":"VideoPlayer_module_playerProgressBar__5af80c12","playerProgressBarValue":"VideoPlayer_module_playerProgressBarValue__5af80c12"};
n(css$7,{});

var css$8 = ".AlertMessage_module_alert__24f7d546{border-radius:4px;color:#333;font-size:12px;margin-bottom:16px;padding:12px 16px;text-align:center}.AlertMessage_module_alert__24f7d546.AlertMessage_module_alertError__24f7d546{background-color:#f2dede;border:1px solid #ebccd1;color:#a94442}.AlertMessage_module_alert__24f7d546.AlertMessage_module_alertInfo__24f7d546{background-color:#f5f5f5;border:1px solid #cdcdcd;color:#333}.AlertMessage_module_alert__24f7d546.AlertMessage_module_alertWarning__24f7d546{background-color:#ff9;border:1px solid #8a6d3b;color:#8a6d3b}";
var modules_e536257d = {"alert":"AlertMessage_module_alert__24f7d546","alert-error":"AlertMessage_module_alertError__24f7d546","alert-info":"AlertMessage_module_alertInfo__24f7d546","alert-warning":"AlertMessage_module_alertWarning__24f7d546"};
n(css$8,{});

var _excluded$4 = ["children", "className", "type"];
var AlertMessage = function AlertMessage(_ref) {
  var children = _ref.children,
    className = _ref.className,
    type = _ref.type,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$4);
  return React__default.createElement("div", Object.assign({
    className: classNames(modules_e536257d.alert, modules_e536257d["alert-" + type], className),
    role: "alert"
  }, props), children);
};

var _excluded$5 = ["ref"],
  _excluded2$1 = ["video"],
  _excluded3 = ["video"];
var attributes = {
  controlsList: 'nodownload noremoteplayback noplaybackrate',
  disablePictureInPicture: true
};
var VideoPlayer = /*#__PURE__*/memo(function (_ref) {
  var _video$sizes$medium;
  var video = _ref.video,
    className = _ref.className,
    videoStyle = _ref.videoStyle,
    progressBarStyle = _ref.progressBarStyle,
    progressBarValueStyle = _ref.progressBarValueStyle,
    _ref$showCustomProgre = _ref.showCustomProgressBar,
    showCustomProgressBar = _ref$showCustomProgre === void 0 ? false : _ref$showCustomProgre,
    width = _ref.width,
    height = _ref.height,
    _ref$autoplay = _ref.autoplay,
    autoplay = _ref$autoplay === void 0 ? false : _ref$autoplay,
    _ref$muted = _ref.muted,
    muted = _ref$muted === void 0 ? false : _ref$muted,
    _ref$controls = _ref.controls,
    controls = _ref$controls === void 0 ? true : _ref$controls,
    customControls = _ref.customControls,
    _ref$allowFullScreen = _ref.allowFullScreen,
    allowFullScreen = _ref$allowFullScreen === void 0 ? true : _ref$allowFullScreen,
    _ref$allowFullScreenC = _ref.allowFullScreenControls,
    allowFullScreenControls = _ref$allowFullScreenC === void 0 ? true : _ref$allowFullScreenC;
  var _useState = useState(true),
    hasInitialAutoplayMute = _useState[0],
    setHasInitialAutoplayMute = _useState[1];
  var _useState2 = useState(false),
    isFullscreen = _useState2[0],
    setIsFullscreen = _useState2[1];
  var _usePostPreview = usePostPreview(),
    _usePostPreview$video = _usePostPreview.videoPlayer,
    ref = _usePostPreview$video.ref,
    videoElement = _objectWithoutPropertiesLoose(_usePostPreview$video, _excluded$5);
  var _useState3 = useState(0),
    progressPercent = _useState3[0],
    setProgressPercent = _useState3[1];
  var reactPlayer = useRef(null);
  var _useState4 = useState((customControls == null ? void 0 : customControls.isPlaying) || autoplay),
    isPlaying = _useState4[0],
    setIsPlaying = _useState4[1];
  var _useState5 = useState(false),
    canBeThumbShown = _useState5[0],
    setCanBeThumbShown = _useState5[1];
  useImperativeHandle(ref, function () {
    return {
      play: play,
      pause: pause,
      toggle: toggle,
      player: reactPlayer == null ? void 0 : reactPlayer.current,
      hideThumbnail: hideThumbnail
    };
  });
  function play() {
    setIsPlaying(true);
    customControls == null ? void 0 : customControls.play == null ? void 0 : customControls.play();
    hideThumbnail();
  }
  function pause() {
    setIsPlaying(false);
    customControls == null ? void 0 : customControls.pause == null ? void 0 : customControls.pause();
  }
  var toggle = useCallback(function () {
    if (isPlaying) {
      pause();
    } else {
      play();
    }
  }, [isPlaying, play, pause]);
  function onProgress(_ref2) {
    var played = _ref2.played;
    setCanBeThumbShown(played === 0);
    setProgressPercent(played * 100);
  }
  function hideThumbnail() {
    setCanBeThumbShown(false);
  }
  function onVideoReady() {
    var _reactPlayer$current;
    var player = (_reactPlayer$current = reactPlayer.current) == null ? void 0 : _reactPlayer$current.getInternalPlayer();
    if (!!autoplay && player) {
      player.muted = !hasInitialAutoplayMute ? muted : true;
      player.play();
      setHasInitialAutoplayMute(false);
    }
  }
  var toggleFullScreen = function toggleFullScreen() {
    var _reactPlayer$current2, _reactPlayer$current3, _reactPlayer$current8, _reactPlayer$current9, _reactPlayer$current10, _reactPlayer$current11;
    if (!allowFullScreen) {
      return;
    }
    var hasWebkitSupport = reactPlayer == null ? void 0 : (_reactPlayer$current2 = reactPlayer.current) == null ? void 0 : (_reactPlayer$current3 = _reactPlayer$current2.getInternalPlayer()) == null ? void 0 : _reactPlayer$current3.webkitSupportsFullscreen;
    if (isFullscreen) {
      var _reactPlayer$current4, _reactPlayer$current5, _reactPlayer$current6, _reactPlayer$current7;
      return hasWebkitSupport ? reactPlayer == null ? void 0 : (_reactPlayer$current4 = reactPlayer.current) == null ? void 0 : (_reactPlayer$current5 = _reactPlayer$current4.getInternalPlayer()) == null ? void 0 : _reactPlayer$current5.webkitExitFullScreen() : reactPlayer == null ? void 0 : (_reactPlayer$current6 = reactPlayer.current) == null ? void 0 : (_reactPlayer$current7 = _reactPlayer$current6.getInternalPlayer()) == null ? void 0 : _reactPlayer$current7.exitFullScreen();
    }
    return hasWebkitSupport ? reactPlayer == null ? void 0 : (_reactPlayer$current8 = reactPlayer.current) == null ? void 0 : (_reactPlayer$current9 = _reactPlayer$current8.getInternalPlayer()) == null ? void 0 : _reactPlayer$current9.webkitEnterFullscreen() : reactPlayer == null ? void 0 : (_reactPlayer$current10 = reactPlayer.current) == null ? void 0 : (_reactPlayer$current11 = _reactPlayer$current10.getInternalPlayer()) == null ? void 0 : _reactPlayer$current11.requestFullscreen();
  };
  useEffect(function () {
    function checkFullscreen() {
      var _reactPlayer$current12;
      setIsFullscreen(document.fullscreenElement === (reactPlayer == null ? void 0 : (_reactPlayer$current12 = reactPlayer.current) == null ? void 0 : _reactPlayer$current12.getInternalPlayer()));
    }
    document.addEventListener('fullscreenchange', checkFullscreen);
    document.addEventListener('webkitfullscreenchange', checkFullscreen);
    return function () {
      document.removeEventListener('fullscreenchange', checkFullscreen);
      document.removeEventListener('webkitfullscreenchange', checkFullscreen);
    };
  }, []);
  useEffect(function () {
    if (customControls != null && customControls.isPlaying) {
      play();
    } else {
      pause();
    }
  }, [customControls == null ? void 0 : customControls.isPlaying]);
  if (video.status === VIDEO_STATUS.AVAILABLE && (_video$sizes$medium = video.sizes.medium) != null && _video$sizes$medium.src) {
    var _video$custom_thumb, _video$original_thumb, _video$custom_thumb$s, _video$custom_thumb2, _video$original_thumb2;
    return React__default.createElement("div", {
      className: classNames(modules_7d7d7f29.playerWrapper, className),
      onClick: !controls && !isFullscreen ? toggle : undefined,
      onDoubleClick: !controls ? toggleFullScreen : undefined,
      "data-cy": DATA_CY_NAMES.VIDEO.PLAYER_WRAPPER
    }, React__default.createElement(ReactPlayer, {
      "data-fullscreen-controls": allowFullScreenControls && isFullscreen,
      onReady: onVideoReady,
      muted: muted,
      style: videoStyle,
      playing: isPlaying,
      ref: reactPlayer,
      controls: controls,
      config: {
        attributes: _extends({}, attributes, videoElement)
      },
      url: video.sizes.medium.src,
      width: width != null ? width : '100%',
      height: height != null ? height : 'auto',
      pip: false,
      onPause: pause,
      onPlay: play,
      onProgress: onProgress
    }), (((_video$custom_thumb = video.custom_thumb) == null ? void 0 : _video$custom_thumb.src) || ((_video$original_thumb = video.original_thumb) == null ? void 0 : _video$original_thumb.src)) && canBeThumbShown && React__default.createElement("div", {
      "data-cy": DATA_CY_NAMES.VIDEO.THUMB,
      className: modules_7d7d7f29.thumbnail,
      onClick: function onClick(e) {
        e.stopPropagation();
        play();
      },
      style: {
        backgroundImage: "url('" + ((_video$custom_thumb$s = (_video$custom_thumb2 = video.custom_thumb) == null ? void 0 : _video$custom_thumb2.src) != null ? _video$custom_thumb$s : (_video$original_thumb2 = video.original_thumb) == null ? void 0 : _video$original_thumb2.src) + "')"
      }
    }), React__default.createElement("div", {
      onClick: function onClick(e) {
        play();
        e.stopPropagation();
      },
      className: modules_7d7d7f29.playbackIcon,
      "data-visible": !isPlaying
    }, React__default.createElement(Icon, {
      icon: faPlay,
      size: 75
    })), !controls && React__default.createElement("div", {
      onClick: function onClick(e) {
        pause();
        e.stopPropagation();
      },
      className: modules_7d7d7f29.playbackIcon,
      "data-visible-on-player-hover": isPlaying
    }, React__default.createElement(Icon, {
      icon: faPause,
      size: 75
    })), showCustomProgressBar && React__default.createElement("div", {
      className: classNames(modules_7d7d7f29.playerProgressBar),
      style: progressBarStyle
    }, React__default.createElement("div", {
      style: _extends({
        width: progressPercent + "%"
      }, progressBarValueStyle),
      className: classNames(modules_7d7d7f29.playerProgressBarValue)
    })));
  }
  var isProcessing = video.status === VIDEO_STATUS.QUEUED || video.status === VIDEO_STATUS.UPLOADING;
  return React__default.createElement("div", {
    className: classNames(modules_7d7d7f29.mockedVideoPlayer, className),
    style: videoStyle
  }, isProcessing ? React__default.createElement(AlertMessage, {
    type: "info",
    className: modules_7d7d7f29.alertMessage
  }, "Video is being processed. ", React__default.createElement("br", null), "It will be available in a while.") : React__default.createElement(AlertMessage, {
    type: "error",
    className: modules_7d7d7f29.alertMessage
  }, "We were unable to show video. ", React__default.createElement("br", null), "Please try again later."));
}, function (_ref3, _ref4) {
  var prevVideo = _ref3.video,
    prevProps = _objectWithoutPropertiesLoose(_ref3, _excluded2$1);
  var nextVideo = _ref4.video,
    nextProps = _objectWithoutPropertiesLoose(_ref4, _excluded3);
  return isEqual(_extends({
    video: getVideoDependencies(prevVideo)
  }, prevProps), _extends({
    video: getVideoDependencies(nextVideo)
  }, nextProps));
});
function getVideoDependencies(video) {
  var _video$sizes$medium2, _video$original_thumb3, _video$custom_thumb3;
  function getCleanUrl(value) {
    try {
      var url = new URL(value != null ? value : '');
      return url.hostname + url.pathname;
    } catch (e) {
      return '';
    }
  }
  return {
    status: video.status,
    src: getCleanUrl((_video$sizes$medium2 = video.sizes.medium) == null ? void 0 : _video$sizes$medium2.src),
    originalThumb: getCleanUrl((_video$original_thumb3 = video.original_thumb) == null ? void 0 : _video$original_thumb3.src),
    customThumb: getCleanUrl((_video$custom_thumb3 = video.custom_thumb) == null ? void 0 : _video$custom_thumb3.src)
  };
}

var Post = function Post(_ref) {
  var content = _ref.content,
    use12hourFormat = _ref.use12hourFormat,
    formatDateTime = _ref.formatDateTime,
    style = _ref.style,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var attachments = getSegmentedAttachments(content);
  return React__default.createElement(PostWrapper, {
    style: style,
    variant: "desktop",
    contentType: content.type
  }, React__default.createElement(Header, {
    content: content,
    use12hourFormat: use12hourFormat,
    formatDateTime: formatDateTime,
    onEditDateTimeClick: onEditDateTimeClick
  }), React__default.createElement(TextContent, {
    content: content
  }), attachments.hasImages && React__default.createElement(ImageGallery, {
    images: attachments.images
  }), !attachments.hasImages && attachments.hasVideos && React__default.createElement(VideoPlayer, {
    video: attachments.videos[0].medium
  }), React__default.createElement(Footer, null));
};

var css$9 = ".LinkInfo_module_linkInfo__c725e5bf{align-items:center;background-color:#f0f2f5;border-bottom:1px solid #d7dbe1;display:flex;justify-content:space-between;padding:12px}.LinkInfo_module_linkInfo__c725e5bf .LinkInfo_module_linkDesc__c725e5bf{min-width:0}.LinkInfo_module_linkInfo__c725e5bf .LinkInfo_module_linkDesc__c725e5bf .LinkInfo_module_hostname__c725e5bf{color:#7a869a;font-size:12px;min-width:0;overflow:hidden;text-overflow:ellipsis;text-transform:uppercase;white-space:nowrap}.LinkInfo_module_linkInfo__c725e5bf .LinkInfo_module_linkDesc__c725e5bf .LinkInfo_module_title__c725e5bf{font-size:16px;font-weight:600;margin-top:2px;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.LinkInfo_module_linkInfo__c725e5bf .LinkInfo_module_linkDesc__c725e5bf .LinkInfo_module_desc__c725e5bf{color:#7a869a;font-size:14px;margin-top:2px;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.LinkInfo_module_linkInfo__c725e5bf .LinkInfo_module_linkCta__c725e5bf{background-color:#e4e6eb;border-radius:6px;color:#444950;flex-shrink:0;font-size:14px;font-weight:600;margin-left:16px;padding:8px 12px}.LinkInfo_module_linkInfo__c725e5bf .LinkInfo_module_linkCta__c725e5bf:hover{background-color:#d8dbe2}[data-preview-variant=mobile] .LinkInfo_module_linkInfo__c725e5bf .LinkInfo_module_linkDesc__c725e5bf .LinkInfo_module_title__c725e5bf{-webkit-box-orient:vertical;-webkit-line-clamp:2;display:-webkit-box;font-size:14px;margin-top:0;white-space:normal}[data-preview-variant=mobile] .LinkInfo_module_linkInfo__c725e5bf .LinkInfo_module_linkCta__c725e5bf{font-size:12px;padding:3px 8px}";
var modules_96605eeb = {"linkInfo":"LinkInfo_module_linkInfo__c725e5bf","linkDesc":"LinkInfo_module_linkDesc__c725e5bf","hostname":"LinkInfo_module_hostname__c725e5bf","title":"LinkInfo_module_title__c725e5bf","desc":"LinkInfo_module_desc__c725e5bf","linkCta":"LinkInfo_module_linkCta__c725e5bf"};
n(css$9,{});

var LinkInfo = function LinkInfo(_ref) {
  var _link$title;
  var link = _ref.link;
  return React__default.createElement("div", {
    className: modules_96605eeb.linkInfo
  }, React__default.createElement("div", {
    className: modules_96605eeb.linkDesc
  }, link.url && React__default.createElement("div", {
    className: modules_96605eeb.hostname
  }, getHostnameFromUrl(link.url)), React__default.createElement("div", {
    className: modules_96605eeb.title
  }, (_link$title = link.title) != null ? _link$title : '*Title is required'), link.description && React__default.createElement("div", {
    className: modules_96605eeb.desc
  }, link.description)), link.call_to_action && React__default.createElement("div", {
    className: modules_96605eeb.linkCta
  }, CTA_DATA[link.call_to_action]));
};

var css$a = ".LinkPost_module_link__f508f25c{color:inherit;text-decoration:none}.LinkPost_module_link__f508f25c:visited{color:inherit}";
var modules_0c03f802 = {"link":"LinkPost_module_link__f508f25c"};
n(css$a,{});

var LinkPost = function LinkPost(_ref) {
  var content = _ref.content,
    use12hourFormat = _ref.use12hourFormat,
    formatDateTime = _ref.formatDateTime,
    style = _ref.style,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var attachments = getSegmentedAttachments(content);
  var linkAttachment = attachments.all[0];
  return React__default.createElement(PostWrapper, {
    style: style,
    variant: "desktop",
    contentType: content.type
  }, React__default.createElement(Header, {
    content: content,
    use12hourFormat: use12hourFormat,
    formatDateTime: formatDateTime,
    onEditDateTimeClick: onEditDateTimeClick
  }), React__default.createElement(TextContent, {
    content: content
  }), linkAttachment && React__default.createElement(ExternalLink, {
    href: linkAttachment == null ? void 0 : linkAttachment.url,
    className: modules_0c03f802.link
  }, React__default.createElement(React__default.Fragment, null, attachments.hasImages && React__default.createElement(ImageGallery, {
    images: attachments.images,
    lightboxEnabled: false
  }), !attachments.hasImages && attachments.hasVideos && React__default.createElement(VideoPlayer, {
    video: attachments.videos[0].medium
  }), React__default.createElement(LinkInfo, {
    link: linkAttachment
  }))), React__default.createElement(Footer, null));
};

var css$b = ".Carousel_module_carousel__dcba0c9b{height:0;padding-bottom:77%;position:relative;width:100%}.Carousel_module_carousel__dcba0c9b:hover .slider-slide:not(.slide-current){opacity:.6}.Carousel_module_carousel__dcba0c9b .Carousel_module_arrow__dcba0c9b{align-items:center;background-color:#fff;border:1px solid rgba(0,0,0,.1);border-radius:50%;cursor:pointer;display:flex;height:48px;justify-content:center;margin:8px;transition:background-color 199ms cubic-bezier(0,0,.21,1.11);width:48px}.Carousel_module_carousel__dcba0c9b .Carousel_module_arrow__dcba0c9b:hover{background-color:#f6faf6}.Carousel_module_carousel__dcba0c9b .Carousel_module_arrow__dcba0c9b svg{color:#65676b}.Carousel_module_carousel__dcba0c9b .Carousel_module_aspectRatio__dcba0c9b{height:100%;left:0;position:absolute;top:0;width:100%}.Carousel_module_carousel__dcba0c9b .Carousel_module_pagingDots__dcba0c9b{display:flex;left:50%;position:absolute;top:calc(100% + 15px);transform:translateX(-50%);z-index:1}.Carousel_module_carousel__dcba0c9b .Carousel_module_pagingDots__dcba0c9b .Carousel_module_dot__dcba0c9b{background-color:rgba(0,0,0,.3);border-radius:50%;cursor:pointer;height:6px;width:6px}.Carousel_module_carousel__dcba0c9b .Carousel_module_pagingDots__dcba0c9b .Carousel_module_dot__dcba0c9b+.Carousel_module_dot__dcba0c9b{margin-left:4px}.Carousel_module_carousel__dcba0c9b .Carousel_module_pagingDots__dcba0c9b .Carousel_module_dot__dcba0c9b.Carousel_module_active__dcba0c9b{background-color:#0095f6}[data-preview-variant=mobile] .Carousel_module_carousel__dcba0c9b .Carousel_module_arrow__dcba0c9b{height:38px;width:38px}";
var modules_794cd056 = {"carousel":"Carousel_module_carousel__dcba0c9b","arrow":"Carousel_module_arrow__dcba0c9b","aspectRatio":"Carousel_module_aspectRatio__dcba0c9b","pagingDots":"Carousel_module_pagingDots__dcba0c9b","dot":"Carousel_module_dot__dcba0c9b","active":"Carousel_module_active__dcba0c9b"};
n(css$b,{});

var css$c = ".CarouselItem_module_item__635cb03d{border:1px solid #d7dbe1;border-radius:max(0px,min(8px,(100vw - 4px - 100%) * 9999))/8px;color:#181b1f;display:flex;flex-direction:column;text-decoration:none}.CarouselItem_module_item__635cb03d:visited{color:#181b1f}.CarouselItem_module_item__635cb03d .CarouselItem_module_aspectRatio__635cb03d{display:flex;height:0;padding-bottom:100%;position:relative;width:100%}.CarouselItem_module_item__635cb03d .CarouselItem_module_aspectRatio__635cb03d .CarouselItem_module_image__635cb03d{background-position:50%;background-size:cover;border-radius:max(0px,min(8px,(100vw - 4px - 100%) * 9999))/8px;border-bottom-left-radius:0;border-bottom-right-radius:0;height:100%;left:0;position:absolute;top:0;width:100%}.CarouselItem_module_item__635cb03d .CarouselItem_module_aspectRatio__635cb03d .CarouselItem_module_pageImage__635cb03d{align-items:center;border-radius:0;display:flex;font-size:34px!important;height:50%!important;justify-content:center;left:50%;top:50%;transform:translate(-50%,-50%);width:50%!important}.CarouselItem_module_item__635cb03d .CarouselItem_module_aspectRatio__635cb03d .CarouselItem_module_pageImage__635cb03d:before{display:none}";
var modules_ee2c7f53 = {"item":"CarouselItem_module_item__635cb03d","aspectRatio":"CarouselItem_module_aspectRatio__635cb03d","image":"CarouselItem_module_image__635cb03d","pageImage":"CarouselItem_module_pageImage__635cb03d"};
n(css$c,{});

var css$d = ".LinkInfo_module_linkInfo__f4c3ccba{container-type:inline-size;align-items:center;border-top:1px solid #d7dbe1;display:flex;flex:1;padding:0 12px}.LinkInfo_module_linkInfo__f4c3ccba .LinkInfo_module_linkDesc__f4c3ccba{flex:1;font-size:14px;min-width:0}.LinkInfo_module_linkInfo__f4c3ccba .LinkInfo_module_linkDesc__f4c3ccba .LinkInfo_module_title__f4c3ccba{-webkit-box-orient:vertical;-webkit-line-clamp:2;display:-webkit-box;font-size:16px;font-weight:600;margin-top:2px;overflow:hidden;word-break:break-word}.LinkInfo_module_linkInfo__f4c3ccba .LinkInfo_module_linkDesc__f4c3ccba .LinkInfo_module_desc__f4c3ccba{color:#7a869a;font-size:14px;margin-top:2px;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;word-break:break-word}.LinkInfo_module_linkInfo__f4c3ccba .LinkInfo_module_linkCta__f4c3ccba{background-color:#e4e6eb;border-radius:6px;color:#444950;flex-shrink:0;font-size:14px;font-weight:600;margin-left:4px;padding:8px 12px}.LinkInfo_module_linkInfo__f4c3ccba .LinkInfo_module_linkCta__f4c3ccba:hover{background-color:#d8dbe2}[data-preview-variant=mobile] .LinkInfo_module_linkInfo__f4c3ccba .LinkInfo_module_linkDesc__f4c3ccba .LinkInfo_module_desc__f4c3ccba,[data-preview-variant=mobile] .LinkInfo_module_linkInfo__f4c3ccba .LinkInfo_module_linkDesc__f4c3ccba .LinkInfo_module_title__f4c3ccba{font-size:12px}[data-preview-variant=mobile] .LinkInfo_module_linkInfo__f4c3ccba .LinkInfo_module_linkCta__f4c3ccba{font-size:10px;padding:6px 10px}@container (max-width: 280px){.LinkInfo_module_linkInfo__f4c3ccba .LinkInfo_module_linkDesc__f4c3ccba .LinkInfo_module_desc__f4c3ccba,.LinkInfo_module_linkInfo__f4c3ccba .LinkInfo_module_linkDesc__f4c3ccba .LinkInfo_module_title__f4c3ccba{-webkit-line-clamp:1;font-size:12px}.LinkInfo_module_linkInfo__f4c3ccba .LinkInfo_module_linkCta__f4c3ccba{font-size:10px;padding:6px 10px}}";
var modules_96605eeb$1 = {"linkInfo":"LinkInfo_module_linkInfo__f4c3ccba","linkDesc":"LinkInfo_module_linkDesc__f4c3ccba","title":"LinkInfo_module_title__f4c3ccba","desc":"LinkInfo_module_desc__f4c3ccba","linkCta":"LinkInfo_module_linkCta__f4c3ccba"};
n(css$d,{});

var LinkInfo$1 = function LinkInfo(_ref) {
  var _link$title;
  var link = _ref.link;
  return React__default.createElement("div", {
    className: modules_96605eeb$1.linkInfo
  }, React__default.createElement("div", {
    className: modules_96605eeb$1.linkDesc
  }, React__default.createElement("div", {
    className: modules_96605eeb$1.title
  }, (_link$title = link.title) != null ? _link$title : '*Title is required'), link.description && React__default.createElement("div", {
    className: modules_96605eeb$1.desc
  }, link.description)), link.call_to_action && React__default.createElement("div", {
    className: modules_96605eeb$1.linkCta
  }, CTA_DATA[link.call_to_action]));
};

var CarouselItem = function CarouselItem(_ref) {
  var attachment = _ref.attachment,
    style = _ref.style;
  function getSrc() {
    var _attachment$medium, _attachment$medium2;
    if (((_attachment$medium = attachment.medium) == null ? void 0 : _attachment$medium.type) === 'video') {
      var _attachment$medium$or;
      return (_attachment$medium$or = attachment.medium.original_thumb) == null ? void 0 : _attachment$medium$or.src;
    }
    if (((_attachment$medium2 = attachment.medium) == null ? void 0 : _attachment$medium2.type) === 'image') {
      var _attachment$medium$si, _attachment$medium$si2;
      return (_attachment$medium$si = attachment.medium.sizes) == null ? void 0 : (_attachment$medium$si2 = _attachment$medium$si.lightbox) == null ? void 0 : _attachment$medium$si2.src;
    }
    return undefined;
  }
  var src = getSrc();
  return React__default.createElement(ExternalLink, {
    href: attachment.url,
    className: modules_ee2c7f53.item,
    style: style,
    "data-cy": DATA_CY_NAMES.CAROUSEL.GALLERY_ITEM
  }, React__default.createElement("div", {
    className: modules_ee2c7f53.aspectRatio
  }, src && React__default.createElement("div", {
    "data-cy": DATA_CY_NAMES.CAROUSEL.GALLERY_IMAGE,
    className: modules_ee2c7f53.image,
    style: {
      backgroundImage: "url('" + getSrc() + "')"
    }
  })), React__default.createElement(LinkInfo$1, {
    link: attachment
  }));
};

var FinalCarouselItem = function FinalCarouselItem(_ref) {
  var _page$logo_src;
  var image = _ref.image,
    page = _ref.page,
    style = _ref.style;
  return React__default.createElement(ExternalLink, {
    className: modules_ee2c7f53.item,
    style: style,
    href: image.url
  }, React__default.createElement("div", {
    className: modules_ee2c7f53.aspectRatio
  }, React__default.createElement(Avatar, {
    src: (_page$logo_src = page == null ? void 0 : page.logo_src) != null ? _page$logo_src : undefined,
    className: classNames(modules_ee2c7f53.image, modules_ee2c7f53.pageImage),
    name: page.name,
    color: "blue"
  })), React__default.createElement(LinkInfo$1, {
    link: {
      url: image.url,
      description: '',
      title: "See more at " + getHostnameFromUrl(image.url),
      caption: '',
      call_to_action: null
    }
  }));
};

var Carousel = function Carousel(_ref) {
  var attachments = _ref.attachments,
    page = _ref.page,
    hasMultiShareEndCard = _ref.hasMultiShareEndCard;
  var _useState = useState(0),
    activeSlide = _useState[0],
    setActiveSlide = _useState[1];
  var _useState2 = useState(false),
    carouselShown = _useState2[0],
    setCarouselShown = _useState2[1];
  var ref = useRef(null);
  var _useElementSize = useElementSize(ref),
    height = _useElementSize.height;
  useEffect(function () {
    setCarouselShown(true);
  }, []);
  return React__default.createElement("div", {
    className: modules_794cd056.carousel
  }, React__default.createElement("div", {
    className: modules_794cd056.aspectRatio,
    ref: ref,
    "data-cy": "post-detail_carousel-slider-list"
  }, carouselShown && React__default.createElement(NukaCarousel, {
    cellSpacing: 6,
    cellAlign: activeSlide === 0 ? 'left' : 'center',
    slidesToShow: 1.6,
    slideIndex: activeSlide,
    disableEdgeSwiping: true,
    beforeSlide: function beforeSlide(currentSlide, endSlide) {
      return setActiveSlide(endSlide);
    },
    renderCenterLeftControls: function renderCenterLeftControls(p) {
      return p.currentSlide !== 0 && React__default.createElement("div", {
        className: modules_794cd056.arrow,
        onClick: p.previousSlide,
        "data-cy": DATA_CY_NAMES.CAROUSEL.ARROW.PREVIOUS
      }, React__default.createElement(Icon, {
        icon: faChevronLeft,
        size: 25
      }));
    },
    renderCenterRightControls: function renderCenterRightControls(p) {
      return p.currentSlide !== p.slideCount - 1 && React__default.createElement("div", {
        className: modules_794cd056.arrow,
        onClick: p.nextSlide,
        "data-cy": DATA_CY_NAMES.CAROUSEL.ARROW.NEXT
      }, React__default.createElement(Icon, {
        icon: faChevronRight,
        size: 25
      }));
    },
    renderBottomCenterControls: null
  }, attachments.map(function (linkAttachment, index) {
    return React__default.createElement(CarouselItem, {
      key: index,
      attachment: linkAttachment,
      style: {
        minHeight: height,
        height: '100%'
      }
    });
  }), hasMultiShareEndCard && React__default.createElement(FinalCarouselItem, {
    page: page,
    image: attachments[0],
    style: {
      minHeight: height,
      height: '100%'
    }
  }))));
};

var CarouselPost = function CarouselPost(_ref) {
  var content = _ref.content,
    use12hourFormat = _ref.use12hourFormat,
    formatDateTime = _ref.formatDateTime,
    style = _ref.style,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var attachments = getSegmentedAttachments(content);
  return React__default.createElement(PostWrapper, {
    style: style,
    variant: "desktop",
    contentType: content.type
  }, React__default.createElement(Header, {
    content: content,
    use12hourFormat: use12hourFormat,
    formatDateTime: formatDateTime,
    onEditDateTimeClick: onEditDateTimeClick
  }), React__default.createElement(TextContent, {
    content: content
  }), attachments.hasAll && React__default.createElement(Carousel, {
    page: content.page,
    hasMultiShareEndCard: attachments.hasMultiShareEndCard,
    attachments: attachments.all
  }), React__default.createElement(Footer, null));
};

var css$e = ".Phone_module_phone__5473e0cb{display:flex;flex-direction:column;max-height:766px;max-width:368px;width:100%}.Phone_module_phone__5473e0cb .Phone_module_phoneAspectRatio__5473e0cb{border-radius:16px;height:0;padding-bottom:200%;position:relative;width:100%}.Phone_module_phone__5473e0cb .Phone_module_phoneAspectRatio__5473e0cb .Phone_module_phoneContent__5473e0cb{background-color:#e4e7eb;border-radius:7%;bottom:1.5%;display:flex;flex-direction:column;left:3%;overflow-x:hidden;overflow-y:auto;position:absolute;right:3%;top:1.5%}.Phone_module_phone__5473e0cb .Phone_module_phoneAspectRatio__5473e0cb .Phone_module_phoneContent__5473e0cb.Phone_module_linkedin__5473e0cb{background-color:#f3f2ef}.Phone_module_phone__5473e0cb .Phone_module_phoneAspectRatio__5473e0cb .Phone_module_phoneContent__5473e0cb.Phone_module_facebook__5473e0cb,.Phone_module_phone__5473e0cb .Phone_module_phoneAspectRatio__5473e0cb .Phone_module_phoneContent__5473e0cb.Phone_module_instagram__5473e0cb{background-color:#000}.Phone_module_phone__5473e0cb .Phone_module_phoneAspectRatio__5473e0cb .Phone_module_phoneContent__5473e0cb.Phone_module_twitter__5473e0cb{background-color:#f7f9fa}.Phone_module_phone__5473e0cb .Phone_module_phoneAspectRatio__5473e0cb .Phone_module_phoneContent__5473e0cb.Phone_module_pinterest__5473e0cb{background-color:#111}.Phone_module_phone__5473e0cb .Phone_module_phoneAspectRatio__5473e0cb .Phone_module_phoneHomeButton__5473e0cb{background-color:#000;border-radius:3px;bottom:20px;left:0;margin:auto;padding:2px;position:absolute;right:0;width:40%}.Phone_module_phone__5473e0cb .Phone_module_phoneAspectRatio__5473e0cb .Phone_module_phoneMockup__5473e0cb{background:url(\"data:image/png;base64,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\") no-repeat 50%;background-size:contain;height:100%;left:0;pointer-events:none;position:absolute;top:0;width:100%;z-index:1}";
var modules_88d8794f = {"phone":"Phone_module_phone__5473e0cb","phoneAspectRatio":"Phone_module_phoneAspectRatio__5473e0cb","phoneContent":"Phone_module_phoneContent__5473e0cb","linkedin":"Phone_module_linkedin__5473e0cb","instagram":"Phone_module_instagram__5473e0cb","facebook":"Phone_module_facebook__5473e0cb","twitter":"Phone_module_twitter__5473e0cb","pinterest":"Phone_module_pinterest__5473e0cb","phoneHomeButton":"Phone_module_phoneHomeButton__5473e0cb","phoneMockup":"Phone_module_phoneMockup__5473e0cb"};
n(css$e,{});

var css$f = ".StatusBar_module_statusBar__909c413d{align-items:center;color:#000;display:flex;font-size:11px;justify-content:space-between;padding:8px 10% 6px}";
var modules_030e6198 = {"statusBar":"StatusBar_module_statusBar__909c413d"};
n(css$f,{});

var getCurrentTime = function getCurrentTime() {
  var date = new Date();
  return "2022-12-22 " + date.getHours() + ":" + date.getMinutes() + ":00";
};
var StatusBar = function StatusBar(props) {
  return React__default.createElement("div", {
    className: clsx(modules_030e6198.statusBar, props.className)
  }, React__default.createElement("div", {
    className: "tw-font-medium"
  }, formatTime(getCurrentTime())), React__default.createElement("div", {
    className: "tw-flex tw-gap-1"
  }, React__default.createElement(Icon, {
    size: 12,
    icon: faSignalBars
  }), React__default.createElement(Icon, {
    size: 12,
    icon: faWifi
  }), React__default.createElement(Icon, {
    size: 12,
    icon: faBatteryFull
  })));
};

var _excluded$6 = ["showHomeButton"];
var Phone = function Phone(_ref) {
  var _ref$showHomeButton = _ref.showHomeButton,
    showHomeButton = _ref$showHomeButton === void 0 ? true : _ref$showHomeButton,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$6);
  return React__default.createElement("div", {
    className: modules_88d8794f.phone,
    style: props.style
  }, React__default.createElement("div", {
    className: modules_88d8794f.phoneAspectRatio
  }, React__default.createElement("div", {
    className: classNames(modules_88d8794f.phoneContent, props.contentBackground && modules_88d8794f[props.contentBackground], props.contentClassName)
  }, React__default.createElement(StatusBar, {
    className: props.statusBarClassName
  }), props.children), showHomeButton && React__default.createElement("div", {
    className: modules_88d8794f.phoneHomeButton
  }), React__default.createElement("div", {
    className: modules_88d8794f.phoneMockup
  })));
};

var css$g = ".AppLayout_module_appLayout__f69f2ad2{display:flex;flex-direction:column;height:100%;overflow:hidden}.AppLayout_module_appLayout__f69f2ad2 .AppLayout_module_body__f69f2ad2{flex:1 1 auto;overflow:auto}.AppLayout_module_appLayout__f69f2ad2 .AppLayout_module_footer__f69f2ad2{height:auto;width:100%}";
var modules_11a4dd02 = {"appLayout":"AppLayout_module_appLayout__f69f2ad2","body":"AppLayout_module_body__f69f2ad2","footer":"AppLayout_module_footer__f69f2ad2"};
n(css$g,{});

var css$h = ".Footer_module_footer__27322241{background-color:#fff;border-top:1px solid #dbdbdb;color:#000;display:flex;height:auto;justify-content:space-between;padding:12px 24px 33.5px;position:relative;width:100%}.Footer_module_footer__27322241 .Footer_module_homeIcon__27322241{position:relative}.Footer_module_footer__27322241 .Footer_module_homeIcon__27322241:before{background-color:#1778f2;content:\"\";height:2px;left:-13px;position:absolute;top:-13px;width:47px}";
var modules_93eb7477$1 = {"footer":"Footer_module_footer__27322241","homeIcon":"Footer_module_homeIcon__27322241"};
n(css$h,{});

var HomeIcon = function HomeIcon() {
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    fill: "none"
  }, createElement("path", {
    fill: "#1778F2",
    fillRule: "evenodd",
    d: "m22.964 10.29-9.593-8.526a1.834 1.834 0 0 0-2.437 0L1.34 10.29a.459.459 0 0 0 .305.801h21.013c.422 0 .62-.521.305-.801Zm-3.003.803v7.709a1.834 1.834 0 0 1-1.835 1.835h-2.454a.917.917 0 0 1-.917-.918v-5.106a.917.917 0 0 0-.917-.918H10.9a.917.917 0 0 0-.917.918v5.106c0 .507-.41.918-.917.918H6.178a1.834 1.834 0 0 1-1.835-1.835v-7.71h15.618Z",
    clipRule: "evenodd"
  }), createElement("path", {
    fill: "#1778F2",
    d: "m13.371 1.764.305-.343-.305.343Zm9.593 8.527.305-.343-.305.343Zm-12.03-8.527-.305-.343.305.343ZM1.34 10.29l-.305-.343.305.343Zm18.62.801h.459v-.458h-.46v.458Zm-15.618 0v-.458h-.458v.458h.458Zm8.723-8.985 9.593 8.526.61-.685-9.593-8.527-.61.686Zm-1.828 0a1.376 1.376 0 0 1 1.829 0l.609-.686a2.293 2.293 0 0 0-3.047 0l.61.686Zm-9.592 8.526 9.592-8.526-.609-.686-9.593 8.527.61.685Zm0 0-.61-.685c-.63.56-.234 1.603.61 1.603v-.918Zm21.013 0H1.646v.918h21.013v-.918Zm0 0v.918c.844 0 1.24-1.043.61-1.603l-.61.685Zm-2.24 8.169v-7.71h-.917v7.71h.918Zm-2.293 2.293a2.293 2.293 0 0 0 2.293-2.293h-.917c0 .76-.616 1.376-1.376 1.376v.917Zm-2.454 0h2.454v-.917h-2.454v.917Zm-1.376-1.376c0 .76.616 1.376 1.376 1.376v-.917a.459.459 0 0 1-.458-.459h-.918Zm0-5.106v5.106h.918v-5.106h-.918Zm-.458-.459c.253 0 .458.205.458.459h.918c0-.76-.616-1.376-1.376-1.376v.917Zm-2.938 0h2.938v-.917H10.9v.917Zm-.458.459c0-.254.205-.459.458-.459v-.917c-.76 0-1.376.616-1.376 1.376h.918Zm0 5.106v-5.106h-.918v5.106h.918Zm-1.376 1.376c.76 0 1.376-.616 1.376-1.376h-.918a.459.459 0 0 1-.458.459v.917Zm-2.888 0h2.888v-.917H6.178v.917Zm-2.293-2.293a2.293 2.293 0 0 0 2.293 2.293v-.917c-.76 0-1.376-.616-1.376-1.376h-.917Zm0-7.71v7.71h.917v-7.71h-.917Zm16.076-.458H4.343v.917h15.618v-.917Z"
  }));
};

var FriendsIcon = function FriendsIcon() {
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 19,
    fill: "none"
  }, createElement("path", {
    stroke: "#7A869A",
    strokeLinecap: "round",
    strokeWidth: 1.376,
    d: "M16.384 16.413h5.147c.882 0 1.648-.634 1.605-1.514-.03-.627-.152-1.353-.486-1.98-1.16-2.178-3.433-2.716-5.615-2.716-1.446 0-2.897.115-4.08.795"
  }), createElement("path", {
    stroke: "#7A869A",
    strokeLinecap: "round",
    strokeWidth: 1.376,
    d: "M14.598 17.846H2.748c-.844 0-1.583-.58-1.633-1.422-.059-.99.022-2.313.658-3.353 1.557-2.548 4.255-2.868 6.94-2.868 2.686 0 5.484.662 6.912 3.344.474.89.601 1.945.608 2.786.006.882-.753 1.513-1.635 1.513Z"
  }), createElement("path", {
    stroke: "#7A869A",
    strokeWidth: 1.376,
    d: "M19.177 5.057c0 1.523-.929 2.617-2.135 2.617-1.205 0-2.134-1.094-2.134-2.617 0-.747.222-1.343.575-1.741.344-.39.856-.644 1.56-.644.703 0 1.215.254 1.56.644.352.398.574.994.574 1.741ZM11.274 3.885c0 2.03-1.346 3.605-2.86 3.605-1.513 0-2.859-1.574-2.859-3.605 0-.997.296-1.797.776-2.338C6.802 1.014 7.496.68 8.415.68c.918 0 1.612.334 2.084.867.48.54.775 1.341.775 2.338Z"
  }));
};

var VideosIcon = function VideosIcon() {
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 21,
    fill: "none"
  }, createElement("rect", {
    width: 20.638,
    height: 16.052,
    x: 1.535,
    y: 1.45,
    stroke: "#7A869A",
    strokeWidth: 1.376,
    rx: 2.522
  }), createElement("path", {
    fill: "#7A869A",
    d: "M15.358 8.498 10.215 5.55c-.295-.163-.655-.163-.917 0-.295.164-.459.492-.459.82v5.929c0 .327.164.655.459.819.13.098.295.13.459.13a.752.752 0 0 0 .458-.13l5.143-2.949c.295-.164.459-.49.459-.819 0-.327-.197-.688-.459-.851Z"
  }), createElement("path", {
    stroke: "#7A869A",
    strokeLinecap: "round",
    strokeWidth: 1.376,
    d: "M6.35 20.024h11.007"
  }));
};

var NotificationIcon = function NotificationIcon() {
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 23,
    fill: "none"
  }, createElement("path", {
    fill: "#7A869A",
    stroke: "#7A869A",
    strokeWidth: 0.138,
    d: "m19.64 12.986-2.345-2.32v-.001c-.576-.576-.985-1.345-1.154-2.26v-.001c-.37-1.924-1.455-3.553-3.109-4.614a7.44 7.44 0 0 0-2.559-1.025 2.425 2.425 0 0 0-.04-.317l-.009-.053C10.173 1.011 8.816.108 7.437.36 6.054.61 5.15 1.967 5.402 3.347a2.059 2.059 0 0 0 .107.374 7.126 7.126 0 0 0-3.308 5.324c-.074.69-.05 1.358.098 2.025.169.843.096 1.633-.239 2.351v.002l-1.32 2.98a2.535 2.535 0 0 0 .326 2.587c.478.628 1.207.98 1.985.98.153 0 .305-.026.45-.05h.002l1.136-.209a3.698 3.698 0 0 0 3.543 2.653c.225 0 .449-.025.697-.075a3.675 3.675 0 0 0 2.365-1.543 3.58 3.58 0 0 0 .627-2.328l6.438-1.137a2.515 2.515 0 0 0 1.96-1.734 2.55 2.55 0 0 0-.49-2.41l.016.002-.154-.153ZM7.555 2.828c-.283.071-.543.164-.798.257-.064-.315.005-.609.187-.884a1.26 1.26 0 0 1 .765-.51c.321-.068.62 0 .899.186.254.184.437.436.507.754-.52.006-1.04.08-1.558.197h-.002ZM1.99 16.948l1.32-2.981a5.281 5.281 0 0 0 .322-3.168 6.07 6.07 0 0 1-.073-1.618c.242-2.415 1.98-4.442 4.297-4.997h.001c.458-.121.916-.17 1.376-.17 1.086 0 2.148.314 3.065.918a5.584 5.584 0 0 1 2.511 3.742c.222 1.16.741 2.2 1.534 2.968l2.346 2.321c.299.3.415.737.276 1.176a1.19 1.19 0 0 1-.9.81L3.26 18.586c-.44.069-.855-.092-1.133-.44l-.053.043.053-.043c-.276-.345-.323-.781-.137-1.2Zm8.114 3.036a2.296 2.296 0 0 1-1.495.973 2.358 2.358 0 0 1-2.633-1.491l4.534-.803c.006.468-.136.915-.406 1.321Z"
  }));
};

var MenuIcon = function MenuIcon() {
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 18,
    fill: "none"
  }, createElement("path", {
    stroke: "#7A869A",
    strokeLinecap: "round",
    strokeWidth: 1.376,
    d: "M1.342 1.597h18.344M1.342 9.852h18.344M1.342 17.19h18.344"
  }));
};

var Footer$1 = function Footer(_ref) {
  var className = _ref.className;
  return React__default.createElement("div", {
    className: classNames(modules_93eb7477$1.footer, className)
  }, React__default.createElement("div", {
    className: classNames(modules_93eb7477$1.icon, modules_93eb7477$1.homeIcon)
  }, React__default.createElement(HomeIcon, null)), React__default.createElement("div", {
    className: modules_93eb7477$1.icon
  }, React__default.createElement(FriendsIcon, null)), React__default.createElement("div", {
    className: modules_93eb7477$1.icon
  }, React__default.createElement(VideosIcon, null)), React__default.createElement("div", {
    className: modules_93eb7477$1.icon
  }, React__default.createElement(NotificationIcon, null)), React__default.createElement("div", {
    className: modules_93eb7477$1.icon
  }, React__default.createElement(MenuIcon, null)));
};

var AppLayout = function AppLayout(props) {
  return React__default.createElement("div", {
    className: modules_11a4dd02.appLayout
  }, React__default.createElement("div", {
    className: modules_11a4dd02.body
  }, props.children), React__default.createElement(Footer$1, null));
};

var css$i = ".MobilePost_module_statusBar__dc0f69e3{background-color:#fff}";
var modules_813dec30 = {"statusBar":"MobilePost_module_statusBar__dc0f69e3"};
n(css$i,{});

var MobilePost = function MobilePost(_ref) {
  var content = _ref.content,
    use12hourFormat = _ref.use12hourFormat,
    formatDateTime = _ref.formatDateTime,
    style = _ref.style,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var attachments = getSegmentedAttachments(content);
  return React__default.createElement(Phone, {
    statusBarClassName: modules_813dec30.statusBar,
    style: style
  }, React__default.createElement(AppLayout, null, React__default.createElement(PostWrapper, {
    variant: "mobile",
    contentType: content.type
  }, React__default.createElement(Header, {
    content: content,
    use12hourFormat: use12hourFormat,
    formatDateTime: formatDateTime,
    onEditDateTimeClick: onEditDateTimeClick
  }), React__default.createElement(TextContent, {
    content: content,
    variant: "mobile"
  }), attachments.hasImages && React__default.createElement(ImageGallery, {
    images: attachments.images
  }), !attachments.hasImages && attachments.hasVideos && React__default.createElement(VideoPlayer, {
    video: attachments.videos[0].medium
  }), React__default.createElement(Footer, null))));
};

var MobileLinkPost = function MobileLinkPost(_ref) {
  var content = _ref.content,
    use12hourFormat = _ref.use12hourFormat,
    formatDateTime = _ref.formatDateTime,
    style = _ref.style,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var attachments = getSegmentedAttachments(content);
  var linkAttachment = attachments.all[0];
  return React__default.createElement(Phone, {
    statusBarClassName: modules_813dec30.statusBar,
    style: style
  }, React__default.createElement(AppLayout, null, React__default.createElement(PostWrapper, {
    variant: "mobile",
    contentType: content.type
  }, React__default.createElement(Header, {
    content: content,
    use12hourFormat: use12hourFormat,
    formatDateTime: formatDateTime,
    onEditDateTimeClick: onEditDateTimeClick
  }), React__default.createElement(TextContent, {
    content: content
  }), linkAttachment && React__default.createElement(ExternalLink, {
    href: linkAttachment.url,
    className: modules_0c03f802.link
  }, attachments.hasImages && React__default.createElement(ImageGallery, {
    images: attachments.images
  }), !attachments.hasImages && attachments.hasVideos && React__default.createElement(VideoPlayer, {
    video: attachments.videos[0].medium
  }), React__default.createElement(LinkInfo, {
    link: linkAttachment
  })), React__default.createElement(Footer, null))));
};

var MobileCarouselPost = function MobileCarouselPost(_ref) {
  var content = _ref.content,
    use12hourFormat = _ref.use12hourFormat,
    formatDateTime = _ref.formatDateTime,
    style = _ref.style,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var attachments = getSegmentedAttachments(content);
  return React__default.createElement(Phone, {
    statusBarClassName: modules_813dec30.statusBar,
    style: style
  }, React__default.createElement(AppLayout, null, React__default.createElement(PostWrapper, {
    variant: "mobile",
    contentType: content.type
  }, React__default.createElement(Header, {
    content: content,
    use12hourFormat: use12hourFormat,
    formatDateTime: formatDateTime,
    onEditDateTimeClick: onEditDateTimeClick
  }), React__default.createElement(TextContent, {
    content: content
  }), attachments.hasAll && React__default.createElement(Carousel, {
    page: content.page,
    hasMultiShareEndCard: attachments.hasMultiShareEndCard,
    attachments: attachments.all
  }), React__default.createElement(Footer, null))));
};

var css$j = ".ReelControls_module_hyperText__dd8ca194.ReelControls_module_hyperText__dd8ca194 a{color:currentColor;opacity:.7}.ReelControls_module_icons__dd8ca194{bottom:14px;position:absolute;right:14px}";
var modules_81d0b6b6 = {"hyperText":"ReelControls_module_hyperText__dd8ca194","icons":"ReelControls_module_icons__dd8ca194"};
n(css$j,{});

var img$1 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAE+CAYAAACa66AgAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAflSURBVHgB7Z3rkds2EID3PP4fuQLDFUSuILwKog5MVyClgqMruHMFUirQuQKdK9ClAioV6FLBBisugiVISgBIOXG83wyGDzwWAJckHksQ4HsCEY11O+tq69Z0DN8CFkrs0bOAa+ME8z6V/shuFpvGKxjJzc3NwW4+WUdCo0s9WjDzzFsTGyFX8FwII2ZBBi7yGhKx13HOgp6DjJwyEGj4i70ULzAFNuEta3Ehzq1wmHWf0r3uSdjYzRJ89Z1ybt1n6wpoFGhjS/LkPO3+g41HYUyQ3M/Wldb9aV0FF0q0H8h5ze4Y+8Cgy+JKHROYEt8F5zacAAktIRJxWVahX6pWv7PVukkI/xdvfw09krQ6VUNt+NKW9i00utFiqgdIL3zrGesOoV/yfZzIHQv+GHpctcSW34c8riaYX5N3fPg8SjBfs1juoXmUfrJKNk4w+BLE8JW3mz7PVOVa0APGbh/B36N9/ATNvXvg9/VlxGNxJ9yRn0AV+8dwxDPNoZsewSV0XxLEZ3oZcBgDl5nulagoiqIo/y7c/aCeQCXOUW/wzvU2hnoV9B5m/7ThCRthyS/yWvZ7sOn57TnhksMUQVyDvrFQDskYanO9se49+HaTw1j30b7gH7kr88W6D0EYapc9QU8jPhrurK3P+NeyVFwTtSh1ORQ3u11N15p3H8VpatJ+imngZQlmoaV1t65dxedeEnuTgwI6VS202gTnUShkLY5XfWkntau5VJV1t3xswLcmb4PglGFSvkdIJSwx9rMbiHtWuRRFURRFURRFUZT/MDcpgbGZcqeRHJoJd5MlNBv+TOMiMDXoTWzOUXOnPdoI5ZJQN/TkevgPPMhSsFugn1HHvtGCHKF3IsHqXGm4VuSUfso8ZCuhIicRzqAreXq1Y8To3Jm4Dxz3sjVEELHMiujjz4RexJdaaHABmYgqX6VEOtlnwQiEjsTd36ydxA5GwNV9UrI+/6vZCFyawu0T7CKMegIJpTpAjGDOKQWe47jH3zxJMPOFtyXk4wbQv0bHEBpZ55baPYAgFXEv30MG6O3C0jKO7UmNaPsPjjcTj834B8iA8HroScaCSvGYRBGv93lwsQWCzbt1C20tJROaP6AxNCH/AtomkjNo2++9yTbN4BLtsB8q6RrbloukoBuO07nOSW0uTpAScbaZxAEa0xo1NlEURVGUiUG1fGkwoJYvavmili+KoiiKoiiKoijKDwaPAhXwLWGhrgOeZcSQK9gE/eRvI1wI3qKfOb2+cCF4zdV+feHYzBtWUtDVhKMfxzwG13YRhJlOOHZNqyou9Wwgg+OF8zVEvnWiRmNHCxdCt5g4158tHL0R2QYyQWHlFBvBrU5TwwhEjT3ERqg5goFMhNBNbITi3HXB5sFRYrN6UTmJ0CCSEefcPbzDLtVooRyxJm0Ux9K+w1k/rLDHvG6MUGf89cjH90IgPTRmIqyRgrOFcmSnzZVIaIc9Sobtl0S+UE7MKVZ9KSEh+DhKaJAYyus8EHY2iVCRWI2RS2FxRtNm0y4kNo3FsKIoiqJcBX5brdEbnSwC/5LP73HKpWhZIHVhFui7pnMh9GQHwK0XEj7K6N8JNWGbizOy4v2TBYzwo+N0Y+7IjHTMbNhvxjWzhanhqtz2nN+IRmLeVz9nhK5xwKaeSztnHUha8TdWqAnOz7HfEGV8AxCb3sSRtdbIxiD6oSaDvn+FOMEXXuEgmmMt/LfifNJiraPh0hpQFEVRFEVRFEVRJiVn6RXq8dOq+q7zTd9I0EfQT9Gr7KcIxH77gE73FSccbppj+xMTSrzE7tIrMkz6B+09Ql0pL07Xox8HI6K/xA8TMaIUVUI8mdkCUsHUafZ2XDfFmzbVj37so0bMXrJhx2mUKZFWqaXFYBwE/cxs/Ngm9vzRSPjtMFhFgWtoH2ozpi7hggMLTGB7gSHk4w8soD6TjomR60ZoMTg3NOaFQ4mL69zxG/qYzn0gJ0t8z+fpE7J30P4ucejLPflYvQz60diCj90nnyYIRw+MNQ4PrCKm3FLo78Pke7gnjSQDo/TcdtOoZa3FRnKKtIcM0Gt/9qJRD5g4QIreaKXG1FekuA1qcbvQfnkmThHEM+dk9P0JhzRUPm3oVngG/zssOn6C5nai//+8hWZBOKfZ5PcxuTXCVbvjai7EecO32VArZIcJipS89ApnooCmhO7XeLr0iqIoivJ/gd/B99xy2PP+5CaSnG5J+26tCGrU0fv0N2jesdSpprGOW5gWSvP018LX3DYi9979kNGeo+1S5JT8P3C4r27pDWxMLwpomjtLzvxn1+zhWltyvPZvLtHb0G6xx4YD/cjAGpvuK+3fs18p4lYY/OxVXLqKt3RchYnvRAtx7VqJ3PZ6FGGdKbRc1M9ZSSyEn9s3QQFPgk/XmKvmlgMV4H87SteYlhM+jfwElWF4K/+rKNfapNr7Z+yLwtg0Di6yu8YFXTcORC1JSmDLfrR2MSlEOIT0An61wT5e4MwfoF+xJ1Wts1ii3Mr/YT5Z9wvn+sB+64hWJSmoEekuOxnF7r8y91LRsL1671EkVspLgH7cwwTxEP3/OatOFlnJTF/2MdPIJDeeoiiKoiiKoiiKoiiKci3QL569DM4b9CsmmMDvjoeV5pBLMPa1EOfX4rxcpGIhzp81tbm0mvPQYHnMvHP+fDJXdWc0Dv3seV9Vr3BgCFpRFOX75m+l5jLsCePLWgAAAABJRU5ErkJggg==";

var _excluded$7 = ["page", "text", "variant", "className"];
var COLLAPSED_TEXT_LENGTH_OPTIONS = {
  mobile: 80,
  desktop: 150
};
var ReelDescription = function ReelDescription(_ref) {
  var _page$logo_src;
  var page = _ref.page,
    text = _ref.text,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'desktop' : _ref$variant,
    className = _ref.className,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$7);
  return React__default.createElement("div", {
    className: clsx('tw-w-full tw-flex-col tw-absolute tw-text-white tw-bottom-0 tw-left-0 tw-text-sm tw-flex tw-justify-between tw-overflow-visible tw-cursor-pointer tw-pointer-events-none', className)
  }, React__default.createElement("div", {
    className: clsx('tw-w-full tw-p-3 tw-mt-auto tw-pointer-events-auto tw-relative', {
      'tw-pr-[55px]': variant === 'mobile'
    })
  }, React__default.createElement("div", {
    className: "tw-flex tw-items-center tw-gap-2 tw-font-bold"
  }, React__default.createElement(Avatar, {
    size: 32,
    name: page.name,
    color: "blue",
    src: (_page$logo_src = page.logo_src) != null ? _page$logo_src : undefined,
    className: modules_81d0b6b6.photo
  }), React__default.createElement(ExternalLink, {
    className: modules_81d0b6b6.title,
    href: page.username ? "https://www.facebook.com/" + page.username : ''
  }, page.name), React__default.createElement("div", {
    className: "tw-ring-1 tw-ring-white tw-text-xs tw-py-1 tw-px-2 tw-font-regular tw-rounded tw-select-none"
  }, "Follow")), text && React__default.createElement("div", {
    className: "tw-pt-3 tw-leading-4 tw-max-h-[200px] tw-overflow-auto",
    "data-cy": "post-preview_reel-description"
  }, React__default.createElement(HyperText, {
    pageType: TYPE_FACEBOOK,
    className: modules_81d0b6b6.hyperText,
    options: {
      maxLength: COLLAPSED_TEXT_LENGTH_OPTIONS[variant],
      expandable: true,
      expandableTrigger: {
        more: ' show more',
        less: ' ...show less'
      }
    }
  }, text)), variant === 'mobile' && React__default.createElement("div", {
    className: modules_81d0b6b6.icons
  }, React__default.createElement("img", {
    src: img$1,
    alt: ""
  }))));
};

var css$k = "[data-preview-variant=mobile] .Reel_module_mute__1147dcc9{padding:4px!important;top:46px!important}[data-preview-variant=mobile] .Reel_module_mute__1147dcc9 svg{height:20px;width:20px}";
var modules_3c0ef345 = {"mute":"Reel_module_mute__1147dcc9"};
n(css$k,{});

var MutedIcon = function MutedIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size;
  return React__default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default.createElement("g", {
    clipPath: "url(#clip0_21837_12311)"
  }, React__default.createElement("path", {
    d: "M19.6875 16.6875C20.0312 16.9375 20.0938 17.4062 19.7812 17.6875C19.5312 18.0312 19.0625 18.0938 18.75 17.8125L0.28125 3.34375C-0.0625 3.09375 -0.125 2.625 0.15625 2.3125C0.28125 2.125 0.5 2 0.75 2C0.90625 2 1.0625 2.0625 1.1875 2.1875L6.6875 6.5L10.3125 3.28125C10.625 3 11.0312 2.9375 11.4062 3.09375C11.75 3.25 12 3.625 12 4V10.625L13.6875 11.9688C13.5938 11.6875 13.6875 11.375 13.9375 11.1562C14.2812 10.875 14.5 10.4688 14.5 10C14.5 9.5625 14.2812 9.15625 13.9375 8.875C13.5938 8.59375 13.5625 8.125 13.8125 7.8125C14.0938 7.5 14.5625 7.4375 14.875 7.6875C15.5938 8.28125 16 9.125 16 10C16 10.9062 15.5938 11.75 14.875 12.3438C14.75 12.4375 14.5625 12.5 14.4062 12.5C14.375 12.5 14.375 12.5 14.3438 12.5L15.75 13.5625C15.7812 13.5312 15.7812 13.5 15.8125 13.4688C16.875 12.625 17.5 11.3438 17.5 10C17.5 8.6875 16.875 7.40625 15.8125 6.59375C15.5 6.3125 15.4375 5.84375 15.7188 5.53125C15.9688 5.1875 16.4375 5.15625 16.7812 5.40625C18.1875 6.53125 19 8.21875 19 10C19 11.7188 18.2188 13.3438 16.9375 14.5L19.6875 16.6875ZM2 8.5C2 7.9375 2.3125 7.46875 2.75 7.21875L12 14.4375V16C12 16.4062 11.75 16.75 11.4062 16.9375C11.25 17 11.125 17 11 17C10.75 17 10.5 16.9375 10.3125 16.7188L6.09375 13H3.5C2.65625 13 2 12.3438 2 11.5V8.5Z",
    fill: "currentColor"
  })), React__default.createElement("defs", null, React__default.createElement("clipPath", {
    id: "clip0_21837_12311"
  }, React__default.createElement("rect", {
    width: "20",
    height: "20",
    fill: "currentColor"
  }))));
};

var UnMutedIcon = function UnMutedIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size;
  return React__default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default.createElement("g", {
    clipPath: "url(#clip0_21837_11371)"
  }, React__default.createElement("path", {
    d: "M11.4062 3.09375C11.75 3.25 12 3.625 12 4V16C12 16.4062 11.75 16.75 11.4062 16.9375C11.0312 17.0938 10.625 17.0312 10.3125 16.75L6.09375 13H4C2.875 13 2 12.125 2 11V9C2 7.90625 2.875 7 4 7H6.09375L10.3125 3.28125C10.625 3 11.0312 2.9375 11.4062 3.09375ZM16.7812 5.34375C18.125 6.46875 19 8.125 19 10C19 11.9062 18.125 13.5625 16.7812 14.6562C16.4375 14.9375 15.9688 14.875 15.7188 14.5625C15.4375 14.25 15.5 13.7812 15.8125 13.5C16.8438 12.6875 17.5 11.4375 17.5 10C17.5 8.59375 16.8438 7.34375 15.8125 6.53125C15.5 6.25 15.4688 5.78125 15.7188 5.46875C15.9688 5.15625 16.4375 5.09375 16.7812 5.34375ZM14.875 7.6875C15.5625 8.25 16 9.0625 16 10C16 10.9688 15.5625 11.7812 14.875 12.3438C14.5625 12.5938 14.0938 12.5625 13.8125 12.2188C13.5625 11.9062 13.625 11.4375 13.9375 11.1875C14.2812 10.9062 14.5 10.4688 14.5 10C14.5 9.53125 14.2812 9.125 13.9375 8.84375C13.625 8.59375 13.5625 8.125 13.8125 7.78125C14.0938 7.46875 14.5625 7.4375 14.875 7.6875Z",
    fill: "currentColor"
  })), React__default.createElement("defs", null, React__default.createElement("clipPath", {
    id: "clip0_21837_11371"
  }, React__default.createElement("rect", {
    width: "20",
    height: "20",
    fill: "currentColor"
  }))));
};

var css$l = ".SoundControlButton_module_content__05860fad{align-items:center;background:rgba(0,0,0,.2);border-radius:100%;cursor:pointer;display:flex;justify-content:center;padding:6px;position:absolute;right:10px;top:10px;z-index:1}.SoundControlButton_module_content__05860fad path{fill:#fff}";
var modules_0f4f5e0c = {"content":"SoundControlButton_module_content__05860fad"};
n(css$l,{});

var SoundControlButton = function SoundControlButton(_ref) {
  var className = _ref.className,
    toggleMute = _ref.toggleMute,
    muted = _ref.muted,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size;
  return React__default.createElement("div", {
    className: classNames(className, modules_0f4f5e0c.content),
    onClick: toggleMute
  }, muted ? React__default.createElement(MutedIcon, {
    size: size
  }) : React__default.createElement(UnMutedIcon, {
    size: size
  }));
};

var useToggle = function useToggle(defaultState) {
  var _useState = useState(defaultState != null ? defaultState : false),
    muted = _useState[0],
    setMuted = _useState[1];
  return {
    muted: muted,
    toggleMute: function toggleMute() {
      return setMuted(function (prevMuted) {
        return !prevMuted;
      });
    }
  };
};

var slidePlaybackTime = 15 * 1000;
var updateInterval = 1000;
function useReelPlayback(_ref) {
  var attachments = _ref.attachments;
  var attachment = attachments[0];
  var _useState = useState(0),
    ratio = _useState[0],
    setRatio = _useState[1];
  var _useState2 = useState(true),
    playing = _useState2[0],
    setPlaying = _useState2[1];
  useEffect(function () {
    if (!playing) {
      return;
    }
    var interval = setInterval(function () {
      setRatio(function (prev) {
        var step = 100 / (slidePlaybackTime / updateInterval);
        return prev + step;
      });
    }, updateInterval);
    return function () {
      return clearInterval(interval);
    };
  }, [attachment, playing]);
  useEffect(function () {
    if (ratio >= 100) {
      resetPlaybackRatio();
    }
  }, [ratio]);
  function pause() {
    setPlaying(false);
  }
  function play() {
    setPlaying(true);
  }
  function resetPlaybackRatio() {
    setRatio(0);
  }
  return {
    ratio: ratio,
    playing: playing,
    play: play,
    pause: pause
  };
}

var ReelIndicator = function ReelIndicator(_ref) {
  var playbackRatio = _ref.playbackRatio;
  return React__default.createElement("div", {
    className: "tw-absolute tw-gap-2 tw-bottom-0 tw-z-[1] tw-left-0 tw-w-full tw-h-[10px] tw-flex tw-flex-nowrap tw-p-1"
  }, React__default.createElement("div", {
    className: "tw-relative tw-bg-grayscale-160 tw-rounded tw-flex-1 tw-h-1 tw-overflow-hidden"
  }, React__default.createElement("div", {
    className: "tw-absolute tw-top-0 tw-left-0 tw-h-full tw-rounded tw-bg-white",
    style: {
      width: playbackRatio + "%",
      transition: "width " + updateInterval + "ms linear"
    }
  })));
};

var Reel = function Reel(_ref) {
  var video = _ref.video,
    page = _ref.page,
    text = _ref.text,
    variant = _ref.variant;
  var _useToggle = useToggle(),
    muted = _useToggle.muted,
    toggleMute = _useToggle.toggleMute;
  var playback = useReelPlayback({
    attachments: video ? [video] : []
  });
  return React__default.createElement("div", {
    className: "tw-h-full tw-flex tw-bg-grayscale-180 tw-items-center tw-relative"
  }, React__default.createElement("div", {
    className: "tw-w-full"
  }, video && React__default.createElement(VideoPlayer, {
    customControls: {
      play: playback.play,
      pause: playback.pause
    },
    video: video.medium,
    controls: false,
    muted: muted
  })), React__default.createElement(ReelDescription, {
    page: page,
    text: text,
    variant: variant
  }), React__default.createElement(ReelIndicator, {
    playbackRatio: playback.ratio
  }), React__default.createElement(SoundControlButton, {
    muted: muted,
    toggleMute: toggleMute,
    className: modules_3c0ef345.mute
  }));
};

var ReelPost = function ReelPost(_ref) {
  var content = _ref.content,
    style = _ref.style;
  var _getSegmentedAttachme = getSegmentedAttachments(content),
    videos = _getSegmentedAttachme.videos;
  return React__default.createElement(PostWrapper, {
    style: style,
    variant: "desktop",
    contentType: content.type,
    contentSubtype: content.subtype
  }, React__default.createElement("div", {
    className: "tw-relative tw-h-0 tw-w-full tw-pb-[177%] tw-bg-grayscale-180"
  }, React__default.createElement("div", {
    className: "tw-absolute tw-top-0 tw-left-0 tw-h-full tw-w-full"
  }, React__default.createElement(Reel, {
    video: videos[0],
    page: content.page,
    text: content.text
  }))));
};

var MobileReelPost = function MobileReelPost(_ref) {
  var content = _ref.content,
    style = _ref.style;
  var _getSegmentedAttachme = getSegmentedAttachments(content),
    videos = _getSegmentedAttachme.videos;
  return React__default.createElement(Phone, {
    statusBarClassName: "tw-bg-transparent tw-text-white tw-absolute tw-w-full tw-top-0 tw-left-0 tw-z-[1]",
    contentBackground: "facebook",
    style: style
  }, React__default.createElement(PostWrapper, {
    variant: "mobile",
    contentType: content.type,
    contentSubtype: content.subtype,
    style: {
      height: '100%'
    }
  }, React__default.createElement(Reel, {
    variant: "mobile",
    video: videos[0],
    page: content.page,
    text: content.text
  })));
};

var css$m = ".Header_module_header__980e4a3b{align-items:center;display:grid;font-size:14px;grid-template-columns:auto auto 1fr;left:0;padding:16px;position:absolute;top:8px;width:100%;z-index:2}.Header_module_header__980e4a3b .Header_module_title__980e4a3b{color:#fff;cursor:pointer;font-weight:600;overflow:hidden;text-decoration:none;text-overflow:ellipsis;white-space:nowrap}.Header_module_header__980e4a3b .Header_module_title__980e4a3b:hover{text-decoration:underline}.Header_module_header__980e4a3b .Header_module_time__980e4a3b{color:#fff;margin-left:8px;opacity:.7;padding-right:70px;white-space:nowrap}.Header_module_header__980e4a3b .Header_module_photo__980e4a3b{align-items:center;border:1px solid #fff;border-radius:100%;display:flex;justify-content:center;margin-right:8px}";
var modules_773fac34$1 = {"header":"Header_module_header__980e4a3b","title":"Header_module_title__980e4a3b","time":"Header_module_time__980e4a3b","photo":"Header_module_photo__980e4a3b"};
n(css$m,{});

var Header$1 = function Header(_ref) {
  var _page$username, _page$logo_src;
  var _ref$content = _ref.content,
    page = _ref$content.page,
    time = _ref$content.time,
    date = _ref$content.date,
    formatDateTime = _ref.formatDateTime,
    use12hourFormat = _ref.use12hourFormat,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var name = (_page$username = page.username) != null ? _page$username : page.name;
  var renderDateTime = function renderDateTime() {
    return React__default.createElement(DateTime, Object.assign({}, {
      time: time,
      date: date,
      use12hourFormat: use12hourFormat,
      formatDateTime: formatDateTime,
      className: modules_773fac34$1.time
    }));
  };
  return React__default.createElement("div", {
    className: modules_773fac34$1.header
  }, React__default.createElement(Avatar, {
    size: 32,
    name: name,
    color: "blue",
    src: (_page$logo_src = page.logo_src) != null ? _page$logo_src : undefined,
    className: modules_773fac34$1.photo
  }), React__default.createElement(ExternalLink, {
    className: modules_773fac34$1.title,
    href: "https://www.instagram.com/" + name
  }, name), onEditDateTimeClick ? React__default.createElement(DateTooltip, Object.assign({}, {
    time: time,
    date: date,
    use12hourFormat: use12hourFormat,
    onEditDateTimeClick: onEditDateTimeClick
  }), renderDateTime()) : renderDateTime());
};

var css$n = ".StoryPlaybackIndicator_module_slider__7827c31f{display:flex;flex-wrap:nowrap;height:10px;left:0;padding:8px 16px;position:absolute;top:0;width:100%;z-index:2}.StoryPlaybackIndicator_module_slider__7827c31f .StoryPlaybackIndicator_module_slide__7827c31f{background:hsla(0,0%,100%,.5);border-radius:10%;flex:1;height:3px;overflow:hidden;position:relative}.StoryPlaybackIndicator_module_slider__7827c31f .StoryPlaybackIndicator_module_slide__7827c31f+.StoryPlaybackIndicator_module_slide__7827c31f{margin-left:5px}.StoryPlaybackIndicator_module_slider__7827c31f .StoryPlaybackIndicator_module_slide__7827c31f .StoryPlaybackIndicator_module_slidePlayback__7827c31f{background-color:#fff;border-radius:10%;height:100%;left:0;position:absolute;top:0;width:0;will-change:width}";
var modules_2d02a964 = {"slider":"StoryPlaybackIndicator_module_slider__7827c31f","slide":"StoryPlaybackIndicator_module_slide__7827c31f","slidePlayback":"StoryPlaybackIndicator_module_slidePlayback__7827c31f"};
n(css$n,{});

var StoryPlaybackIndicator = function StoryPlaybackIndicator(_ref) {
  var count = _ref.count,
    playbackRatio = _ref.playbackRatio,
    activeSlide = _ref.activeSlide;
  var slides = new Array(count).fill(0);
  return React__default.createElement("div", {
    className: modules_2d02a964.slider
  }, slides.map(function (_, index) {
    return React__default.createElement("div", {
      className: modules_2d02a964.slide,
      key: index
    }, React__default.createElement("div", {
      className: modules_2d02a964.slidePlayback,
      style: {
        width: index === activeSlide ? playbackRatio + "%" : index < activeSlide ? '100%' : '0%'
      }
    }));
  }));
};

var css$o = ".StoriesSlider_module_pager__aa70d903{height:100%;left:0;position:absolute;top:0;width:100%}.StoriesSlider_module_pager__aa70d903 .StoriesSlider_module_pagerLeft__aa70d903{background:linear-gradient(90deg,rgba(0,0,0,.5),transparent);cursor:pointer;height:100%;left:0;opacity:0;position:absolute;top:0;transition:opacity 199ms cubic-bezier(0,0,.21,1.11);width:33.3%;z-index:1}.StoriesSlider_module_pager__aa70d903 .StoriesSlider_module_pagerLeft__aa70d903:hover{opacity:1}.StoriesSlider_module_pager__aa70d903 .StoriesSlider_module_pagerRight__aa70d903{background:linear-gradient(90deg,transparent,rgba(0,0,0,.5));cursor:pointer;height:100%;opacity:0;position:absolute;right:0;top:0;transition:opacity 199ms cubic-bezier(0,0,.21,1.11);width:33.3%;z-index:1}.StoriesSlider_module_pager__aa70d903 .StoriesSlider_module_pagerRight__aa70d903:hover{opacity:1}.StoriesSlider_module_controls__aa70d903{align-items:center;color:#fff;display:flex;height:64px;justify-content:center;position:absolute;right:16px;top:8px;z-index:10}.StoriesSlider_module_controls__aa70d903 .StoriesSlider_module_btn__aa70d903{align-items:center;border-radius:50%;cursor:pointer;display:flex;height:25px;justify-content:center;width:25px}.StoriesSlider_module_controls__aa70d903 .StoriesSlider_module_btn__aa70d903+.StoriesSlider_module_btn__aa70d903{margin-left:8px}.StoriesSlider_module_controls__aa70d903 .StoriesSlider_module_mute__aa70d903{background-color:transparent;padding:0;position:relative;right:auto!important;top:auto!important}";
var modules_bbff2ee4 = {"pager":"StoriesSlider_module_pager__aa70d903","pagerLeft":"StoriesSlider_module_pagerLeft__aa70d903","pagerRight":"StoriesSlider_module_pagerRight__aa70d903","controls":"StoriesSlider_module_controls__aa70d903","btn":"StoriesSlider_module_btn__aa70d903","mute":"StoriesSlider_module_mute__aa70d903"};
n(css$o,{});

var css$p = ".StoriesSlide_module_item__9f9e5f0b{align-items:center;background:#4e5656;display:flex;height:100%;overflow:hidden;position:relative;width:100%}.StoriesSlide_module_item__9f9e5f0b .StoriesSlide_module_imageItem__9f9e5f0b{background-position:50%;background-size:cover;height:auto;object-fit:cover;width:100%;z-index:1}.StoriesSlide_module_item__9f9e5f0b .StoriesSlide_module_videoItem__9f9e5f0b{height:auto;object-fit:cover;width:100%;z-index:1}.StoriesSlide_module_item__9f9e5f0b .StoriesSlide_module_bgImage__9f9e5f0b{background:no-repeat;background-size:auto 100%;filter:blur(50px);height:100%;left:0;opacity:.5;pointer-events:none;position:absolute;top:0;width:100%}.StoriesSlide_module_item__9f9e5f0b video{object-fit:cover;object-position:center}";
var modules_1bbc0535 = {"item":"StoriesSlide_module_item__9f9e5f0b","imageItem":"StoriesSlide_module_imageItem__9f9e5f0b","videoItem":"StoriesSlide_module_videoItem__9f9e5f0b","bgImage":"StoriesSlide_module_bgImage__9f9e5f0b"};
n(css$p,{});

var StoriesSlideImage = function StoriesSlideImage(_ref) {
  var attachment = _ref.attachment,
    customControls = _ref.customControls;
  useEffect(function () {
    customControls == null ? void 0 : customControls.play();
  }, [customControls]);
  return React__default.createElement("img", {
    className: modules_1bbc0535.imageItem,
    src: attachment.medium.sizes.lightbox.src,
    "data-cy": "post-preview_story-slide-image"
  });
};

var StoriesSlide = function StoriesSlide(_ref) {
  var _attachment$medium$si, _attachment$medium$or, _attachment$medium, _attachment$medium2;
  var attachment = _ref.attachment,
    _ref$autoplay = _ref.autoplay,
    autoplay = _ref$autoplay === void 0 ? false : _ref$autoplay,
    style = _ref.style,
    muted = _ref.muted,
    customControls = _ref.customControls;
  var bgImage = attachment.medium && (attachment.medium.type === 'image' ? (_attachment$medium$si = attachment.medium.sizes) == null ? void 0 : _attachment$medium$si.lightbox.src : (_attachment$medium$or = attachment.medium.original_thumb) == null ? void 0 : _attachment$medium$or.src);
  return React__default.createElement("div", {
    className: modules_1bbc0535.item,
    style: style,
    "data-cy": "post-preview_gallery"
  }, bgImage && React__default.createElement("div", {
    className: modules_1bbc0535.bgImage,
    style: {
      backgroundImage: "url('" + bgImage + "')"
    }
  }), ((_attachment$medium = attachment.medium) == null ? void 0 : _attachment$medium.type) === 'image' && React__default.createElement(StoriesSlideImage, {
    customControls: customControls,
    attachment: attachment
  }), ((_attachment$medium2 = attachment.medium) == null ? void 0 : _attachment$medium2.type) === 'video' && React__default.createElement(VideoPlayer, {
    className: modules_1bbc0535.videoItem,
    height: "100%",
    width: "100%",
    autoplay: autoplay,
    muted: muted,
    video: attachment.medium,
    controls: false,
    customControls: customControls,
    allowFullScreenControls: false
  }));
};

var PlayIcon = function PlayIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size;
  return React__default.createElement("svg", {
    fill: "currentColor",
    height: size,
    viewBox: "0 0 48 48",
    width: size
  }, React__default.createElement("path", {
    d: "M9.6 46.5c-1 0-2-.3-2.9-.8-1.8-1.1-2.9-2.9-2.9-5.1V7.3c0-2.1 1.1-4 2.9-5.1 1.9-1.1 4.1-1.1 5.9 0l30.1 17.6c1.5.9 2.3 2.4 2.3 4.1 0 1.7-.9 3.2-2.3 4.1L12.6 45.7c-.9.5-2 .8-3 .8z"
  }));
};

var PauseIcon = function PauseIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size;
  return React__default.createElement("svg", {
    fill: "currentColor",
    height: size,
    viewBox: "0 0 48 48",
    width: size
  }, React__default.createElement("path", {
    d: "M15 1c-3.3 0-6 1.3-6 3v40c0 1.7 2.7 3 6 3s6-1.3 6-3V4c0-1.7-2.7-3-6-3zm18 0c-3.3 0-6 1.3-6 3v40c0 1.7 2.7 3 6 3s6-1.3 6-3V4c0-1.7-2.7-3-6-3z"
  }));
};

var iconSize = 16;
var StoriesSlider = function StoriesSlider(_ref) {
  var _attachments$activeSl;
  var attachments = _ref.attachments,
    activeSlide = _ref.activeSlide,
    prevSlide = _ref.prevSlide,
    nextSlide = _ref.nextSlide,
    autoplay = _ref.autoplay,
    playbackPaused = _ref.playbackPaused,
    playPlayback = _ref.playPlayback,
    pausePlayback = _ref.pausePlayback;
  var _useToggle = useToggle(!!autoplay),
    muted = _useToggle.muted,
    toggleMute = _useToggle.toggleMute;
  return React__default.createElement("div", {
    className: modules_bbff2ee4.pager
  }, React__default.createElement(StoriesSlide, {
    autoplay: autoplay,
    attachment: attachments[activeSlide],
    muted: muted,
    customControls: {
      isPlaying: !playbackPaused,
      play: playPlayback,
      pause: pausePlayback
    }
  }), activeSlide !== 0 && React__default.createElement("div", {
    className: modules_bbff2ee4.pagerLeft,
    onClick: prevSlide
  }), activeSlide !== attachments.length - 1 && React__default.createElement("div", {
    className: modules_bbff2ee4.pagerRight,
    onClick: nextSlide
  }), React__default.createElement("div", {
    className: modules_bbff2ee4.controls
  }, !playbackPaused && React__default.createElement("div", {
    className: modules_bbff2ee4.btn,
    onClick: function onClick() {
      pausePlayback();
    }
  }, React__default.createElement(PauseIcon, {
    size: iconSize
  })), playbackPaused && React__default.createElement("div", {
    className: modules_bbff2ee4.btn,
    onClick: function onClick() {
      playPlayback();
    }
  }, React__default.createElement(PlayIcon, {
    size: iconSize
  })), ((_attachments$activeSl = attachments[activeSlide].medium) == null ? void 0 : _attachments$activeSl.type) === 'video' && React__default.createElement(SoundControlButton, {
    muted: muted,
    toggleMute: toggleMute,
    className: classNames(modules_bbff2ee4.btn, modules_bbff2ee4.mute),
    size: iconSize
  })));
};
var StoriesSlider$1 = /*#__PURE__*/React__default.memo(StoriesSlider, function (prevProps, nextProps) {
  return prevProps.activeSlide === nextProps.activeSlide && prevProps.attachments === nextProps.attachments && prevProps.playbackPaused === nextProps.playbackPaused;
});

var defaultSlidePlaybackTime = 15;
var defaultSlideAdditionalTime = 0;
function getSlidePlaybackTime(attachment) {
  function getTime() {
    var _attachment$medium;
    if ((attachment == null ? void 0 : (_attachment$medium = attachment.medium) == null ? void 0 : _attachment$medium.type) === 'video' && attachment != null && attachment.medium.meta.duration) {
      return Math.max(0, Math.min(attachment.medium.meta.duration, 60));
    }
    return defaultSlidePlaybackTime;
  }
  return (getTime() + defaultSlideAdditionalTime) * 1000;
}
function useStoryPlayback(_ref) {
  var attachments = _ref.attachments;
  var _useState = useState(0),
    activeSlide = _useState[0],
    setActiveSlide = _useState[1];
  var _useState2 = useState(0),
    ratio = _useState2[0],
    setRatio = _useState2[1];
  var _useState3 = useState(false),
    playing = _useState3[0],
    setPlaying = _useState3[1];
  var requestRef = useRef(null);
  var previousTimeRef = useRef(null);
  var updatePlayback = function updatePlayback(time) {
    if (!playing) {
      previousTimeRef.current = null;
      return;
    }
    if (previousTimeRef.current !== null) {
      var deltaTime = time - previousTimeRef.current;
      var slidePlaybackTime = getSlidePlaybackTime(attachments[activeSlide]);
      var step = 100 / slidePlaybackTime * deltaTime;
      setRatio(function (prev) {
        return prev + step;
      });
    }
    previousTimeRef.current = time;
    requestRef.current = requestAnimationFrame(updatePlayback);
  };
  useEffect(function () {
    if (playing) {
      requestRef.current = requestAnimationFrame(updatePlayback);
    } else if (requestRef.current !== null) {
      cancelAnimationFrame(requestRef.current);
      requestRef.current = null;
    }
    return function () {
      if (requestRef.current !== null) {
        cancelAnimationFrame(requestRef.current);
        requestRef.current = null;
      }
    };
  }, [playing, activeSlide]);
  useEffect(function () {
    if (ratio > 100) {
      nextSlide();
      resetPlaybackRatio();
    }
  }, [ratio]);
  useEffect(function () {
    if (activeSlide === attachments.length - 1 && ratio > 100) {
      pause();
    }
  }, [activeSlide, ratio]);
  function nextSlide() {
    resetPlaybackRatio();
    setActiveSlide(function (prev) {
      return prev === attachments.length - 1 ? 0 : prev + 1;
    });
  }
  function prevSlide() {
    resetPlaybackRatio();
    setActiveSlide(function (prev) {
      return prev === 0 ? 0 : prev - 1;
    });
  }
  function pause() {
    setPlaying(false);
    if (previousTimeRef.current !== null) {
      cancelAnimationFrame(previousTimeRef.current);
      previousTimeRef.current = null;
    }
  }
  function play() {
    setPlaying(true);
  }
  function resetPlaybackRatio() {
    setRatio(0);
  }
  return {
    activeSlide: activeSlide,
    ratio: ratio,
    playing: playing,
    play: play,
    pause: pause,
    prevSlide: prevSlide,
    nextSlide: nextSlide
  };
}

var Story = function Story(_ref) {
  var attachments = _ref.attachments,
    _ref$autoplay = _ref.autoplay,
    autoplay = _ref$autoplay === void 0 ? true : _ref$autoplay;
  var playback = useStoryPlayback({
    attachments: attachments
  });
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(StoryPlaybackIndicator, {
    count: attachments.length,
    activeSlide: playback.activeSlide,
    playbackRatio: playback.ratio
  }), React__default.createElement(StoriesSlider$1, {
    autoplay: autoplay,
    attachments: attachments,
    playbackPaused: !playback.playing,
    playPlayback: playback.play,
    pausePlayback: playback.pause,
    activeSlide: playback.activeSlide,
    nextSlide: playback.nextSlide,
    prevSlide: playback.prevSlide
  }));
};

var img$2 = "data:image/png;base64,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";

var Footer$2 = function Footer(_ref) {
  var isMobile = _ref.isMobile;
  return React__default.createElement("div", {
    className: clsx('tw-w-full tw-overflow-hidden tw-bottom-0 tw-left-0 tw-p-4 tw-text-white tw-flex', {
      'tw-relative tw-bg-black': isMobile,
      'tw-absolute': !isMobile
    })
  }, React__default.createElement("div", {
    className: clsx('tw-flex-1 tw-items-center tw-flex tw-text-md tw-px-6 tw-rounded-full', {
      'tw-border tw-border-white tw-bg-transparent tw-hidden': !isMobile,
      'tw-bg-grayscale-140': isMobile
    })
  }, "Send message"), React__default.createElement("img", {
    src: img$2,
    alt: "Story emojis",
    className: clsx('tw-relative -tw-right-4', {
      'tw-hidden': !isMobile
    })
  }));
};

var StoryPost = function StoryPost(_ref) {
  var content = _ref.content,
    use12hourFormat = _ref.use12hourFormat,
    formatDateTime = _ref.formatDateTime,
    style = _ref.style,
    onEditDateTimeClick = _ref.onEditDateTimeClick,
    videoPlayer = _ref.videoPlayer;
  return React__default.createElement(PostWrapper, {
    style: style,
    variant: "desktop",
    contentType: content.type,
    contentSubtype: content.subtype
  }, React__default.createElement("div", {
    className: "tw-relative tw-h-[0px] tw-w-full tw-pb-[177%] tw-bg-grayscale-160"
  }, React__default.createElement("div", {
    className: "tw-absolute tw-top-0 tw-left-0 tw-h-full tw-w-full"
  }, React__default.createElement(Header$1, {
    content: content,
    use12hourFormat: use12hourFormat,
    formatDateTime: formatDateTime,
    onEditDateTimeClick: onEditDateTimeClick
  }), content.attachments.cards.length > 0 && React__default.createElement(Story, {
    autoplay: videoPlayer == null ? void 0 : videoPlayer.autoPlay,
    attachments: content.attachments.cards
  })), React__default.createElement(Footer$2, null)));
};

var MobileStoryPost = function MobileStoryPost(_ref) {
  var content = _ref.content,
    use12hourFormat = _ref.use12hourFormat,
    formatDateTime = _ref.formatDateTime,
    style = _ref.style,
    onEditDateTimeClick = _ref.onEditDateTimeClick,
    videoPlayer = _ref.videoPlayer;
  return React__default.createElement(Phone, {
    statusBarClassName: "tw-bg-transparent tw-text-white tw-w-full tw-z-10",
    contentBackground: "facebook",
    style: style
  }, React__default.createElement(PostWrapper, {
    variant: "mobile",
    contentType: content.type,
    contentSubtype: content.subtype,
    style: {
      height: '100%'
    }
  }, React__default.createElement("div", {
    className: "tw-w-full tw-bg-grayscale-160 tw-h-full tw-relative tw-overflow-hidden"
  }, React__default.createElement(Header$1, {
    content: content,
    use12hourFormat: use12hourFormat,
    formatDateTime: formatDateTime,
    onEditDateTimeClick: onEditDateTimeClick
  }), content.attachments.cards.length > 0 && React__default.createElement(Story, {
    autoplay: videoPlayer == null ? void 0 : videoPlayer.autoPlay,
    attachments: content.attachments.cards
  })), React__default.createElement(Footer$2, {
    isMobile: true
  })));
};

var css$q = ".TextContent_module_textContent__6d3819ac{font-size:14px;font-weight:400;line-height:18px;margin:0 16px 12px}.TextContent_module_seeMore__6d3819ac{cursor:pointer}";
var modules_82161d99$1 = {"textContent":"TextContent_module_textContent__6d3819ac","seeMore":"TextContent_module_seeMore__6d3819ac"};
n(css$q,{});

var InstagramUserName = function InstagramUserName(_ref) {
  var name = _ref.name,
    collaborators = _ref.collaborators,
    className = _ref.className;
  if (!(collaborators != null && collaborators.length)) {
    return createElement(ExternalLink, {
      href: "https://www.instagram.com/" + name,
      className: "!tw-cursor-pointer hover:!tw-underline !tw-font-semibold " + (className || '')
    }, name);
  }
  return createElement("span", {
    className: className
  }, createElement(ExternalLink, {
    href: "https://www.instagram.com/" + name,
    className: "!tw-cursor-pointer hover:!tw-underline !tw-font-semibold"
  }, name), createElement("span", {
    className: "!tw-font-normal"
  }, " and "), collaborators.map(function (collaborator, index) {
    return createElement("span", {
      key: collaborator
    }, createElement(ExternalLink, {
      href: "https://www.instagram.com/" + collaborator,
      className: "!tw-cursor-pointer hover:!tw-underline !tw-font-semibold"
    }, collaborator), index < collaborators.length - 1 && ', ');
  }));
};

var TextContent$1 = function TextContent(_ref) {
  var _page$username;
  var _ref$content = _ref.content,
    text = _ref$content.text,
    page = _ref$content.page,
    attachments = _ref$content.attachments;
  var name = (_page$username = page.username) != null ? _page$username : page.name;
  var collaborators = attachments == null ? void 0 : attachments.collaborators;
  if (!text) {
    return null;
  }
  return React__default.createElement("div", {
    className: modules_82161d99$1.textContent
  }, React__default.createElement(InstagramUserName, {
    name: name,
    collaborators: collaborators,
    className: modules_82161d99$1.name
  }), React__default.createElement("span", null, "\xA0"), React__default.createElement(PostTextContentWrapper, {
    as: "span"
  }, React__default.createElement(HyperText, {
    pageType: TYPE_INSTAGRAM,
    options: {
      maxLength: IG_TRUNCATED_TEXT,
      expandable: true,
      expandableTrigger: {
        more: React__default.createElement("span", {
          className: modules_82161d99$1.seeMore
        }, "\xA0more"),
        less: React__default.createElement(React__default.Fragment, null)
      }
    }
  }, text)));
};

var css$r = ".Header_module_header__7a607644{align-items:center;display:flex;max-width:100%;padding:8px 16px}.Header_module_header__7a607644 .Header_module_more__7a607644{margin-left:auto}.Header_module_header__7a607644 .Header_module_title__7a607644{color:#262626;font-size:14px;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap}.Header_module_header__7a607644 .Header_module_photo__7a607644{align-items:center;border:1px solid #8e8e8e;border-radius:100%;display:flex;justify-content:center;margin-right:8px}.Header_module_header__7a607644 .Header_module_content__7a607644{display:flex;flex-direction:column;max-width:calc(100% - 68px)}.Header_module_header__7a607644 .Header_module_content__7a607644 .Header_module_contentTitle__7a607644{display:flex}.Header_module_header__7a607644 .Header_module_content__7a607644 .Header_module_contentDatetime__7a607644{color:#8e8e8e;display:flex;white-space:nowrap}.Header_module_header__7a607644 .Header_module_tag__7a607644{font-size:12px;font-weight:400;line-height:14px}";
var modules_773fac34$2 = {"header":"Header_module_header__7a607644","more":"Header_module_more__7a607644","title":"Header_module_title__7a607644","photo":"Header_module_photo__7a607644","content":"Header_module_content__7a607644","contentTitle":"Header_module_contentTitle__7a607644","contentDatetime":"Header_module_contentDatetime__7a607644","tag":"Header_module_tag__7a607644"};
n(css$r,{});

var Header$2 = function Header(_ref) {
  var _page$username, _page$logo_src;
  var _ref$content = _ref.content,
    time = _ref$content.time,
    date = _ref$content.date,
    page = _ref$content.page,
    attachments = _ref$content.attachments,
    type = _ref$content.type,
    use12hourFormat = _ref.use12hourFormat,
    formatDateTime = _ref.formatDateTime,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var name = (_page$username = page.username) != null ? _page$username : page.name;
  var isAd = type === TYPE$1.AD;
  var location = attachments == null ? void 0 : attachments.location;
  var collaborators = attachments == null ? void 0 : attachments.collaborators;
  var renderDateTime = function renderDateTime() {
    return React__default.createElement(DateTime, Object.assign({}, {
      time: time,
      date: date,
      use12hourFormat: use12hourFormat,
      formatDateTime: formatDateTime,
      className: modules_773fac34$2.contentDatetime
    }));
  };
  return React__default.createElement("div", {
    className: modules_773fac34$2.header
  }, React__default.createElement(Avatar, {
    size: 32,
    name: name,
    color: "blue",
    src: (_page$logo_src = page.logo_src) != null ? _page$logo_src : undefined,
    className: modules_773fac34$2.photo
  }), React__default.createElement("div", {
    className: modules_773fac34$2.content
  }, React__default.createElement("div", {
    className: modules_773fac34$2.contentTitle
  }, React__default.createElement(InstagramUserName, {
    name: name,
    collaborators: collaborators,
    className: modules_773fac34$2.userName
  }), (time || date) && React__default.createElement("div", {
    className: modules_773fac34$2.divider
  }, "\xA0\xB7\xA0"), onEditDateTimeClick ? React__default.createElement(DateTooltip, Object.assign({}, {
    time: time,
    date: date,
    use12hourFormat: use12hourFormat,
    onEditDateTimeClick: onEditDateTimeClick
  }), renderDateTime()) : renderDateTime()), isAd && React__default.createElement("span", {
    className: modules_773fac34$2.tag
  }, "Sponsored"), !isAd && (location == null ? void 0 : location.name) && React__default.createElement("span", {
    className: modules_773fac34$2.tag
  }, location.name)), React__default.createElement(Icon, {
    size: 16,
    className: modules_773fac34$2.more,
    icon: faEllipsis
  }));
};

var css$s = ".PostWrapper_module_postWrapper__034cd463{background:#fff;border-radius:8px;box-sizing:border-box;color:#262626;display:flex;flex-direction:column;font-family:-apple-system,system-ui,Segoe UI,Roboto,Helvetica,Arial,sans-serif;font-size:14px;line-height:18px;max-width:500px;overflow:hidden;position:relative;width:100%}.PostWrapper_module_postWrapper__034cd463[data-content-subtype=\"2\"],.PostWrapper_module_postWrapper__034cd463[data-content-subtype=\"3\"],.PostWrapper_module_postWrapper__034cd463[data-content-type=\"6\"]{background:#000;border:0;flex:1;margin:0}.PostWrapper_module_postWrapper__034cd463[data-preview-variant=mobile]{border-radius:0;max-width:100%}.PostWrapper_module_postWrapper__034cd463[data-preview-variant=mobile][data-content-subtype=\"2\"],.PostWrapper_module_postWrapper__034cd463[data-preview-variant=mobile][data-content-subtype=\"3\"],.PostWrapper_module_postWrapper__034cd463[data-preview-variant=mobile][data-content-type=\"6\"]{margin:0}.PostWrapper_module_postWrapper__034cd463 a{color:inherit}.PostWrapper_module_postWrapper__034cd463 a:hover{color:inherit;text-decoration:none}";
var modules_6850efbf$1 = {"postWrapper":"PostWrapper_module_postWrapper__034cd463"};
n(css$s,{});

var PostWrapper$1 = function PostWrapper(props) {
  return React__default.createElement("div", {
    className: classNames(modules_6850efbf$1.postWrapper, props.className),
    "data-preview-variant": props.variant,
    "data-content-type": props.contentType,
    "data-content-subtype": props.contentSubtype,
    style: props.style
  }, props.children);
};
PostWrapper$1.defaultProps = {
  variant: 'desktop'
};

var css$t = ".ActionButtons_module_actionButtons__f0621adc{align-items:center;display:flex;padding:12px 16px}.ActionButtons_module_actionButtons__f0621adc .ActionButtons_module_btn__f0621adc{cursor:pointer;display:flex}.ActionButtons_module_actionButtons__f0621adc .ActionButtons_module_btn__f0621adc:not(:first-of-type){margin-left:16px}.ActionButtons_module_actionButtons__f0621adc .ActionButtons_module_btn__f0621adc:last-of-type{margin-left:auto}[data-preview-variant=mobile] .ActionButtons_module_btn__f0621adc svg{height:20px;width:20px}";
var modules_3d9c89a6 = {"actionButtons":"ActionButtons_module_actionButtons__f0621adc","btn":"ActionButtons_module_btn__f0621adc"};
n(css$t,{});

var HeartIcon = function HeartIcon(_ref) {
  return React__default.createElement("svg", {
    width: "20",
    height: "18",
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0483 0.25C12.3999 0.25 11.066 0.818603 9.99197 1.9629C8.92152 0.852542 7.59488 0.289346 5.95609 0.288196C2.65281 0.246562 0.0830078 3.13015 0.0830078 6.5382C0.0830078 9.68086 2.39749 11.683 4.31075 13.3381L4.39612 13.412L4.40148 13.4164C4.62752 13.6048 4.87309 13.816 5.07698 14.0199L5.09546 14.0384L5.99105 14.8172C6.2204 15.0205 6.43471 15.2108 6.63472 15.3884C7.16262 15.8572 7.59084 16.2375 7.93273 16.534C8.38741 16.9284 8.74454 17.2243 9.00269 17.3792C9.27426 17.5422 9.63619 17.6771 9.99967 17.6771C10.3632 17.6771 10.7251 17.5422 10.9967 17.3792C11.2522 17.2259 11.5655 16.9737 12.0213 16.5749C12.4874 16.1671 13.1426 15.5696 14.0947 14.6936L14.8489 14.0148C14.9649 13.9153 15.0587 13.8307 15.1421 13.7556C15.2901 13.6222 15.4053 13.5184 15.5537 13.4124L15.5758 13.3965L15.5968 13.3791C17.5769 11.7353 19.9163 9.76572 19.9163 6.5382C19.9163 3.1255 17.3437 0.25 14.0483 0.25ZM18.0205 6.5382C18.0205 4.13194 16.2254 2.14583 14.0483 2.14583C12.4441 2.14583 11.5656 2.90972 10.9545 3.78819C10.5431 4.35125 10.3281 4.75467 10.1981 4.99848C10.0989 5.18468 10.0493 5.27778 9.99967 5.27778C9.95006 5.27778 9.90044 5.18468 9.80121 4.99848C9.67128 4.75467 9.45627 4.35124 9.04481 3.78819C8.4337 2.90972 7.55523 2.14583 5.95106 2.14583C3.77398 2.14583 1.97884 4.13194 1.97884 6.5382C1.97884 8.86401 3.75533 10.3935 5.69002 12.0592C5.91579 12.2535 6.1437 12.4497 6.3712 12.6493C6.70502 12.9483 7.02363 13.2347 7.32406 13.5048C8.6736 14.7177 9.65603 15.6008 9.99967 15.8194C10.2893 15.6457 10.9963 15.0106 12.254 13.8809C12.6547 13.5209 13.1113 13.1108 13.6281 12.6493C13.8862 12.4189 14.1459 12.1929 14.4032 11.9691C16.278 10.338 18.0205 8.82206 18.0205 6.5382Z",
    fill: "currentColor"
  }));
};

var CommentIcon = function CommentIcon(_ref) {
  return React__default.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9937 0.499512C4.74203 0.499512 0.499756 4.74179 0.499756 9.99345C0.499756 15.2451 4.74203 19.4874 9.9937 19.4874C11.5621 19.4874 13.056 19.1066 14.3639 18.4176L18.5263 19.4771L18.5277 19.4774C18.817 19.5498 19.0888 19.4376 19.2633 19.2631C19.4378 19.0886 19.55 18.8167 19.4777 18.5275L18.4178 14.3637C19.1068 13.0558 19.4876 11.5618 19.4876 9.99345C19.4876 4.74179 15.2454 0.499512 9.9937 0.499512ZM2.33586 9.99345C2.33586 5.77266 5.7729 2.33562 9.9937 2.33562C14.2145 2.33562 17.6515 5.77266 17.6515 9.99345C17.6515 11.487 17.2808 12.6028 16.6771 13.7347L16.6732 13.7425C16.5672 13.9545 16.5109 14.2247 16.5665 14.5027L16.5681 14.5105L17.2534 17.2519L14.5502 16.5679L14.5419 16.5663C14.3235 16.5226 14.0185 16.5018 13.7517 16.6893C13.0732 17.0643 11.8112 17.6513 10.0327 17.6513C5.77185 17.6513 2.33586 14.2132 2.33586 9.99345Z",
    fill: "currentColor"
  }));
};

var ShareIcon = function ShareIcon(_ref) {
  return React__default.createElement("svg", {
    width: "20",
    height: "18",
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5884 0.666504H1.37825L1.35104 0.671039C1.04274 0.722423 0.693323 0.929011 0.561778 1.25787C0.437435 1.56873 0.503687 1.96172 0.72553 2.23902L0.738058 2.25468L6.75561 8.15869L8.83064 16.6852C8.9027 17.0787 9.22974 17.3106 9.56048 17.3657L9.58769 17.3702H9.69164C10.0081 17.3702 10.2907 17.1882 10.4547 16.9696L10.4654 16.9553L19.3146 2.07944C19.569 1.79299 19.5345 1.4069 19.3706 1.13381C19.2048 0.857526 18.9129 0.666504 18.5884 0.666504ZM7.76229 6.58221L3.63241 2.51686H15.0864L7.76229 6.58221ZM10.0922 14.1371L8.66193 8.15612L16.1057 4.02791L10.0922 14.1371Z",
    fill: "currentColor"
  }));
};

var SaveIcon = function SaveIcon(_ref) {
  return React__default.createElement("svg", {
    width: "16",
    height: "18",
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.57755 0.749512C1.12981 0.749512 0.749878 1.12944 0.749878 1.57718V16.4072C0.749878 16.7299 0.952489 17.0496 1.27434 17.173C1.43713 17.2583 1.61302 17.2632 1.75958 17.2314C1.91546 17.1975 2.0637 17.1175 2.17576 17.0054L2.17703 17.0041L8.00388 11.1139L13.8546 17.0282L13.8828 17.0471C13.9983 17.124 14.1982 17.2349 14.4302 17.2349L14.4404 17.2349C14.5014 17.2352 14.6305 17.2357 14.764 17.173C15.0579 17.049 15.2579 16.7266 15.2579 16.4072V1.57718C15.2579 1.12944 14.878 0.749512 14.4302 0.749512H1.57755ZM2.40521 14.4088V2.40485H13.6026V14.4088L8.96609 9.71368L8.96461 9.7122C8.70028 9.44787 8.34998 9.31797 8.00388 9.31797C7.65779 9.31797 7.30749 9.44787 7.04316 9.7122L7.04168 9.71369L2.40521 14.4088Z",
    fill: "currentColor"
  }));
};

var ActionButtons = function ActionButtons(_ref) {
  var size = _ref.size;
  return React__default.createElement("div", {
    className: modules_3d9c89a6.actionButtons
  }, React__default.createElement("div", {
    className: modules_3d9c89a6.btn
  }, React__default.createElement(HeartIcon, {
    size: size
  })), React__default.createElement("div", {
    className: modules_3d9c89a6.btn
  }, React__default.createElement(CommentIcon, {
    size: size
  })), React__default.createElement("div", {
    className: modules_3d9c89a6.btn
  }, React__default.createElement(ShareIcon, {
    size: size
  })), React__default.createElement("div", {
    className: modules_3d9c89a6.btn
  }, React__default.createElement(SaveIcon, {
    size: size
  })));
};

var css$u = ".ImageGallery_module_imageGallery__f0f6acc0{cursor:pointer;display:flex}.ImageGallery_module_oneImage__f0f6acc0{height:auto;width:100%}.ImageGallery_module_oneImageCropped__f0f6acc0{aspect-ratio:4/5;height:auto;object-fit:cover;width:100%}";
var modules_ccc28e88$1 = {"imageGallery":"ImageGallery_module_imageGallery__f0f6acc0","oneImage":"ImageGallery_module_oneImage__f0f6acc0","oneImageCropped":"ImageGallery_module_oneImageCropped__f0f6acc0"};
n(css$u,{});

function calcHeightRatioFromDimensions(attachment) {
  var _attachment$medium, _attachment$medium2;
  var MIN_HEIGHT_RATIO = 56;
  var MAX_HEIGHT_RATIO = 125;
  var width;
  var height;
  if (((_attachment$medium = attachment.medium) == null ? void 0 : _attachment$medium.type) === 'image') {
    width = attachment.medium.sizes.lightbox.width;
    height = attachment.medium.sizes.lightbox.height;
  }
  if (((_attachment$medium2 = attachment.medium) == null ? void 0 : _attachment$medium2.type) === 'video') {
    var _attachment$medium$si, _attachment$medium$si2, _attachment$medium$si3, _attachment$medium$si4;
    width = (_attachment$medium$si = attachment.medium.sizes) == null ? void 0 : (_attachment$medium$si2 = _attachment$medium$si.medium) == null ? void 0 : _attachment$medium$si2.width;
    height = (_attachment$medium$si3 = attachment.medium.sizes) == null ? void 0 : (_attachment$medium$si4 = _attachment$medium$si3.medium) == null ? void 0 : _attachment$medium$si4.height;
  }
  if (width && height) {
    var heightRatio = Math.round(height / width * 100);
    if (Number.isFinite(heightRatio)) {
      if (heightRatio < MIN_HEIGHT_RATIO) return MIN_HEIGHT_RATIO;
      if (heightRatio > MAX_HEIGHT_RATIO) return MAX_HEIGHT_RATIO;
      return heightRatio;
    }
  }
}
function calcAspectRatioFromDimensions(attachment) {
  var _attachment$medium3, _attachment$medium4;
  if (((_attachment$medium3 = attachment.medium) == null ? void 0 : _attachment$medium3.type) === 'image') {
    var width = attachment.medium.sizes.original.width;
    var height = attachment.medium.sizes.original.height;
    if (width && height) {
      var aspectRatio = width / height;
      if (Number.isFinite(aspectRatio)) {
        return aspectRatio;
      }
    }
  } else if (((_attachment$medium4 = attachment.medium) == null ? void 0 : _attachment$medium4.type) === 'video') {
    var _attachment$medium$si5, _attachment$medium$si6, _attachment$medium$si7, _attachment$medium$si8;
    var _width = (_attachment$medium$si5 = attachment.medium.sizes) == null ? void 0 : (_attachment$medium$si6 = _attachment$medium$si5.medium) == null ? void 0 : _attachment$medium$si6.width;
    var _height = (_attachment$medium$si7 = attachment.medium.sizes) == null ? void 0 : (_attachment$medium$si8 = _attachment$medium$si7.medium) == null ? void 0 : _attachment$medium$si8.height;
    if (_width && _height) {
      var _aspectRatio = _width / _height;
      if (Number.isFinite(_aspectRatio)) {
        return _aspectRatio;
      }
    }
  }
  return 1;
}

var MAX_PORTRAIT_ASPECT_RATIO = 4 / 5;
var Image = function Image(_ref) {
  var _medium$sizes$origina;
  var image = _ref.image;
  var medium = image.medium;
  var _useLightbox = useLightbox(),
    lightbox = _useLightbox.lightbox,
    handleOpenLightbox = _useLightbox.handleOpenLightbox,
    enableLightbox = _useLightbox.enableLightbox;
  function getIsOverMaxPortraitAspectRatio() {
    var aspectRatio = calcAspectRatioFromDimensions(image);
    return aspectRatio < MAX_PORTRAIT_ASPECT_RATIO;
  }
  return React__default.createElement("div", {
    "data-cy": DATA_CY_NAMES.IMAGE_GALLERY,
    className: modules_ccc28e88$1.imageGallery
  }, medium.meta.is_animated_gif && (_medium$sizes$origina = medium.sizes.original) != null && _medium$sizes$origina.src ? React__default.createElement("img", {
    src: medium.sizes.original.src,
    className: getIsOverMaxPortraitAspectRatio() ? modules_ccc28e88$1.oneImageCropped : modules_ccc28e88$1.oneImage,
    onClick: function onClick() {
      return handleOpenLightbox();
    }
  }) : React__default.createElement("img", {
    src: medium.sizes.lightbox.src,
    className: getIsOverMaxPortraitAspectRatio() ? modules_ccc28e88$1.oneImageCropped : modules_ccc28e88$1.oneImage,
    onClick: function onClick() {
      return handleOpenLightbox();
    }
  }), enableLightbox && React__default.createElement(AttachmentsLightBox$1, {
    onInit: function onInit(_ref2) {
      var instance = _ref2.instance;
      return lightbox.current = instance;
    },
    attachments: [image]
  }));
};

var css$v = ".Carousel_module_carousel__3fb37414{height:0;padding-bottom:100%;position:relative;width:100%}.Carousel_module_carousel__3fb37414 .Carousel_module_arrow__3fb37414{align-items:center;background-color:#fff;border-radius:50%;cursor:pointer;display:flex;height:25px;justify-content:center;margin:8px;opacity:.7;transition:opacity 199ms cubic-bezier(0,0,.21,1.11);width:25px}.Carousel_module_carousel__3fb37414 .Carousel_module_arrow__3fb37414:hover{opacity:1}.Carousel_module_carousel__3fb37414 .Carousel_module_arrow__3fb37414 svg{color:rgba(0,0,0,.8)}.Carousel_module_carousel__3fb37414 .Carousel_module_aspectRatio__3fb37414{height:100%;left:0;position:absolute;top:0;width:100%}.Carousel_module_carousel__3fb37414 .Carousel_module_aspectRatioVideo__3fb37414{left:0;position:absolute;top:0;width:100%}.Carousel_module_carousel__3fb37414 .Carousel_module_pagingDots__3fb37414{align-items:center;display:flex;left:50%;overflow:hidden;position:absolute;top:calc(100% - 20px);transform:translateX(-50%);width:35px;z-index:1}.Carousel_module_carousel__3fb37414 .Carousel_module_pagingDots__3fb37414 .Carousel_module_pagingDotsSlide__3fb37414{display:flex;height:6px;position:relative;width:100%}.Carousel_module_carousel__3fb37414 .Carousel_module_pagingDots__3fb37414 .Carousel_module_dot__3fb37414{background-color:#fff;border-radius:50%;cursor:pointer;height:6px;opacity:.25;position:absolute;transform:translateX(-50%);transition:all .3s ease-in-out;width:6px}.Carousel_module_carousel__3fb37414 .Carousel_module_pagingDots__3fb37414 .Carousel_module_dot__3fb37414.Carousel_module_active__3fb37414{opacity:1}.Carousel_module_carousel__3fb37414 .Carousel_module_pagingDots__3fb37414 .Carousel_module_small__3fb37414{height:4px;width:4px}.Carousel_module_carousel__3fb37414 .Carousel_module_pagingDots__3fb37414 .Carousel_module_micro__3fb37414{height:2px;width:2px}.Carousel_module_carousel__3fb37414 .Carousel_module_pagingDots__3fb37414 .Carousel_module_hidden__3fb37414{height:0;width:0}[data-preview-variant=mobile] .Carousel_module_carousel__3fb37414 .Carousel_module_pagingDots__3fb37414{top:calc(100% + 20px)}[data-preview-variant=mobile] .Carousel_module_carousel__3fb37414 .Carousel_module_pagingDots__3fb37414 .Carousel_module_dot__3fb37414{background-color:#8792a4}[data-preview-variant=mobile] .Carousel_module_carousel__3fb37414 .Carousel_module_pagingDots__3fb37414 .Carousel_module_dot__3fb37414.Carousel_module_active__3fb37414{background-color:#2146ec}";
var modules_794cd056$1 = {"carousel":"Carousel_module_carousel__3fb37414","arrow":"Carousel_module_arrow__3fb37414","aspectRatio":"Carousel_module_aspectRatio__3fb37414","aspectRatioVideo":"Carousel_module_aspectRatioVideo__3fb37414","pagingDots":"Carousel_module_pagingDots__3fb37414","pagingDotsSlide":"Carousel_module_pagingDotsSlide__3fb37414","dot":"Carousel_module_dot__3fb37414","active":"Carousel_module_active__3fb37414","small":"Carousel_module_small__3fb37414","micro":"Carousel_module_micro__3fb37414","hidden":"Carousel_module_hidden__3fb37414"};
n(css$v,{});

var css$w = ".CarouselItem_module_item__1023008a{height:100%;position:relative;width:100%}.CarouselItem_module_item__1023008a .CarouselItem_module_imageItem__1023008a{background-position:50%;background-size:cover;height:100%;width:100%}.CarouselItem_module_item__1023008a .CarouselItem_module_videoItem__1023008a{height:100%;width:100%}.CarouselItem_module_item__1023008a video{object-fit:cover;object-position:center}";
var modules_ee2c7f53$1 = {"item":"CarouselItem_module_item__1023008a","imageItem":"CarouselItem_module_imageItem__1023008a","videoItem":"CarouselItem_module_videoItem__1023008a"};
n(css$w,{});

var MutedIcon$1 = function MutedIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size;
  return React__default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default.createElement("g", {
    clipPath: "url(#clip0_21837_12311)"
  }, React__default.createElement("path", {
    d: "M19.6875 16.6875C20.0312 16.9375 20.0938 17.4062 19.7812 17.6875C19.5312 18.0312 19.0625 18.0938 18.75 17.8125L0.28125 3.34375C-0.0625 3.09375 -0.125 2.625 0.15625 2.3125C0.28125 2.125 0.5 2 0.75 2C0.90625 2 1.0625 2.0625 1.1875 2.1875L6.6875 6.5L10.3125 3.28125C10.625 3 11.0312 2.9375 11.4062 3.09375C11.75 3.25 12 3.625 12 4V10.625L13.6875 11.9688C13.5938 11.6875 13.6875 11.375 13.9375 11.1562C14.2812 10.875 14.5 10.4688 14.5 10C14.5 9.5625 14.2812 9.15625 13.9375 8.875C13.5938 8.59375 13.5625 8.125 13.8125 7.8125C14.0938 7.5 14.5625 7.4375 14.875 7.6875C15.5938 8.28125 16 9.125 16 10C16 10.9062 15.5938 11.75 14.875 12.3438C14.75 12.4375 14.5625 12.5 14.4062 12.5C14.375 12.5 14.375 12.5 14.3438 12.5L15.75 13.5625C15.7812 13.5312 15.7812 13.5 15.8125 13.4688C16.875 12.625 17.5 11.3438 17.5 10C17.5 8.6875 16.875 7.40625 15.8125 6.59375C15.5 6.3125 15.4375 5.84375 15.7188 5.53125C15.9688 5.1875 16.4375 5.15625 16.7812 5.40625C18.1875 6.53125 19 8.21875 19 10C19 11.7188 18.2188 13.3438 16.9375 14.5L19.6875 16.6875ZM2 8.5C2 7.9375 2.3125 7.46875 2.75 7.21875L12 14.4375V16C12 16.4062 11.75 16.75 11.4062 16.9375C11.25 17 11.125 17 11 17C10.75 17 10.5 16.9375 10.3125 16.7188L6.09375 13H3.5C2.65625 13 2 12.3438 2 11.5V8.5Z",
    fill: "currentColor"
  })), React__default.createElement("defs", null, React__default.createElement("clipPath", {
    id: "clip0_21837_12311"
  }, React__default.createElement("rect", {
    width: "20",
    height: "20",
    fill: "currentColor"
  }))));
};

var UnMutedIcon$1 = function UnMutedIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size;
  return React__default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default.createElement("g", {
    clipPath: "url(#clip0_21837_11371)"
  }, React__default.createElement("path", {
    d: "M11.4062 3.09375C11.75 3.25 12 3.625 12 4V16C12 16.4062 11.75 16.75 11.4062 16.9375C11.0312 17.0938 10.625 17.0312 10.3125 16.75L6.09375 13H4C2.875 13 2 12.125 2 11V9C2 7.90625 2.875 7 4 7H6.09375L10.3125 3.28125C10.625 3 11.0312 2.9375 11.4062 3.09375ZM16.7812 5.34375C18.125 6.46875 19 8.125 19 10C19 11.9062 18.125 13.5625 16.7812 14.6562C16.4375 14.9375 15.9688 14.875 15.7188 14.5625C15.4375 14.25 15.5 13.7812 15.8125 13.5C16.8438 12.6875 17.5 11.4375 17.5 10C17.5 8.59375 16.8438 7.34375 15.8125 6.53125C15.5 6.25 15.4688 5.78125 15.7188 5.46875C15.9688 5.15625 16.4375 5.09375 16.7812 5.34375ZM14.875 7.6875C15.5625 8.25 16 9.0625 16 10C16 10.9688 15.5625 11.7812 14.875 12.3438C14.5625 12.5938 14.0938 12.5625 13.8125 12.2188C13.5625 11.9062 13.625 11.4375 13.9375 11.1875C14.2812 10.9062 14.5 10.4688 14.5 10C14.5 9.53125 14.2812 9.125 13.9375 8.84375C13.625 8.59375 13.5625 8.125 13.8125 7.78125C14.0938 7.46875 14.5625 7.4375 14.875 7.6875Z",
    fill: "currentColor"
  })), React__default.createElement("defs", null, React__default.createElement("clipPath", {
    id: "clip0_21837_11371"
  }, React__default.createElement("rect", {
    width: "20",
    height: "20",
    fill: "currentColor"
  }))));
};

var css$x = ".SoundControlButton_module_content__05860fad{align-items:center;background:rgba(0,0,0,.2);border-radius:100%;cursor:pointer;display:flex;justify-content:center;padding:6px;position:absolute;right:10px;top:10px;z-index:1}.SoundControlButton_module_content__05860fad path{fill:#fff}";
var modules_0f4f5e0c$1 = {"content":"SoundControlButton_module_content__05860fad"};
n(css$x,{});

var SoundControlButton$1 = function SoundControlButton(_ref) {
  var className = _ref.className,
    toggleMute = _ref.toggleMute,
    muted = _ref.muted,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size;
  return React__default.createElement("div", {
    className: classNames(className, modules_0f4f5e0c$1.content),
    onClick: toggleMute
  }, muted ? React__default.createElement(MutedIcon$1, {
    size: size
  }) : React__default.createElement(UnMutedIcon$1, {
    size: size
  }));
};

var CarouselItem$1 = function CarouselItem(_ref) {
  var _attachment$medium, _attachment$medium2;
  var attachment = _ref.attachment,
    style = _ref.style,
    onClick = _ref.onClick;
  var _useToggle = useToggle(),
    muted = _useToggle.muted,
    toggleMute = _useToggle.toggleMute;
  return React__default.createElement("div", {
    className: modules_ee2c7f53$1.item,
    style: style,
    "data-cy": DATA_CY_NAMES.CAROUSEL.GALLERY_ITEM
  }, ((_attachment$medium = attachment.medium) == null ? void 0 : _attachment$medium.type) === 'image' && React__default.createElement("div", {
    "data-cy": DATA_CY_NAMES.CAROUSEL.GALLERY_IMAGE,
    className: modules_ee2c7f53$1.imageItem,
    onClick: onClick,
    style: {
      backgroundImage: "url('" + attachment.medium.sizes.lightbox.src + "')"
    }
  }), ((_attachment$medium2 = attachment.medium) == null ? void 0 : _attachment$medium2.type) === 'video' && React__default.createElement(React__default.Fragment, null, React__default.createElement(SoundControlButton$1, {
    muted: muted,
    toggleMute: toggleMute
  }), React__default.createElement(VideoPlayer, {
    className: modules_ee2c7f53$1.videoItem,
    height: "100%",
    width: "100%",
    video: attachment.medium,
    muted: muted
  })));
};

var VIDEO_CAROUSEL_OFFSET = 16;
var Carousel$1 = function Carousel(_ref) {
  var attachments = _ref.attachments,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'desktop' : _ref$variant;
  var _useLightbox = useLightbox(),
    handleOpenLightbox = _useLightbox.handleOpenLightbox,
    lightbox = _useLightbox.lightbox,
    enableLightbox = _useLightbox.enableLightbox;
  var _useState = useState(0),
    activeSlide = _useState[0],
    setActiveSlide = _useState[1];
  var _useState2 = useState(0),
    height = _useState2[0],
    setHeight = _useState2[1];
  var carousel = useMemo(function () {
    var _attachments$activeSl, _attachments$activeSl2;
    var isDesktop = variant === 'desktop';
    var isAttachmentVideo = ((_attachments$activeSl = attachments[activeSlide]) == null ? void 0 : (_attachments$activeSl2 = _attachments$activeSl.medium) == null ? void 0 : _attachments$activeSl2.type) === 'video';
    var hasSpecialPlacement = isDesktop && isAttachmentVideo;
    return {
      style: {
        aspectRatioClassNames: hasSpecialPlacement ? modules_794cd056$1.aspectRatioVideo : modules_794cd056$1.aspectRatio,
        aspectRatioStyles: hasSpecialPlacement ? {
          height: "calc(100% - " + VIDEO_CAROUSEL_OFFSET + "px)",
          transform: "translateY(" + VIDEO_CAROUSEL_OFFSET / 2 + "px)"
        } : {},
        carouselPadding: hasSpecialPlacement ? VIDEO_CAROUSEL_OFFSET : 0
      }
    };
  }, [activeSlide]);
  var elementRef = useCallback(function (node) {
    if (!node) return;
    var resizeObserver = new ResizeObserver(function () {
      node && setHeight(node == null ? void 0 : node.clientHeight);
    });
    resizeObserver.observe(node);
  }, []);
  var getCarouselStyle = useCallback(function () {
    var styles = {};
    var activeAttachment = attachments[activeSlide];
    if (activeAttachment) {
      var heightRatio = calcHeightRatioFromDimensions(activeAttachment);
      if (heightRatio) {
        styles.paddingBottom = "calc(" + heightRatio + "% + " + carousel.style.carouselPadding + "px)";
        styles.margin = "-" + carousel.style.carouselPadding / 2 + "px 0";
      }
    }
    return styles;
  }, [activeSlide, attachments]);
  var getTrasformTraslateX = function getTrasformTraslateX(all, activeSlide) {
    var inactiveSlides = 2;
    if (activeSlide > all - inactiveSlides) {
      return "translateX(-" + (all - 2 - inactiveSlides) * 9 + "px)";
    }
    if (activeSlide < inactiveSlides) {
      return "translateX(9px)";
    }
    return "translateX(-" + (activeSlide - inactiveSlides) * 9 + "px)";
  };
  var getDotStyle = function getDotStyle(index) {
    return index * 9 + "px";
  };
  return React__default.createElement("div", {
    className: modules_794cd056$1.carousel,
    style: _extends({}, getCarouselStyle())
  }, React__default.createElement("div", {
    className: carousel.style.aspectRatioClassNames,
    style: carousel.style.aspectRatioStyles,
    ref: elementRef
  }, React__default.createElement(NukaCarousel, {
    slideIndex: activeSlide,
    disableEdgeSwiping: true,
    beforeSlide: function beforeSlide(currentSlide, endSlide) {
      return setActiveSlide(endSlide);
    },
    renderCenterLeftControls: function renderCenterLeftControls(p) {
      return p.currentSlide !== 0 && React__default.createElement("div", {
        className: modules_794cd056$1.arrow,
        onClick: p.previousSlide,
        "data-cy": DATA_CY_NAMES.CAROUSEL.ARROW.PREVIOUS
      }, React__default.createElement(Icon, {
        icon: faChevronLeft
      }));
    },
    renderCenterRightControls: function renderCenterRightControls(p) {
      return p.currentSlide !== p.slideCount - 1 && React__default.createElement("div", {
        className: modules_794cd056$1.arrow,
        onClick: p.nextSlide,
        "data-cy": DATA_CY_NAMES.CAROUSEL.ARROW.NEXT
      }, React__default.createElement(Icon, {
        icon: faChevronRight
      }));
    },
    renderBottomCenterControls: null
  }, attachments.map(function (attachment, i) {
    return React__default.createElement(CarouselItem$1, {
      key: i,
      attachment: attachment,
      style: {
        height: height
      },
      onClick: function onClick() {
        return handleOpenLightbox(i);
      }
    });
  }))), React__default.createElement("div", {
    className: modules_794cd056$1.pagingDots
  }, React__default.createElement("div", {
    className: modules_794cd056$1.pagingDotsSlide,
    style: {
      width: attachments.length * 9 + "px",
      transform: getTrasformTraslateX(attachments.length, activeSlide),
      transition: '0.3s all ease-in-out'
    }
  }, attachments.map(function (attachment, index) {
    var _attachment$medium;
    return React__default.createElement("div", {
      key: ((_attachment$medium = attachment.medium) == null ? void 0 : _attachment$medium.id) + "-" + index,
      style: {
        left: getDotStyle(index)
      },
      className: classNames(modules_794cd056$1.dot, activeSlide === index && modules_794cd056$1.active, (activeSlide - 2 === index || activeSlide + 2 === index) && modules_794cd056$1.small, (activeSlide - 1 > index || activeSlide + 1 < index) && modules_794cd056$1.hidden),
      onClick: function onClick() {
        return setActiveSlide(index);
      }
    });
  }))), enableLightbox && React__default.createElement(AttachmentsLightBox$1, {
    onInit: function onInit(_ref2) {
      var instance = _ref2.instance;
      return lightbox.current = instance;
    },
    attachments: attachments.filter(function (attachment) {
      var _attachment$medium2;
      return (attachment == null ? void 0 : (_attachment$medium2 = attachment.medium) == null ? void 0 : _attachment$medium2.type) === 'image';
    })
  }));
};

var Post$1 = function Post(_ref) {
  var content = _ref.content,
    use12hourFormat = _ref.use12hourFormat,
    formatDateTime = _ref.formatDateTime,
    style = _ref.style,
    videoPlayer = _ref.videoPlayer,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var attachments = getSegmentedAttachments(content);
  return React__default.createElement(PostWrapper$1, {
    style: style,
    variant: "desktop",
    contentType: content.type,
    contentSubtype: content.subtype
  }, React__default.createElement(Header$2, {
    content: content,
    use12hourFormat: use12hourFormat,
    formatDateTime: formatDateTime,
    onEditDateTimeClick: onEditDateTimeClick
  }), attachments.hasImages && !attachments.hasVideos && React__default.createElement(React__default.Fragment, null, attachments.images.length === 1 && React__default.createElement(Image, {
    image: attachments.images[0]
  }), attachments.images.length > 1 && React__default.createElement(Carousel$1, {
    attachments: attachments.images
  })), attachments.hasVideos && !attachments.hasImages && React__default.createElement(React__default.Fragment, null, attachments.videos.length === 1 && React__default.createElement(VideoPlayer, {
    video: attachments.videos[0].medium,
    videoElement: videoPlayer
  }), attachments.videos.length > 1 && React__default.createElement(Carousel$1, {
    attachments: attachments.videos
  })), attachments.hasImages && attachments.hasVideos && React__default.createElement(Carousel$1, {
    attachments: attachments.all
  }), React__default.createElement(ActionButtons, null), React__default.createElement(TextContent$1, {
    content: content
  }));
};

var css$y = ".Header_module_header__4bb82f39{align-items:center;display:grid;font-size:14px;grid-template-columns:auto auto 1fr;left:0;padding:16px;position:absolute;top:0;width:100%;z-index:2}.Header_module_header__4bb82f39 .Header_module_title__4bb82f39{color:#fff;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.Header_module_header__4bb82f39 .Header_module_time__4bb82f39{color:#fff;margin-left:8px;opacity:.7;padding-right:70px;white-space:nowrap}.Header_module_header__4bb82f39 .Header_module_photo__4bb82f39{align-items:center;border:1px solid #fff;border-radius:100%;display:flex;justify-content:center;margin-right:8px}[data-preview-variant=desktop] .Header_module_header__4bb82f39{top:8px}";
var modules_773fac34$3 = {"header":"Header_module_header__4bb82f39","title":"Header_module_title__4bb82f39","time":"Header_module_time__4bb82f39","photo":"Header_module_photo__4bb82f39"};
n(css$y,{});

var Header$3 = function Header(_ref) {
  var _page$username, _page$logo_src;
  var _ref$content = _ref.content,
    page = _ref$content.page,
    time = _ref$content.time,
    date = _ref$content.date,
    attachments = _ref$content.attachments,
    formatDateTime = _ref.formatDateTime,
    use12hourFormat = _ref.use12hourFormat,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var name = (_page$username = page.username) != null ? _page$username : page.name;
  var collaborators = attachments == null ? void 0 : attachments.collaborators;
  var renderDateTime = function renderDateTime() {
    return React__default.createElement(DateTime, Object.assign({}, {
      time: time,
      date: date,
      use12hourFormat: use12hourFormat,
      formatDateTime: formatDateTime,
      className: modules_773fac34$3.time
    }));
  };
  return React__default.createElement("div", {
    className: modules_773fac34$3.header
  }, React__default.createElement(Avatar, {
    size: 28,
    name: name,
    color: "blue",
    src: (_page$logo_src = page.logo_src) != null ? _page$logo_src : undefined,
    className: modules_773fac34$3.photo
  }), React__default.createElement(InstagramUserName, {
    name: name,
    collaborators: collaborators,
    className: modules_773fac34$3.title
  }), onEditDateTimeClick ? React__default.createElement(DateTooltip, Object.assign({}, {
    time: time,
    date: date,
    use12hourFormat: use12hourFormat,
    onEditDateTimeClick: onEditDateTimeClick
  }), renderDateTime()) : renderDateTime());
};

var css$z = ".StoryPlaybackIndicator_module_slider__4868c13d{display:flex;flex-wrap:nowrap;height:10px;left:0;padding:8px 16px;position:absolute;top:0;width:100%;z-index:2}.StoryPlaybackIndicator_module_slider__4868c13d .StoryPlaybackIndicator_module_slide__4868c13d{background:hsla(0,0%,100%,.5);border-radius:10%;flex:1;height:3px;overflow:hidden;position:relative}.StoryPlaybackIndicator_module_slider__4868c13d .StoryPlaybackIndicator_module_slide__4868c13d+.StoryPlaybackIndicator_module_slide__4868c13d{margin-left:5px}.StoryPlaybackIndicator_module_slider__4868c13d .StoryPlaybackIndicator_module_slide__4868c13d .StoryPlaybackIndicator_module_slidePlayback__4868c13d{background-color:#fff;border-radius:10%;height:100%;left:0;position:absolute;top:0;width:0;will-change:width}[data-preview-variant=mobile] .StoryPlaybackIndicator_module_slider__4868c13d{padding:4px 16px}";
var modules_2d02a964$1 = {"slider":"StoryPlaybackIndicator_module_slider__4868c13d","slide":"StoryPlaybackIndicator_module_slide__4868c13d","slidePlayback":"StoryPlaybackIndicator_module_slidePlayback__4868c13d"};
n(css$z,{});

var StoryPlaybackIndicator$1 = function StoryPlaybackIndicator(_ref) {
  var count = _ref.count,
    playbackRatio = _ref.playbackRatio,
    activeSlide = _ref.activeSlide;
  var slides = new Array(count).fill(0);
  return React__default.createElement("div", {
    className: modules_2d02a964$1.slider
  }, slides.map(function (_, index) {
    return React__default.createElement("div", {
      className: modules_2d02a964$1.slide,
      key: index
    }, React__default.createElement("div", {
      className: modules_2d02a964$1.slidePlayback,
      style: {
        width: index === activeSlide ? playbackRatio + "%" : index < activeSlide ? '100%' : '0%'
      }
    }));
  }));
};

var css$A = ".StoriesSlider_module_pager__f1e9f4c2{height:100%;left:0;position:absolute;top:0;width:100%}.StoriesSlider_module_pager__f1e9f4c2 .StoriesSlider_module_pagerLeft__f1e9f4c2{background:linear-gradient(90deg,rgba(0,0,0,.5),transparent);cursor:pointer;height:100%;left:0;opacity:0;position:absolute;top:0;transition:opacity 199ms cubic-bezier(0,0,.21,1.11);width:33.3%;z-index:1}.StoriesSlider_module_pager__f1e9f4c2 .StoriesSlider_module_pagerLeft__f1e9f4c2:hover{opacity:1}.StoriesSlider_module_pager__f1e9f4c2 .StoriesSlider_module_pagerRight__f1e9f4c2{background:linear-gradient(90deg,transparent,rgba(0,0,0,.5));cursor:pointer;height:100%;opacity:0;position:absolute;right:0;top:0;transition:opacity 199ms cubic-bezier(0,0,.21,1.11);width:33.3%;z-index:1}.StoriesSlider_module_pager__f1e9f4c2 .StoriesSlider_module_pagerRight__f1e9f4c2:hover{opacity:1}.StoriesSlider_module_controls__f1e9f4c2{align-items:center;color:#fff;display:flex;height:64px;justify-content:center;position:absolute;right:16px;top:-2px;z-index:10}.StoriesSlider_module_controls__f1e9f4c2 .StoriesSlider_module_btn__f1e9f4c2{align-items:center;border-radius:50%;cursor:pointer;display:flex;height:25px;justify-content:center;width:25px}.StoriesSlider_module_controls__f1e9f4c2 .StoriesSlider_module_btn__f1e9f4c2+.StoriesSlider_module_btn__f1e9f4c2{margin-left:8px}.StoriesSlider_module_controls__f1e9f4c2 .StoriesSlider_module_mute__f1e9f4c2{background-color:transparent;padding:0;position:relative;right:auto!important;top:auto!important}[data-preview-variant=desktop] .StoriesSlider_module_controls__f1e9f4c2{top:8px}";
var modules_bbff2ee4$1 = {"pager":"StoriesSlider_module_pager__f1e9f4c2","pagerLeft":"StoriesSlider_module_pagerLeft__f1e9f4c2","pagerRight":"StoriesSlider_module_pagerRight__f1e9f4c2","controls":"StoriesSlider_module_controls__f1e9f4c2","btn":"StoriesSlider_module_btn__f1e9f4c2","mute":"StoriesSlider_module_mute__f1e9f4c2"};
n(css$A,{});

var css$B = ".StoriesSlide_module_item__9f9e5f0b{align-items:center;background:#4e5656;display:flex;height:100%;overflow:hidden;position:relative;width:100%}.StoriesSlide_module_item__9f9e5f0b .StoriesSlide_module_imageItem__9f9e5f0b{background-position:50%;background-size:cover;height:auto;object-fit:cover;width:100%;z-index:1}.StoriesSlide_module_item__9f9e5f0b .StoriesSlide_module_videoItem__9f9e5f0b{height:auto;object-fit:cover;width:100%;z-index:1}.StoriesSlide_module_item__9f9e5f0b .StoriesSlide_module_bgImage__9f9e5f0b{background:no-repeat;background-size:auto 100%;filter:blur(50px);height:100%;left:0;opacity:.5;pointer-events:none;position:absolute;top:0;width:100%}.StoriesSlide_module_item__9f9e5f0b video{object-fit:cover;object-position:center}";
var modules_1bbc0535$1 = {"item":"StoriesSlide_module_item__9f9e5f0b","imageItem":"StoriesSlide_module_imageItem__9f9e5f0b","videoItem":"StoriesSlide_module_videoItem__9f9e5f0b","bgImage":"StoriesSlide_module_bgImage__9f9e5f0b"};
n(css$B,{});

var StoriesSlideImage$1 = function StoriesSlideImage(_ref) {
  var attachment = _ref.attachment,
    customControls = _ref.customControls;
  useEffect(function () {
    customControls == null ? void 0 : customControls.play();
  }, [customControls]);
  return React__default.createElement("img", {
    className: modules_1bbc0535$1.imageItem,
    src: attachment.medium.sizes.lightbox.src,
    "data-cy": "post-preview_story-slide-image"
  });
};

var StoriesSlide$1 = function StoriesSlide(_ref) {
  var _attachment$medium$si, _attachment$medium$or, _attachment$medium, _attachment$medium2;
  var attachment = _ref.attachment,
    _ref$autoplay = _ref.autoplay,
    autoplay = _ref$autoplay === void 0 ? false : _ref$autoplay,
    style = _ref.style,
    muted = _ref.muted,
    customControls = _ref.customControls;
  var bgImage = attachment.medium && (attachment.medium.type === 'image' ? (_attachment$medium$si = attachment.medium.sizes) == null ? void 0 : _attachment$medium$si.lightbox.src : (_attachment$medium$or = attachment.medium.original_thumb) == null ? void 0 : _attachment$medium$or.src);
  return React__default.createElement("div", {
    className: modules_1bbc0535$1.item,
    style: style,
    "data-cy": "post-preview_gallery"
  }, bgImage && React__default.createElement("div", {
    className: modules_1bbc0535$1.bgImage,
    style: {
      backgroundImage: "url('" + bgImage + "')"
    }
  }), ((_attachment$medium = attachment.medium) == null ? void 0 : _attachment$medium.type) === 'image' && React__default.createElement(StoriesSlideImage$1, {
    customControls: customControls,
    attachment: attachment
  }), ((_attachment$medium2 = attachment.medium) == null ? void 0 : _attachment$medium2.type) === 'video' && React__default.createElement(VideoPlayer, {
    className: modules_1bbc0535$1.videoItem,
    height: "100%",
    width: "100%",
    autoplay: autoplay,
    muted: muted,
    video: attachment.medium,
    controls: false,
    customControls: customControls,
    allowFullScreenControls: false
  }));
};

var PlayIcon$1 = function PlayIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size;
  return React__default.createElement("svg", {
    fill: "currentColor",
    height: size,
    viewBox: "0 0 48 48",
    width: size
  }, React__default.createElement("path", {
    d: "M9.6 46.5c-1 0-2-.3-2.9-.8-1.8-1.1-2.9-2.9-2.9-5.1V7.3c0-2.1 1.1-4 2.9-5.1 1.9-1.1 4.1-1.1 5.9 0l30.1 17.6c1.5.9 2.3 2.4 2.3 4.1 0 1.7-.9 3.2-2.3 4.1L12.6 45.7c-.9.5-2 .8-3 .8z"
  }));
};

var PauseIcon$1 = function PauseIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size;
  return React__default.createElement("svg", {
    fill: "currentColor",
    height: size,
    viewBox: "0 0 48 48",
    width: size
  }, React__default.createElement("path", {
    d: "M15 1c-3.3 0-6 1.3-6 3v40c0 1.7 2.7 3 6 3s6-1.3 6-3V4c0-1.7-2.7-3-6-3zm18 0c-3.3 0-6 1.3-6 3v40c0 1.7 2.7 3 6 3s6-1.3 6-3V4c0-1.7-2.7-3-6-3z"
  }));
};

var iconSize$1 = 16;
var StoriesSlider$2 = function StoriesSlider(_ref) {
  var _attachments$activeSl;
  var attachments = _ref.attachments,
    activeSlide = _ref.activeSlide,
    prevSlide = _ref.prevSlide,
    nextSlide = _ref.nextSlide,
    autoplay = _ref.autoplay,
    playbackPaused = _ref.playbackPaused,
    playPlayback = _ref.playPlayback,
    pausePlayback = _ref.pausePlayback;
  var _useToggle = useToggle(!!autoplay),
    muted = _useToggle.muted,
    toggleMute = _useToggle.toggleMute;
  return React__default.createElement("div", {
    className: modules_bbff2ee4$1.pager
  }, React__default.createElement(StoriesSlide$1, {
    autoplay: autoplay,
    attachment: attachments[activeSlide],
    muted: muted,
    customControls: {
      isPlaying: !playbackPaused,
      play: playPlayback,
      pause: pausePlayback
    }
  }), activeSlide !== 0 && React__default.createElement("div", {
    className: modules_bbff2ee4$1.pagerLeft,
    onClick: prevSlide
  }), activeSlide !== attachments.length - 1 && React__default.createElement("div", {
    className: modules_bbff2ee4$1.pagerRight,
    onClick: nextSlide
  }), React__default.createElement("div", {
    className: modules_bbff2ee4$1.controls
  }, !playbackPaused && React__default.createElement("div", {
    className: modules_bbff2ee4$1.btn,
    onClick: function onClick() {
      pausePlayback();
    }
  }, React__default.createElement(PauseIcon$1, {
    size: iconSize$1
  })), playbackPaused && React__default.createElement("div", {
    className: modules_bbff2ee4$1.btn,
    onClick: function onClick() {
      playPlayback();
    }
  }, React__default.createElement(PlayIcon$1, {
    size: iconSize$1
  })), ((_attachments$activeSl = attachments[activeSlide].medium) == null ? void 0 : _attachments$activeSl.type) === 'video' && React__default.createElement(SoundControlButton$1, {
    muted: muted,
    toggleMute: toggleMute,
    className: classNames(modules_bbff2ee4$1.btn, modules_bbff2ee4$1.mute),
    size: iconSize$1
  })));
};
var StoriesSlider$3 = /*#__PURE__*/React__default.memo(StoriesSlider$2, function (prevProps, nextProps) {
  return prevProps.activeSlide === nextProps.activeSlide && prevProps.attachments === nextProps.attachments && prevProps.playbackPaused === nextProps.playbackPaused;
});

var defaultSlidePlaybackTime$1 = 15;
var defaultSlideAdditionalTime$1 = 0;
function getSlidePlaybackTime$1(attachment) {
  function getTime() {
    var _attachment$medium;
    if ((attachment == null ? void 0 : (_attachment$medium = attachment.medium) == null ? void 0 : _attachment$medium.type) === 'video' && attachment != null && attachment.medium.meta.duration) {
      return Math.max(0, Math.min(attachment.medium.meta.duration, 60));
    }
    return defaultSlidePlaybackTime$1;
  }
  return (getTime() + defaultSlideAdditionalTime$1) * 1000;
}
function useStoryPlayback$1(_ref) {
  var attachments = _ref.attachments;
  var _useState = useState(0),
    activeSlide = _useState[0],
    setActiveSlide = _useState[1];
  var _useState2 = useState(0),
    ratio = _useState2[0],
    setRatio = _useState2[1];
  var _useState3 = useState(false),
    playing = _useState3[0],
    setPlaying = _useState3[1];
  var requestRef = useRef(null);
  var previousTimeRef = useRef(null);
  var updatePlayback = function updatePlayback(time) {
    if (!playing) {
      previousTimeRef.current = null;
      return;
    }
    if (previousTimeRef.current !== null) {
      var deltaTime = time - previousTimeRef.current;
      var slidePlaybackTime = getSlidePlaybackTime$1(attachments[activeSlide]);
      var step = 100 / slidePlaybackTime * deltaTime;
      setRatio(function (prev) {
        return prev + step;
      });
    }
    previousTimeRef.current = time;
    requestRef.current = requestAnimationFrame(updatePlayback);
  };
  useEffect(function () {
    if (playing) {
      requestRef.current = requestAnimationFrame(updatePlayback);
    } else if (requestRef.current !== null) {
      cancelAnimationFrame(requestRef.current);
      requestRef.current = null;
    }
    return function () {
      if (requestRef.current !== null) {
        cancelAnimationFrame(requestRef.current);
        requestRef.current = null;
      }
    };
  }, [playing, activeSlide]);
  useEffect(function () {
    if (ratio > 100) {
      nextSlide();
      resetPlaybackRatio();
    }
  }, [ratio]);
  useEffect(function () {
    if (activeSlide === attachments.length - 1 && ratio > 100) {
      pause();
    }
  }, [activeSlide, ratio]);
  function nextSlide() {
    resetPlaybackRatio();
    setActiveSlide(function (prev) {
      return prev === attachments.length - 1 ? 0 : prev + 1;
    });
  }
  function prevSlide() {
    resetPlaybackRatio();
    setActiveSlide(function (prev) {
      return prev === 0 ? 0 : prev - 1;
    });
  }
  function pause() {
    setPlaying(false);
    if (previousTimeRef.current !== null) {
      cancelAnimationFrame(previousTimeRef.current);
      previousTimeRef.current = null;
    }
  }
  function play() {
    setPlaying(true);
  }
  function resetPlaybackRatio() {
    setRatio(0);
  }
  return {
    activeSlide: activeSlide,
    ratio: ratio,
    playing: playing,
    play: play,
    pause: pause,
    prevSlide: prevSlide,
    nextSlide: nextSlide
  };
}

var Story$1 = function Story(_ref) {
  var attachments = _ref.attachments,
    _ref$autoplay = _ref.autoplay,
    autoplay = _ref$autoplay === void 0 ? true : _ref$autoplay;
  var playback = useStoryPlayback$1({
    attachments: attachments
  });
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(StoryPlaybackIndicator$1, {
    count: attachments.length,
    activeSlide: playback.activeSlide,
    playbackRatio: playback.ratio
  }), React__default.createElement(StoriesSlider$3, {
    autoplay: autoplay,
    attachments: attachments,
    playbackPaused: !playback.playing,
    playPlayback: playback.play,
    pausePlayback: playback.pause,
    activeSlide: playback.activeSlide,
    nextSlide: playback.nextSlide,
    prevSlide: playback.prevSlide
  }));
};

var css$C = ".StoryPost_module_content__60ed426b{height:0;padding-bottom:177.78%;position:relative;width:100%}.StoryPost_module_content__60ed426b .StoryPost_module_aspectRatio__60ed426b{height:100%;left:0;position:absolute;top:0;width:100%}";
var modules_675aeda3 = {"content":"StoryPost_module_content__60ed426b","aspectRatio":"StoryPost_module_aspectRatio__60ed426b"};
n(css$C,{});

var css$D = ".Footer_module_footer__459dab4b{align-items:center;bottom:0;color:#fff;display:flex;left:0;padding:16px;position:absolute;width:100%;z-index:1}.Footer_module_footer__459dab4b .Footer_module_fakeInput__459dab4b{border:1px solid #fff;border-radius:25px;color:#e4e7eb;flex:1;margin-right:16px;padding:12px 24px}.Footer_module_footer__459dab4b .Footer_module_icons__459dab4b{display:flex}.Footer_module_footer__459dab4b .Footer_module_icons__459dab4b>:not(:last-child){margin-right:16px}[data-preview-variant=mobile] .Footer_module_footer__459dab4b{padding:8px 16px 44px;position:relative}[data-preview-variant=mobile] .Footer_module_footer__459dab4b:after{background-color:#fff;border-radius:3px;bottom:10px;content:\" \";left:0;margin:auto;padding:2px;position:absolute;right:0;width:40%}[data-preview-variant=mobile] .Footer_module_footer__459dab4b .Footer_module_fakeInput__459dab4b{padding:8px 16px}";
var modules_93eb7477$2 = {"footer":"Footer_module_footer__459dab4b","fakeInput":"Footer_module_fakeInput__459dab4b","icons":"Footer_module_icons__459dab4b"};
n(css$D,{});

var Footer$3 = function Footer(_ref) {
  var size = _ref.size;
  return React__default.createElement("div", {
    className: modules_93eb7477$2.footer
  }, React__default.createElement("div", {
    className: modules_93eb7477$2.fakeInput
  }, "Send message..."), React__default.createElement("div", {
    className: modules_93eb7477$2.icons
  }, React__default.createElement(HeartIcon, {
    size: size
  }), React__default.createElement(ShareIcon, {
    size: size
  })));
};

var StoryPost$1 = function StoryPost(_ref) {
  var content = _ref.content,
    use12hourFormat = _ref.use12hourFormat,
    formatDateTime = _ref.formatDateTime,
    style = _ref.style,
    onEditDateTimeClick = _ref.onEditDateTimeClick,
    videoPlayer = _ref.videoPlayer;
  return React__default.createElement(PostWrapper$1, {
    style: style,
    variant: "desktop",
    contentType: content.type,
    contentSubtype: content.subtype
  }, React__default.createElement("div", {
    className: modules_675aeda3.content
  }, React__default.createElement("div", {
    className: modules_675aeda3.aspectRatio
  }, React__default.createElement(Header$3, {
    content: content,
    use12hourFormat: use12hourFormat,
    formatDateTime: formatDateTime,
    onEditDateTimeClick: onEditDateTimeClick
  }), content.attachments.cards.length > 0 && React__default.createElement(Story$1, {
    autoplay: videoPlayer == null ? void 0 : videoPlayer.autoPlay,
    attachments: content.attachments.cards
  }))), React__default.createElement(Footer$3, null));
};

var css$E = ".ReelPost_module_content__25724fc8{height:0;padding-bottom:177%;position:relative;width:100%}.ReelPost_module_content__25724fc8 .ReelPost_module_aspectRatio__25724fc8{height:100%;left:0;position:absolute;top:0;width:100%}.ReelPost_module_reel__25724fc8{align-items:center;display:flex;height:100%;position:relative}.ReelPost_module_reel__25724fc8 .ReelPost_module_videoWrapper__25724fc8{width:100%}.ReelPost_module_reel__25724fc8 .ReelPost_module_reelDescription__25724fc8{bottom:0;left:0;position:absolute}.ReelPost_module_reel__25724fc8 .ReelPost_module_iconsWrapper__25724fc8{color:#fff;cursor:pointer;margin-bottom:auto;position:absolute;right:14px;top:14px}";
var modules_f6e714cb = {"content":"ReelPost_module_content__25724fc8","aspectRatio":"ReelPost_module_aspectRatio__25724fc8","reel":"ReelPost_module_reel__25724fc8","videoWrapper":"ReelPost_module_videoWrapper__25724fc8","reelDescription":"ReelPost_module_reelDescription__25724fc8","iconsWrapper":"ReelPost_module_iconsWrapper__25724fc8"};
n(css$E,{});

var MoreIcon = function MoreIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size;
  return React__default.createElement("svg", {
    "aria-label": "More options",
    fill: "currentColor",
    height: size,
    role: "img",
    viewBox: "0 0 24 24",
    width: size
  }, React__default.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "1.5"
  }), React__default.createElement("circle", {
    cx: "6",
    cy: "12",
    r: "1.5"
  }), React__default.createElement("circle", {
    cx: "18",
    cy: "12",
    r: "1.5"
  }));
};

var css$F = ".ReelControls_module_hyperText__59857a01.ReelControls_module_hyperText__59857a01 a{color:currentColor;opacity:.7}.ReelControls_module_descriptionWrapper__59857a01{background:linear-gradient(180deg,transparent,rgba(0,0,0,.25));bottom:0;color:#fff;cursor:pointer;display:flex;font-size:12px;justify-content:\"space-between\";left:0;overflow:visible;pointer-events:none;position:absolute;width:100%}.ReelControls_module_descriptionWrapper__59857a01 .ReelControls_module_description__59857a01{margin-top:auto;padding:14px 50px 14px 14px;pointer-events:auto;position:relative;width:100%}.ReelControls_module_descriptionWrapper__59857a01 .ReelControls_module_description__59857a01 .ReelControls_module_profile__59857a01{align-items:center;display:flex}.ReelControls_module_descriptionWrapper__59857a01 .ReelControls_module_description__59857a01 .ReelControls_module_profile__59857a01 .ReelControls_module_externalLink__59857a01{width:calc(100% - 50px)}.ReelControls_module_descriptionWrapper__59857a01 .ReelControls_module_description__59857a01 .ReelControls_module_profile__59857a01 .ReelControls_module_profileInfo__59857a01{display:flex;font-weight:600}.ReelControls_module_descriptionWrapper__59857a01 .ReelControls_module_description__59857a01 .ReelControls_module_profile__59857a01 .ReelControls_module_profileInfo__59857a01>div:not(:first-of-type){margin-left:8px}.ReelControls_module_descriptionWrapper__59857a01 .ReelControls_module_description__59857a01 .ReelControls_module_profile__59857a01 .ReelControls_module_avatar__59857a01{align-items:center;border:1px solid #fff;border-radius:100%;display:flex;justify-content:center;margin-right:12px}.ReelControls_module_descriptionWrapper__59857a01 .ReelControls_module_description__59857a01 .ReelControls_module_text__59857a01{margin-right:32px;padding-top:8px}.ReelControls_module_descriptionWrapper__59857a01 .ReelControls_module_icons__59857a01{bottom:14px;position:absolute;right:14px}.ReelControls_module_descriptionWrapper__59857a01 .ReelControls_module_icons__59857a01 .ReelControls_module_icon__59857a01{align-self:center;display:flex;flex-direction:column;justify-content:center;text-align:center}.ReelControls_module_descriptionWrapper__59857a01 .ReelControls_module_icons__59857a01 .ReelControls_module_icon__59857a01 span{padding-top:10px}.ReelControls_module_descriptionWrapper__59857a01 .ReelControls_module_icons__59857a01 .ReelControls_module_icon__59857a01:not(:first-of-type){margin-top:24px}.ReelControls_module_descriptionWrapper__59857a01 .ReelControls_module_icons__59857a01 .ReelControls_module_icon__59857a01 svg{height:24px;width:24px}.ReelControls_module_reelDescriptionContentHeader__59857a01{display:flex}.ReelControls_module_reelDescription__59857a01{color:#fff;cursor:pointer;display:flex;font-size:12px;justify-content:space-between;overflow:visible;padding:14px;pointer-events:none;width:100%}.ReelControls_module_reelDescriptionContent__59857a01{margin-top:auto;overflow:hidden;pointer-events:auto}.ReelControls_module_avatarWrapper__59857a01{margin-right:6px}.ReelControls_module_externalLinkContent__59857a01{display:flex;flex:1;overflow:hidden;text-overflow:ellipsis}.ReelControls_module_userName__59857a01{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:auto;word-break:break-word}.ReelControls_module_follow__59857a01{font-weight:500}.ReelControls_module_divider__59857a01{padding:0 6px;text-align:center}.ReelControls_module_textWrapper__59857a01{line-height:16px;max-height:200px;overflow:auto;padding-top:12px}.ReelControls_module_iconsWrapper__59857a01{align-items:center;display:flex;flex-direction:column;gap:22px;justify-content:flex-end;margin-left:12px}";
var modules_81d0b6b6$1 = {"hyperText":"ReelControls_module_hyperText__59857a01","descriptionWrapper":"ReelControls_module_descriptionWrapper__59857a01","description":"ReelControls_module_description__59857a01","profile":"ReelControls_module_profile__59857a01","externalLink":"ReelControls_module_externalLink__59857a01","profileInfo":"ReelControls_module_profileInfo__59857a01","avatar":"ReelControls_module_avatar__59857a01","text":"ReelControls_module_text__59857a01","icons":"ReelControls_module_icons__59857a01","icon":"ReelControls_module_icon__59857a01","reelDescriptionContentHeader":"ReelControls_module_reelDescriptionContentHeader__59857a01","reelDescription":"ReelControls_module_reelDescription__59857a01","reelDescriptionContent":"ReelControls_module_reelDescriptionContent__59857a01","avatarWrapper":"ReelControls_module_avatarWrapper__59857a01","externalLinkContent":"ReelControls_module_externalLinkContent__59857a01","userName":"ReelControls_module_userName__59857a01","follow":"ReelControls_module_follow__59857a01","divider":"ReelControls_module_divider__59857a01","textWrapper":"ReelControls_module_textWrapper__59857a01","iconsWrapper":"ReelControls_module_iconsWrapper__59857a01"};
n(css$F,{});

var _excluded$8 = ["page", "text", "variant", "className", "collaborators"];
var iconSize$2 = 24;
var COLLAPSED_TEXT_LENGTH_OPTIONS$1 = {
  mobile: 80,
  desktop: 150
};
var ReelDescription$1 = function ReelDescription(_ref) {
  var _page$username, _page$logo_src;
  var page = _ref.page,
    text = _ref.text,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'desktop' : _ref$variant,
    className = _ref.className,
    collaborators = _ref.collaborators,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$8);
  var name = (_page$username = page.username) != null ? _page$username : page.name;
  return React__default.createElement("div", {
    className: classNames(modules_81d0b6b6$1.descriptionWrapper, className)
  }, React__default.createElement("div", {
    className: modules_81d0b6b6$1.description
  }, React__default.createElement("div", {
    className: modules_81d0b6b6$1.profile
  }, React__default.createElement(Avatar, {
    className: modules_81d0b6b6$1.avatar,
    size: iconSize$2 + 2,
    name: name,
    src: (_page$logo_src = page.logo_src) != null ? _page$logo_src : undefined
  }), React__default.createElement("div", {
    className: modules_81d0b6b6$1.externalLink
  }, React__default.createElement("div", {
    className: modules_81d0b6b6$1.externalLinkContent
  }, React__default.createElement(InstagramUserName, {
    name: name,
    collaborators: collaborators,
    className: modules_81d0b6b6$1.userName
  }), React__default.createElement("div", {
    className: modules_81d0b6b6$1.divider
  }, "\xA0\xB7\xA0"), React__default.createElement("div", {
    className: modules_81d0b6b6$1.follow
  }, "Follow")))), text && React__default.createElement("div", {
    className: modules_81d0b6b6$1.textWrapper,
    "data-cy": "post-preview_reel-description"
  }, React__default.createElement(HyperText, {
    pageType: TYPE_INSTAGRAM,
    className: modules_81d0b6b6$1.hyperText,
    options: {
      maxLength: COLLAPSED_TEXT_LENGTH_OPTIONS$1[variant],
      expandable: true,
      expandableTrigger: {
        more: ' show more',
        less: ' ...show less'
      }
    }
  }, text)), React__default.createElement("div", {
    className: modules_81d0b6b6$1.icons
  }, React__default.createElement("div", {
    className: modules_81d0b6b6$1.icon
  }, React__default.createElement(HeartIcon, {
    size: iconSize$2
  }), React__default.createElement("span", null, "320")), React__default.createElement("div", {
    className: modules_81d0b6b6$1.icon
  }, React__default.createElement(CommentIcon, {
    size: iconSize$2
  }), React__default.createElement("span", null, "120")), React__default.createElement("div", {
    className: modules_81d0b6b6$1.icon
  }, React__default.createElement(ShareIcon, {
    size: iconSize$2
  })), React__default.createElement("div", {
    className: modules_81d0b6b6$1.icon
  }, React__default.createElement(MoreIcon, {
    size: iconSize$2 - 4
  })))));
};

var css$G = "[data-preview-variant=mobile] .Reel_module_mute__1147dcc9{padding:4px!important;top:46px!important}[data-preview-variant=mobile] .Reel_module_mute__1147dcc9 svg{height:20px;width:20px}";
var modules_3c0ef345$1 = {"mute":"Reel_module_mute__1147dcc9"};
n(css$G,{});

var slidePlaybackTime$1 = 15 * 1000;
var updateInterval$1 = 1000;
function useReelPlayback$1(_ref) {
  var attachments = _ref.attachments;
  var attachment = attachments[0];
  var _useState = useState(0),
    ratio = _useState[0],
    setRatio = _useState[1];
  var _useState2 = useState(true),
    playing = _useState2[0],
    setPlaying = _useState2[1];
  useEffect(function () {
    if (!playing) {
      return;
    }
    var interval = setInterval(function () {
      setRatio(function (prev) {
        var step = 100 / (slidePlaybackTime$1 / updateInterval$1);
        return prev + step;
      });
    }, updateInterval$1);
    return function () {
      return clearInterval(interval);
    };
  }, [attachment, playing]);
  useEffect(function () {
    if (ratio >= 100) {
      resetPlaybackRatio();
    }
  }, [ratio]);
  function pause() {
    setPlaying(false);
  }
  function play() {
    setPlaying(true);
  }
  function resetPlaybackRatio() {
    setRatio(0);
  }
  return {
    ratio: ratio,
    playing: playing,
    play: play,
    pause: pause
  };
}

var css$H = ".ReelIndicator_module_slider__4b7e6562{bottom:0;display:flex;flex-wrap:nowrap;height:10px;left:0;padding:8px 0;position:absolute;width:100%;z-index:2}.ReelIndicator_module_slider__4b7e6562 .ReelIndicator_module_slide__4b7e6562{background:hsla(0,0%,100%,.5);border-radius:10%;flex:1;height:3px;overflow:hidden;position:relative}.ReelIndicator_module_slider__4b7e6562 .ReelIndicator_module_slide__4b7e6562+.ReelIndicator_module_slide__4b7e6562{margin-left:5px}.ReelIndicator_module_slider__4b7e6562 .ReelIndicator_module_slide__4b7e6562 .ReelIndicator_module_slidePlayback__4b7e6562{background-color:#fff;border-radius:10%;height:100%;left:0;position:absolute;top:0;width:0;will-change:width}[data-preview-variant=desktop] .ReelIndicator_module_slider__4b7e6562{display:none}";
var modules_a593a91f = {"slider":"ReelIndicator_module_slider__4b7e6562","slide":"ReelIndicator_module_slide__4b7e6562","slidePlayback":"ReelIndicator_module_slidePlayback__4b7e6562"};
n(css$H,{});

var ReelIndicator$1 = function ReelIndicator(_ref) {
  var playbackRatio = _ref.playbackRatio;
  return React__default.createElement("div", {
    className: modules_a593a91f.slider
  }, React__default.createElement("div", {
    className: modules_a593a91f.slide
  }, React__default.createElement("div", {
    className: modules_a593a91f.slidePlayback,
    style: {
      width: playbackRatio + "%",
      transition: "width " + updateInterval$1 + "ms linear"
    }
  })));
};

var Reel$1 = function Reel(_ref) {
  var video = _ref.video,
    page = _ref.page,
    text = _ref.text,
    variant = _ref.variant,
    collaborators = _ref.collaborators;
  var _useToggle = useToggle(),
    muted = _useToggle.muted,
    toggleMute = _useToggle.toggleMute;
  var playback = useReelPlayback$1({
    attachments: video ? [video] : []
  });
  return React__default.createElement("div", {
    className: modules_f6e714cb.reel
  }, React__default.createElement("div", {
    className: modules_f6e714cb.videoWrapper
  }, video && React__default.createElement(VideoPlayer, {
    customControls: {
      play: playback.play,
      pause: playback.pause
    },
    video: video.medium,
    controls: false,
    muted: muted
  })), React__default.createElement(ReelDescription$1, {
    page: page,
    text: text,
    variant: variant,
    collaborators: collaborators
  }), React__default.createElement(ReelIndicator$1, {
    playbackRatio: playback.ratio
  }), React__default.createElement(SoundControlButton$1, {
    muted: muted,
    toggleMute: toggleMute,
    className: modules_3c0ef345$1.mute
  }));
};

var ReelPost$1 = function ReelPost(_ref) {
  var _content$attachments;
  var content = _ref.content,
    style = _ref.style;
  var _getSegmentedAttachme = getSegmentedAttachments(content),
    videos = _getSegmentedAttachme.videos;
  var collaborators = (_content$attachments = content.attachments) == null ? void 0 : _content$attachments.collaborators;
  return React__default.createElement(PostWrapper$1, {
    style: style,
    variant: "desktop",
    contentType: content.type,
    contentSubtype: content.subtype
  }, React__default.createElement("div", {
    className: modules_f6e714cb.content
  }, React__default.createElement("div", {
    className: modules_f6e714cb.aspectRatio
  }, React__default.createElement(Reel$1, {
    video: videos[0],
    page: content.page,
    text: content.text,
    collaborators: collaborators
  }))));
};

var css$I = ".AppLayout_module_appLayout__57c0bf0e{background-color:#e4e7eb;display:flex;flex-direction:column;height:100%;overflow:hidden}.AppLayout_module_appLayout__57c0bf0e .AppLayout_module_header__57c0bf0e{background-color:#fff;display:flex;padding:12px 16px}.AppLayout_module_appLayout__57c0bf0e .AppLayout_module_header__57c0bf0e img{height:26px;width:auto}.AppLayout_module_appLayout__57c0bf0e .AppLayout_module_header__57c0bf0e img:first-of-type{margin-right:auto}.AppLayout_module_appLayout__57c0bf0e .AppLayout_module_header__57c0bf0e .AppLayout_module_actions__57c0bf0e{display:flex}.AppLayout_module_appLayout__57c0bf0e .AppLayout_module_header__57c0bf0e .AppLayout_module_actions__57c0bf0e svg{stroke-width:10px;height:22px;width:22px}.AppLayout_module_appLayout__57c0bf0e .AppLayout_module_header__57c0bf0e .AppLayout_module_actions__57c0bf0e svg+svg{margin-left:12px}.AppLayout_module_appLayout__57c0bf0e .AppLayout_module_body__57c0bf0e{flex:1 1 auto;overflow:auto}.AppLayout_module_appLayout__57c0bf0e .AppLayout_module_footer__57c0bf0e{border-top:1px solid #dbdbdb;display:flex;height:auto;justify-content:space-between;padding:12px 24px 33.5px;width:100%}";
var modules_11a4dd02$1 = {"appLayout":"AppLayout_module_appLayout__57c0bf0e","header":"AppLayout_module_header__57c0bf0e","actions":"AppLayout_module_actions__57c0bf0e","body":"AppLayout_module_body__57c0bf0e","footer":"AppLayout_module_footer__57c0bf0e"};
n(css$I,{});

var css$J = ".Footer_module_footer__48170a4d{background-color:#fff;border-top:1px solid #dbdbdb;color:#000;display:flex;height:auto;justify-content:space-between;padding:12px 24px 33.5px;position:relative;width:100%}.Footer_module_footer__48170a4d .Footer_module_icon__48170a4d{border-radius:100%}[data-content-subtype=\"3\"] .Footer_module_footer__48170a4d{background-color:#000;border:none;color:#fff}[data-content-subtype=\"3\"] .Footer_module_footer__48170a4d:after{background-color:#fff;border-radius:3px;bottom:10px;content:\" \";height:4px;left:0;margin:auto;position:absolute;right:0;width:40%;z-index:1}";
var modules_93eb7477$3 = {"footer":"Footer_module_footer__48170a4d","icon":"Footer_module_icon__48170a4d"};
n(css$J,{});

var HomeIcon$1 = function HomeIcon(_ref) {
  return React__default.createElement("svg", {
    width: "20",
    height: "18",
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99978 0.25C9.79603 0.25 9.58813 0.330704 9.43012 0.492112L1.46744 8.62621C1.07243 9.02973 0.852051 9.57342 0.852051 10.1426V16.463C0.852051 17.1723 1.41755 17.75 2.11194 17.75H6.67749C7.36357 17.75 7.92075 17.1808 7.92075 16.48V12.6572C7.92075 11.4848 8.85215 10.5334 9.99978 10.5334C11.1474 10.5334 12.0788 11.4848 12.0788 12.6572V16.48C12.0788 17.1808 12.636 17.75 13.3221 17.75H17.8876C18.582 17.75 19.1475 17.1723 19.1475 16.463V10.1426C19.1475 9.57342 18.9271 9.02973 18.5321 8.62621L10.5694 0.492112C10.4114 0.330704 10.2035 0.25 9.99978 0.25Z",
    fill: "currentColor"
  }));
};

var PlusIcon = function PlusIcon(_ref) {
  return React__default.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.499695 6.11062C0.499695 3.01169 3.01188 0.499512 6.11081 0.499512H13.8886C16.9875 0.499512 19.4997 3.01169 19.4997 6.11062V13.8884C19.4997 16.9873 16.9875 19.4995 13.8886 19.4995H6.11081C3.01187 19.4995 0.499695 16.9873 0.499695 13.8884V6.11062ZM6.11081 1.99951C3.8403 1.99951 1.99969 3.84012 1.99969 6.11062V13.8884C1.99969 16.1589 3.8403 17.9995 6.11081 17.9995H13.8886C16.1591 17.9995 17.9997 16.1589 17.9997 13.8884V6.11062C17.9997 3.84012 16.1591 1.99951 13.8886 1.99951H6.11081Z",
    fill: "currentColor"
  }), React__default.createElement("path", {
    d: "M10.7207 4.91618C10.7207 4.50197 10.3849 4.16618 9.97072 4.16618C9.55651 4.16618 9.22072 4.50196 9.22072 4.91618V9.1792H4.91636C4.50215 9.1792 4.16636 9.51499 4.16636 9.9292C4.16636 10.3434 4.50215 10.6792 4.91636 10.6792H9.22072V15.0828C9.22072 15.4971 9.55651 15.8328 9.97072 15.8328C10.3849 15.8328 10.7207 15.4971 10.7207 15.0828V10.6792H15.083C15.4972 10.6792 15.833 10.3434 15.833 9.9292C15.833 9.51499 15.4972 9.1792 15.083 9.1792H10.7207V4.91618Z",
    fill: "currentColor"
  }));
};

var SearchIcon = function SearchIcon(_ref) {
  return React__default.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.11967 0.917969C4.58735 0.917969 0.910645 4.59467 0.910645 9.127C0.910645 13.6593 4.58735 17.336 9.11967 17.336C11.0951 17.336 12.8973 16.6325 14.3109 15.4735L17.6776 18.8401C17.9997 19.1623 18.5218 19.1632 18.8451 18.8422C19.17 18.5196 19.1709 17.9943 18.8472 17.6705L15.4817 14.3051C16.6328 12.8919 17.3287 11.0941 17.3287 9.127C17.3287 4.59467 13.652 0.917969 9.11967 0.917969ZM2.56423 9.127C2.56423 5.51425 5.50693 2.57155 9.11967 2.57155C12.7324 2.57155 15.6751 5.51425 15.6751 9.127C15.6751 12.7397 12.7324 15.6824 9.11967 15.6824C5.50693 15.6824 2.56423 12.7397 2.56423 9.127Z",
    fill: "currentColor"
  }));
};

var StoreIcon = function StoreIcon(_ref) {
  return React__default.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default.createElement("path", {
    d: "M11.7083 11.028C11.9861 10.8676 11.9861 10.4667 11.7083 10.3063L7.33333 7.7804C7.05556 7.62003 6.70833 7.8205 6.70833 8.14125V13.1931C6.70833 13.5138 7.05555 13.7143 7.33333 13.5539L11.7083 11.028Z",
    fill: "currentColor"
  }), React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41667 0.25C2.11548 0.25 0.25 2.11548 0.25 4.41667V13.5833C0.25 15.8845 2.11548 17.75 4.41667 17.75H13.5833C15.8845 17.75 17.75 15.8845 17.75 13.5833V4.41667C17.75 2.11548 15.8845 0.25 13.5833 0.25H4.41667ZM6.01185 1.75L8.22852 4.52083L8.11719 4.58268H11.8007L9.53451 1.75H6.01185ZM16.25 4.58268H13.5339L13.6452 4.52083L11.4285 1.75H13.5833C15.0561 1.75 16.25 2.94391 16.25 4.41667V4.58268ZM6.38399 4.58268L4.13002 1.76523C2.79206 1.90822 1.75 3.04075 1.75 4.41667V4.58268H6.38399ZM1.75 13.5833V6.08268H16.25V13.5833C16.25 15.0561 15.0561 16.25 13.5833 16.25H4.41667C2.94391 16.25 1.75 15.0561 1.75 13.5833Z",
    fill: "currentColor"
  }));
};

var Footer$4 = function Footer(_ref) {
  var content = _ref.content,
    className = _ref.className;
  return React__default.createElement("div", {
    className: classNames(modules_93eb7477$3.footer, className)
  }, React__default.createElement("div", {
    className: modules_93eb7477$3.icon
  }, React__default.createElement(HomeIcon$1, null)), React__default.createElement("div", {
    className: modules_93eb7477$3.icon
  }, React__default.createElement(SearchIcon, null)), React__default.createElement("div", {
    className: modules_93eb7477$3.icon
  }, React__default.createElement(PlusIcon, null)), React__default.createElement("div", {
    className: modules_93eb7477$3.icon
  }, React__default.createElement(StoreIcon, null)), React__default.createElement(Avatar, {
    name: content == null ? void 0 : content.page.name,
    src: (content == null ? void 0 : content.page.logo_src) || undefined,
    className: modules_93eb7477$3.icon,
    color: "blue"
  }));
};

var AppLayout$1 = function AppLayout(props) {
  return React__default.createElement("div", {
    className: modules_11a4dd02$1.appLayout
  }, React__default.createElement("div", {
    className: modules_11a4dd02$1.body
  }, props.children), React__default.createElement(Footer$4, {
    content: props.content
  }));
};

var css$K = ".MobilePost_module_statusBar__68ff81f6{background-color:#fff}.MobilePost_module_fullScreenPostStatusBar__68ff81f6,.MobilePost_module_postStatusBar__68ff81f6{background-color:transparent;color:#fff;width:100%;z-index:1}.MobilePost_module_fullScreenPostStatusBar__68ff81f6{left:0;position:absolute;top:0}.MobilePost_module_mobileStoryPostWrapper__68ff81f6{height:100%;overflow:hidden;position:relative;width:100%}[data-preview-variant=mobile] .MobilePost_module_mobileStoryPostWrapper__68ff81f6{border-radius:8px}";
var modules_813dec30$1 = {"statusBar":"MobilePost_module_statusBar__68ff81f6","postStatusBar":"MobilePost_module_postStatusBar__68ff81f6","fullScreenPostStatusBar":"MobilePost_module_fullScreenPostStatusBar__68ff81f6","mobileStoryPostWrapper":"MobilePost_module_mobileStoryPostWrapper__68ff81f6"};
n(css$K,{});

var MobilePost$1 = function MobilePost(_ref) {
  var content = _ref.content,
    use12hourFormat = _ref.use12hourFormat,
    formatDateTime = _ref.formatDateTime,
    style = _ref.style,
    videoPlayer = _ref.videoPlayer,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var attachments = getSegmentedAttachments(content);
  return React__default.createElement(Phone, {
    statusBarClassName: modules_813dec30$1.statusBar,
    contentBackground: "instagram",
    style: style
  }, React__default.createElement(AppLayout$1, {
    content: content
  }, React__default.createElement(PostWrapper$1, {
    variant: "mobile",
    contentType: content.type,
    contentSubtype: content.subtype
  }, React__default.createElement(Header$2, {
    content: content,
    use12hourFormat: use12hourFormat,
    formatDateTime: formatDateTime,
    onEditDateTimeClick: onEditDateTimeClick
  }), attachments.hasImages && !attachments.hasVideos && React__default.createElement(React__default.Fragment, null, attachments.images.length === 1 && React__default.createElement(Image, {
    image: attachments.images[0]
  }), attachments.images.length > 1 && React__default.createElement(Carousel$1, {
    variant: "mobile",
    attachments: attachments.images
  })), attachments.hasVideos && !attachments.hasImages && React__default.createElement(React__default.Fragment, null, attachments.videos.length === 1 && React__default.createElement(VideoPlayer, {
    video: attachments.videos[0].medium,
    videoElement: videoPlayer
  }), attachments.videos.length > 1 && React__default.createElement(Carousel$1, {
    variant: "mobile",
    attachments: attachments.videos
  })), attachments.hasImages && attachments.hasVideos && React__default.createElement(Carousel$1, {
    variant: "mobile",
    attachments: attachments.all
  }), React__default.createElement(ActionButtons, {
    size: 20
  }), React__default.createElement(TextContent$1, {
    content: content
  }))));
};

var MobileStoryPost$1 = function MobileStoryPost(_ref) {
  var content = _ref.content,
    use12hourFormat = _ref.use12hourFormat,
    formatDateTime = _ref.formatDateTime,
    style = _ref.style,
    onEditDateTimeClick = _ref.onEditDateTimeClick,
    videoPlayer = _ref.videoPlayer;
  return React__default.createElement(Phone, {
    statusBarClassName: modules_813dec30$1.postStatusBar,
    contentBackground: "instagram",
    style: style
  }, React__default.createElement(PostWrapper$1, {
    variant: "mobile",
    contentType: content.type,
    contentSubtype: content.subtype
  }, React__default.createElement(Header$3, {
    content: content,
    use12hourFormat: use12hourFormat,
    formatDateTime: formatDateTime,
    onEditDateTimeClick: onEditDateTimeClick
  }), React__default.createElement("div", {
    className: modules_813dec30$1.mobileStoryPostWrapper
  }, content.attachments.cards.length > 0 && React__default.createElement(Story$1, {
    autoplay: videoPlayer == null ? void 0 : videoPlayer.autoPlay,
    attachments: content.attachments.cards
  })), React__default.createElement(Footer$3, {
    size: 20
  })));
};

var MobileReelPost$1 = function MobileReelPost(_ref) {
  var _content$attachments;
  var content = _ref.content,
    style = _ref.style;
  var _getSegmentedAttachme = getSegmentedAttachments(content),
    videos = _getSegmentedAttachme.videos;
  var collaborators = (_content$attachments = content.attachments) == null ? void 0 : _content$attachments.collaborators;
  return React__default.createElement(Phone, {
    statusBarClassName: modules_813dec30$1.fullScreenPostStatusBar,
    contentBackground: "instagram",
    style: style
  }, React__default.createElement(PostWrapper$1, {
    variant: "mobile",
    contentType: content.type,
    contentSubtype: content.subtype
  }, React__default.createElement(Reel$1, {
    variant: "mobile",
    video: videos[0],
    page: content.page,
    text: content.text,
    collaborators: collaborators
  }), React__default.createElement(Footer$4, {
    content: content
  })));
};

var css$L = ".PostWrapper_module_postWrapper__c96fbec0{background:#fff;border:1px solid #ebeef0;border-radius:max(0px,min(8px,(100vw - 4px - 100%) * 9999))/8px;box-shadow:0 1px 2px 0 rgba(16,24,40,.06);box-sizing:border-box;color:#0f1419;display:flex;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica,Arial,sans-serif;font-size:14px;line-height:20px;max-width:500px;overflow:hidden;padding:16px 16px 0;width:100%}.PostWrapper_module_postWrapper__c96fbec0[data-preview-variant=mobile]{border:none;border-radius:0;box-shadow:none;margin:8px 0}.PostWrapper_module_postWrapper__c96fbec0 a{color:inherit}.PostWrapper_module_postWrapper__c96fbec0 a:hover{color:inherit;text-decoration:none}";
var modules_6850efbf$2 = {"postWrapper":"PostWrapper_module_postWrapper__c96fbec0"};
n(css$L,{});

var PostWrapper$2 = function PostWrapper(props) {
  return React__default.createElement("div", {
    className: modules_6850efbf$2.postWrapper,
    "data-preview-variant": props.variant,
    "data-content-type": props.contentType,
    style: props.style,
    "data-cy": props.dataCy
  }, props.children);
};

var css$M = ".Header_module_header__58b01c59{color:#5b7083;display:flex;margin-bottom:2px}.Header_module_header__58b01c59 .Header_module_title__58b01c59{color:#0f1419;cursor:pointer;font-size:14px;font-weight:700;min-width:fit-content;text-decoration:none}.Header_module_header__58b01c59 .Header_module_title__58b01c59:hover{text-decoration:underline}.Header_module_header__58b01c59 .Header_module_time__58b01c59{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.Header_module_header__58b01c59 .Header_module_username__58b01c59{color:#5b7083;cursor:pointer;margin-left:4px;min-width:0;overflow:hidden;text-decoration:none;text-overflow:ellipsis;white-space:nowrap}.Header_module_header__58b01c59 .Header_module_username__58b01c59:hover{text-decoration:none}[data-preview-variant=mobile] .Header_module_time__58b01c59,[data-preview-variant=mobile] .Header_module_username__58b01c59{font-size:12px}";
var modules_773fac34$4 = {"header":"Header_module_header__58b01c59","title":"Header_module_title__58b01c59","time":"Header_module_time__58b01c59","username":"Header_module_username__58b01c59"};
n(css$M,{});

var Header$4 = function Header(_ref) {
  var _ref$content = _ref.content,
    date = _ref$content.date,
    _ref$content$page = _ref$content.page,
    name = _ref$content$page.name,
    username = _ref$content$page.username,
    time = _ref$content.time,
    use12hourFormat = _ref.use12hourFormat,
    formatDateTime = _ref.formatDateTime,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var renderDateTime = function renderDateTime() {
    return React__default.createElement(DateTime, Object.assign({}, {
      time: time,
      date: date,
      use12hourFormat: use12hourFormat,
      formatDateTime: formatDateTime,
      className: modules_773fac34$4.time
    }));
  };
  return React__default.createElement("div", {
    className: modules_773fac34$4.header
  }, React__default.createElement(ExternalLink, {
    className: modules_773fac34$4.title,
    href: "https://twitter.com/" + username
  }, name), React__default.createElement(ExternalLink, {
    className: modules_773fac34$4.username,
    href: "https://twitter.com/" + username
  }, "@", username), (time || date) && React__default.createElement("div", {
    className: modules_773fac34$4.divider
  }, "\xA0\xB7\xA0"), onEditDateTimeClick ? React__default.createElement(DateTooltip, Object.assign({}, {
    time: time,
    date: date,
    use12hourFormat: use12hourFormat,
    onEditDateTimeClick: onEditDateTimeClick
  }), renderDateTime()) : renderDateTime());
};

var css$N = ".Avatar_module_avatar__330a54be{border-radius:100%;box-shadow:inset 0 0 2px rgba(0,0,0,.02);flex-shrink:0;margin-right:12px}.Avatar_module_avatar__330a54be:before{border-color:rgba(0,0,0,.04)}";
var modules_bcbcb7f7 = {"avatar":"Avatar_module_avatar__330a54be"};
n(css$N,{});

var img$3 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZAAAAGQCAMAAAC3Ycb+AAACKFBMVEXM1t3K1Nu7xs6tusOisLqYprGMm6eGlaJ/j5x4iZZzhJJuf45sfYzJ09vBzNSsucKXprGEk6B0hJJmeIdld4bAy9OlsryLmqZxgpC3w8uXpbC+ydGZp7J0hZPL1dyrt8GAkJ3H0tmeq7ZwgZDG0NiaqLNtfoygrbhtfo2jsLtqfIrDzdWDk6CyvsdvgI6cqrTJ09qJmKTDztV8jJm/ytK8x8+6xs66xc5vgI+9ydHBzNN3iJWNnKe3wstneYjG0dhyg5GJmaWotL5sfoyHl6PI0tqap7Jpe4mNnKhneIeIl6OKmaWRoKtrfIuhrrigrrh2h5S1wMm0wMmOnaiFlaFoeomntL5rfYuToq3Ez9aqt8CQn6t6ipezv8icqrWIl6R2hpR1hpTI09qms72WpK+HlqN3h5VpeonCzdSRn6uFlKF6i5h6iphwgY+9yNC7x8+qt8GfrbefrLeElKB+jpt9jZqdq7Wksbu4xMy4w8yCkp+SoKyir7qir7nF0NfFz9eerLa1wcrK1dyHlqKruMGcqbR1hpOxvcawvMWPnanH0dl7i5nI0tl5ipeuusNtf42otb9ugI6QnqqWpLBoeohqe4qUo66bqbOGlqKToa14iJZpe4qvu8R5iZe8x9C5xc25xM3Ez9fCzdW3w8yVpK+qtsCdqrWVo66RoKyUoq62wsqOnamjsLqtucO7xs/Ezta2wsuuusSPnqmvvMWCkZ6SoayptsCVo692ayFsAAAIy0lEQVR4AezBMQEAAAQAMKB/ZbcO2+IDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALJ69tiDBzMJojAIgH1ra/61bdv5Z3UJrGYePnVVKByJxmLxRCIei0Uj4VAw4PclQZal0plszpE3nFw2k06B7MgXiiX5QalYyMMwKmei4kK0UoYxVK3VxbVcrQoDqNFsiUetZgOkV7vTFQXdThukT68/EEWDfg+kx99wJBqMhn8gDfw50STnB6nKh0WjcB6kZDwRrSZjkHfTmWg3m4I8mi/EgMUc5MnSESOcJci91VqMWa9ALm22YtB2A3JlFxOjYjuQC/uuGNbdg352iItx8SPoR/u4WHA6g35y6YoVpQvoB72rWHLtgb76a4k1rT/QNzex6Ab6YixWjUEf3R9i1eMO+uD5z9496Ia2hUEAnmt7jo3g2lZt2zi2att959qI0zXJP98r7L38I4MnLOMm7HiZPHGZsGNlMYEsHMO+zmYC2V/jaJbDJHJwJPuEiXyCI1juWSaS8QMOs7eYTB4OsVP5TCb/FA6yAib0D+yAXwuZUOGvsP1ymFQRbJ/XmdjrsL3OMLFi2B6/FDKxwl9gu0qYXAlsx7VSJvfVNWyzMgooxzaroIAK2JZKSqiCbaqmhGrYhtxSSijNRTJ+Sffr+vFqKKIGtub/Woqo/R+A1VFGHQDLoYwcwF6rp4z612DfUsi3sAYKaYC9RyHv+Xs0UskXjYiuiVKaEF0zpTQjuhYq8SKSW0gphbmIrZViWhFbG8W0IbZ2imlHbB0U04nQbn1BMV/cQmT/Us6/iOw25dxGZHco5w4iu0s5dxHZPcq5h8juU859BPaAgh44ylpLpYNIVTig9HsK+h5xPaQUPxo+oqBHiOsxBT1BXBkU9BRx1VJQ4WVEdZOSfkJUzyjpuUNONDgE/gUlvUBUpynpNKJ6SUmvEFUeJV108pSWBtc40VLtbiEa3FGki5K+QVTf+IMI8AfR1U1J3Yiqh5J6/EH8QfxB/EG8hgjwLkuYP4i+R5T0yE1DtJxxkwoNblxxnpLOI6peSupFVH2U1Ieo3qCkNxBVPyUNIKqfKOlrhPUfBf3n/BAtGYhrkIIGEdcQBQ0hrmEKGnFnBKeHqBiloDEE9jnlfI7IfqScHxHZOOWMI7JzlDOByC5nU8xXkwhtimI+Q2zDPhZq+Zhi/kJwP1PKz4hu3JteLae+oJAvfoESv4kMwqYp5Aps8ill/DEJ2AxlzACw/+spov4m1th5rShrG8umhOwxbLCXWoXL7LVZCrj0GrbYHAXMY4ctMLkF7LLFDCaWsYg9rPI/JvVFFfaxciZ1HaaUtF6Mg+y1q0zm6ms4xHKXmMjS8io79aAcVwCFAfjEHCVnHefGySg2RrXtNrbu1o1t29Y71ubiarr/9xAfwW+0jbIqRtsJfksQWQVWgeAPnpSz4sqf0J+BFyvMK4zgb8bGWUHjYwT/UPWSFfOyiuDfJiZZEZMTZBMQ7haw7AqmBLIVZD9kmT3MJrCHu6GAZVNgcCewl246i2WRNa0jR4BbuM8MS2zmWrgbOQyE0ppZlsxsTalA4CS3/rnh0+y008Nz/W4kDYgcmF8wssOMC/MDkQQSEy4nLF5bWmY7LC9dW0y4LBDIqC1jRf/glqHGd9U/IJB/ERjgv+pbY7j1QL+S0U6guJG299IslrS290YIAAAAAAAAAAAAAAAAAAAAAAAA4P/wZC2lpNk8VZwcId6798jf//G9e2JEcvGUubkkZe0JgWLc1kumH9bF8l/F1j2cLtlwI5DV5krMmUun2WanL52JWdkkkEP6M0MQOyTI8CydpARbpYZ6dkq9oXSLJAHrXrUsiVqvdXISbJeFsoRCy7bJYZC+48+S899JJwdApF5kmVj1kWQfMHnPsoxmvU0ENuvatbLsrLtdBLYQ9opYEcY9gf4FkvYTWTGJ+0n0N7D1qpIVVXmwRX8Ct+cqWXGVh7fpd8At6iar4maUG/0CJopYNcYJ+hEcDbOqajvpG2gbDGaVBR+30WdQGsAaMF5KH8CayBohrhGEtVSyZlS2hJGLSxNZU8Q0cmnPzrPGJJ6Q6xKusQZdE8hFmYpYk4pM5JI6ZlijCjrQlcrQVmMfa9i79u4BPc8oCKBwbX731LZt27Zt27Zt2/b2uoEyHL1bOMHNzDz54fgGXz3ejUO41pU99dieEC8993PDMBIVRjq5gmi0GyV2uzjfanMONc61cTC8ylAkMz/aet8TVXq+t91jZ0uUabnT9PSqAurM6Ge4xwxQWKRW9CgIUaTbBZS6YHKwVa0JajUx+Pr9kKFY9sHc+qMPqvUxtiAp2hDlGhY1FWQM6o2x1KM2Blyx02M6Jky30uPjVUy4+trIg7cJRjQx8fitXwYzyli4xX6BIdf199iIKRu196gzDlPG9VJ+8XMGY84Ujb8IZamtuce8hDlpnuIR70AMGqh38FsDSWLM+AmjPunscboJRjU5rTLIZ8z6rPKFhWEKX1oV62FYvYrqghzDtGPaelS6hmnXKikLMgjjBsVvdGHmqdoS9sG85Zq2h9VxoLqiJ+9AHBio5+m7GRcOaukxoCUutBygJEhJnCipo8eB1jjR+kDs0f9b7NebzsCNGRq2uTdwpJn8Hosv4cilxeKDtMKVfeKDTMSVTPpE6wTOfBEeZDXOfJXdo2vCm/Wig7zCnW+i5+4VcKdCR8FBvuPQRcFBduPQbrk9KiUcSpXiOO7fxNHccVw6LrVHLZyqJTTID5z6ITRIPZyqJ7PHQ9x6GLt0WaqIDLIItxZJ7LEeUWLk2wLHWggM0hbH2gqcvN/BsTsVY5kuy4nYFcoyU1yQe7hWVlqP/QnX0n5hQd7h3Lv4Z7CyvBAWZCvObZXV4/AInBtxWFSQJ4gSa8NWEaSVqCBvIsgUUUHWRpC1knrUXxFBVtQXFOQ+gfvxmRTxSRa/0wFR4qJ0JIGRMTiJ4cnvrCOwTk6PYQRgmJggDwjAgyJ54CdHF8F5TMtp0wAAAABJRU5ErkJggg==";

var Avatar$1 = function Avatar$1(_ref) {
  var _ref$content$page = _ref.content.page,
    name = _ref$content$page.name,
    logo_src = _ref$content$page.logo_src,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 48 : _ref$size;
  return React__default.createElement(Avatar, {
    size: size,
    name: name,
    src: logo_src ? logo_src : img$3,
    className: modules_bcbcb7f7.avatar,
    color: "blue"
  });
};

var css$O = ".Body_module_body__2ac8f2f1{display:flex;flex:1;flex-direction:column;min-width:0}";
var modules_3d0e1832 = {"body":"Body_module_body__2ac8f2f1"};
n(css$O,{});

var Body = function Body(props) {
  return React__default.createElement("div", {
    className: modules_3d0e1832.body
  }, props.children);
};

var css$P = ".TextContent_module_textContent__20948b6f{font-weight:400;line-height:20px;padding-bottom:8px}";
var modules_82161d99$2 = {"textContent":"TextContent_module_textContent__20948b6f"};
n(css$P,{});

var TextContent$2 = function TextContent(_ref) {
  var text = _ref.content.text;
  if (!text) {
    return null;
  }
  return React__default.createElement(PostTextContentWrapper, {
    className: classNames(modules_82161d99$2.textContent)
  }, React__default.createElement(HyperText, {
    pageType: TYPE_TWITTER
  }, text));
};

var css$Q = ".Footer_module_footer__889929ab{color:#7a869a;display:flex;justify-content:space-between;max-width:425px;min-width:100%;padding-bottom:16px;padding-top:10px}.Footer_module_footer__889929ab .Footer_module_btn__889929ab{align-items:center;border-radius:50%;cursor:pointer;display:flex;justify-content:center;transition:background-color .1s ease-in-out}.Footer_module_footer__889929ab .Footer_module_btn__889929ab svg{height:18px;transition:fill .1s ease-in-out;width:18px}.Footer_module_footer__889929ab .Footer_module_btn__889929ab svg path{stroke:#7a869a}.Footer_module_footer__889929ab .Footer_module_btn__889929ab span{margin-left:8px}";
var modules_93eb7477$4 = {"footer":"Footer_module_footer__889929ab","btn":"Footer_module_btn__889929ab"};
n(css$Q,{});

var LikeIcon = function LikeIcon(props) {
  return React__default.createElement("svg", {
    viewBox: "0 0 24 24"
  }, React__default.createElement("g", null, React__default.createElement("path", {
    d: "M12 21.638h-.014C9.403 21.59 1.95 14.856 1.95 8.478c0-3.064 2.525-5.754 5.403-5.754 2.29 0 3.83 1.58 4.646 2.73.814-1.148 2.354-2.73 4.645-2.73 2.88 0 5.404 2.69 5.404 5.755 0 6.376-7.454 13.11-10.037 13.157H12zM7.354 4.225c-2.08 0-3.903 1.988-3.903 4.255 0 5.74 7.034 11.596 8.55 11.658 1.518-.062 8.55-5.917 8.55-11.658 0-2.267-1.823-4.255-3.903-4.255-2.528 0-3.94 2.936-3.952 2.965-.23.562-1.156.562-1.387 0-.014-.03-1.425-2.965-3.954-2.965z"
  })));
};

var ShareIcon$1 = function ShareIcon(props) {
  return React__default.createElement("svg", {
    viewBox: "0 0 24 24"
  }, React__default.createElement("g", null, React__default.createElement("path", {
    d: "M17.53 7.47l-5-5c-.293-.293-.768-.293-1.06 0l-5 5c-.294.293-.294.768 0 1.06s.767.294 1.06 0l3.72-3.72V15c0 .414.336.75.75.75s.75-.336.75-.75V4.81l3.72 3.72c.146.147.338.22.53.22s.384-.072.53-.22c.293-.293.293-.767 0-1.06z"
  }), React__default.createElement("path", {
    d: "M19.708 21.944H4.292C3.028 21.944 2 20.916 2 19.652V14c0-.414.336-.75.75-.75s.75.336.75.75v5.652c0 .437.355.792.792.792h15.416c.437 0 .792-.355.792-.792V14c0-.414.336-.75.75-.75s.75.336.75.75v5.652c0 1.264-1.028 2.292-2.292 2.292z"
  })));
};

var ReplyIcon = function ReplyIcon(props) {
  return React__default.createElement("svg", {
    viewBox: "0 0 24 24"
  }, React__default.createElement("g", null, React__default.createElement("path", {
    d: "M14.046 2.242l-4.148-.01h-.002c-4.374 0-7.8 3.427-7.8 7.802 0 4.098 3.186 7.206 7.465 7.37v3.828c0 .108.044.286.12.403.142.225.384.347.632.347.138 0 .277-.038.402-.118.264-.168 6.473-4.14 8.088-5.506 1.902-1.61 3.04-3.97 3.043-6.312v-.017c-.006-4.367-3.43-7.787-7.8-7.788zm3.787 12.972c-1.134.96-4.862 3.405-6.772 4.643V16.67c0-.414-.335-.75-.75-.75h-.396c-3.66 0-6.318-2.476-6.318-5.886 0-3.534 2.768-6.302 6.3-6.302l4.147.01h.002c3.532 0 6.3 2.766 6.302 6.296-.003 1.91-.942 3.844-2.514 5.176z"
  })));
};

var RetweetIcon = function RetweetIcon(props) {
  return React__default.createElement("svg", {
    viewBox: "0 0 24 24"
  }, React__default.createElement("g", null, React__default.createElement("path", {
    d: "M23.77 15.67c-.292-.293-.767-.293-1.06 0l-2.22 2.22V7.65c0-2.068-1.683-3.75-3.75-3.75h-5.85c-.414 0-.75.336-.75.75s.336.75.75.75h5.85c1.24 0 2.25 1.01 2.25 2.25v10.24l-2.22-2.22c-.293-.293-.768-.293-1.06 0s-.294.768 0 1.06l3.5 3.5c.145.147.337.22.53.22s.383-.072.53-.22l3.5-3.5c.294-.292.294-.767 0-1.06zm-10.66 3.28H7.26c-1.24 0-2.25-1.01-2.25-2.25V6.46l2.22 2.22c.148.147.34.22.532.22s.384-.073.53-.22c.293-.293.293-.768 0-1.06l-3.5-3.5c-.293-.294-.768-.294-1.06 0l-3.5 3.5c-.294.292-.294.767 0 1.06s.767.293 1.06 0l2.22-2.22V16.7c0 2.068 1.683 3.75 3.75 3.75h5.85c.414 0 .75-.336.75-.75s-.337-.75-.75-.75z"
  })));
};

var Footer$5 = function Footer(props) {
  return React__default.createElement("div", {
    className: modules_93eb7477$4.footer
  }, React__default.createElement("div", {
    className: classNames(modules_93eb7477$4.btn, modules_93eb7477$4.reply)
  }, React__default.createElement(ReplyIcon, null), " ", React__default.createElement("span", null, "12")), React__default.createElement("div", {
    className: classNames(modules_93eb7477$4.btn, modules_93eb7477$4.retweet)
  }, React__default.createElement(RetweetIcon, null), " ", React__default.createElement("span", null, "10")), React__default.createElement("div", {
    className: classNames(modules_93eb7477$4.btn, modules_93eb7477$4.like)
  }, React__default.createElement(LikeIcon, null), " ", React__default.createElement("span", null, "203")), React__default.createElement("div", {
    className: classNames(modules_93eb7477$4.btn, modules_93eb7477$4.share)
  }, React__default.createElement(ShareIcon$1, null)));
};

var css$R = "[data-content-type=\"2\"] .ImageGallery_module_imageGallery__420aab6a{border:none;border-radius:0;margin-top:0}.ImageGallery_module_imageGallery__420aab6a{border:1px solid #c4cfd6;border-radius:16px;cursor:pointer;display:flex;overflow:hidden}.ImageGallery_module_singleImageWrapper__420aab6a{display:flex;flex:1;position:relative}.ImageGallery_module_singleImageWrapper__420aab6a img{height:auto;width:100%}.ImageGallery_module_gifBadge__420aab6a{background:#0f1419;border-radius:4px;bottom:3%;color:#fff;font-size:13px;font-weight:700;left:3%;padding:0 5px;position:absolute;text-transform:uppercase}.ImageGallery_module_twitterAspectRatio__420aab6a{flex:1;height:0;overflow:hidden;padding-bottom:56.25%;position:relative}.ImageGallery_module_twoImageGallery__420aab6a{display:flex;height:100%;left:0;position:absolute;top:0;width:100%}.ImageGallery_module_twoImageGallery__420aab6a img{flex:1;height:auto;object-fit:cover;object-position:center;width:auto}.ImageGallery_module_twoImageGallery__420aab6a img:first-child{border-right:1px solid #fff;width:calc(50% - 1px)}.ImageGallery_module_twoImageGallery__420aab6a img:nth-child(2){border-left:1px solid #fff;width:calc(50% - 1px)}.ImageGallery_module_threeImageGallery__420aab6a{display:flex;height:100%;left:0;position:absolute;top:0;width:100%}.ImageGallery_module_threeImageGallery__420aab6a img{flex:1;height:auto;object-fit:cover;object-position:center;position:absolute;width:auto}.ImageGallery_module_threeImageGallery__420aab6a img:first-child{height:100%;left:0;top:0;width:calc(50% - 1px)}.ImageGallery_module_threeImageGallery__420aab6a img:nth-child(2){height:calc(50% - 1px);right:0;top:0;width:calc(50% - 1px)}.ImageGallery_module_threeImageGallery__420aab6a img:nth-child(3){bottom:0;height:calc(50% - 1px);right:0;width:calc(50% - 1px)}.ImageGallery_module_fourImagesGallery__420aab6a{display:flex;height:100%;left:0;position:absolute;top:0;width:100%}.ImageGallery_module_fourImagesGallery__420aab6a img{flex:1;height:auto;object-fit:cover;object-position:center;position:absolute;width:auto}.ImageGallery_module_fourImagesGallery__420aab6a img:first-child{height:calc(50% - 1px);left:0;top:0;width:calc(50% - 1px)}.ImageGallery_module_fourImagesGallery__420aab6a img:nth-child(2){height:calc(50% - 1px);right:0;top:0;width:calc(50% - 1px)}.ImageGallery_module_fourImagesGallery__420aab6a img:nth-child(3){bottom:0;height:calc(50% - 1px);left:0;width:calc(50% - 1px)}.ImageGallery_module_fourImagesGallery__420aab6a img:nth-child(4){bottom:0;height:calc(50% - 1px);right:0;width:calc(50% - 1px)}";
var modules_ccc28e88$2 = {"imageGallery":"ImageGallery_module_imageGallery__420aab6a","singleImageWrapper":"ImageGallery_module_singleImageWrapper__420aab6a","gifBadge":"ImageGallery_module_gifBadge__420aab6a","twitterAspectRatio":"ImageGallery_module_twitterAspectRatio__420aab6a","twoImageGallery":"ImageGallery_module_twoImageGallery__420aab6a","threeImageGallery":"ImageGallery_module_threeImageGallery__420aab6a","fourImagesGallery":"ImageGallery_module_fourImagesGallery__420aab6a"};
n(css$R,{});

var ImageGallery$1 = function ImageGallery(_ref) {
  var images = _ref.images,
    _ref$lightboxEnabled = _ref.lightboxEnabled,
    lightboxEnabled = _ref$lightboxEnabled === void 0 ? true : _ref$lightboxEnabled;
  var _useLightbox = useLightbox(lightboxEnabled),
    lightbox = _useLightbox.lightbox,
    handleOpenLightbox = _useLightbox.handleOpenLightbox,
    enableLightbox = _useLightbox.enableLightbox;
  return React__default.createElement("div", {
    className: classNames(modules_ccc28e88$2.imageGallery)
  }, images.length === 1 && function (medium) {
    var isGif = medium.meta.is_animated_gif;
    return React__default.createElement("div", {
      "data-cy": DATA_CY_NAMES.IMAGE_GALLERY,
      className: modules_ccc28e88$2.singleImageWrapper
    }, React__default.createElement("img", {
      src: isGif ? medium.sizes.original.src : medium.sizes.lightbox.src,
      key: medium.id,
      onClick: function onClick() {
        return handleOpenLightbox();
      }
    }), medium.meta.is_animated_gif && React__default.createElement("div", {
      className: modules_ccc28e88$2.gifBadge
    }, "gif"));
  }(images[0].medium), images.length > 1 && React__default.createElement("div", {
    className: modules_ccc28e88$2.twitterAspectRatio
  }, React__default.createElement("div", {
    "data-cy": DATA_CY_NAMES.IMAGE_GALLERY_WRAPPER,
    className: classNames(images.length === 2 && modules_ccc28e88$2.twoImageGallery, images.length === 3 && modules_ccc28e88$2.threeImageGallery, images.length > 3 && modules_ccc28e88$2.fourImagesGallery)
  }, images.slice(0, 4).map(function (image, i) {
    return React__default.createElement("img", {
      src: image.medium.sizes.lightbox.src,
      key: image.medium.id + "-" + i,
      onClick: function onClick() {
        return handleOpenLightbox(i);
      }
    });
  }))), enableLightbox && React__default.createElement(AttachmentsLightBox$1, {
    onInit: function onInit(_ref2) {
      var instance = _ref2.instance;
      return lightbox.current = instance;
    },
    attachments: images
  }));
};

var css$S = ".Post_module_postVideoPlayerWrapper__e9c29a78{border-radius:16px;margin-top:12px;overflow:hidden}";
var modules_4e180e43 = {"postVideoPlayerWrapper":"Post_module_postVideoPlayerWrapper__e9c29a78"};
n(css$S,{});

var Post$2 = function Post(_ref) {
  var formatDateTime = _ref.formatDateTime,
    content = _ref.content,
    use12hourFormat = _ref.use12hourFormat,
    style = _ref.style,
    dataCy = _ref.dataCy,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var attachments = getSegmentedAttachments(content);
  return React__default.createElement(PostWrapper$2, {
    style: style,
    contentType: content.type,
    variant: "desktop",
    dataCy: dataCy == null ? void 0 : dataCy.wrapper
  }, React__default.createElement(Avatar$1, {
    content: content
  }), React__default.createElement(Body, null, React__default.createElement(Header$4, {
    content: content,
    use12hourFormat: use12hourFormat,
    formatDateTime: formatDateTime,
    onEditDateTimeClick: onEditDateTimeClick
  }), React__default.createElement(TextContent$2, {
    content: content
  }), attachments.hasImages && React__default.createElement(ImageGallery$1, {
    images: attachments.images
  }), attachments.hasVideos && !attachments.hasImages && React__default.createElement("div", {
    className: modules_4e180e43.postVideoPlayerWrapper
  }, React__default.createElement(VideoPlayer, {
    video: attachments.videos[0].medium
  })), React__default.createElement(Footer$5, null)));
};

var css$T = ".LinkInfo_module_linkInfo__59592838{display:flex;flex-direction:column;padding:2px 20px}.LinkInfo_module_linkInfo__59592838>span:not(:first-child){padding-top:2px}.LinkInfo_module_linkInfo__59592838 .LinkInfo_module_linkInfoUrl__59592838{color:#5b7083;font-size:12px}.LinkInfo_module_linkInfo__59592838 .LinkInfo_module_linkInfoTitle__59592838{color:#0f1419;font-weight:600}.LinkInfo_module_linkInfo__59592838 .LinkInfo_module_linkInfoDescription__59592838{color:#5b7083;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}";
var modules_96605eeb$2 = {"linkInfo":"LinkInfo_module_linkInfo__59592838","linkInfoUrl":"LinkInfo_module_linkInfoUrl__59592838","linkInfoTitle":"LinkInfo_module_linkInfoTitle__59592838","linkInfoDescription":"LinkInfo_module_linkInfoDescription__59592838"};
n(css$T,{});

var LinkInfo$2 = function LinkInfo(_ref) {
  var link = _ref.link;
  if (link.url) {
    return React__default.createElement("div", {
      className: modules_96605eeb$2.linkInfo
    }, React__default.createElement("span", {
      className: modules_96605eeb$2.linkInfoUrl
    }, getHostnameFromUrl(link.url)), React__default.createElement("span", {
      className: modules_96605eeb$2.linkInfoTitle
    }, link.title), React__default.createElement("span", {
      className: modules_96605eeb$2.linkInfoDescription
    }, link.description));
  }
  return null;
};

var css$U = ".LinkPost_module_link__0d74e9cd{border:1px solid #c4cfd6;border-radius:16px;color:inherit;overflow:hidden;position:relative;text-decoration:none}.LinkPost_module_link__0d74e9cd:visited{color:inherit}";
var modules_0c03f802$1 = {"link":"LinkPost_module_link__0d74e9cd"};
n(css$U,{});

var LinkPost$1 = function LinkPost(_ref) {
  var content = _ref.content,
    use12hourFormat = _ref.use12hourFormat,
    formatDateTime = _ref.formatDateTime,
    style = _ref.style,
    dataCy = _ref.dataCy,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var attachments = getSegmentedAttachments(content);
  var linkAttachment = attachments.all[0];
  return React__default.createElement(PostWrapper$2, {
    style: style,
    contentType: content.type,
    variant: "desktop",
    dataCy: dataCy == null ? void 0 : dataCy.wrapper
  }, React__default.createElement(Avatar$1, {
    content: content
  }), React__default.createElement(Body, null, React__default.createElement(Header$4, {
    content: content,
    use12hourFormat: use12hourFormat,
    formatDateTime: formatDateTime,
    onEditDateTimeClick: onEditDateTimeClick
  }), React__default.createElement(TextContent$2, {
    content: content
  }), linkAttachment && React__default.createElement(ExternalLink, {
    href: linkAttachment.url,
    className: modules_0c03f802$1.link
  }, attachments.hasImages && React__default.createElement(ImageGallery$1, {
    images: attachments.images,
    lightboxEnabled: false
  }), React__default.createElement(LinkInfo$2, {
    link: linkAttachment
  })), React__default.createElement(Footer$5, null)));
};

var css$V = ".AppLayout_module_appLayout__1e5ad6cd{background-color:#fff;display:flex;flex-direction:column;height:100%;overflow:hidden}.AppLayout_module_appLayout__1e5ad6cd .AppLayout_module_body__1e5ad6cd{flex:1 1 auto;overflow:auto}.AppLayout_module_appLayout__1e5ad6cd .AppLayout_module_footer__1e5ad6cd{border-top:1px solid #e4e7eb;padding:10px 24px 24px}.AppLayout_module_appLayout__1e5ad6cd .AppLayout_module_footer__1e5ad6cd .AppLayout_module_footerImage__1e5ad6cd{height:auto;width:100%}";
var modules_11a4dd02$2 = {"appLayout":"AppLayout_module_appLayout__1e5ad6cd","body":"AppLayout_module_body__1e5ad6cd","footer":"AppLayout_module_footer__1e5ad6cd","footerImage":"AppLayout_module_footerImage__1e5ad6cd"};
n(css$V,{});

var img$4 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASQAAAAYCAYAAABTNoCOAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAARRSURBVHgB7ZztURsxEIZfMvmfpAKUCjAdKBXEVJBLBTgVICoAKrCpwHRgdwCpwE4FkArI7UiL5LPOlkwywet9ZnbuQ9KBVqvVru4AUBRFURRFURRFUd4oR6jDtmJameAwsUGOW3lq5Wcr81aWUA4d28qglZNw/Qt+niyh/HU+tnLVynOQMbxjOhSGrSwQ+9+VKyiHimllhn7bkDxXyC9s6vs2mYZnVEGT8THzMJqgDeRzgdjn+1au4fs9gldoqo9q5e4hBtEISR+DpGwQ7j2HOgayMYgLFfV3GO6ZcM66WECmLhpEO5hVCutmVPrDaHKlE+4QV4BzxH72Kc5g1SilQ32lBWqcnJOtmOR6Go7S9cHj7jbUcZBrGw6+bxb1WGzX3Qs0EXNRUZ9IjJYMosGNKuo2kIvBqhENEQ0yPSeuw7WBTBrEBXkbvLBbyMLhHzskg9flhJKipQZ1K1tt/X2EIiFaqDhV44k2CELntJ9mEENyqWls2vdtWJQ7r33CYXXMS0n3pF1fpdqoqE/oGcV54RuGDa4prM+TVfIkJGhs0/G+TsomnTIHuZDDfayoT3UXkIVDXUBC8+ICq37G9VUmw9q0Z+TCAz9mfpFUppCxEvAKbyvaLCA7TWEsvA3YTBmlbiPIS0+6LFDnYGrr7wMOcVFi2885JhvupUEL+xq36QcY9Dujvl+mK/QMCRECO6SSkJw5BIfUwBvTDPHNEkFjPkrKppC9n1abns9CG0k4rC7aDdYd0yy5niHahMUrHNKgoq6BDCYo29BmDKIOpJKucul4k9yjf19RGuR8qW93FW04IpCUzjvks4gG646oW8ci45DeYXekf3PDxva1sP63cJxDJhfwhvbQyhf4r/w/w3+JTGW0aN2Fe1R2GsqojYMs2PZr9pB+d9pKZgJvI6dB6HyOHTDIr3K5L5HHkB0hkeEs4Pt0saUuv2HKrRYSMPB9W2B9fG1Slmv3iPitkhQsCtKNDg7y7MNh9z5ZZHT4HmVQ2kIGdRuOFDU0kM1TK9/hw00HP7kusf63SeeISqWyB8jDhuMN1vvPkeGPTLtlaMPR1TVkwM6V5sFxYRve9jBQijFA0av9TWIgiwarrynJQY2DpPf5PBdF7Du8H5DbS6T+bkpdDOr3W946DXafHw3k4PCfIqRDZgKf/zr4aMB2yikiugl1aOKacKS8eQkZmHAcIr5VIwezDGV0dFuecQI5UN/n4Zw/ECU7OOvUo60O0ldqC09QejnqXPPHfa/hE+Qq3cAbIIfsD1hN0ah8Guos4Q1UQgqXe3PIk2yBco4gE36LNIFfnHhbg7Y6yHmdQSbUP3K6ZOO1c550RPOEtkUmfDNnIA7bN3H7uITsr3NLIEVTOkcroxR9NJl7c3gjHKKcCWRikP/vBhw1LSGT1NZ3YQ6vnxdn1rdiNfDe6wPKuYXcV967QIMkad9E2Q6NuQ3nc+j4K4qiKIqiKIqiKHL4A+s27ymZBDBNAAAAAElFTkSuQmCC";

var AppLayout$2 = function AppLayout(_ref) {
  var children = _ref.children;
  return React__default.createElement("div", {
    className: modules_11a4dd02$2.appLayout
  }, React__default.createElement("div", {
    className: modules_11a4dd02$2.body
  }, children), React__default.createElement("div", {
    className: modules_11a4dd02$2.footer
  }, React__default.createElement("img", {
    src: img$4,
    className: modules_11a4dd02$2.footerImage,
    alt: "Twitter app footer"
  })));
};

var css$W = ".MobilePost_module_statusBar__8db4f19b{background-color:#fff}.MobilePost_module_videoPlayerWrapper__8db4f19b{border-radius:16px;margin-top:12px;overflow:hidden}";
var modules_813dec30$2 = {"statusBar":"MobilePost_module_statusBar__8db4f19b","videoPlayerWrapper":"MobilePost_module_videoPlayerWrapper__8db4f19b"};
n(css$W,{});

var MobilePost$2 = function MobilePost(_ref) {
  var content = _ref.content,
    use12hourFormat = _ref.use12hourFormat,
    formatDateTime = _ref.formatDateTime,
    style = _ref.style,
    dataCy = _ref.dataCy,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var attachments = getSegmentedAttachments(content);
  return React__default.createElement(Phone, {
    statusBarClassName: modules_813dec30$2.statusBar,
    style: style
  }, React__default.createElement(AppLayout$2, {
    content: content
  }, React__default.createElement(PostWrapper$2, {
    variant: "mobile",
    contentType: content.type,
    dataCy: dataCy == null ? void 0 : dataCy.wrapper
  }, React__default.createElement(Avatar$1, {
    content: content
  }), React__default.createElement(Body, null, React__default.createElement(Header$4, {
    content: content,
    use12hourFormat: use12hourFormat,
    formatDateTime: formatDateTime,
    onEditDateTimeClick: onEditDateTimeClick
  }), React__default.createElement(TextContent$2, {
    content: content
  }), attachments.hasImages && React__default.createElement(ImageGallery$1, {
    images: attachments.images
  }), attachments.hasVideos && !attachments.hasImages && React__default.createElement("div", {
    className: modules_813dec30$2.videoPlayerWrapper
  }, React__default.createElement(VideoPlayer, {
    video: attachments.videos[0].medium
  })), React__default.createElement(Footer$5, null)))));
};

var MobileLinkPost$1 = function MobileLinkPost(_ref) {
  var content = _ref.content,
    use12hourFormat = _ref.use12hourFormat,
    formatDateTime = _ref.formatDateTime,
    style = _ref.style,
    dataCy = _ref.dataCy,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var attachments = getSegmentedAttachments(content);
  var linkAttachment = attachments.all[0];
  return React__default.createElement(Phone, {
    statusBarClassName: modules_813dec30$2.statusBar,
    style: style
  }, React__default.createElement(AppLayout$2, {
    content: content
  }, React__default.createElement(PostWrapper$2, {
    variant: "mobile",
    contentType: content.type,
    dataCy: dataCy == null ? void 0 : dataCy.wrapper
  }, React__default.createElement(Avatar$1, {
    content: content
  }), React__default.createElement(Body, null, React__default.createElement(Header$4, {
    content: content,
    use12hourFormat: use12hourFormat,
    formatDateTime: formatDateTime,
    onEditDateTimeClick: onEditDateTimeClick
  }), React__default.createElement(TextContent$2, {
    content: content
  }), linkAttachment && React__default.createElement(ExternalLink, {
    href: linkAttachment.url,
    className: modules_0c03f802$1.link
  }, attachments.hasImages && React__default.createElement(ImageGallery$1, {
    images: attachments.images
  }), React__default.createElement(LinkInfo$2, {
    link: linkAttachment
  })), React__default.createElement(Footer$5, null)))));
};

var PostWrapper$3 = function PostWrapper(props) {
  return React__default.createElement("div", {
    className: clsx('tw-text-grayscale-180 tw-box-border tw-bg-white tw-p-4 tw-pb-7 tw-w-full tw-flex tw-max-w-[600px]', {
      'tw-shadow-md tw-rounded': props.variant === 'desktop'
    }),
    "data-preview-variant": props.variant,
    "data-content-type": props.contentType,
    style: props.style,
    "data-cy": props.dataCy
  }, props.children);
};

var Header$5 = function Header(_ref) {
  var _ref$content = _ref.content,
    date = _ref$content.date,
    name = _ref$content.page.name,
    time = _ref$content.time,
    use12hourFormat = _ref.use12hourFormat,
    formatDateTime = _ref.formatDateTime,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var renderDateTime = function renderDateTime() {
    return React__default.createElement(DateTime, Object.assign({}, {
      time: time,
      date: date,
      use12hourFormat: use12hourFormat,
      formatDateTime: formatDateTime,
      className: 'tw-truncate'
    }));
  };
  return React__default.createElement("div", {
    className: "tw-flex tw-mb-1 tw-justify-between tw-items-center tw-max-w-full"
  }, React__default.createElement(ExternalLink, {
    className: "tw-color-black tw-whitespace-nowrap tw-text-ellipsis tw-max-w-full tw-overflow-hidden  tw-text-[16px] tw-font-semibold",
    href: "https://www.threads.net/@" + name
  }, React__default.createElement("span", {
    className: "tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis"
  }, name)), React__default.createElement("div", {
    className: "tw-flex tw-gap-[10px] tw-items-center tw-text-md tw-text-grayscale-100"
  }, onEditDateTimeClick ? React__default.createElement(DateTooltip, Object.assign({}, {
    time: time,
    date: date,
    use12hourFormat: use12hourFormat,
    onEditDateTimeClick: onEditDateTimeClick
  }), renderDateTime()) : renderDateTime()));
};

var SidePanel = function SidePanel(_ref) {
  var _ref$content$page = _ref.content.page,
    name = _ref$content$page.name,
    logo_src = _ref$content$page.logo_src,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 36 : _ref$size;
  return React__default.createElement("div", {
    className: "tw-flex tw-flex-col tw-items-center tw-gap-2 tw-mr-2 tw-justify-between"
  }, React__default.createElement("div", {
    className: "tw-relative"
  }, React__default.createElement(Avatar, {
    size: size,
    name: name,
    src: logo_src != null ? logo_src : undefined,
    className: "tw-rounded-full",
    color: "blue"
  })));
};

var Body$1 = function Body(props) {
  return React__default.createElement("div", {
    className: "tw-flex tw-flex-col tw-flex-1 tw-min-w-0"
  }, props.children);
};

var TextContent$3 = function TextContent(_ref) {
  var text = _ref.content.text;
  if (!text) {
    return null;
  }
  return React__default.createElement(PostTextContentWrapper, {
    className: "tw-font-regular tw-leading-[20px] tw-pb-2"
  }, React__default.createElement(HyperText, {
    pageType: TYPE_THREADS
  }, text));
};

var img$5 = "data:image/png;base64,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";

var Footer$6 = function Footer() {
  return React__default.createElement("div", null, React__default.createElement("img", {
    alt: "",
    src: img$5,
    style: {
      width: 132,
      height: 'auto'
    }
  }), React__default.createElement("div", {
    className: "tw-text-md tw-text-grayscale-100"
  }, "2 replies \u2022 People liked your content"));
};

var css$X = ".slider-list{align-items:center}";
n(css$X,{});

var CarouselGallery = function CarouselGallery(_ref) {
  var images = _ref.images,
    videos = _ref.videos,
    _ref$lightboxEnabled = _ref.lightboxEnabled,
    lightboxEnabled = _ref$lightboxEnabled === void 0 ? true : _ref$lightboxEnabled,
    isLinkPost = _ref.isLinkPost;
  var _useLightbox = useLightbox(lightboxEnabled),
    lightbox = _useLightbox.lightbox,
    handleOpenLightbox = _useLightbox.handleOpenLightbox,
    enableLightbox = _useLightbox.enableLightbox;
  var _useState = useState(false),
    isDragging = _useState[0],
    setIsDragging = _useState[1];
  return React__default.createElement("div", {
    "data-cy": DATA_CY_NAMES.IMAGE_GALLERY
  }, images.length === 1 && videos.length === 0 && function (medium) {
    return React__default.createElement("div", {
      "data-cy": DATA_CY_NAMES.IMAGE_GALLERY_WRAPPER,
      className: "tw-relative"
    }, React__default.createElement("img", {
      className: clsx('tw-w-full tw-h-auto tw-rounded', {
        'tw-rounded-none': isLinkPost
      }),
      src: medium.sizes.lightbox.src,
      onClick: function onClick() {
        return handleOpenLightbox();
      }
    }));
  }(images[0].medium), images.length === 0 && videos.length === 1 && React__default.createElement("div", {
    className: "tw-rounded tw-overflow-hidden"
  }, React__default.createElement(VideoPlayer, {
    video: videos[0].medium
  })), [].concat(images, videos).length > 1 && React__default.createElement(NukaCarousel, {
    className: "tw-w-[calc(100%+15px)]",
    style: {
      width: 'calc(100% + 15px)'
    },
    slideWidth: images.length === 2 ? '50%' : '47.5%',
    renderBottomCenterControls: null,
    renderCenterRightControls: null,
    renderCenterLeftControls: null,
    cellSpacing: 6,
    beforeSlide: function beforeSlide() {
      return setIsDragging(true);
    },
    afterSlide: function afterSlide() {
      return setIsDragging(false);
    }
  }, images.map(function (image, i) {
    return React__default.createElement("img", {
      className: clsx('tw-aspect-[7/8] tw-w-full tw-flex-shrink-0 tw-object-cover tw-rounded'),
      src: image.medium.sizes.lightbox.src,
      key: image.medium.id + "-" + i,
      onClick: function onClick() {
        if (isDragging) return;
        handleOpenLightbox(i);
      },
      "data-cy": DATA_CY_NAMES.CAROUSEL.GALLERY_IMAGE
    });
  }), videos.map(function (video, i) {
    return React__default.createElement("div", {
      key: video.medium.id + "-" + i,
      className: "tw-rounded tw-aspect-[7/8] tw-overflow-hidden tw-flex tw-flex-shrink-0"
    }, React__default.createElement(VideoPlayer, {
      height: "100%",
      video: video.medium
    }));
  })), enableLightbox && React__default.createElement(AttachmentsLightBox$1, {
    onInit: function onInit(_ref2) {
      var instance = _ref2.instance;
      return lightbox.current = instance;
    },
    attachments: images
  }));
};

var Post$3 = function Post(_ref) {
  var formatDateTime = _ref.formatDateTime,
    content = _ref.content,
    use12hourFormat = _ref.use12hourFormat,
    style = _ref.style,
    dataCy = _ref.dataCy,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var attachments = getSegmentedAttachments(content);
  return React__default.createElement(PostWrapper$3, {
    style: style,
    contentType: content.type,
    variant: "desktop",
    dataCy: dataCy == null ? void 0 : dataCy.wrapper
  }, React__default.createElement(SidePanel, {
    content: content
  }), React__default.createElement(Body$1, null, React__default.createElement(Header$5, {
    content: content,
    use12hourFormat: use12hourFormat,
    formatDateTime: formatDateTime,
    onEditDateTimeClick: onEditDateTimeClick
  }), React__default.createElement(TextContent$3, {
    content: content
  }), (attachments.hasImages || attachments.hasVideos) && React__default.createElement(CarouselGallery, {
    images: attachments.images,
    videos: attachments.videos
  }), React__default.createElement(Footer$6, null)));
};

var LinkInfo$3 = function LinkInfo(_ref) {
  var link = _ref.link;
  if (link.url) {
    return React__default.createElement("div", {
      className: "tw-flex tw-flex-col tw-py-2 tw-px-3"
    }, React__default.createElement("span", {
      className: "tw-text-sm tw-text-grayscale-100"
    }, getHostnameFromUrl(link.url)), React__default.createElement("span", {
      className: "tw-font-medium tw-text-grayscale-180 tw-text-md"
    }, link.title));
  }
  return null;
};

var LinkPost$2 = function LinkPost(_ref) {
  var content = _ref.content,
    use12hourFormat = _ref.use12hourFormat,
    formatDateTime = _ref.formatDateTime,
    style = _ref.style,
    dataCy = _ref.dataCy,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var attachments = getSegmentedAttachments(content);
  var linkAttachment = attachments.all[0];
  return React__default.createElement(PostWrapper$3, {
    style: style,
    contentType: content.type,
    variant: "desktop",
    dataCy: dataCy == null ? void 0 : dataCy.wrapper
  }, React__default.createElement(SidePanel, {
    content: content
  }), React__default.createElement(Body$1, null, React__default.createElement(Header$5, {
    content: content,
    use12hourFormat: use12hourFormat,
    formatDateTime: formatDateTime,
    onEditDateTimeClick: onEditDateTimeClick
  }), React__default.createElement(TextContent$3, {
    content: content
  }), linkAttachment && React__default.createElement(ExternalLink, {
    href: linkAttachment.url,
    className: "tw-relative tw-no-underline tw-border tw-border-grayscale-20 tw-overflow-hidden tw-rounded-md"
  }, (attachments.hasImages || attachments.hasVideos) && React__default.createElement(CarouselGallery, {
    images: attachments.images,
    videos: attachments.videos,
    lightboxEnabled: false,
    isLinkPost: true
  }), React__default.createElement(LinkInfo$3, {
    link: linkAttachment
  })), React__default.createElement(Footer$6, null)));
};

var img$6 = "data:image/png;base64,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";

var AppLayout$3 = function AppLayout(_ref) {
  var children = _ref.children;
  return React__default.createElement("div", {
    className: "tw-flex tw-flex-col tw-overflow-hidden tw-h-full tw-bg-white"
  }, React__default.createElement("div", {
    className: "tw-flex tw-justify-center tw-h-[50px] tw-items-center"
  }, React__default.createElement(Icon, {
    size: "xl",
    className: "tw-text-black",
    icon: faThreads
  })), React__default.createElement("div", {
    className: "tw-flex-1 tw-overflow-auto tw-scrollbar-hide"
  }, children), React__default.createElement("img", {
    src: img$6,
    className: "tw-w-full tw-h-auto"
  }));
};

var MobilePost$3 = function MobilePost(_ref) {
  var content = _ref.content,
    use12hourFormat = _ref.use12hourFormat,
    formatDateTime = _ref.formatDateTime,
    style = _ref.style,
    dataCy = _ref.dataCy,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var attachments = getSegmentedAttachments(content);
  return React__default.createElement(Phone, {
    statusBarClassName: "tw-bg-white",
    style: style
  }, React__default.createElement(AppLayout$3, {
    content: content
  }, React__default.createElement(PostWrapper$3, {
    variant: "mobile",
    contentType: content.type,
    dataCy: dataCy == null ? void 0 : dataCy.wrapper
  }, React__default.createElement(SidePanel, {
    content: content
  }), React__default.createElement(Body$1, null, React__default.createElement(Header$5, {
    content: content,
    use12hourFormat: use12hourFormat,
    formatDateTime: formatDateTime,
    onEditDateTimeClick: onEditDateTimeClick
  }), React__default.createElement(TextContent$3, {
    content: content
  }), (attachments.hasImages || attachments.hasVideos) && React__default.createElement(CarouselGallery, {
    images: attachments.images,
    videos: attachments.videos
  }), React__default.createElement(Footer$6, null)))));
};

var MobileLinkPost$2 = function MobileLinkPost(_ref) {
  var content = _ref.content,
    use12hourFormat = _ref.use12hourFormat,
    formatDateTime = _ref.formatDateTime,
    style = _ref.style,
    dataCy = _ref.dataCy,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var attachments = getSegmentedAttachments(content);
  var linkAttachment = attachments.all[0];
  return React__default.createElement(Phone, {
    statusBarClassName: "tw-bg-white",
    style: style
  }, React__default.createElement(AppLayout$3, {
    content: content
  }, React__default.createElement(PostWrapper$3, {
    variant: "mobile",
    contentType: content.type,
    dataCy: dataCy == null ? void 0 : dataCy.wrapper
  }, React__default.createElement(SidePanel, {
    content: content
  }), React__default.createElement(Body$1, null, React__default.createElement(Header$5, {
    content: content,
    use12hourFormat: use12hourFormat,
    formatDateTime: formatDateTime,
    onEditDateTimeClick: onEditDateTimeClick
  }), React__default.createElement(TextContent$3, {
    content: content
  }), linkAttachment && React__default.createElement(ExternalLink, {
    href: linkAttachment.url,
    className: "tw-relative tw-no-underline tw-border tw-border-grayscale-20 tw-overflow-hidden tw-rounded-md"
  }, (attachments.hasImages || attachments.hasVideos) && React__default.createElement(CarouselGallery, {
    isLinkPost: true,
    images: attachments.images,
    videos: attachments.videos
  }), React__default.createElement(LinkInfo$3, {
    link: linkAttachment
  })), React__default.createElement(Footer$6, null)))));
};

var css$Y = ".PostWrapper_module_postWrapper__fcf01825{background:#fff;border-radius:8px;box-shadow:0 0 0 1px rgba(0,0,0,.08);box-sizing:border-box;display:flex;flex-direction:column;font-family:-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Fira Sans,Ubuntu,Oxygen,Oxygen Sans,Cantarell,Droid Sans,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Lucida Grande,Helvetica,Arial,sans-serif;font-size:14px;font-weight:400;line-height:1.5;max-width:500px;overflow:hidden;width:100%;@apply tw-text-grayscale-180}.PostWrapper_module_postWrapper__fcf01825[data-preview-variant=mobile]{border-radius:0}.PostWrapper_module_postWrapper__fcf01825 a{color:inherit}.PostWrapper_module_postWrapper__fcf01825 a:hover{color:inherit;text-decoration:none}";
var modules_6850efbf$3 = {"postWrapper":"PostWrapper_module_postWrapper__fcf01825"};
n(css$Y,{});

var PostWrapper$4 = function PostWrapper(props) {
  return React__default.createElement("div", {
    className: modules_6850efbf$3.postWrapper,
    "data-preview-variant": props.variant,
    "data-content-type": props.contentType,
    style: modules_6850efbf$3
  }, props.children);
};

var css$Z = ".Header_module_header__24980518{display:flex;padding:12px 16px}.Header_module_header__24980518 .Header_module_title__24980518{color:rgba(0,0,0,.9);cursor:pointer;font-weight:600;text-decoration:none}.Header_module_header__24980518 .Header_module_title__24980518:hover{color:#0a66c2;text-decoration:underline}.Header_module_header__24980518 .Header_module_photo__24980518{border-radius:0;margin-right:8px}.Header_module_header__24980518 .Header_module_photo__24980518:before{border:none}.Header_module_header__24980518 .Header_module_meta__24980518{align-items:center;color:#7a869a;display:flex;font-size:12px}.Header_module_header__24980518 .Header_module_meta__24980518 .Header_module_time__24980518{align-items:center;display:flex}";
var modules_773fac34$5 = {"header":"Header_module_header__24980518","title":"Header_module_title__24980518","photo":"Header_module_photo__24980518","meta":"Header_module_meta__24980518","time":"Header_module_time__24980518"};
n(css$Z,{});

var GlobeIcon = function GlobeIcon(props) {
  return React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    "data-supported-dps": "16x16",
    fill: "currentColor",
    width: "16",
    height: "16",
    focusable: "false",
    className: props.className
  }, React__default.createElement("path", {
    d: "M8 1a7 7 0 107 7 7 7 0 00-7-7zM3 8a5 5 0 011-3l.55.55A1.5 1.5 0 015 6.62v1.07a.75.75 0 00.22.53l.56.56a.75.75 0 00.53.22H7v.69a.75.75 0 00.22.53l.56.56a.75.75 0 01.22.53V13a5 5 0 01-5-5zm6.24 4.83l2-2.46a.75.75 0 00.09-.8l-.58-1.16A.76.76 0 0010 8H7v-.19a.51.51 0 01.28-.45l.38-.19a.74.74 0 01.68 0L9 7.5l.38-.7a1 1 0 00.12-.48v-.85a.78.78 0 01.21-.53l1.07-1.09a5 5 0 01-1.54 9z"
  }));
};

var Header$6 = function Header(_ref) {
  var _ref$content = _ref.content,
    date = _ref$content.date,
    _ref$content$page = _ref$content.page,
    logo_src = _ref$content$page.logo_src,
    name = _ref$content$page.name,
    time = _ref$content.time,
    use12hourFormat = _ref.use12hourFormat,
    formatDateTime = _ref.formatDateTime,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var renderDateTime = function renderDateTime() {
    return React__default.createElement(DateTime, Object.assign({}, {
      time: time,
      date: date,
      use12hourFormat: use12hourFormat,
      formatDateTime: formatDateTime,
      className: modules_773fac34$5.time
    }));
  };
  return React__default.createElement("div", {
    className: modules_773fac34$5.header
  }, React__default.createElement(Avatar, {
    size: 48,
    name: name,
    src: logo_src || undefined,
    className: modules_773fac34$5.photo,
    color: "blue"
  }), React__default.createElement("div", {
    className: modules_773fac34$5.content
  }, React__default.createElement("div", {
    className: modules_773fac34$5.title
  }, name), React__default.createElement("div", {
    className: modules_773fac34$5.meta
  }, "3,148 followers"), React__default.createElement("div", {
    className: modules_773fac34$5.meta
  }, onEditDateTimeClick ? React__default.createElement(DateTooltip, Object.assign({}, {
    time: time,
    date: date,
    use12hourFormat: use12hourFormat,
    onEditDateTimeClick: onEditDateTimeClick
  }), renderDateTime()) : renderDateTime(), (time || date) && React__default.createElement("div", {
    className: modules_773fac34$5.divider
  }, "\xA0\u2022\xA0"), React__default.createElement(GlobeIcon, null))));
};

var css$_ = ".TextContent_module_textContent__afe3565d{font-size:14px;font-weight:400;line-height:20px;margin:0 16px}.TextContent_module_seeMore__afe3565d{color:#7a869a;cursor:pointer;margin-left:4px}.TextContent_module_seeMore__afe3565d:hover{text-decoration:underline}";
var modules_82161d99$3 = {"textContent":"TextContent_module_textContent__afe3565d","seeMore":"TextContent_module_seeMore__afe3565d"};
n(css$_,{});

var getTextBreakPoint = function getTextBreakPoint(type, variant) {
  if (variant === 'desktop') {
    return 3;
  }
  return type === TYPE_COMMENT ? 2 : 1;
};
var TextContent$4 = function TextContent(_ref) {
  var variant = _ref.variant,
    content = _ref.content;
  if (content.text) {
    var textBreakPoint = getTextBreakPoint(content.type, variant != null ? variant : 'desktop');
    return React__default.createElement(PostTextContentWrapper, {
      className: clsx('tw-text-grayscale-180', modules_82161d99$3.textContent)
    }, React__default.createElement("span", null, React__default.createElement(HyperText, {
      pageType: TYPE_LINKEDIN,
      options: {
        maxLines: textBreakPoint,
        expandableTrigger: {
          less: React__default.createElement(React__default.Fragment, null),
          more: React__default.createElement("span", {
            className: modules_82161d99$3.seeMore
          }, "...show more")
        }
      }
    }, content.text)));
  }
  return null;
};

var css$$ = ".Footer_module_footer__a62d3275{color:#7a869a;display:flex;justify-content:space-evenly;margin:0 6px;padding:4px 0}.Footer_module_footer__a62d3275 .Footer_module_btn__a62d3275{align-items:center;border-radius:4px;cursor:pointer;display:flex;font-weight:600;justify-content:center;padding:8px;transition:background-color 199ms cubic-bezier(0,0,.21,1.11)}.Footer_module_footer__a62d3275 .Footer_module_btn__a62d3275:hover{background-color:rgba(0,0,0,.08)}.Footer_module_footer__a62d3275 .Footer_module_btn__a62d3275 svg{margin-right:4px}[data-preview-variant=mobile] .Footer_module_footer__a62d3275{justify-content:space-around;padding:0}[data-preview-variant=mobile] .Footer_module_footer__a62d3275 .Footer_module_btn__a62d3275{flex-direction:column;font-size:12px;padding:6px}[data-preview-variant=mobile] .Footer_module_footer__a62d3275 .Footer_module_btn__a62d3275 svg{height:16px;margin-right:0;width:16px}.Footer_module_divider__a62d3275{border-bottom:1px solid rgba(0,0,0,.08);height:1px;margin:16px 16px 0}";
var modules_93eb7477$5 = {"footer":"Footer_module_footer__a62d3275","btn":"Footer_module_btn__a62d3275","divider":"Footer_module_divider__a62d3275"};
n(css$$,{});

var LikeIcon$1 = function LikeIcon(props) {
  return React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "data-supported-dps": "24x24",
    fill: "currentColor",
    className: props.className,
    width: "24",
    height: "24",
    focusable: "false"
  }, React__default.createElement("path", {
    d: "M19.46 11l-3.91-3.91a7 7 0 01-1.69-2.74l-.49-1.47A2.76 2.76 0 0010.76 1 2.75 2.75 0 008 3.74v1.12a9.19 9.19 0 00.46 2.85L8.89 9H4.12A2.12 2.12 0 002 11.12a2.16 2.16 0 00.92 1.76A2.11 2.11 0 002 14.62a2.14 2.14 0 001.28 2 2 2 0 00-.28 1 2.12 2.12 0 002 2.12v.14A2.12 2.12 0 007.12 22h7.49a8.08 8.08 0 003.58-.84l.31-.16H21V11zM19 19h-1l-.73.37a6.14 6.14 0 01-2.69.63H7.72a1 1 0 01-1-.72l-.25-.87-.85-.41A1 1 0 015 17l.17-1-.76-.74A1 1 0 014.27 14l.66-1.09-.73-1.1a.49.49 0 01.08-.7.48.48 0 01.34-.11h7.05l-1.31-3.92A7 7 0 0110 4.86V3.75a.77.77 0 01.75-.75.75.75 0 01.71.51L12 5a9 9 0 002.13 3.5l4.5 4.5H19z"
  }));
};

var CommentIcon$1 = function CommentIcon(props) {
  return React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "data-supported-dps": "24x24",
    fill: "currentColor",
    className: props.className,
    width: "24",
    height: "24",
    focusable: "false"
  }, React__default.createElement("path", {
    d: "M7 9h10v1H7zm0 4h7v-1H7zm16-2a6.78 6.78 0 01-2.84 5.61L12 22v-4H8A7 7 0 018 4h8a7 7 0 017 7zm-2 0a5 5 0 00-5-5H8a5 5 0 000 10h6v2.28L19 15a4.79 4.79 0 002-4z"
  }));
};

var ShareIcon$2 = function ShareIcon(props) {
  return React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "24",
    viewBox: "0 0 18 24",
    fill: "none"
  }, React__default.createElement("path", {
    d: "M10.96 5H3C2.45 5 2 5.45 2 6V16H0V6C0 4.34 1.34 3 3 3H10.96L9 0H11.37L14 4L11.37 8H9L10.96 5ZM16.5 8H16V18C16 18.55 15.55 19 15 19H7.04L9 16H6.63L4 20L6.63 24H9L7.04 21H15C16.66 21 18 19.66 18 18V8H16.5Z",
    fill: "#7A869A"
  }));
};

var SendIcon = function SendIcon(props) {
  return React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "data-supported-dps": "24x24",
    fill: "currentColor",
    className: props.className,
    width: "24",
    height: "24",
    focusable: "false"
  }, React__default.createElement("path", {
    d: "M21 3L0 10l7.66 4.26L16 8l-6.26 8.34L14 24l7-21z"
  }));
};

var Footer$7 = function Footer(_ref) {
  var showDivider = _ref.showDivider;
  return React__default.createElement(React__default.Fragment, null, showDivider && React__default.createElement("div", {
    className: modules_93eb7477$5.divider
  }), React__default.createElement("div", {
    className: modules_93eb7477$5.footer
  }, React__default.createElement("div", {
    className: modules_93eb7477$5.btn
  }, React__default.createElement(LikeIcon$1, null), React__default.createElement("span", null, "Like")), React__default.createElement("div", {
    className: modules_93eb7477$5.btn
  }, React__default.createElement(CommentIcon$1, null), React__default.createElement("span", null, "Comment")), React__default.createElement("div", {
    className: modules_93eb7477$5.btn
  }, React__default.createElement(ShareIcon$2, null), React__default.createElement("span", null, "Repost")), React__default.createElement("div", {
    className: modules_93eb7477$5.btn
  }, React__default.createElement(SendIcon, null), React__default.createElement("span", null, "Send"))));
};

var useGetImageSourse = function useGetImageSourse(image) {
  var _image$sizes$original;
  if (image.meta.is_animated_gif && (_image$sizes$original = image.sizes.original) != null && _image$sizes$original.src) {
    return image.sizes.original.src;
  }
  return image.sizes.lightbox.src;
};

var TwoImagesLayout = function TwoImagesLayout(_ref) {
  var images = _ref.images,
    aspectRatios = _ref.aspectRatios,
    _onClick = _ref.onClick;
  var aspectRatiosTogether = aspectRatios[0] + aspectRatios[1];
  return React__default.createElement("div", {
    className: "tw-grid tw-grid-cols-[auto,auto] tw-grid-rows-[100%] tw-max-h-[552px] ",
    style: {
      aspectRatio: aspectRatiosTogether
    }
  }, React__default.createElement("div", {
    className: "tw-w-full tw-h-full",
    style: {
      aspectRatio: aspectRatios[0]
    },
    onClick: function onClick() {
      return _onClick(0);
    }
  }, React__default.createElement("img", {
    src: useGetImageSourse(images[0].medium),
    className: "tw-w-full tw-h-full tw-object-cover tw-border tw-border-white tw-border-solid"
  })), React__default.createElement("div", {
    className: "tw-w-full tw-h-full",
    onClick: function onClick() {
      return _onClick(1);
    }
  }, React__default.createElement("img", {
    src: useGetImageSourse(images[1].medium),
    className: "tw-w-full tw-h-full tw-object-cover tw-border tw-border-white tw-border-solid"
  })));
};

var ThreeImagesLayout = function ThreeImagesLayout(_ref) {
  var images = _ref.images,
    orientations = _ref.orientations,
    _onClick = _ref.onClick,
    aspectRatios = _ref.aspectRatios;
  return React__default.createElement("div", {
    className: clsx('tw-grid tw-max-h-[552px]', {
      'tw-grid-cols-[auto_minmax(33.33%,_1fr)] tw-grid-rows-[50%,50%]': orientations[0] === 'vertical' || orientations[0] === 'square',
      'tw-grid-cols-[50%,50%] tw-grid-rows-[1fr_minmax(0,auto)]': orientations[0] === 'horizontal',
      'tw-aspect-[3/2]': orientations[0] === 'square'
    })
  }, React__default.createElement("div", {
    className: clsx('tw-grid tw-w-full tw-h-full', {
      'tw-col-start-1  tw-col-end-auto tw-row-start-1 tw-row-end-3': orientations[0] === 'vertical' || orientations[0] === 'square',
      'tw-col-start-1 tw-col-end-3 tw-row-start-1 tw-row-end-auto': orientations[0] === 'horizontal'
    }),
    onClick: function onClick() {
      return _onClick(0);
    },
    style: {
      aspectRatio: aspectRatios[0]
    }
  }, React__default.createElement("img", {
    src: useGetImageSourse(images[0].medium),
    className: "tw-w-full tw-h-full tw-object-cover tw-border tw-border-white tw-border-solid"
  })), React__default.createElement("div", {
    className: "tw-row-span-1 tw-col-span-1",
    onClick: function onClick() {
      return _onClick(1);
    }
  }, React__default.createElement("img", {
    src: useGetImageSourse(images[1].medium),
    className: "tw-w-full tw-h-full tw-object-cover tw-border tw-border-white tw-border-solid"
  })), React__default.createElement("div", {
    className: "tw-row-span-1 tw-col-span-1",
    onClick: function onClick() {
      return _onClick(2);
    }
  }, React__default.createElement("img", {
    src: useGetImageSourse(images[2].medium),
    className: "tw-w-full tw-h-full tw-object-cover tw-border tw-border-white tw-border-solid"
  })));
};

var FourAndMoreImagesLayout = function FourAndMoreImagesLayout(_ref) {
  var images = _ref.images,
    orientations = _ref.orientations,
    _onClick = _ref.onClick;
  return React__default.createElement("div", {
    className: clsx('tw-grid tw-max-h-[552px] tw-w-full', {
      'tw-grid-cols-[auto_minmax(33.33%,_1fr)] tw-grid-rows-[repeat(3,33.33%)]': orientations[0] === 'vertical' || orientations[0] === 'square',
      'tw-grid-cols-[repeat(3,33.33%)] tw-grid-rows-[1fr_minmax(0,auto)]': orientations[0] === 'horizontal',
      'tw-aspect-[3/2]': orientations[0] === 'square'
    })
  }, React__default.createElement("div", {
    className: clsx('tw-grid tw-w-full tw-h-full tw-max-h-[552px]', {
      'tw-col-start-1  tw-col-end-auto tw-row-start-1 tw-row-end-4': orientations[0] === 'vertical' || orientations[0] === 'square',
      'tw-aspect-square': orientations[0] === 'square',
      'tw-col-start-1 tw-col-end-4 tw-row-start-1 tw-row-end-auto': orientations[0] === 'horizontal'
    }),
    onClick: function onClick() {
      return _onClick(0);
    }
  }, React__default.createElement("img", {
    src: useGetImageSourse(images[0].medium),
    className: "tw-w-full tw-h-full tw-object-cover tw-border tw-border-white tw-border-solid"
  })), React__default.createElement("div", {
    className: "tw-w-full tw-row-span-1 tw-col-span-1",
    onClick: function onClick() {
      return _onClick(1);
    }
  }, React__default.createElement("img", {
    src: useGetImageSourse(images[1].medium),
    className: "tw-w-full tw-h-full  tw-object-cover tw-border tw-border-white tw-border-solid"
  })), React__default.createElement("div", {
    className: "tw-w-full tw-row-span-1 tw-col-span-1",
    onClick: function onClick() {
      return _onClick(2);
    }
  }, React__default.createElement("img", {
    src: useGetImageSourse(images[2].medium),
    className: "tw-w-full tw-h-full tw-object-cover tw-border tw-border-white tw-border-solid"
  })), React__default.createElement("div", {
    className: "tw-relative tw-w-full tw-row-span-1 tw-col-span-1",
    onClick: function onClick() {
      return _onClick(3);
    }
  }, React__default.createElement("img", {
    src: useGetImageSourse(images[3].medium),
    className: "tw-w-full tw-h-full tw-object-cover tw-border tw-border-white tw-border-solid"
  }), images.length > 4 && React__default.createElement("div", {
    className: "tw-cursor-pointer tw-flex tw-justify-center tw-items-center tw-absolute tw-top-0 tw-left-0 tw-right-0 tw-w-full tw-h-full tw-bg-opacity-30 tw-bg-black",
    onClick: function onClick() {
      return _onClick(3);
    }
  }, React__default.createElement("span", {
    className: "tw-text-xl tw-text-white"
  }, "+", images.length - 4))));
};

var OneImageLayout = function OneImageLayout(_ref) {
  var images = _ref.images,
    _onClick = _ref.onClick;
  var imageSrc = useGetImageSourse(images[0].medium);
  var _images$0$medium$size = images[0].medium.sizes.original,
    width = _images$0$medium$size.width,
    height = _images$0$medium$size.height;
  var paddingTop = Number((height / width * 100).toFixed(2)) + "%";
  return React__default.createElement("div", {
    className: "tw-w-full tw-h-0 tw-overflow-hidden tw-relative",
    onClick: function onClick() {
      return _onClick(0);
    },
    style: {
      paddingTop: paddingTop
    }
  }, React__default.createElement("div", {
    className: "tw-w-full tw-h-full tw-absolute tw-top-0 tw-left-0 tw-flex  tw-items-start tw-justify-center "
  }, React__default.createElement("img", {
    src: imageSrc,
    className: "tw-max-w-full tw-h-auto tw-mx-auto tw-object-contain tw-bg-contain tw-bg-no-repeat tw-object-center "
  })));
};

function getImageOrientation(width, height) {
  if (width > height) {
    return 'horizontal';
  } else if (height > width) {
    return 'vertical';
  } else {
    return 'square';
  }
}
var ImageGallery$2 = function ImageGallery(_ref) {
  var images = _ref.images,
    _ref$lightboxEnabled = _ref.lightboxEnabled,
    lightboxEnabled = _ref$lightboxEnabled === void 0 ? true : _ref$lightboxEnabled;
  var _useLightbox = useLightbox(lightboxEnabled),
    lightbox = _useLightbox.lightbox,
    handleOpenLightbox = _useLightbox.handleOpenLightbox,
    enableLightbox = _useLightbox.enableLightbox;
  var imagesAspectRatios = useMemo(function () {
    return images.map(function (image) {
      var _image$medium$sizes$o = image.medium.sizes.original,
        width = _image$medium$sizes$o.width,
        height = _image$medium$sizes$o.height;
      var ratio = width / height;
      return Number(ratio.toFixed(2));
    });
  }, [images]);
  var imagesOrientations = useMemo(function () {
    return images.map(function (image) {
      var _image$medium$sizes$o2 = image.medium.sizes.original,
        width = _image$medium$sizes$o2.width,
        height = _image$medium$sizes$o2.height;
      return getImageOrientation(width, height);
    });
  }, [images]);
  return React__default.createElement("div", {
    "data-cy": DATA_CY_NAMES.IMAGE_GALLERY,
    className: "tw-flex tw-h-full tw-w-full tw-overflow-hidden tw-max-h-[625px] tw-mt-3 tw-cursor-pointer"
  }, images.length === 1 && React__default.createElement(OneImageLayout, {
    images: images,
    onClick: function onClick(i) {
      return handleOpenLightbox(i);
    }
  }), React__default.createElement("div", {
    "data-cy": DATA_CY_NAMES.IMAGE_GALLERY_WRAPPER
  }, images.length === 2 && React__default.createElement(TwoImagesLayout, {
    images: images,
    aspectRatios: imagesAspectRatios,
    onClick: function onClick(i) {
      return handleOpenLightbox(i);
    }
  }), images.length === 3 && React__default.createElement(ThreeImagesLayout, {
    images: images,
    orientations: imagesOrientations,
    onClick: function onClick(i) {
      return handleOpenLightbox(i);
    },
    aspectRatios: imagesAspectRatios
  }), images.length >= 4 && React__default.createElement(FourAndMoreImagesLayout, {
    images: images,
    orientations: imagesOrientations,
    onClick: function onClick(i) {
      return handleOpenLightbox(i);
    },
    aspectRatios: imagesAspectRatios
  })), enableLightbox && React__default.createElement(AttachmentsLightBox$1, {
    onInit: function onInit(_ref2) {
      var instance = _ref2.instance;
      return lightbox.current = instance;
    },
    attachments: images
  }));
};

var css$10 = ".Post_module_postVideoPlayerWrapper__20d0ea85{margin-top:12px}";
var modules_4e180e43$1 = {"postVideoPlayerWrapper":"Post_module_postVideoPlayerWrapper__20d0ea85"};
n(css$10,{});

var Post$4 = function Post(_ref) {
  var formatDateTime = _ref.formatDateTime,
    content = _ref.content,
    use12hourFormat = _ref.use12hourFormat,
    style = _ref.style,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var attachments = getSegmentedAttachments(content);
  return React__default.createElement(PostWrapper$4, {
    style: style,
    variant: "desktop",
    contentType: content.type
  }, React__default.createElement(Header$6, {
    content: content,
    use12hourFormat: use12hourFormat,
    formatDateTime: formatDateTime,
    onEditDateTimeClick: onEditDateTimeClick
  }), React__default.createElement(TextContent$4, {
    content: content
  }), attachments.hasImages && React__default.createElement(ImageGallery$2, {
    images: attachments.images
  }), !attachments.hasImages && attachments.hasVideos && React__default.createElement("div", {
    className: modules_4e180e43$1.postVideoPlayerWrapper
  }, React__default.createElement(VideoPlayer, {
    video: attachments.videos[0].medium
  })), React__default.createElement(Footer$7, {
    showDivider: !attachments.hasImages && !attachments.hasVideos
  }));
};

var LinkInfo$4 = function LinkInfo(_ref) {
  var _link$title;
  var link = _ref.link,
    attachments = _ref.attachments,
    variant = _ref.variant;
  var isDesktop = variant === 'desktop';
  return React__default.createElement("div", {
    className: clsx('tw-flex tw-gap-3  tw-items-center tw-justify-between tw-h-24 tw-py-3 tw-px-3 tw-bg-blue-alt-light', {
      'tw-px-5': isDesktop
    })
  }, React__default.createElement("div", {
    className: clsx('tw-h-[72px] tw-flex tw-justify-center  tw-items-center ', {
      'tw-w-[130px]': isDesktop,
      'tw-w-[112px]': !isDesktop,
      'tw-bg-grayscale-10': !attachments.hasImages
    })
  }, attachments.hasImages ? React__default.createElement("img", {
    src: attachments.images[0].medium.sizes.lightbox.src,
    className: "tw-w-full tw-h-full tw-rounded-md tw-object-cover "
  }) : React__default.createElement(Icon, {
    icon: faImageSlash,
    className: "tw-text-grayscale-50"
  })), React__default.createElement("div", {
    className: "tw-flex-1 tw-min-w-0"
  }, React__default.createElement("div", {
    className: "tw-font-semibold  tw-text-md tw-mb-2 tw-truncate tw-max-w-[318px]"
  }, (_link$title = link.title) != null ? _link$title : '*Title is required'), link.description && React__default.createElement("div", {
    className: "tw-text-sm tw-truncate  tw-font-regular tw-text-grayscale-140"
  }, link.description)));
};

var css$11 = ".LinkPost_module_link__bc6a2d1c{color:inherit;margin-top:12px;text-decoration:none}.LinkPost_module_link__bc6a2d1c:visited{color:inherit}";
var modules_0c03f802$2 = {"link":"LinkPost_module_link__bc6a2d1c"};
n(css$11,{});

var LinkPost$3 = function LinkPost(_ref) {
  var content = _ref.content,
    use12hourFormat = _ref.use12hourFormat,
    formatDateTime = _ref.formatDateTime,
    style = _ref.style,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var attachments = getSegmentedAttachments(content);
  var linkAttachment = attachments.all[0];
  return React__default.createElement(PostWrapper$4, {
    style: style,
    variant: "desktop",
    contentType: content.type
  }, React__default.createElement(Header$6, {
    content: content,
    use12hourFormat: use12hourFormat,
    formatDateTime: formatDateTime,
    onEditDateTimeClick: onEditDateTimeClick
  }), React__default.createElement(TextContent$4, {
    content: content
  }), linkAttachment && React__default.createElement(ExternalLink, {
    href: linkAttachment.url,
    className: modules_0c03f802$2.link
  }, React__default.createElement(LinkInfo$4, {
    link: linkAttachment,
    attachments: attachments,
    variant: "desktop"
  })), React__default.createElement(Footer$7, {
    showDivider: !attachments.hasImages && !attachments.hasVideos
  }));
};

var css$12 = ".Carousel_module_carousel__087bf28b{height:0;margin-top:12px;position:relative;width:100%}.Carousel_module_carousel__087bf28b:hover .slider-slide:not(.slide-current){opacity:.6}.Carousel_module_carousel__087bf28b .Carousel_module_arrow__087bf28b{align-items:center;background-color:#fff;border:1px solid rgba(0,0,0,.1);border-radius:50%;cursor:pointer;display:flex;height:48px;justify-content:center;margin:8px;transition:background-color 199ms cubic-bezier(0,0,.21,1.11);width:48px}.Carousel_module_carousel__087bf28b .Carousel_module_arrow__087bf28b:hover{background-color:#f6faf6}.Carousel_module_carousel__087bf28b .Carousel_module_arrow__087bf28b svg{color:#65676b}.Carousel_module_carousel__087bf28b .Carousel_module_aspectRatio__087bf28b{height:100%;left:0;position:absolute;top:0;width:100%}.Carousel_module_carousel__087bf28b .Carousel_module_pagingDots__087bf28b{display:flex;left:50%;position:absolute;top:calc(100% + 15px);transform:translateX(-50%);z-index:1}.Carousel_module_carousel__087bf28b .Carousel_module_pagingDots__087bf28b .Carousel_module_dot__087bf28b{background-color:rgba(0,0,0,.3);border-radius:50%;cursor:pointer;height:6px;width:6px}.Carousel_module_carousel__087bf28b .Carousel_module_pagingDots__087bf28b .Carousel_module_dot__087bf28b+.Carousel_module_dot__087bf28b{margin-left:4px}.Carousel_module_carousel__087bf28b .Carousel_module_pagingDots__087bf28b .Carousel_module_dot__087bf28b.Carousel_module_active__087bf28b{background-color:#0095f6}[data-preview-variant=mobile] .Carousel_module_carousel__087bf28b .Carousel_module_arrow__087bf28b{height:38px;width:38px}";
var modules_794cd056$2 = {"carousel":"Carousel_module_carousel__087bf28b","arrow":"Carousel_module_arrow__087bf28b","aspectRatio":"Carousel_module_aspectRatio__087bf28b","pagingDots":"Carousel_module_pagingDots__087bf28b","dot":"Carousel_module_dot__087bf28b","active":"Carousel_module_active__087bf28b"};
n(css$12,{});

var css$13 = ".CarouselItem_module_item__096919c5{border:1px solid rgba(0,0,0,.08);border-radius:8px;color:rgba(0,0,0,.9);display:flex;flex-direction:column;text-decoration:none}.CarouselItem_module_item__096919c5:visited{color:rgba(0,0,0,.9)}.CarouselItem_module_item__096919c5 .CarouselItem_module_aspectRatio__096919c5{display:flex;height:0;padding-bottom:100%;position:relative;width:100%}.CarouselItem_module_item__096919c5 .CarouselItem_module_aspectRatio__096919c5 .CarouselItem_module_image__096919c5{background-position:50%;background-size:cover;border-radius:8px 8px 0 0;height:100%;left:0;position:absolute;top:0;width:100%}.CarouselItem_module_item__096919c5 .CarouselItem_module_aspectRatio__096919c5 .CarouselItem_module_pageImage__096919c5{align-items:center;border-radius:0;display:flex;font-size:34px!important;height:50%!important;justify-content:center;left:50%;top:50%;transform:translate(-50%,-50%);width:50%!important}.CarouselItem_module_item__096919c5 .CarouselItem_module_aspectRatio__096919c5 .CarouselItem_module_pageImage__096919c5:before{display:none}.CarouselItem_module_item__096919c5 .CarouselItem_module_footer__096919c5{align-items:center;border-top:1px solid rgba(0,0,0,.08);display:flex;flex:1;padding:0 12px}.CarouselItem_module_item__096919c5 .CarouselItem_module_footer__096919c5 .CarouselItem_module_desc__096919c5{-webkit-box-orient:vertical;-webkit-line-clamp:2;align-items:center;display:-webkit-box;display:flex;font-size:12px;font-weight:600;height:40px;overflow:hidden;white-space:normal;word-break:break-word}[data-preview-variant=mobile] .CarouselItem_module_item__096919c5 .CarouselItem_module_footer__096919c5 .CarouselItem_module_cta__096919c5{font-size:12px;padding:6px 10px}";
var modules_ee2c7f53$2 = {"item":"CarouselItem_module_item__096919c5","aspectRatio":"CarouselItem_module_aspectRatio__096919c5","image":"CarouselItem_module_image__096919c5","pageImage":"CarouselItem_module_pageImage__096919c5","footer":"CarouselItem_module_footer__096919c5","desc":"CarouselItem_module_desc__096919c5","cta":"CarouselItem_module_cta__096919c5"};
n(css$13,{});

var CarouselItem$2 = function CarouselItem(_ref) {
  var attachment = _ref.attachment,
    style = _ref.style;
  function getSrc() {
    var _attachment$medium, _attachment$medium2;
    if (((_attachment$medium = attachment.medium) == null ? void 0 : _attachment$medium.type) === 'video') {
      var _attachment$medium$or;
      return (_attachment$medium$or = attachment.medium.original_thumb) == null ? void 0 : _attachment$medium$or.src;
    }
    if (((_attachment$medium2 = attachment.medium) == null ? void 0 : _attachment$medium2.type) === 'image') {
      var _attachment$medium$si, _attachment$medium$si2;
      return (_attachment$medium$si = attachment.medium.sizes) == null ? void 0 : (_attachment$medium$si2 = _attachment$medium$si.lightbox) == null ? void 0 : _attachment$medium$si2.src;
    }
    return undefined;
  }
  var src = getSrc();
  return React__default.createElement(ExternalLink, {
    href: attachment.url,
    className: modules_ee2c7f53$2.item,
    style: style,
    "data-cy": DATA_CY_NAMES.CAROUSEL.GALLERY_ITEM
  }, React__default.createElement("div", {
    className: modules_ee2c7f53$2.aspectRatio
  }, src && React__default.createElement("div", {
    "data-cy": DATA_CY_NAMES.CAROUSEL.GALLERY_IMAGE,
    className: modules_ee2c7f53$2.image,
    style: {
      backgroundImage: "url('" + src + "')"
    }
  })), React__default.createElement("div", {
    className: modules_ee2c7f53$2.footer,
    style: {
      height: '40px'
    }
  }, attachment.title && React__default.createElement("div", {
    className: modules_ee2c7f53$2.desc
  }, attachment.title)));
};

var Carousel$2 = function Carousel(_ref) {
  var attachments = _ref.attachments;
  var _useState = useState(0),
    activeSlide = _useState[0],
    setActiveSlide = _useState[1];
  var _useState2 = useState(false),
    carouselShown = _useState2[0],
    setCarouselShown = _useState2[1];
  var _useState3 = useState(0),
    height = _useState3[0],
    setHeight = _useState3[1];
  useEffect(function () {
    setCarouselShown(true);
  }, []);
  var elementRef = useCallback(function (node) {
    if (!node) return;
    var resizeObserver = new ResizeObserver(function () {
      node && setHeight(node == null ? void 0 : node.clientHeight);
    });
    resizeObserver.observe(node);
  }, []);
  return React__default.createElement("div", {
    className: modules_794cd056$2.carousel,
    style: {
      height: height
    }
  }, React__default.createElement("div", {
    className: modules_794cd056$2.aspectRatio
  }, carouselShown && React__default.createElement(NukaCarousel, {
    ref: elementRef,
    adaptiveHeight: true,
    cellSpacing: 6,
    cellAlign: activeSlide === 0 ? 'left' : 'center',
    slidesToShow: 1.6,
    slideIndex: activeSlide,
    disableEdgeSwiping: true,
    beforeSlide: function beforeSlide(currentSlide, endSlide) {
      return setActiveSlide(endSlide);
    },
    renderCenterLeftControls: function renderCenterLeftControls(p) {
      return p.currentSlide !== 0 && React__default.createElement("div", {
        className: modules_794cd056$2.arrow,
        onClick: p.previousSlide,
        "data-cy": DATA_CY_NAMES.CAROUSEL.ARROW.PREVIOUS
      }, React__default.createElement(Icon, {
        icon: faChevronLeft,
        size: 25
      }));
    },
    renderCenterRightControls: function renderCenterRightControls(p) {
      return p.currentSlide !== p.slideCount - 1 && React__default.createElement("div", {
        className: modules_794cd056$2.arrow,
        onClick: p.nextSlide,
        "data-cy": DATA_CY_NAMES.CAROUSEL.ARROW.NEXT
      }, React__default.createElement(Icon, {
        icon: faChevronRight,
        size: 25
      }));
    },
    renderBottomCenterControls: null
  }, attachments.map(function (linkAttachment, index) {
    return React__default.createElement(CarouselItem$2, {
      key: index,
      attachment: linkAttachment
    });
  }))));
};

var CarouselPost$1 = function CarouselPost(_ref) {
  var content = _ref.content,
    use12hourFormat = _ref.use12hourFormat,
    formatDateTime = _ref.formatDateTime,
    style = _ref.style,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var attachments = getSegmentedAttachments(content);
  return React__default.createElement(PostWrapper$4, {
    style: style,
    variant: "desktop",
    contentType: content.type
  }, React__default.createElement(Header$6, {
    content: content,
    use12hourFormat: use12hourFormat,
    formatDateTime: formatDateTime,
    onEditDateTimeClick: onEditDateTimeClick
  }), React__default.createElement(TextContent$4, {
    content: content
  }), content.attachments.cards.length > 0 && React__default.createElement(Carousel$2, {
    attachments: content.attachments.cards
  }), React__default.createElement(Footer$7, {
    showDivider: !attachments.hasImages && !attachments.hasVideos
  }));
};

var css$14 = ".AppLayout_module_appLayout__b7df141d{display:flex;flex-direction:column;height:100%;overflow:hidden}.AppLayout_module_appLayout__b7df141d .AppLayout_module_header__b7df141d{align-items:center;background-color:#fff;box-shadow:0 0 0 1px rgba(0,0,0,.03);color:#7a869a;display:flex;justify-content:space-between;padding:12px 16px}.AppLayout_module_appLayout__b7df141d .AppLayout_module_header__b7df141d .AppLayout_module_avatar__b7df141d:before{border:none}.AppLayout_module_appLayout__b7df141d .AppLayout_module_header__b7df141d .AppLayout_module_fakeSearch__b7df141d{align-items:center;background-color:#eef3f8;border-radius:4px;display:flex;flex:1;margin:0 5%;padding:6px 8px}.AppLayout_module_appLayout__b7df141d .AppLayout_module_header__b7df141d .AppLayout_module_fakeSearch__b7df141d span{font-size:12px}.AppLayout_module_appLayout__b7df141d .AppLayout_module_header__b7df141d .AppLayout_module_fakeSearch__b7df141d svg{margin-right:8px}.AppLayout_module_appLayout__b7df141d .AppLayout_module_body__b7df141d{flex:1 1 auto;overflow:auto}.AppLayout_module_appLayout__b7df141d .AppLayout_module_footer__b7df141d{height:auto;width:100%}";
var modules_11a4dd02$3 = {"appLayout":"AppLayout_module_appLayout__b7df141d","header":"AppLayout_module_header__b7df141d","avatar":"AppLayout_module_avatar__b7df141d","fakeSearch":"AppLayout_module_fakeSearch__b7df141d","body":"AppLayout_module_body__b7df141d","footer":"AppLayout_module_footer__b7df141d"};
n(css$14,{});

var css$15 = ".Footer_module_footer__d2390692{background-color:#fff;border-top:1px solid #dbdbdb;display:flex;height:auto;justify-content:space-between;padding:12px 24px 26px;position:relative;width:100%}.Footer_module_footer__d2390692 .Footer_module_icon__d2390692{align-items:center;display:flex;flex-direction:column}.Footer_module_footer__d2390692 .Footer_module_icon__d2390692 span{color:#626b7b;font-size:10px;margin-top:4px}.Footer_module_footer__d2390692 .Footer_module_homeIcon__d2390692{color:#181b1f;position:relative}.Footer_module_footer__d2390692 .Footer_module_homeIcon__d2390692:before{background-color:#181b1f;content:\"\";height:2px;left:-23px;position:absolute;top:-13px;width:68px}";
var modules_93eb7477$6 = {"footer":"Footer_module_footer__d2390692","icon":"Footer_module_icon__d2390692","homeIcon":"Footer_module_homeIcon__d2390692"};
n(css$15,{});

var HomeIcon$2 = function HomeIcon() {
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, createElement("g", {
    clipPath: "url(#a)"
  }, createElement("path", {
    fill: "#181B1F",
    d: "M20.088 9.06V7.15l-2.806-1.792V.833h-2.5v2.928L10.198.833.308 7.151V9.06h1.55v6.806a3.3 3.3 0 0 0 3.3 3.3h2.929v-6.124h4.223v6.124h2.928a3.3 3.3 0 0 0 3.301-3.3V9.06h1.55Z"
  })), createElement("defs", null, createElement("clipPath", {
    id: "a"
  }, createElement("path", {
    fill: "#fff",
    d: "M.2 0h20v20H.2z"
  }))));
};

var NetworkIcon = function NetworkIcon() {
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, createElement("path", {
    fill: "#626B7B",
    d: "M6.624 8.71a3.939 3.939 0 1 0 0-7.877 3.939 3.939 0 0 0 0 7.877ZM7.36 10.875a3.616 3.616 0 0 1 3.615 3.614v4.675H2.683v-4.675a3.616 3.616 0 0 1 3.615-3.614H7.36ZM15.906 11.22a2.993 2.993 0 1 0 0-5.986 2.993 2.993 0 0 0 0 5.986ZM16.064 12.866a3.152 3.152 0 0 1 3.15 3.15v3.15h-6.3v-3.15a3.152 3.152 0 0 1 3.15-3.15Z"
  }));
};

var PostIcon = function PostIcon() {
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, createElement("path", {
    fill: "#626B7B",
    fillRule: "evenodd",
    d: "M1.03 2.487C.667 3.2.667 4.133.667 6v6c0 1.867 0 2.8.363 3.514.32.627.83 1.137 1.457 1.456.713.364 1.646.364 3.513.364h6c1.867 0 2.8 0 3.513-.364a3.333 3.333 0 0 0 1.457-1.456c.363-.713.363-1.647.363-3.514V6c0-1.867 0-2.8-.363-3.513a3.333 3.333 0 0 0-1.457-1.457C14.8.667 13.867.667 12 .667H6c-1.867 0-2.8 0-3.513.363-.627.32-1.137.83-1.457 1.457Zm7.137 2.347h1.666v3.333h3.334v1.667H9.833v3.333H8.167V9.834H4.833V8.167h3.334V4.834Z",
    clipRule: "evenodd"
  }));
};

var NotificationsIcon = function NotificationsIcon() {
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    fill: "none"
  }, createElement("path", {
    fill: "#626B7B",
    d: "M15.478 9.963V6.75a6.082 6.082 0 1 0-12.164 0v3.214h12.164ZM18.277 15.211a.29.29 0 0 0 .284-.346l-.41-2.07a3.342 3.342 0 0 0-.184-.635l-.008-.023c-.396-.938-1.344-1.523-2.36-1.523H3.201c-1.017 0-1.965.585-2.36 1.523v.002c-.08.191-.138.389-.18.591L.24 14.863a.29.29 0 0 0 .284.346h7.069c.009 1.251.815 2.262 1.808 2.262.993 0 1.802-1.01 1.808-2.262h7.069v.002Z"
  }));
};

var JobsIcon = function JobsIcon() {
  return createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, createElement("path", {
    fill: "#626B7B",
    d: "M15.309 5.604v-.29a3.652 3.652 0 0 0-3.648-3.647H9.94a3.652 3.652 0 0 0-3.648 3.648v.289H1.633V9.61a3.198 3.198 0 0 0 2.938 1.944H17.03c1.317 0 2.45-.802 2.938-1.944V5.604h-4.658Zm-7.63-.29a2.264 2.264 0 0 1 2.26-2.26h1.722a2.264 2.264 0 0 1 2.26 2.26v.29H7.679v-.29Z"
  }), createElement("path", {
    fill: "#626B7B",
    d: "M4.571 12.478a4.116 4.116 0 0 1-2.938-1.236v4.186a2.45 2.45 0 0 0 2.45 2.45h13.433a2.45 2.45 0 0 0 2.45-2.45v-4.186a4.098 4.098 0 0 1-2.937 1.236H4.57Z"
  }));
};

var Footer$8 = function Footer(_ref) {
  var className = _ref.className;
  return React__default.createElement("div", {
    className: classNames(modules_93eb7477$6.footer, className)
  }, React__default.createElement("div", {
    className: classNames(modules_93eb7477$6.icon, modules_93eb7477$6.homeIcon)
  }, React__default.createElement(HomeIcon$2, null), React__default.createElement("span", null, "Home")), React__default.createElement("div", {
    className: modules_93eb7477$6.icon
  }, React__default.createElement(NetworkIcon, null), React__default.createElement("span", null, "My Network")), React__default.createElement("div", {
    className: modules_93eb7477$6.icon
  }, React__default.createElement(PostIcon, null), React__default.createElement("span", null, "Post")), React__default.createElement("div", {
    className: modules_93eb7477$6.icon
  }, React__default.createElement(NotificationsIcon, null), React__default.createElement("span", null, "Notifications")), React__default.createElement("div", {
    className: modules_93eb7477$6.icon
  }, React__default.createElement(JobsIcon, null), React__default.createElement("span", null, "Jobs")));
};

var AppLayout$4 = function AppLayout(_ref) {
  var children = _ref.children;
  return React__default.createElement("div", {
    className: modules_11a4dd02$3.appLayout
  }, React__default.createElement("div", {
    className: modules_11a4dd02$3.body
  }, children), React__default.createElement(Footer$8, null));
};

var css$16 = ".MobilePost_module_statusBar__35108c5e{background-color:#fff}.MobilePost_module_videoPlayerWrapper__35108c5e{margin-top:12px}";
var modules_813dec30$3 = {"statusBar":"MobilePost_module_statusBar__35108c5e","videoPlayerWrapper":"MobilePost_module_videoPlayerWrapper__35108c5e"};
n(css$16,{});

var MobilePost$4 = function MobilePost(_ref) {
  var content = _ref.content,
    use12hourFormat = _ref.use12hourFormat,
    formatDateTime = _ref.formatDateTime,
    style = _ref.style,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var attachments = getSegmentedAttachments(content);
  return React__default.createElement(Phone, {
    statusBarClassName: modules_813dec30$3.statusBar,
    style: style
  }, React__default.createElement(AppLayout$4, {
    page: content.page
  }, React__default.createElement(PostWrapper$4, {
    variant: "mobile",
    contentType: content.type
  }, React__default.createElement(Header$6, {
    content: content,
    use12hourFormat: use12hourFormat,
    formatDateTime: formatDateTime,
    onEditDateTimeClick: onEditDateTimeClick
  }), React__default.createElement(TextContent$4, {
    content: content,
    variant: "mobile"
  }), attachments.hasImages && React__default.createElement(ImageGallery$2, {
    images: attachments.images
  }), !attachments.hasImages && attachments.hasVideos && React__default.createElement("div", {
    className: modules_813dec30$3.videoPlayerWrapper
  }, React__default.createElement(VideoPlayer, {
    video: attachments.videos[0].medium
  })), React__default.createElement(Footer$7, {
    showDivider: true
  }))));
};

var MobileLinkPost$3 = function MobileLinkPost(_ref) {
  var content = _ref.content,
    use12hourFormat = _ref.use12hourFormat,
    formatDateTime = _ref.formatDateTime,
    style = _ref.style,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var attachments = getSegmentedAttachments(content);
  var linkAttachment = attachments.all[0];
  return React__default.createElement(Phone, {
    statusBarClassName: modules_813dec30$3.statusBar,
    style: style
  }, React__default.createElement(AppLayout$4, {
    page: content.page
  }, React__default.createElement(PostWrapper$4, {
    variant: "mobile",
    contentType: content.type
  }, React__default.createElement(Header$6, {
    content: content,
    use12hourFormat: use12hourFormat,
    formatDateTime: formatDateTime,
    onEditDateTimeClick: onEditDateTimeClick
  }), React__default.createElement(TextContent$4, {
    content: content
  }), linkAttachment && React__default.createElement(ExternalLink, {
    href: linkAttachment.url,
    className: modules_0c03f802$2.link
  }, React__default.createElement(LinkInfo$4, {
    link: linkAttachment,
    attachments: attachments,
    variant: "mobile"
  })), React__default.createElement(Footer$7, {
    showDivider: true
  }))));
};

var MobileCarouselPost$1 = function MobileCarouselPost(_ref) {
  var content = _ref.content,
    use12hourFormat = _ref.use12hourFormat,
    formatDateTime = _ref.formatDateTime,
    style = _ref.style,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  return React__default.createElement(Phone, {
    statusBarClassName: modules_813dec30$3.statusBar,
    style: style
  }, React__default.createElement(AppLayout$4, {
    page: content.page
  }, React__default.createElement(PostWrapper$4, {
    variant: "mobile",
    contentType: content.type
  }, React__default.createElement(Header$6, {
    content: content,
    use12hourFormat: use12hourFormat,
    formatDateTime: formatDateTime,
    onEditDateTimeClick: onEditDateTimeClick
  }), React__default.createElement(TextContent$4, {
    content: content
  }), content.attachments.cards.length > 0 && React__default.createElement(Carousel$2, {
    attachments: content.attachments.cards
  }), React__default.createElement(Footer$7, {
    showDivider: true
  }))));
};

var css$17 = ".PostWrapper_module_postWrapper__b4319b70{background:#fff;border-radius:max(0px,min(8px,(100vw - 4px - 100%) * 9999))/8px;box-shadow:0 1px 2px rgba(0,0,0,.2);box-sizing:border-box;color:#3c4043;display:flex;flex-direction:column;font-family:Roboto,Arial,sans-serif;font-size:14px;line-height:1.34;max-width:500px;overflow:hidden;width:100%}.PostWrapper_module_postWrapper__b4319b70[data-preview-variant=mobile]{border-radius:0;max-width:100%}.PostWrapper_module_postWrapper__b4319b70 a{color:inherit}.PostWrapper_module_postWrapper__b4319b70 a:hover{color:inherit;text-decoration:none}";
var modules_6850efbf$4 = {"postWrapper":"PostWrapper_module_postWrapper__b4319b70"};
n(css$17,{});

var PostWrapper$5 = function PostWrapper(props) {
  return React__default.createElement("div", {
    className: modules_6850efbf$4.postWrapper,
    "data-preview-variant": props.variant,
    "data-content-type": props.contentType,
    style: props.style
  }, props.children);
};
PostWrapper$5.defaultProps = {
  variant: 'desktop'
};

var css$18 = ".Header_module_header__5aa1635f{align-items:center;display:flex;flex-direction:row;gap:4px;padding:8px 20px}.Header_module_header__5aa1635f .Header_module_content__5aa1635f{display:flex;flex-direction:column;margin-left:8px}.Header_module_header__5aa1635f .Header_module_username__5aa1635f{font-size:14px;font-weight:600}.Header_module_header__5aa1635f .Header_module_time__5aa1635f{color:#7a869a;font-size:12px}";
var modules_773fac34$6 = {"header":"Header_module_header__5aa1635f","content":"Header_module_content__5aa1635f","username":"Header_module_username__5aa1635f","time":"Header_module_time__5aa1635f"};
n(css$18,{});

var Header$7 = function Header(_ref) {
  var _ref$content = _ref.content,
    date = _ref$content.date,
    _ref$content$page = _ref$content.page,
    logo_src = _ref$content$page.logo_src,
    name = _ref$content$page.name,
    time = _ref$content.time,
    use12hourFormat = _ref.use12hourFormat,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var renderDateTime = function renderDateTime() {
    return React__default.createElement("span", {
      className: modules_773fac34$6.time,
      "data-cy": DATA_CY_NAMES.POST_PREVIEW_DATE
    }, formatDateTimeAsSocialNetworkPost({
      date: date,
      time: time,
      use12hourFormat: use12hourFormat
    }));
  };
  return React__default.createElement("div", {
    className: modules_773fac34$6.header
  }, React__default.createElement(Avatar, {
    size: 32,
    name: name,
    src: logo_src || undefined
  }), React__default.createElement("div", {
    className: modules_773fac34$6.content
  }, React__default.createElement("span", {
    className: modules_773fac34$6.username
  }, name), onEditDateTimeClick ? React__default.createElement(DateTooltip, Object.assign({}, {
    time: time,
    date: date,
    use12hourFormat: use12hourFormat,
    onEditDateTimeClick: onEditDateTimeClick
  }), renderDateTime()) : renderDateTime()), React__default.createElement("div", {
    style: {
      marginLeft: 'auto'
    }
  }, React__default.createElement(Icon, {
    icon: faEllipsisV
  })));
};

var css$19 = ".TextContent_module_textContent__1c3dc690{font-size:.875rem;font-weight:400;letter-spacing:.0142857143em;line-height:1.25rem;padding:16px}.TextContent_module_seeMore__1c3dc690{cursor:pointer;display:inline-block;font-weight:600}.TextContent_module_seeMore__1c3dc690:hover{text-decoration:underline}";
var modules_82161d99$4 = {"textContent":"TextContent_module_textContent__1c3dc690","seeMore":"TextContent_module_seeMore__1c3dc690"};
n(css$19,{});

var TextContent$5 = function TextContent(_ref) {
  var _ref$content = _ref.content,
    text = _ref$content.text,
    attachments = _ref$content.attachments,
    variant = _ref.variant;
  var _useState = useState(false),
    showWholeText = _useState[0],
    setShowWholeText = _useState[1];
  if (!text) {
    return React__default.createElement(PostTextContentWrapper, {
      className: classNames(modules_82161d99$4.textContent)
    });
  }
  function getHasLargeText() {
    if (attachments.cards.length > 0) {
      return false;
    }
    return (text == null ? void 0 : text.length) && text.length <= FACEBOOK.LARGER_FONTSIZE_LIMIT;
  }
  function getCharacterLimit() {
    if (variant === 'mobile' && text && text.length > FACEBOOK.TRUNCATED_TEXT_LENGTH_MOBILE) {
      return FACEBOOK.TRUNCATED_TEXT_LENGTH_MOBILE;
    }
    if (text && text.length > FACEBOOK.TRUNCATED_TEXT_LENGTH_WEB) {
      return FACEBOOK.TRUNCATED_TEXT_LENGTH_WEB;
    }
    return undefined;
  }
  var hasLargeText = getHasLargeText();
  var characterLimit = getCharacterLimit();
  var canSeeShowWholeText = (text == null ? void 0 : text.length) && text.length > truncateHtmlString(text, {
    maxLength: characterLimit,
    ellipsis: false
  }).length && !showWholeText;
  return React__default.createElement(PostTextContentWrapper, {
    className: classNames(modules_82161d99$4.textContent, hasLargeText && modules_82161d99$4.largeText)
  }, React__default.createElement(HyperText, {
    pageType: TYPE_GOOGLE_MY_BUSINESS,
    options: {
      maxLength: showWholeText ? undefined : characterLimit
    }
  }, text), canSeeShowWholeText && React__default.createElement("span", {
    className: modules_82161d99$4.seeMore,
    onClick: function onClick() {
      return setShowWholeText(true);
    }
  }, "See More"));
};

var css$1a = ".Footer_module_footer__90281f99{display:flex;flex-direction:column;justify-content:space-between;padding:16px}.Footer_module_footer__90281f99 .Footer_module_link__90281f99{color:#1a0dab;cursor:pointer;font-size:14px;text-decoration:none}.Footer_module_footer__90281f99 .Footer_module_ctaWrapper__90281f99,.Footer_module_footer__90281f99 .Footer_module_termsAndConditions__90281f99{align-items:center;display:flex;justify-content:space-between}.Footer_module_footer__90281f99 .Footer_module_tacLink__90281f99{color:#bdc3cd;cursor:pointer;font-size:14px;overflow:hidden;padding-right:8px;text-decoration:none;text-overflow:ellipsis;white-space:nowrap}.Footer_module_footer__90281f99 .Footer_module_divider__90281f99{background-color:#e4e7eb;height:1px;padding:0 16px;width:100%}.Footer_module_footer__90281f99 .Footer_module_icon__90281f99{padding:7px 7px 5px 5px}.Footer_module_footer__90281f99 .Footer_module_icon__90281f99 :hover{cursor:pointer}[data-preview-variant=mobile] .Footer_module_footer__90281f99 .Footer_module_ctaWrapper__90281f99 .Footer_module_link__90281f99{border:1px solid #f2f3f5;border-radius:100px;color:#3771e0;padding:4px 12px}[data-preview-variant=mobile] .Footer_module_footer__90281f99 .Footer_module_ctaWrapper__90281f99 .Footer_module_link__90281f99:hover{opacity:.8}[data-preview-variant=mobile] .Footer_module_footer__90281f99 .Footer_module_ctaWrapper__90281f99 .Footer_module_shareIcon__90281f99{display:none}";
var modules_93eb7477$7 = {"footer":"Footer_module_footer__90281f99","link":"Footer_module_link__90281f99","termsAndConditions":"Footer_module_termsAndConditions__90281f99","ctaWrapper":"Footer_module_ctaWrapper__90281f99","tacLink":"Footer_module_tacLink__90281f99","divider":"Footer_module_divider__90281f99","icon":"Footer_module_icon__90281f99","shareIcon":"Footer_module_shareIcon__90281f99"};
n(css$1a,{});

var Footer$9 = function Footer(_ref) {
  var termsAndConditions = _ref.termsAndConditions,
    ctaType = _ref.ctaType,
    ctaLink = _ref.ctaLink;
  if (!ctaType && !termsAndConditions) {
    return null;
  }
  return React__default.createElement("div", {
    className: modules_93eb7477$7.footer
  }, ctaType && React__default.createElement("div", {
    className: modules_93eb7477$7.ctaWrapper
  }, React__default.createElement(ExternalLink, {
    href: ctaLink || '',
    className: modules_93eb7477$7.link
  }, ctaType), React__default.createElement(Icon, {
    icon: faShareNodes,
    size: "lg",
    className: modules_93eb7477$7.shareIcon
  })), termsAndConditions && React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
    className: modules_93eb7477$7.divider
  }), React__default.createElement("div", {
    className: modules_93eb7477$7.termsAndConditions
  }, React__default.createElement(ExternalLink, {
    href: termsAndConditions || '',
    className: modules_93eb7477$7.tacLink,
    "data-cy": DATA_CY_NAMES.OFFER_INFO.OFFER_TERMS_AND_CONDITIONS
  }, "Terms and conditions"), React__default.createElement(Icon, {
    icon: faShareNodes,
    size: "lg"
  }))));
};

var css$1b = ".Carousel_module_carousel__58f5edec:hover .slider-slide:not(.slide-current){opacity:.6}.Carousel_module_carousel__58f5edec .Carousel_module_arrow__58f5edec{align-items:center;background-color:#fff;border:1px solid rgba(0,0,0,.1);border-radius:50%;cursor:pointer;display:flex;height:40px;justify-content:center;margin:8px 30px 8px 8px;transition:background-color 199ms cubic-bezier(0,0,.21,1.11);width:40px}.Carousel_module_carousel__58f5edec .Carousel_module_arrow__58f5edec:hover{background-color:#f6faf6}.Carousel_module_carousel__58f5edec .Carousel_module_arrow__58f5edec svg{color:#1a73e8}.Carousel_module_carousel__58f5edec .Carousel_module_tag__58f5edec{background-color:hsla(0,0%,7%,.57);border-radius:25px;color:#fff;font-size:12px;margin:10px;padding:4px 10px}.Carousel_module_carousel__58f5edec .Carousel_module_aspectRatio__58f5edec{width:100%}.Carousel_module_carousel__58f5edec .Carousel_module_pagingDots__58f5edec{display:flex;left:50%;position:absolute;top:calc(100% + 15px);transform:translateX(-50%);z-index:1}.Carousel_module_carousel__58f5edec .Carousel_module_pagingDots__58f5edec .Carousel_module_dot__58f5edec{background-color:rgba(0,0,0,.3);border-radius:50%;cursor:pointer;height:6px;width:6px}.Carousel_module_carousel__58f5edec .Carousel_module_pagingDots__58f5edec .Carousel_module_dot__58f5edec+.Carousel_module_dot__58f5edec{margin-left:4px}.Carousel_module_carousel__58f5edec .Carousel_module_pagingDots__58f5edec .Carousel_module_dot__58f5edec.Carousel_module_active__58f5edec{background-color:#0095f6}[data-preview-variant=mobile] .Carousel_module_carousel__58f5edec .Carousel_module_arrow__58f5edec{height:38px;width:38px}";
var modules_794cd056$3 = {"carousel":"Carousel_module_carousel__58f5edec","arrow":"Carousel_module_arrow__58f5edec","tag":"Carousel_module_tag__58f5edec","aspectRatio":"Carousel_module_aspectRatio__58f5edec","pagingDots":"Carousel_module_pagingDots__58f5edec","dot":"Carousel_module_dot__58f5edec","active":"Carousel_module_active__58f5edec"};
n(css$1b,{});

var css$1c = ".CarouselItem_module_item__6a780fd5{color:#181b1f;display:flex;flex-direction:column;text-decoration:none}.CarouselItem_module_item__6a780fd5:visited{color:#181b1f}.CarouselItem_module_item__6a780fd5 .CarouselItem_module_aspectRatio__6a780fd5{display:flex;height:0;padding-bottom:75%;position:relative;width:100%}.CarouselItem_module_item__6a780fd5 .CarouselItem_module_aspectRatio__6a780fd5 .CarouselItem_module_image__6a780fd5{background-position:50%;background-size:cover;height:100%;left:0;position:absolute;top:0;width:100%}";
var modules_ee2c7f53$3 = {"item":"CarouselItem_module_item__6a780fd5","aspectRatio":"CarouselItem_module_aspectRatio__6a780fd5","image":"CarouselItem_module_image__6a780fd5"};
n(css$1c,{});

var CarouselItem$3 = function CarouselItem(_ref) {
  var image = _ref.image,
    style = _ref.style;
  return React__default.createElement(ExternalLink, {
    className: modules_ee2c7f53$3.item,
    style: style,
    href: image.url
  }, image.medium.sizes.lightbox && React__default.createElement("div", {
    className: modules_ee2c7f53$3.aspectRatio
  }, React__default.createElement("div", {
    className: modules_ee2c7f53$3.image,
    style: {
      backgroundImage: "url('" + image.medium.sizes.lightbox.src + "')"
    }
  })));
};

var FinalCarouselItem$1 = function FinalCarouselItem(_ref) {
  var _page$logo_src;
  var image = _ref.image,
    page = _ref.page,
    style = _ref.style;
  return React__default.createElement(ExternalLink, {
    className: modules_ee2c7f53$3.item,
    style: style,
    href: image.url
  }, React__default.createElement("div", {
    className: modules_ee2c7f53$3.aspectRatio
  }, React__default.createElement(Avatar, {
    src: (_page$logo_src = page == null ? void 0 : page.logo_src) != null ? _page$logo_src : undefined,
    name: page.name,
    className: classNames(modules_ee2c7f53$3.image, modules_ee2c7f53$3.pageImage)
  })));
};

var Carousel$3 = function Carousel(_ref) {
  var images = _ref.images,
    page = _ref.page,
    hasMultiShareEndCard = _ref.hasMultiShareEndCard;
  var _useState = useState(0),
    activeSlide = _useState[0],
    setActiveSlide = _useState[1];
  var _useState2 = useState(false),
    carouselShown = _useState2[0],
    setCarouselShown = _useState2[1];
  var ref = useRef(null);
  useEffect(function () {
    setCarouselShown(true);
  }, []);
  return React__default.createElement("div", {
    className: modules_794cd056$3.carousel
  }, React__default.createElement("div", {
    className: modules_794cd056$3.aspectRatio,
    ref: ref
  }, carouselShown && React__default.createElement(NukaCarousel, {
    cellSpacing: 6,
    cellAlign: 'left',
    slidesToShow: 1.3,
    slideIndex: activeSlide,
    disableEdgeSwiping: true,
    beforeSlide: function beforeSlide(currentSlide, endSlide) {
      return setActiveSlide(endSlide);
    },
    renderTopRightControls: function renderTopRightControls(p) {
      return React__default.createElement("div", {
        className: modules_794cd056$3.tag
      }, p.currentSlide + 1 + '/' + p.slideCount);
    },
    renderCenterLeftControls: function renderCenterLeftControls(p) {
      return p.currentSlide !== 0 && React__default.createElement("div", {
        className: modules_794cd056$3.arrow,
        onClick: p.previousSlide,
        "data-cy": DATA_CY_NAMES.CAROUSEL.ARROW.PREVIOUS
      }, React__default.createElement(Icon, {
        icon: faChevronLeft,
        size: 25
      }));
    },
    renderCenterRightControls: function renderCenterRightControls(p) {
      return p.currentSlide !== p.slideCount - 1 && React__default.createElement("div", {
        className: modules_794cd056$3.arrow,
        onClick: p.nextSlide,
        "data-cy": DATA_CY_NAMES.CAROUSEL.ARROW.NEXT
      }, React__default.createElement(Icon, {
        icon: faChevronRight,
        size: 25
      }));
    },
    renderBottomCenterControls: null
  }, images.map(function (linkAttachment, index) {
    return React__default.createElement(CarouselItem$3, {
      key: index,
      image: linkAttachment
    });
  }), hasMultiShareEndCard && React__default.createElement(FinalCarouselItem$1, {
    page: page,
    image: images[0]
  }))));
};

var css$1d = ".OfferInfo_module_offerInfo__f9c814f3{display:flex;flex-direction:column}.OfferInfo_module_offerInfo__f9c814f3 .OfferInfo_module_title__f9c814f3{font-size:24px;font-weight:600;margin-bottom:4px;margin-top:0}.OfferInfo_module_offerInfo__f9c814f3 .OfferInfo_module_titleAndValidity__f9c814f3{margin:16px}.OfferInfo_module_offerInfo__f9c814f3 .OfferInfo_module_tagIcon__f9c814f3{color:#f3b500}.OfferInfo_module_offerInfo__f9c814f3 .OfferInfo_module_titleWithIcon__f9c814f3{align-items:center;display:flex;justify-content:space-between}.OfferInfo_module_offerInfo__f9c814f3 .OfferInfo_module_offerLink__f9c814f3{color:#3b78e7;cursor:pointer;margin-bottom:16px;padding-left:16px;padding-right:16px}.OfferInfo_module_offerInfo__f9c814f3 .OfferInfo_module_offer__f9c814f3{align-items:center;background-color:#f8f9fa;border:1px dashed #d7dbe1;border-radius:8px;display:flex;flex-direction:column;gap:4px;justify-content:center;margin:16px;padding:20px}.OfferInfo_module_offerInfo__f9c814f3 .OfferInfo_module_offer__f9c814f3 .OfferInfo_module_codeInfo__f9c814f3{color:#7a869a}.OfferInfo_module_offerInfo__f9c814f3 .OfferInfo_module_offer__f9c814f3 .OfferInfo_module_offerCode__f9c814f3{font-size:24px;font-weight:600}.OfferInfo_module_offerInfo__f9c814f3 .OfferInfo_module_offer__f9c814f3 .OfferInfo_module_offerDate__f9c814f3{color:#7a869a;font-size:12px;font-weight:300}[data-preview-variant=mobile] .OfferInfo_module_offerInfo__f9c814f3 .OfferInfo_module_tagIcon__f9c814f3{display:none}";
var modules_4d7c4c58 = {"offerInfo":"OfferInfo_module_offerInfo__f9c814f3","title":"OfferInfo_module_title__f9c814f3","titleAndValidity":"OfferInfo_module_titleAndValidity__f9c814f3","tagIcon":"OfferInfo_module_tagIcon__f9c814f3","titleWithIcon":"OfferInfo_module_titleWithIcon__f9c814f3","offerLink":"OfferInfo_module_offerLink__f9c814f3","offer":"OfferInfo_module_offer__f9c814f3","codeInfo":"OfferInfo_module_codeInfo__f9c814f3","offerCode":"OfferInfo_module_offerCode__f9c814f3","offerDate":"OfferInfo_module_offerDate__f9c814f3"};
n(css$1d,{});

var OfferInfo = function OfferInfo(_ref) {
  var content = _ref.content;
  return React__default.createElement("div", {
    className: modules_4d7c4c58.offerInfo
  }, React__default.createElement("div", {
    className: modules_4d7c4c58.titleAndValidity
  }, React__default.createElement("div", {
    className: modules_4d7c4c58.titleWithIcon,
    "data-cy": DATA_CY_NAMES.OFFER_INFO.OFFER_TITLE
  }, React__default.createElement("p", {
    className: modules_4d7c4c58.title
  }, content.attachments.title), React__default.createElement(Icon, {
    icon: faTag,
    className: modules_4d7c4c58.tagIcon,
    size: "lg"
  })), formatDate(content.attachments.startDate), " -", ' ', formatDate(content.attachments.endDate)), content && React__default.createElement(TextContent$5, {
    content: content
  }), content.attachments.couponCode && React__default.createElement("div", {
    className: modules_4d7c4c58.offer
  }, React__default.createElement("span", {
    className: modules_4d7c4c58.codeInfo,
    "data-cy": DATA_CY_NAMES.OFFER_INFO.CODE_INFO
  }, "Show this code at the shop"), React__default.createElement("span", {
    className: modules_4d7c4c58.offerCode,
    "data-cy": DATA_CY_NAMES.OFFER_INFO.OFFER_CODE
  }, content.attachments.couponCode), React__default.createElement("span", {
    className: modules_4d7c4c58.offerDate,
    "data-cy": DATA_CY_NAMES.OFFER_INFO.OFFER_DATE
  }, "Valid ", formatDate(content.attachments.startDate), " -", ' ', formatDate(content.attachments.endDate))), content.attachments.offerLink && React__default.createElement(ExternalLink, {
    href: content.attachments.offerLink,
    className: modules_4d7c4c58.offerLink,
    "data-cy": DATA_CY_NAMES.OFFER_INFO.OFFER_LINK
  }, "Redeem online"));
};

var css$1e = ".EventInfo_module_eventInfo__c630dc1b{display:flex;flex-direction:column}.EventInfo_module_eventInfo__c630dc1b .EventInfo_module_titleWithDateWrapper__c630dc1b{display:flex;flex-direction:column;padding:16px 16px 0}.EventInfo_module_eventInfo__c630dc1b .EventInfo_module_title__c630dc1b{font-size:24px;margin-bottom:4px}.EventInfo_module_eventInfo__c630dc1b .EventInfo_module_date__c630dc1b{font-size:16px;margin-top:4px}.EventInfo_module_eventInfo__c630dc1b .EventInfo_module_description__c630dc1b{color:#65676b;font-size:14px;margin:10px 0}";
var modules_111ab5a1 = {"eventInfo":"EventInfo_module_eventInfo__c630dc1b","titleWithDateWrapper":"EventInfo_module_titleWithDateWrapper__c630dc1b","title":"EventInfo_module_title__c630dc1b","date":"EventInfo_module_date__c630dc1b","description":"EventInfo_module_description__c630dc1b"};
n(css$1e,{});

var EventInfo = function EventInfo(_ref) {
  var content = _ref.content,
    use12hourFormat = _ref.use12hourFormat,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var renderDateTime = function renderDateTime() {
    return React__default.createElement("span", {
      className: modules_111ab5a1.date
    }, formatDateTimeAsSocialNetworkPost({
      date: content.attachments.startDate,
      time: content.attachments.startTime,
      use12hourFormat: use12hourFormat
    }), content.attachments.startDate || content.attachments.startTime ? ' - ' : '', formatDateTimeAsSocialNetworkPost({
      date: content.attachments.endDate,
      time: content.attachments.endTime,
      use12hourFormat: use12hourFormat
    }));
  };
  return React__default.createElement("div", {
    className: modules_111ab5a1.eventInfo
  }, React__default.createElement("div", {
    className: modules_111ab5a1.titleWithDateWrapper
  }, React__default.createElement("span", {
    className: modules_111ab5a1.title
  }, content.attachments.title), onEditDateTimeClick ? React__default.createElement(DateTooltip, {
    onEditDateTimeClick: onEditDateTimeClick
  }, renderDateTime()) : renderDateTime()), React__default.createElement(TextContent$5, {
    content: content
  }));
};

var Post$5 = function Post(_ref) {
  var _CTA_LABEL$content$at;
  var use12hourFormat = _ref.use12hourFormat,
    formatDateTime = _ref.formatDateTime,
    content = _ref.content,
    style = _ref.style,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var attachments = getSegmentedAttachments(content);
  var ctaType = (_CTA_LABEL$content$at = CTA_LABEL[content.attachments.ctaType]) != null ? _CTA_LABEL$content$at : null;
  return React__default.createElement(PostWrapper$5, {
    style: style,
    variant: "desktop",
    contentType: content.type
  }, React__default.createElement(Header$7, {
    content: content,
    use12hourFormat: use12hourFormat,
    formatDateTime: formatDateTime,
    onEditDateTimeClick: onEditDateTimeClick
  }), attachments.hasImages && React__default.createElement(React__default.Fragment, null, attachments.images.length === 1 && React__default.createElement(ImageGallery, {
    images: attachments.images
  }), attachments.images.length > 1 && React__default.createElement(Carousel$3, {
    page: content.page,
    hasMultiShareEndCard: attachments.hasMultiShareEndCard,
    images: attachments.images
  })), !attachments.hasImages && attachments.hasVideos && React__default.createElement(VideoPlayer, {
    video: attachments.videos[0].medium
  }), content.subtype === SUBTYPE.GMB_EVENT_POST && React__default.createElement(EventInfo, {
    content: content,
    use12hourFormat: use12hourFormat
  }), content.subtype === SUBTYPE.GMB_OFFER_POST && React__default.createElement(OfferInfo, {
    content: content
  }), content.subtype === SUBTYPE.DEFAULT && React__default.createElement(TextContent$5, {
    content: content
  }), React__default.createElement(Footer$9, {
    termsAndConditions: content.subtype === SUBTYPE.GMB_OFFER_POST ? content.attachments.termsAndConditions : undefined,
    ctaType: content.subtype !== SUBTYPE.GMB_OFFER_POST ? ctaType : undefined,
    ctaLink: content.subtype !== SUBTYPE.GMB_OFFER_POST ? content.attachments.ctaLink : undefined
  }));
};

var css$1f = ".AppLayout_module_appLayout__613d63f5{display:flex;flex-direction:column;height:100%;overflow:hidden}.AppLayout_module_appLayout__613d63f5 .AppLayout_module_header__613d63f5{align-items:center;background-color:#fff;display:flex;justify-content:center}.AppLayout_module_appLayout__613d63f5 .AppLayout_module_body__613d63f5{flex:1 1 auto;overflow:auto;padding:8px}.AppLayout_module_appLayout__613d63f5 .AppLayout_module_footer__613d63f5{height:auto;width:100%}";
var modules_11a4dd02$4 = {"appLayout":"AppLayout_module_appLayout__613d63f5","header":"AppLayout_module_header__613d63f5","body":"AppLayout_module_body__613d63f5","footer":"AppLayout_module_footer__613d63f5"};
n(css$1f,{});

var AppLayout$5 = function AppLayout(props) {
  return React__default.createElement("div", {
    className: modules_11a4dd02$4.appLayout
  }, React__default.createElement("div", {
    className: modules_11a4dd02$4.body
  }, props.children));
};

var MobilePost$5 = function MobilePost(_ref) {
  var _CTA_LABEL$content$at;
  var content = _ref.content,
    use12hourFormat = _ref.use12hourFormat,
    formatDateTime = _ref.formatDateTime,
    style = _ref.style,
    onEditDateTimeClick = _ref.onEditDateTimeClick;
  var attachments = getSegmentedAttachments(content);
  var ctaType = (_CTA_LABEL$content$at = CTA_LABEL[content.attachments.ctaType]) != null ? _CTA_LABEL$content$at : null;
  return React__default.createElement(Phone, {
    style: style,
    showHomeButton: false
  }, React__default.createElement(AppLayout$5, {
    page: content.page
  }, React__default.createElement(PostWrapper$5, {
    variant: "mobile",
    contentType: content.type
  }, React__default.createElement(Header$7, {
    content: content,
    use12hourFormat: use12hourFormat,
    formatDateTime: formatDateTime,
    onEditDateTimeClick: onEditDateTimeClick
  }), attachments.hasImages && React__default.createElement(React__default.Fragment, null, attachments.images.length === 1 && React__default.createElement(ImageGallery, {
    images: attachments.images
  }), attachments.images.length > 1 && React__default.createElement(Carousel$3, {
    page: content.page,
    hasMultiShareEndCard: attachments.hasMultiShareEndCard,
    images: attachments.images
  })), !attachments.hasImages && attachments.hasVideos && React__default.createElement(VideoPlayer, {
    video: attachments.videos[0].medium
  }), content.subtype === SUBTYPE.GMB_EVENT_POST && React__default.createElement(EventInfo, {
    content: content
  }), content.subtype === SUBTYPE.GMB_OFFER_POST && React__default.createElement(OfferInfo, {
    content: content
  }), content.subtype === SUBTYPE.DEFAULT && React__default.createElement(TextContent$5, {
    content: content
  }), React__default.createElement(Footer$9, {
    termsAndConditions: content.subtype === SUBTYPE.GMB_OFFER_POST ? content.attachments.termsAndConditions : undefined,
    ctaType: content.subtype !== SUBTYPE.GMB_OFFER_POST ? ctaType : undefined,
    ctaLink: content.subtype !== SUBTYPE.GMB_OFFER_POST ? content.attachments.ctaLink : undefined
  }))));
};

var css$1g = "@charset \"UTF-8\";.PostWrapper_module_contentWrapper__b535a8a9{padding:0 16px 16px}.PostWrapper_module_postWrapper__b535a8a9{background:#fff;border-radius:32px;box-sizing:border-box;color:#111;display:flex;flex-direction:column;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen-Sans,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Helvetica,ヒラギノ角ゴ Pro W3,Hiragino Kaku Gothic Pro,メイリオ,Meiryo,ＭＳ Ｐゴシック,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;font-size:12px;max-width:500px;min-height:100%;overflow:hidden;padding-bottom:32px;width:100%}.PostWrapper_module_postWrapper__b535a8a9 a{color:inherit}.PostWrapper_module_postWrapper__b535a8a9 a:hover{color:inherit;text-decoration:none}";
var modules_6850efbf$5 = {"contentWrapper":"PostWrapper_module_contentWrapper__b535a8a9","postWrapper":"PostWrapper_module_postWrapper__b535a8a9"};
n(css$1g,{});

var PostWrapper$6 = function PostWrapper(props) {
  return React__default.createElement("div", {
    className: modules_6850efbf$5.postWrapper,
    "data-preview-variant": props.variant,
    "data-content-type": props.contentType,
    style: props.style
  }, props.children);
};

var css$1h = ".ImageGallery_module_imageGallery__abec66fd{border-top-left-radius:32px;border-top-right-radius:32px;cursor:pointer;display:flex;overflow:hidden;position:relative}.ImageGallery_module_imageGallery__abec66fd img{height:auto;width:100%}.ImageGallery_module_imageGallery__abec66fd:hover .ImageGallery_module_overlayLink__abec66fd{display:flex}.ImageGallery_module_imageGallery__abec66fd .ImageGallery_module_overlayLink__abec66fd{align-items:center;background-color:rgba(0,0,0,.3);border-top-left-radius:32px;border-top-right-radius:32px;display:none;font-size:16px;font-weight:600;height:100%;justify-content:center;left:0;position:absolute;text-decoration:none;top:0;width:100%}[data-preview-variant=mobile] .ImageGallery_module_imageGallery__abec66fd .ImageGallery_module_overlayLink__abec66fd,[data-preview-variant=mobile] .ImageGallery_module_imageGallery__abec66fd img{border-radius:0}";
var modules_ccc28e88$3 = {"imageGallery":"ImageGallery_module_imageGallery__abec66fd","overlayLink":"ImageGallery_module_overlayLink__abec66fd"};
n(css$1h,{});

var ImageGallery$3 = function ImageGallery(_ref) {
  var _image$medium$meta;
  var image = _ref.image;
  var _useLightbox = useLightbox(),
    lightbox = _useLightbox.lightbox,
    handleOpenLightbox = _useLightbox.handleOpenLightbox,
    enableLightbox = _useLightbox.enableLightbox;
  var isGifPost = (_image$medium$meta = image.medium.meta) == null ? void 0 : _image$medium$meta.is_animated_gif;
  return React__default.createElement("div", {
    "data-cy": DATA_CY_NAMES.IMAGE_GALLERY,
    className: modules_ccc28e88$3.imageGallery
  }, React__default.createElement("img", {
    src: isGifPost ? image.medium.sizes.original.src : image.medium.sizes.lightbox.src,
    onClick: function onClick() {
      return handleOpenLightbox();
    }
  }), image.url && React__default.createElement(ExternalLink, {
    href: image.url,
    className: modules_ccc28e88$3.overlayLink
  }, React__default.createElement(Icon, {
    icon: faArrowUpRight,
    size: 28
  }), getHostnameFromUrl(image.url)), enableLightbox && React__default.createElement(AttachmentsLightBox$1, {
    onInit: function onInit(_ref2) {
      var instance = _ref2.instance;
      return lightbox.current = instance;
    },
    attachments: [image]
  }));
};

var css$1i = ".Header_module_header__346b9280{align-items:center;display:flex;justify-content:space-between;margin:12px 0 0 -10px}.Header_module_header__346b9280 .Header_module_btn__346b9280{align-items:center;border-radius:50%;cursor:pointer;display:flex;flex-shrink:0;height:48px;justify-content:center;transition:background-color 199ms cubic-bezier(0,0,.21,1.11);width:48px}.Header_module_header__346b9280 .Header_module_btn__346b9280:hover{background-color:#e2e2e2}.Header_module_header__346b9280 .Header_module_btnContainer__346b9280{align-items:center;display:flex}.Header_module_header__346b9280 .Header_module_boardName__346b9280{align-items:center;display:flex;margin-left:auto;min-width:0}.Header_module_header__346b9280 .Header_module_boardName__346b9280 .Header_module_name__346b9280{font-size:16px;font-weight:700;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.Header_module_header__346b9280 .Header_module_boardName__346b9280 svg{flex-shrink:0;margin-left:2px}.Header_module_header__346b9280 .Header_module_saveBtn__346b9280{align-items:center;background-color:#e60023;border-radius:24px;color:#fff;cursor:pointer;display:flex;font-size:14px;font-weight:600;justify-content:center;margin-left:16px;padding:14px 16px}.Header_module_header__346b9280 .Header_module_saveBtn__346b9280:hover{background-color:#ad081b}";
var modules_773fac34$7 = {"header":"Header_module_header__346b9280","btn":"Header_module_btn__346b9280","btnContainer":"Header_module_btnContainer__346b9280","boardName":"Header_module_boardName__346b9280","name":"Header_module_name__346b9280","saveBtn":"Header_module_saveBtn__346b9280"};
n(css$1i,{});

var MoreIcon$1 = function MoreIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size;
  return React__default.createElement("svg", {
    height: size,
    width: size,
    fill: "currentColor"
  }, React__default.createElement("path", {
    d: "M12 9.5A2.497 2.497 0 0 0 9.5 12c0 1.383 1.117 2.5 2.5 2.5s2.5-1.117 2.5-2.5-1.117-2.5-2.5-2.5Zm-7.5 0C5.883 9.5 7 10.617 7 12s-1.117 2.5-2.5 2.5A2.497 2.497 0 0 1 2 12c0-1.383 1.117-2.5 2.5-2.5Zm15 0c1.383 0 2.5 1.117 2.5 2.5s-1.117 2.5-2.5 2.5A2.497 2.497 0 0 1 17 12c0-1.383 1.117-2.5 2.5-2.5Z"
  }));
};

var ShareIcon$3 = function ShareIcon(props) {
  return React__default.createElement("svg", {
    height: "20",
    width: "20",
    viewBox: "0 0 24 24"
  }, React__default.createElement("path", {
    d: "M21 14c1.1 0 2 .9 2 2v6c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2v-6c0-1.1.9-2 2-2s2 .9 2 2v4h14v-4c0-1.1.9-2 2-2zM8.82 8.84c-.78.78-2.05.79-2.83 0-.78-.78-.79-2.04-.01-2.82L11.99 0l6.02 6.01c.78.78.79 2.05.01 2.83-.78.78-2.05.79-2.83 0l-1.2-1.19v6.18a2 2 0 1 1-4 0V7.66L8.82 8.84z"
  }));
};

var LinkIcon = function LinkIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size;
  return React__default.createElement("svg", {
    height: size,
    width: size,
    fill: "currentColor"
  }, React__default.createElement("path", {
    d: "m19.5 8.033-3.375 3.375-.884-.883.559-.559A1.25 1.25 0 1 0 14.033 8.2l-.558.558-.884-.883L15.966 4.5 19.5 8.033Zm-8.084 8.083L8.025 19.5 4.5 15.966l3.375-3.375.883.884-.558.558A1.25 1.25 0 0 0 9.966 15.8l.559-.559.891.875Zm2.775-13.375-3.375 3.375a2.5 2.5 0 0 0 0 3.534l.884.883-1.184 1.183-.883-.883a2.5 2.5 0 0 0-3.533 0L2.733 14.2a2.5 2.5 0 0 0 0 3.533l3.533 3.533a2.5 2.5 0 0 0 3.534 0l3.375-3.375a2.5 2.5 0 0 0 0-3.533l-.884-.883 1.184-1.184.883.884a2.5 2.5 0 0 0 3.533 0L21.266 9.8a2.5 2.5 0 0 0 0-3.534l-3.533-3.533a2.5 2.5 0 0 0-3.533 0l-.009.008Z"
  }));
};

var Header$8 = function Header(_ref) {
  return React__default.createElement("div", {
    className: modules_773fac34$7.header
  }, React__default.createElement("div", {
    className: modules_773fac34$7.btnContainer
  }, React__default.createElement("div", {
    className: modules_773fac34$7.btn
  }, React__default.createElement(MoreIcon$1, null)), React__default.createElement("div", {
    className: modules_773fac34$7.btn
  }, React__default.createElement(ShareIcon$3, null)), React__default.createElement("div", {
    className: modules_773fac34$7.btn
  }, React__default.createElement(LinkIcon, null))), React__default.createElement("div", {
    className: modules_773fac34$7.saveBtn
  }, "Save"));
};

var css$1j = ".TextContent_module_textContent__a3b151c1{font-size:14px;font-weight:400;line-height:20px}.TextContent_module_moreBtn__a3b151c1{cursor:pointer;font-size:14px;font-weight:600;margin-left:4px}";
var modules_82161d99$5 = {"textContent":"TextContent_module_textContent__a3b151c1","moreBtn":"TextContent_module_moreBtn__a3b151c1"};
n(css$1j,{});

var TRUNCATED_TEXT_LENGTH_WEB = 195;
var TRUNCATED_TEXT_LENGTH_MOBILE = 80;
var TextContent$6 = function TextContent(_ref) {
  var text = _ref.content.text,
    variant = _ref.variant;
  var _useState = useState(false),
    showWholeText = _useState[0],
    setShowWholeText = _useState[1];
  if (!text) {
    return null;
  }
  function getCharacterLimit() {
    if (variant === 'mobile' && text && text.length > TRUNCATED_TEXT_LENGTH_MOBILE) {
      return TRUNCATED_TEXT_LENGTH_MOBILE;
    }
    if (text && text.length > TRUNCATED_TEXT_LENGTH_WEB) {
      return TRUNCATED_TEXT_LENGTH_WEB;
    }
    return undefined;
  }
  var characterLimit = getCharacterLimit();
  var canSeeShowWholeText = (text == null ? void 0 : text.length) && text.length > truncateHtmlString(text, {
    maxLength: characterLimit,
    ellipsis: false
  }).length && !showWholeText;
  return React__default.createElement(PostTextContentWrapper, {
    className: classNames(modules_82161d99$5.textContent)
  }, React__default.createElement(HyperText, {
    pageType: TYPE_PINTEREST,
    options: {
      maxLength: showWholeText ? undefined : characterLimit
    }
  }, text), canSeeShowWholeText && React__default.createElement("span", {
    className: modules_82161d99$5.moreBtn,
    onClick: function onClick() {
      return setShowWholeText(true);
    }
  }, "more"), !canSeeShowWholeText && React__default.createElement("span", {
    className: modules_82161d99$5.moreBtn,
    onClick: function onClick() {
      return setShowWholeText(false);
    }
  }, "\u2026 less"));
};

var css$1k = ".LinkInfo_module_linkInfo__73a24c08{margin:8px 0 0}.LinkInfo_module_linkInfo__73a24c08 .LinkInfo_module_title__73a24c08{font-size:24px;font-weight:600;line-height:34px;margin-top:8px;word-break:break-word}.LinkInfo_module_linkInfo__73a24c08 .LinkInfo_module_url__73a24c08{color:#111;display:block;font-size:14px;font-weight:500;line-height:20px;max-width:265px;min-width:0;overflow:hidden;text-decoration:underline;text-overflow:ellipsis;white-space:nowrap}";
var modules_96605eeb$3 = {"linkInfo":"LinkInfo_module_linkInfo__73a24c08","title":"LinkInfo_module_title__73a24c08","url":"LinkInfo_module_url__73a24c08"};
n(css$1k,{});

var LinkInfo$5 = function LinkInfo(_ref) {
  var link = _ref.link;
  return React__default.createElement("div", {
    className: modules_96605eeb$3.linkInfo
  }, link.url && React__default.createElement(ExternalLink, {
    className: modules_96605eeb$3.url,
    href: link.url
  }, getHostnameFromUrl(link.url)), link.title && React__default.createElement("div", {
    className: modules_96605eeb$3.title
  }, link.title));
};

var css$1l = ".Page_module_page__e5a3a692{align-items:center;display:flex;margin-top:16px;width:100%}.Page_module_page__e5a3a692 .Page_module_textWrapper__e5a3a692{display:flex;flex-direction:column;margin-left:8px;margin-right:8px;max-width:50%;min-width:50px}.Page_module_page__e5a3a692 .Page_module_followersStat__e5a3a692{font-size:12px;line-height:16px;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.Page_module_page__e5a3a692 .Page_module_name__e5a3a692{font-size:14px;font-weight:600;line-height:20px;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.Page_module_page__e5a3a692 .Page_module_followBtn__e5a3a692{align-items:center;background-color:#efefef;border-radius:24px;cursor:pointer;display:flex;font-size:14px;font-weight:600;justify-content:center;line-height:20px;margin-left:auto;padding:14px 16px}.Page_module_page__e5a3a692 .Page_module_followBtn__e5a3a692:hover{background-color:#e2e2e2}[data-preview-variant=mobile] .Page_module_page__e5a3a692{margin-top:12px}";
var modules_3ca4fc74 = {"page":"Page_module_page__e5a3a692","textWrapper":"Page_module_textWrapper__e5a3a692","followersStat":"Page_module_followersStat__e5a3a692","name":"Page_module_name__e5a3a692","followBtn":"Page_module_followBtn__e5a3a692"};
n(css$1l,{});

var Footer$a = function Footer(_ref) {
  var _page$logo_src;
  var page = _ref.content.page,
    variant = _ref.variant;
  return React__default.createElement("div", {
    className: modules_3ca4fc74.page
  }, React__default.createElement(Avatar, {
    size: variant === 'mobile' ? 32 : 48,
    src: (_page$logo_src = page == null ? void 0 : page.logo_src) != null ? _page$logo_src : undefined,
    name: page.name,
    style: {
      borderRadius: 9999
    },
    color: "blue"
  }), React__default.createElement("div", {
    className: modules_3ca4fc74.textWrapper
  }, React__default.createElement("div", {
    className: modules_3ca4fc74.name
  }, page.name), React__default.createElement("span", {
    className: modules_3ca4fc74.followersStat
  }, "3,2K followers")), React__default.createElement("div", {
    className: modules_3ca4fc74.followBtn
  }, "Follow"));
};

var Post$6 = function Post(_ref) {
  var content = _ref.content,
    style = _ref.style;
  var attachments = getSegmentedAttachments(content);
  var linkImage = attachments.images[0];
  return React__default.createElement(PostWrapper$6, {
    style: style,
    variant: "desktop",
    contentType: content.type
  }, linkImage && React__default.createElement(ImageGallery$3, {
    image: linkImage
  }), React__default.createElement("div", {
    className: modules_6850efbf$5.contentWrapper
  }, React__default.createElement(Header$8, {
    content: content
  }), linkImage && React__default.createElement(LinkInfo$5, {
    link: linkImage
  }), React__default.createElement(TextContent$6, {
    content: content
  }), React__default.createElement(Footer$a, {
    content: content
  })));
};

var css$1m = ".ActionButtons_module_footerWrapper__ab5da099 .ActionButtons_module_actionButtons__ab5da099{align-items:center;display:flex;justify-content:space-between;margin-top:24px}.ActionButtons_module_footerWrapper__ab5da099 .ActionButtons_module_actionButtons__ab5da099 .ActionButtons_module_ctas__ab5da099{display:flex}.ActionButtons_module_footerWrapper__ab5da099 .ActionButtons_module_actionButtons__ab5da099 .ActionButtons_module_ctas__ab5da099 .ActionButtons_module_btn__ab5da099{align-items:center;background-color:#efefef;border-radius:24px;cursor:pointer;display:flex;font-size:14px;font-weight:600;justify-content:center;padding:12px 16px}.ActionButtons_module_footerWrapper__ab5da099 .ActionButtons_module_actionButtons__ab5da099 .ActionButtons_module_ctas__ab5da099 .ActionButtons_module_btn__ab5da099:hover{background-color:#e2e2e2}.ActionButtons_module_footerWrapper__ab5da099 .ActionButtons_module_actionButtons__ab5da099 .ActionButtons_module_ctas__ab5da099 .ActionButtons_module_btn__ab5da099+.ActionButtons_module_btn__ab5da099{margin-left:8px}.ActionButtons_module_footerWrapper__ab5da099 .ActionButtons_module_actionButtons__ab5da099 .ActionButtons_module_ctas__ab5da099 .ActionButtons_module_saveBtn__ab5da099{background-color:#e60023;color:#fff}.ActionButtons_module_footerWrapper__ab5da099 .ActionButtons_module_actionButtons__ab5da099 .ActionButtons_module_ctas__ab5da099 .ActionButtons_module_saveBtn__ab5da099:hover{background-color:#ad081b}.ActionButtons_module_footerWrapper__ab5da099 .ActionButtons_module_actionButtons__ab5da099 svg{fill:#111}.ActionButtons_module_footerWrapper__ab5da099 [data-preview-variant=mobile] .ActionButtons_module_header__ab5da099{margin-top:12px}.ActionButtons_module_footerWrapper__ab5da099 .ActionButtons_module_commentInput__ab5da099{border:1px solid #bdc3cd;border-radius:99px;color:#8792a4;font-size:14px;font-weight:500;height:36px;line-height:20px;margin-top:24px;padding:8px 16px;width:100%}";
var modules_3d9c89a6$1 = {"footerWrapper":"ActionButtons_module_footerWrapper__ab5da099","actionButtons":"ActionButtons_module_actionButtons__ab5da099","ctas":"ActionButtons_module_ctas__ab5da099","btn":"ActionButtons_module_btn__ab5da099","saveBtn":"ActionButtons_module_saveBtn__ab5da099","header":"ActionButtons_module_header__ab5da099","commentInput":"ActionButtons_module_commentInput__ab5da099"};
n(css$1m,{});

var CommentIcon$2 = function CommentIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size;
  return React__default.createElement("svg", {
    height: size,
    width: size,
    fill: "currentColor"
  }, React__default.createElement("path", {
    fillRule: "evenodd",
    d: "M22 12c0 5.523-4.477 10-10 10a9.95 9.95 0 0 1-4.582-1.11l-4.262 2.132a.16.16 0 0 1-.222-.197l1.521-4.26A9.96 9.96 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10Zm-10 4.4 4.013-3.77a2.42 2.42 0 0 0 0-3.573c-.933-.876-2.446-.876-3.38 0l-.632.595-.634-.595c-.933-.876-2.446-.876-3.38 0a2.42 2.42 0 0 0 0 3.573l4.014 3.77Z",
    clipRule: "evenodd"
  }));
};

var ActionButtons$1 = function ActionButtons(props) {
  return React__default.createElement("div", {
    className: modules_3d9c89a6$1.footerWrapper
  }, React__default.createElement("div", {
    className: modules_3d9c89a6$1.actionButtons
  }, React__default.createElement(CommentIcon$2, null), React__default.createElement("div", {
    className: modules_3d9c89a6$1.ctas
  }, React__default.createElement("div", {
    className: modules_3d9c89a6$1.btn
  }, "Read it"), React__default.createElement("div", {
    className: classNames(modules_3d9c89a6$1.btn, modules_3d9c89a6$1.saveBtn)
  }, "Save")), React__default.createElement(ShareIcon$3, null)), React__default.createElement("input", {
    type: "text",
    placeholder: "Add a comment",
    disabled: true,
    className: modules_3d9c89a6$1.commentInput
  }));
};

var css$1n = ".MobilePost_module_statusBar__906709be{background-color:#111;color:#fff}.MobilePost_module_spacer__906709be{display:flex;flex-direction:column;padding:0 16px}";
var modules_813dec30$4 = {"statusBar":"MobilePost_module_statusBar__906709be","spacer":"MobilePost_module_spacer__906709be"};
n(css$1n,{});

var css$1o = ".AppLayout_module_appLayout__61c34e35{display:flex;flex-direction:column;height:100%;overflow:hidden}.AppLayout_module_appLayout__61c34e35 .AppLayout_module_body__61c34e35{flex:1 auto;overflow:auto}";
var modules_11a4dd02$5 = {"appLayout":"AppLayout_module_appLayout__61c34e35","body":"AppLayout_module_body__61c34e35"};
n(css$1o,{});

var AppLayout$6 = function AppLayout(props) {
  return React__default.createElement("div", {
    className: modules_11a4dd02$5.appLayout
  }, React__default.createElement("div", {
    className: modules_11a4dd02$5.body
  }, props.children));
};

var MobilePost$6 = function MobilePost(_ref) {
  var content = _ref.content,
    style = _ref.style;
  var attachments = getSegmentedAttachments(content);
  var linkImage = attachments.images[0];
  return React__default.createElement(Phone, {
    statusBarClassName: modules_813dec30$4.statusBar,
    contentBackground: "pinterest",
    style: style
  }, React__default.createElement(AppLayout$6, null, React__default.createElement(PostWrapper$6, {
    variant: "mobile",
    contentType: content.type
  }, linkImage && React__default.createElement(ImageGallery$3, {
    image: linkImage
  }), React__default.createElement("div", {
    className: modules_813dec30$4.spacer
  }, React__default.createElement(Footer$a, {
    content: content,
    variant: "mobile"
  }), linkImage && React__default.createElement(LinkInfo$5, {
    link: linkImage
  }), React__default.createElement(TextContent$6, {
    content: content,
    variant: "mobile"
  }), React__default.createElement(ActionButtons$1, null)))));
};

var css$1p = ".RightColumn_module_wrapper__c40e740f{align-items:center;background-color:#f0f2f5;display:flex;height:147px;overflow:hidden!important;padding:12px;position:relative!important;width:335px}.RightColumn_module_wrapper__c40e740f .RightColumn_module_thumbnail__c40e740f{background-color:#7a869a;background-position:50%;background-size:cover;border-radius:8px;height:125px;max-width:125px;min-width:125px;overflow:hidden!important;width:100%}.RightColumn_module_wrapper__c40e740f .RightColumn_module_meta__c40e740f{margin-left:12px}.RightColumn_module_wrapper__c40e740f .RightColumn_module_meta__c40e740f span{color:#000;display:block;font-size:12px;font-weight:600}.RightColumn_module_wrapper__c40e740f .RightColumn_module_meta__c40e740f .RightColumn_module_caption__c40e740f,.RightColumn_module_wrapper__c40e740f .RightColumn_module_meta__c40e740f .RightColumn_module_description__c40e740f{-webkit-line-clamp:2;-webkit-box-orient:vertical;display:-webkit-box;max-width:175px;overflow:hidden}.RightColumn_module_wrapper__c40e740f .RightColumn_module_meta__c40e740f .RightColumn_module_url__c40e740f{color:#7a869a;font-size:11px;margin-top:4px;max-width:175px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.RightColumn_module_wrapper__c40e740f .RightColumn_module_link__c40e740f{bottom:0;left:0;position:absolute;right:0;top:0}";
var modules_88d15890 = {"wrapper":"RightColumn_module_wrapper__c40e740f","thumbnail":"RightColumn_module_thumbnail__c40e740f","meta":"RightColumn_module_meta__c40e740f","caption":"RightColumn_module_caption__c40e740f","description":"RightColumn_module_description__c40e740f","url":"RightColumn_module_url__c40e740f","link":"RightColumn_module_link__c40e740f"};
n(css$1p,{});

var RightColumn = function RightColumn(_ref) {
  var _info$title, _info$description, _info$url;
  var content = _ref.content,
    style = _ref.style,
    className = _ref.className;
  var attachments = getSegmentedAttachments(content);
  var info = attachments.all[0];
  var getThumb = function getThumb() {
    var _info$medium, _info$medium$original, _info$medium3, _info$medium3$sizes, _info$medium3$sizes$t;
    // @ts-ignore
    if (!!(info != null && (_info$medium = info.medium) != null && (_info$medium$original = _info$medium.original_thumb) != null && _info$medium$original.src)) {
      var _info$medium$original2, _info$medium2, _info$medium2$origina;
      // @ts-ignore
      return (_info$medium$original2 = info == null ? void 0 : (_info$medium2 = info.medium) == null ? void 0 : (_info$medium2$origina = _info$medium2.original_thumb) == null ? void 0 : _info$medium2$origina.src) != null ? _info$medium$original2 : null;
    }
    // @ts-ignore
    if (!!(info != null && (_info$medium3 = info.medium) != null && (_info$medium3$sizes = _info$medium3.sizes) != null && (_info$medium3$sizes$t = _info$medium3$sizes.thumb) != null && _info$medium3$sizes$t.src)) {
      var _info$medium$sizes$th, _info$medium4, _info$medium4$sizes, _info$medium4$sizes$t;
      // @ts-ignore
      return (_info$medium$sizes$th = info == null ? void 0 : (_info$medium4 = info.medium) == null ? void 0 : (_info$medium4$sizes = _info$medium4.sizes) == null ? void 0 : (_info$medium4$sizes$t = _info$medium4$sizes.thumb) == null ? void 0 : _info$medium4$sizes$t.src) != null ? _info$medium$sizes$th : null;
    }
    return null;
  };
  var thumb = getThumb();
  return React__default.createElement("div", {
    style: style,
    className: classNames(modules_88d15890.wrapper, className)
  }, React__default.createElement("div", {
    className: modules_88d15890.thumbnail,
    style: thumb ? {
      backgroundImage: "url('" + thumb + "')"
    } : undefined
  }), React__default.createElement("div", {
    className: modules_88d15890.meta
  }, React__default.createElement("span", {
    className: modules_88d15890.caption
  }, (info == null ? void 0 : (_info$title = info.title) == null ? void 0 : _info$title.length) > 0 ? info.title : 'Title placeholder'), React__default.createElement("span", {
    className: modules_88d15890.description
  }, (info == null ? void 0 : (_info$description = info.description) == null ? void 0 : _info$description.length) > 0 ? info.description : 'Description placeholder'), React__default.createElement("span", {
    className: modules_88d15890.url
  }, (info == null ? void 0 : (_info$url = info.url) == null ? void 0 : _info$url.length) > 0 ? info.url : 'example.com')), (info == null ? void 0 : info.url) && React__default.createElement(ExternalLink, {
    className: modules_88d15890.link,
    href: info.url
  }));
};

var css$1q = ".PostWrapper_module_postWrapper__35b9268a{background:#000;border:0;border-radius:3px;box-sizing:border-box;display:flex;flex:1;flex-direction:column;font-family:-apple-system,system-ui,Segoe UI,Roboto,Helvetica,Arial,sans-serif;font-size:14px;height:100%;line-height:18px;margin:0;max-width:500px;position:relative;width:100%}.PostWrapper_module_postWrapper__35b9268a[data-preview-variant=mobile]{border-radius:0;margin:0;max-width:100%}.PostWrapper_module_postWrapper__35b9268a a{color:inherit}.PostWrapper_module_postWrapper__35b9268a a:hover{color:inherit;text-decoration:none}";
var modules_6850efbf$6 = {"postWrapper":"PostWrapper_module_postWrapper__35b9268a"};
n(css$1q,{});

var PostWrapper$7 = function PostWrapper(props) {
  return React__default.createElement("div", {
    className: classNames(modules_6850efbf$6.postWrapper, props.className),
    "data-preview-variant": props.variant,
    "data-content-type": props.contentType,
    "data-content-subtype": props.contentSubtype,
    style: props.style
  }, props.children);
};
PostWrapper$7.defaultProps = {
  variant: 'desktop'
};

var css$1r = ".ShortPost_module_content__52f465df{height:0;padding-bottom:177%;position:relative;width:100%}.ShortPost_module_content__52f465df [data-preview-variant=mobile] .ShortPost_module_overlay__52f465df{background:linear-gradient(180deg,transparent 0,rgba(0,0,0,.25))}.ShortPost_module_shortWrapper__52f465df{align-items:center;display:flex;height:100%;position:relative;width:100%}.ShortPost_module_videoWrapper__52f465df{width:100%}.ShortPost_module_aspectRatio__52f465df{height:100%;left:0;position:absolute;top:0;width:100%}.ShortPost_module_overlay__52f465df{background:linear-gradient(180deg,transparent 0,#000);bottom:0;height:30%;left:0;position:absolute;right:0;width:100%}";
var modules_cadef3fc = {"content":"ShortPost_module_content__52f465df","overlay":"ShortPost_module_overlay__52f465df","shortWrapper":"ShortPost_module_shortWrapper__52f465df","videoWrapper":"ShortPost_module_videoWrapper__52f465df","aspectRatio":"ShortPost_module_aspectRatio__52f465df"};
n(css$1r,{});

var css$1s = "[data-preview-variant=desktop] .ShortDescription_module_shortDescriptionContainer__11edbffa{display:flex;flex-direction:column-reverse;gap:8px}[data-preview-variant=desktop] .ShortDescription_module_nameContainer__11edbffa{flex:1 1 auto;justify-content:space-between}[data-preview-variant=desktop] .ShortDescription_module_actionContainer__11edbffa{display:none}.ShortDescription_module_actionButton__11edbffa{align-items:center;display:flex;flex-direction:column}.ShortDescription_module_actionButton__11edbffa span{font-size:12px;line-height:16px;margin-top:4px}.ShortDescription_module_actionContainer__11edbffa{display:flex}";
var modules_3fb2f8d6 = {"shortDescriptionContainer":"ShortDescription_module_shortDescriptionContainer__11edbffa","nameContainer":"ShortDescription_module_nameContainer__11edbffa","actionContainer":"ShortDescription_module_actionContainer__11edbffa","actionButton":"ShortDescription_module_actionButton__11edbffa"};
n(css$1s,{});

var _excluded$9 = ["page", "text", "variant"];
var iconSize$3 = 32;
var COLLAPSED_TEXT_LENGTH_OPTIONS$2 = {
  mobile: 80,
  desktop: 150
};
var ShortDescription = function ShortDescription(_ref) {
  var _page$logo_src;
  var page = _ref.page,
    text = _ref.text,
    variant = _ref.variant,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$9);
  return React__default.createElement("div", Object.assign({}, props, {
    className: mergeTailwindClasses('tw-p-3 tw-w-full tw-text-white tw-flex tw-justify-between tw-overflow-visible tw-pointer-events-none tw-cursor-pointer', props.className)
  }), React__default.createElement("div", {
    className: clsx('tw-overflow-hidden tw-mt-auto tw-pointer-events-auto', modules_3fb2f8d6.shortDescriptionContainer)
  }, React__default.createElement("div", {
    className: "tw-flex tw-items-center"
  }, React__default.createElement("div", {
    className: "tw-pr-3"
  }, React__default.createElement(Avatar, {
    size: iconSize$3,
    name: page.name,
    src: (_page$logo_src = page.logo_src) != null ? _page$logo_src : undefined
  })), React__default.createElement(ExternalLink, {
    href: "https://www.youtube.com/@" + page.name,
    style: {
      fontWeight: 'bold',
      textDecoration: 'none',
      width: '100%'
    }
  }, React__default.createElement("div", {
    className: clsx('tw-flex tw-items-center', modules_3fb2f8d6.nameContainer)
  }, React__default.createElement("div", {
    className: "tw-break-words tw-text-md"
  }, page.username || page.name)))), text && React__default.createElement("div", {
    className: "tw-pt-2 tw-text-md tw-pr-4"
  }, React__default.createElement(HyperText, {
    pageType: TYPE_YOUTUBE,
    options: {
      maxLength: COLLAPSED_TEXT_LENGTH_OPTIONS$2[variant],
      expandable: true,
      expandableTrigger: {
        more: ' show more',
        less: ' ...show less'
      }
    }
  }, text))), React__default.createElement("div", {
    className: clsx('tw-flex tw-gap-4 tw-flex-col tw-justify-end tw-items-center', modules_3fb2f8d6.actionContainer)
  }, React__default.createElement("div", {
    className: modules_3fb2f8d6.actionButton
  }, React__default.createElement(Icon, {
    icon: faThumbsUp
  })), React__default.createElement("div", {
    className: modules_3fb2f8d6.actionButton
  }, React__default.createElement(Icon, {
    icon: faThumbsDown
  })), React__default.createElement("div", {
    className: modules_3fb2f8d6.actionButton
  }, React__default.createElement(Icon, {
    icon: faComment
  })), React__default.createElement("div", {
    className: modules_3fb2f8d6.actionButton
  }, React__default.createElement(Icon, {
    icon: faShare
  }))));
};

var Short = function Short(_ref) {
  var video = _ref.video,
    page = _ref.page,
    text = _ref.text,
    variant = _ref.variant;
  return React__default.createElement("div", {
    className: modules_cadef3fc.shortWrapper
  }, React__default.createElement("div", {
    className: modules_cadef3fc.videoWrapper
  }, video && React__default.createElement(VideoPlayer, {
    video: video.medium,
    controls: false
  })), React__default.createElement("div", {
    className: modules_cadef3fc.overlay
  }), React__default.createElement(ShortDescription, {
    page: page,
    text: text,
    variant: variant,
    className: "tw-absolute tw-bottom-0 tw-left-0"
  }));
};

var ShortPost = function ShortPost(_ref) {
  var content = _ref.content,
    style = _ref.style;
  var _getSegmentedAttachme = getSegmentedAttachments(content),
    videos = _getSegmentedAttachme.videos;
  return React__default.createElement(PostWrapper$7, {
    style: style,
    variant: "desktop",
    contentType: content.type,
    contentSubtype: content.subtype
  }, React__default.createElement("div", {
    className: modules_cadef3fc.content
  }, React__default.createElement("div", {
    className: modules_cadef3fc.aspectRatio
  }, React__default.createElement(Short, {
    variant: "desktop",
    video: videos[0],
    page: content.page,
    text: content.text
  }))));
};

var img$7 = "data:image/png;base64,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";

var AppLayout$7 = function AppLayout(props) {
  return React__default.createElement("div", {
    className: "tw-flex tw-flex-col tw-overflow-hidden tw-h-full"
  }, React__default.createElement("div", {
    className: "tw-flex-1 tw-overflow-auto tw-scrollbar-hide"
  }, props.children), React__default.createElement("img", {
    src: img$7,
    className: "tw-w-full tw-h-auto"
  }));
};

var MobileShortPost = function MobileShortPost(_ref) {
  var content = _ref.content,
    style = _ref.style;
  var _getSegmentedAttachme = getSegmentedAttachments(content),
    videos = _getSegmentedAttachme.videos;
  return React__default.createElement(Phone, {
    statusBarClassName: "tw-bg-transparent tw-text-white tw-absolute tw-z-10 tw-w-full",
    contentBackground: "youtube",
    style: style
  }, React__default.createElement(AppLayout$7, null, React__default.createElement(PostWrapper$7, {
    variant: "mobile",
    contentType: content.type,
    contentSubtype: content.subtype
  }, React__default.createElement(Short, {
    variant: "mobile",
    video: videos[0],
    page: content.page,
    text: content.text
  }))));
};

var css$1t = ".PostWrapper_module_postWrapper__35b9268a{background:#000;border:0;border-radius:3px;box-sizing:border-box;display:flex;flex:1;flex-direction:column;font-family:-apple-system,system-ui,Segoe UI,Roboto,Helvetica,Arial,sans-serif;font-size:14px;height:100%;line-height:18px;margin:0;max-width:500px;position:relative;width:100%}.PostWrapper_module_postWrapper__35b9268a[data-preview-variant=mobile]{border-radius:0;margin:0;max-width:100%}.PostWrapper_module_postWrapper__35b9268a a{color:inherit}.PostWrapper_module_postWrapper__35b9268a a:hover{color:inherit;text-decoration:none}";
var modules_6850efbf$7 = {"postWrapper":"PostWrapper_module_postWrapper__35b9268a"};
n(css$1t,{});

var PostWrapper$8 = function PostWrapper(props) {
  return React__default.createElement("div", {
    className: classNames(modules_6850efbf$7.postWrapper, props.className),
    "data-preview-variant": props.variant,
    "data-content-type": props.contentType,
    "data-content-subtype": props.contentSubtype,
    style: props.style
  }, props.children);
};
PostWrapper$8.defaultProps = {
  variant: 'desktop'
};

var css$1u = ".Post_module_content__7ad5e1c3{height:100%;padding-bottom:177%;position:relative;width:100%}.Post_module_content__7ad5e1c3 [data-preview-variant=mobile] .Post_module_overlay__7ad5e1c3{background:linear-gradient(180deg,transparent 0,rgba(0,0,0,.25))}.Post_module_shortWrapper__7ad5e1c3{align-items:center;display:flex;height:100%;position:relative;width:100%}.Post_module_videoWrapper__7ad5e1c3{width:100%}.Post_module_aspectRatio__7ad5e1c3{height:100%;left:0;position:absolute;top:0;width:100%}.Post_module_overlay__7ad5e1c3{background:linear-gradient(180deg,transparent 0,#000);bottom:0;height:30%;left:0;position:absolute;right:0;width:100%}";
var modules_4e180e43$2 = {"content":"Post_module_content__7ad5e1c3","overlay":"Post_module_overlay__7ad5e1c3","shortWrapper":"Post_module_shortWrapper__7ad5e1c3","videoWrapper":"Post_module_videoWrapper__7ad5e1c3","aspectRatio":"Post_module_aspectRatio__7ad5e1c3"};
n(css$1u,{});

var css$1v = "[data-preview-variant=desktop] .PostDescription_module_postDescriptionContainer__20b13446{display:flex;flex-direction:column;gap:8px}[data-preview-variant=desktop] .PostDescription_module_nameContainer__20b13446{flex:1 1 auto;justify-content:space-between}[data-preview-variant=desktop] .PostDescription_module_actionContainer__20b13446{display:none}.PostDescription_module_hyperText__20b13446.PostDescription_module_hyperText__20b13446 a{@apply tw-text-primary-100}.PostDescription_module_profileButton__20b13446{align-items:center;display:flex;flex-direction:column}.PostDescription_module_profileButton__20b13446 svg{position:relative;top:-8px}.PostDescription_module_actionButton__20b13446{align-items:center;display:flex;flex-direction:column}.PostDescription_module_actionButton__20b13446 span{font-size:12px;line-height:16px;margin-top:4px}.PostDescription_module_actionContainer__20b13446{display:flex}";
var modules_21510a30 = {"postDescriptionContainer":"PostDescription_module_postDescriptionContainer__20b13446","nameContainer":"PostDescription_module_nameContainer__20b13446","actionContainer":"PostDescription_module_actionContainer__20b13446","hyperText":"PostDescription_module_hyperText__20b13446","profileButton":"PostDescription_module_profileButton__20b13446","actionButton":"PostDescription_module_actionButton__20b13446"};
n(css$1v,{});

var LikeIcon$2 = function LikeIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return React__default.createElement("svg", {
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, React__default.createElement("path", {
    fill: "#fff",
    d: "M15.49 29.635c.83.592 1.943.592 2.773 0 4.149-2.962 8.122-6.37 10.87-10.73 1.377-2.184 1.954-3.95 2.18-5.395.093-.508.14-1.033.14-1.57 0-4.659-3.616-8.436-8.076-8.436-2.666 0-5.03 1.349-6.5 3.429-1.472-2.08-3.836-3.43-6.502-3.43-4.46 0-8.076 3.778-8.076 8.437 0 .537.048 1.062.14 1.57.226 1.445.804 3.211 2.18 5.396 2.749 4.36 6.721 7.767 10.87 10.729Z"
  }));
};

var CommentIcon$3 = function CommentIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return React__default.createElement("svg", {
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, React__default.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m17.168 26.918-.267.002c-7.937 0-14.372-5.332-14.372-11.908 0-6.577 6.435-11.908 14.372-11.908 7.938 0 14.372 5.331 14.372 11.908a10.15 10.15 0 0 1-1.155 4.684c-.997 2.033-2.536 3.848-4.206 5.413-2.544 2.384-5.488 4.184-7.584 5.199-.554.268-1.16-.152-1.16-.737v-2.653Zm-5.194-11.29a2.053 2.053 0 1 1-4.106 0 2.053 2.053 0 0 1 4.106 0ZM16.9 17.68a2.053 2.053 0 1 0 0-4.106 2.053 2.053 0 0 0 0 4.106Zm9.034-2.053a2.053 2.053 0 1 1-4.106 0 2.053 2.053 0 0 1 4.106 0Z",
    clipRule: "evenodd"
  }));
};

var ShareIcon$4 = function ShareIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: "none"
  }, React__default.createElement("path", {
    fill: "#fff",
    d: "M30.595 17.732a.821.821 0 0 0 .02-1.2L19.706 5.986a.821.821 0 0 0-1.392.59v4.403c-4.078-.063-7.142 1.004-9.42 2.638-2.312 1.66-3.786 3.887-4.694 6.044-.907 2.156-1.256 4.26-1.312 5.701-.027.711.015 1.298.117 1.657.026.091.061.188.112.273a.567.567 0 0 0 .31.26.501.501 0 0 0 .482-.106.84.84 0 0 0 .195-.265l.005-.01.005-.01v-.002l.001-.002.009-.018a4.925 4.925 0 0 1 .22-.402 7.76 7.76 0 0 1 .829-1.11c.784-.881 2.067-1.97 4.054-2.765 1.132-.453 3.017-.659 4.866-.692 1.764-.032 3.41.095 4.22.273v4.531a.821.821 0 0 0 1.373.61l10.91-9.852Z"
  }));
};

var SubscribeIcon = function SubscribeIcon() {
  return React__default.createElement("svg", {
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, React__default.createElement("rect", {
    width: "18",
    height: "18",
    x: ".879",
    y: ".754",
    fill: "#E13338",
    rx: "9"
  }), React__default.createElement("path", {
    fill: "#fff",
    d: "M10.679 6.554a.8.8 0 0 0-1.6 0v2.4h-2.4a.8.8 0 1 0 0 1.6h2.4v2.4a.8.8 0 0 0 1.6 0v-2.4h2.4a.8.8 0 0 0 0-1.6h-2.4v-2.4Z"
  }));
};

var SoundIcon = function SoundIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 40 : _ref$size;
  return React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: "none"
  }, React__default.createElement("circle", {
    cx: "20.879",
    cy: "20.875",
    r: "20.121",
    fill: "url(#a)"
  }), React__default.createElement("circle", {
    cx: "20.879",
    cy: "20.875",
    r: "5.133",
    fill: "#DDBC43"
  }), React__default.createElement("defs", null, React__default.createElement("radialGradient", {
    id: "a",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "rotate(88.831 -.213 21.092) scale(20.125)",
    gradientUnits: "userSpaceOnUse"
  }, React__default.createElement("stop", {
    offset: ".126",
    stopColor: "#171717"
  }), React__default.createElement("stop", {
    offset: ".384",
    stopColor: "#373736"
  }), React__default.createElement("stop", {
    offset: ".628",
    stopColor: "#171717"
  }), React__default.createElement("stop", {
    offset: ".88",
    stopColor: "#373736"
  }))));
};

var _excluded$a = ["page", "text", "variant"];
var COLLAPSED_TEXT_LENGTH_OPTIONS$3 = {
  mobile: 80,
  desktop: 150
};
var ShortDescription$1 = function ShortDescription(_ref) {
  var _page$logo_src;
  var page = _ref.page,
    text = _ref.text,
    variant = _ref.variant,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$a);
  return React__default.createElement("div", Object.assign({}, props, {
    className: mergeTailwindClasses('tw-p-3 tw-w-full tw-text-white tw-flex tw-justify-between tw-overflow-visible tw-pointer-events-none tw-cursor-pointer', props.className)
  }), React__default.createElement("div", {
    className: clsx('tw-overflow-hidden tw-mt-auto tw-pointer-events-auto', modules_21510a30.postDescriptionContainer)
  }, React__default.createElement("div", {
    className: "tw-flex tw-items-center"
  }, React__default.createElement(ExternalLink, {
    href: "https://www.tiktok.com/@" + page.name,
    style: {
      fontWeight: 'bold',
      textDecoration: 'none',
      width: '100%'
    }
  }, React__default.createElement("div", {
    className: clsx('tw-flex tw-items-center', modules_21510a30.nameContainer)
  }, React__default.createElement("div", {
    className: "tw-text-md tw-break-words"
  }, "@", page.username || page.name)))), text && React__default.createElement("div", {
    className: "tw-pt-2 tw-text-md tw-max-h-[200px] tw-pr-4 tw-overflow-auto tw-scrollbar-hide"
  }, React__default.createElement(HyperText, {
    pageType: TYPE_TIKTOK,
    className: modules_21510a30.hyperText,
    options: {
      maxLength: COLLAPSED_TEXT_LENGTH_OPTIONS$3[variant],
      expandable: true,
      expandableTrigger: {
        more: ' show more',
        less: ' ...show less'
      }
    }
  }, text))), React__default.createElement("div", {
    className: clsx('tw-flex tw-gap-4 tw-flex-col tw-justify-end tw-items-center', modules_21510a30.actionContainer)
  }, React__default.createElement("div", {
    className: modules_21510a30.profileButton
  }, React__default.createElement(Avatar, {
    size: 36,
    name: page.name,
    src: (_page$logo_src = page.logo_src) != null ? _page$logo_src : undefined
  }), React__default.createElement(SubscribeIcon, null)), React__default.createElement("div", {
    className: modules_21510a30.actionButton
  }, React__default.createElement(LikeIcon$2, null), React__default.createElement("span", null, "328.7K")), React__default.createElement("div", {
    className: modules_21510a30.actionButton
  }, React__default.createElement(CommentIcon$3, null), React__default.createElement("span", null, "578")), React__default.createElement("div", {
    className: modules_21510a30.actionButton
  }, React__default.createElement(ShareIcon$4, null), React__default.createElement("span", null, "Share")), React__default.createElement(SoundIcon, null)));
};

var css$1w = ".Carousel_module_carousel__81af9f3f{height:100%;width:100%}.Carousel_module_carousel__81af9f3f .Carousel_module_aspectRatio__81af9f3f{height:100%;left:0;position:absolute;top:0;width:100%}.Carousel_module_carousel__81af9f3f .Carousel_module_aspectRatioVideo__81af9f3f{left:0;position:absolute;top:0;width:100%}.Carousel_module_carousel__81af9f3f .Carousel_module_pagingDots__81af9f3f{align-items:center;bottom:20%;display:flex;gap:3px;left:50%;overflow:hidden;position:absolute;transform:translateX(-50%);z-index:1}.Carousel_module_carousel__81af9f3f .Carousel_module_pagingDots__81af9f3f .Carousel_module_dot__81af9f3f{background-color:#fff;border-radius:50%;cursor:pointer;height:6px;opacity:.25;transition:all .3s ease-in-out;width:6px}.Carousel_module_carousel__81af9f3f .Carousel_module_pagingDots__81af9f3f .Carousel_module_dot__81af9f3f.Carousel_module_active__81af9f3f{opacity:1}";
var modules_794cd056$4 = {"carousel":"Carousel_module_carousel__81af9f3f","aspectRatio":"Carousel_module_aspectRatio__81af9f3f","aspectRatioVideo":"Carousel_module_aspectRatioVideo__81af9f3f","pagingDots":"Carousel_module_pagingDots__81af9f3f","dot":"Carousel_module_dot__81af9f3f","active":"Carousel_module_active__81af9f3f"};
n(css$1w,{});

var css$1x = ".CarouselItem_module_item__0f6391b3{height:100%;position:relative;width:100%}.CarouselItem_module_item__0f6391b3 .CarouselItem_module_imageItem__0f6391b3{background-position:50%;background-size:cover;height:100%;width:100%}.CarouselItem_module_item__0f6391b3 .CarouselItem_module_imageItemCropped__0f6391b3{background-position:top;background-repeat:no-repeat;background-size:cover;height:78%;width:100%}.CarouselItem_module_item__0f6391b3 .CarouselItem_module_videoItem__0f6391b3{height:100%;width:100%}.CarouselItem_module_item__0f6391b3 video{object-fit:cover;object-position:center}";
var modules_ee2c7f53$4 = {"item":"CarouselItem_module_item__0f6391b3","imageItem":"CarouselItem_module_imageItem__0f6391b3","imageItemCropped":"CarouselItem_module_imageItemCropped__0f6391b3","videoItem":"CarouselItem_module_videoItem__0f6391b3"};
n(css$1x,{});

var MutedIcon$2 = function MutedIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size;
  return React__default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default.createElement("g", {
    clipPath: "url(#clip0_21837_12311)"
  }, React__default.createElement("path", {
    d: "M19.6875 16.6875C20.0312 16.9375 20.0938 17.4062 19.7812 17.6875C19.5312 18.0312 19.0625 18.0938 18.75 17.8125L0.28125 3.34375C-0.0625 3.09375 -0.125 2.625 0.15625 2.3125C0.28125 2.125 0.5 2 0.75 2C0.90625 2 1.0625 2.0625 1.1875 2.1875L6.6875 6.5L10.3125 3.28125C10.625 3 11.0312 2.9375 11.4062 3.09375C11.75 3.25 12 3.625 12 4V10.625L13.6875 11.9688C13.5938 11.6875 13.6875 11.375 13.9375 11.1562C14.2812 10.875 14.5 10.4688 14.5 10C14.5 9.5625 14.2812 9.15625 13.9375 8.875C13.5938 8.59375 13.5625 8.125 13.8125 7.8125C14.0938 7.5 14.5625 7.4375 14.875 7.6875C15.5938 8.28125 16 9.125 16 10C16 10.9062 15.5938 11.75 14.875 12.3438C14.75 12.4375 14.5625 12.5 14.4062 12.5C14.375 12.5 14.375 12.5 14.3438 12.5L15.75 13.5625C15.7812 13.5312 15.7812 13.5 15.8125 13.4688C16.875 12.625 17.5 11.3438 17.5 10C17.5 8.6875 16.875 7.40625 15.8125 6.59375C15.5 6.3125 15.4375 5.84375 15.7188 5.53125C15.9688 5.1875 16.4375 5.15625 16.7812 5.40625C18.1875 6.53125 19 8.21875 19 10C19 11.7188 18.2188 13.3438 16.9375 14.5L19.6875 16.6875ZM2 8.5C2 7.9375 2.3125 7.46875 2.75 7.21875L12 14.4375V16C12 16.4062 11.75 16.75 11.4062 16.9375C11.25 17 11.125 17 11 17C10.75 17 10.5 16.9375 10.3125 16.7188L6.09375 13H3.5C2.65625 13 2 12.3438 2 11.5V8.5Z",
    fill: "currentColor"
  })), React__default.createElement("defs", null, React__default.createElement("clipPath", {
    id: "clip0_21837_12311"
  }, React__default.createElement("rect", {
    width: "20",
    height: "20",
    fill: "currentColor"
  }))));
};

var UnMutedIcon$2 = function UnMutedIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size;
  return React__default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, React__default.createElement("g", {
    clipPath: "url(#clip0_21837_11371)"
  }, React__default.createElement("path", {
    d: "M11.4062 3.09375C11.75 3.25 12 3.625 12 4V16C12 16.4062 11.75 16.75 11.4062 16.9375C11.0312 17.0938 10.625 17.0312 10.3125 16.75L6.09375 13H4C2.875 13 2 12.125 2 11V9C2 7.90625 2.875 7 4 7H6.09375L10.3125 3.28125C10.625 3 11.0312 2.9375 11.4062 3.09375ZM16.7812 5.34375C18.125 6.46875 19 8.125 19 10C19 11.9062 18.125 13.5625 16.7812 14.6562C16.4375 14.9375 15.9688 14.875 15.7188 14.5625C15.4375 14.25 15.5 13.7812 15.8125 13.5C16.8438 12.6875 17.5 11.4375 17.5 10C17.5 8.59375 16.8438 7.34375 15.8125 6.53125C15.5 6.25 15.4688 5.78125 15.7188 5.46875C15.9688 5.15625 16.4375 5.09375 16.7812 5.34375ZM14.875 7.6875C15.5625 8.25 16 9.0625 16 10C16 10.9688 15.5625 11.7812 14.875 12.3438C14.5625 12.5938 14.0938 12.5625 13.8125 12.2188C13.5625 11.9062 13.625 11.4375 13.9375 11.1875C14.2812 10.9062 14.5 10.4688 14.5 10C14.5 9.53125 14.2812 9.125 13.9375 8.84375C13.625 8.59375 13.5625 8.125 13.8125 7.78125C14.0938 7.46875 14.5625 7.4375 14.875 7.6875Z",
    fill: "currentColor"
  })), React__default.createElement("defs", null, React__default.createElement("clipPath", {
    id: "clip0_21837_11371"
  }, React__default.createElement("rect", {
    width: "20",
    height: "20",
    fill: "currentColor"
  }))));
};

var css$1y = ".SoundControlButton_module_content__05860fad{align-items:center;background:rgba(0,0,0,.2);border-radius:100%;cursor:pointer;display:flex;justify-content:center;padding:6px;position:absolute;right:10px;top:10px;z-index:1}.SoundControlButton_module_content__05860fad path{fill:#fff}";
var modules_0f4f5e0c$2 = {"content":"SoundControlButton_module_content__05860fad"};
n(css$1y,{});

var SoundControlButton$2 = function SoundControlButton(_ref) {
  var className = _ref.className,
    toggleMute = _ref.toggleMute,
    muted = _ref.muted,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size;
  return React__default.createElement("div", {
    className: classNames(className, modules_0f4f5e0c$2.content),
    onClick: toggleMute
  }, muted ? React__default.createElement(MutedIcon$2, {
    size: size
  }) : React__default.createElement(UnMutedIcon$2, {
    size: size
  }));
};

var CROPPED_ASPECT_RATIO = 16 / 9;
var CarouselItem$4 = function CarouselItem(_ref) {
  var _attachment$medium, _attachment$medium2;
  var attachment = _ref.attachment,
    style = _ref.style,
    onClick = _ref.onClick;
  var _useToggle = useToggle(),
    muted = _useToggle.muted,
    toggleMute = _useToggle.toggleMute;
  return React__default.createElement("div", {
    className: modules_ee2c7f53$4.item,
    style: style,
    "data-cy": DATA_CY_NAMES.CAROUSEL.GALLERY_ITEM
  }, ((_attachment$medium = attachment.medium) == null ? void 0 : _attachment$medium.type) === 'image' && React__default.createElement("div", {
    "data-cy": DATA_CY_NAMES.CAROUSEL.GALLERY_IMAGE,
    className: calcAspectRatioFromDimensions(attachment) > CROPPED_ASPECT_RATIO ? modules_ee2c7f53$4.imageItemCropped : modules_ee2c7f53$4.imageItem,
    onClick: onClick,
    style: {
      backgroundImage: "url('" + attachment.medium.sizes.lightbox.src + "')"
    }
  }), ((_attachment$medium2 = attachment.medium) == null ? void 0 : _attachment$medium2.type) === 'video' && React__default.createElement(React__default.Fragment, null, React__default.createElement(SoundControlButton$2, {
    muted: muted,
    toggleMute: toggleMute
  }), React__default.createElement(VideoPlayer, {
    className: modules_ee2c7f53$4.videoItem,
    height: "100%",
    width: "100%",
    video: attachment.medium,
    muted: muted
  })));
};

var Carousel$4 = function Carousel(_ref) {
  var attachments = _ref.attachments;
  var _useLightbox = useLightbox(),
    handleOpenLightbox = _useLightbox.handleOpenLightbox,
    lightbox = _useLightbox.lightbox,
    enableLightbox = _useLightbox.enableLightbox;
  var _useState = useState(0),
    activeSlide = _useState[0],
    setActiveSlide = _useState[1];
  var _useState2 = useState(0),
    height = _useState2[0],
    setHeight = _useState2[1];
  var elementRef = useCallback(function (node) {
    if (!node) return;
    var resizeObserver = new ResizeObserver(function () {
      node && setHeight(node == null ? void 0 : node.clientHeight);
    });
    resizeObserver.observe(node);
  }, []);
  return React__default.createElement("div", {
    className: modules_794cd056$4.carousel
  }, React__default.createElement("div", {
    className: modules_794cd056$4.aspectRatio,
    ref: elementRef
  }, React__default.createElement(NukaCarousel, {
    slideIndex: activeSlide,
    disableEdgeSwiping: true,
    beforeSlide: function beforeSlide(_, endSlide) {
      return setActiveSlide(endSlide);
    },
    renderBottomCenterControls: null,
    renderCenterRightControls: null,
    renderCenterLeftControls: null
  }, attachments.map(function (attachment, i) {
    return React__default.createElement(CarouselItem$4, {
      key: i,
      attachment: attachment,
      style: {
        height: height
      },
      onClick: function onClick() {
        return handleOpenLightbox(i);
      }
    });
  }))), attachments.length > 1 && React__default.createElement("div", {
    className: modules_794cd056$4.pagingDots
  }, attachments.map(function (attachment, index) {
    var _attachment$medium;
    return React__default.createElement("div", {
      key: ((_attachment$medium = attachment.medium) == null ? void 0 : _attachment$medium.id) + "-" + index,
      className: classNames(modules_794cd056$4.dot, activeSlide === index && modules_794cd056$4.active),
      onClick: function onClick() {
        return setActiveSlide(index);
      }
    });
  })), enableLightbox && React__default.createElement(AttachmentsLightBox$1, {
    onInit: function onInit(_ref2) {
      var instance = _ref2.instance;
      return lightbox.current = instance;
    },
    attachments: attachments.filter(function (attachment) {
      var _attachment$medium2;
      return (attachment == null ? void 0 : (_attachment$medium2 = attachment.medium) == null ? void 0 : _attachment$medium2.type) === 'image';
    })
  }));
};

var Post$7 = function Post(_ref) {
  var content = _ref.content,
    variant = _ref.variant;
  var _getSegmentedAttachme = getSegmentedAttachments(content),
    videos = _getSegmentedAttachme.videos,
    hasVideos = _getSegmentedAttachme.hasVideos,
    images = _getSegmentedAttachme.images,
    hasImages = _getSegmentedAttachme.hasImages;
  return React__default.createElement("div", {
    className: modules_4e180e43$2.shortWrapper
  }, hasVideos && React__default.createElement("div", {
    className: "tw-w-full"
  }, React__default.createElement(VideoPlayer, {
    video: videos[0].medium,
    controls: false
  })), hasImages && React__default.createElement("div", {
    className: "tw-h-full tw-w-full"
  }, React__default.createElement(Carousel$4, {
    variant: "mobile",
    attachments: images
  })), React__default.createElement("div", {
    className: modules_4e180e43$2.overlay
  }), React__default.createElement(ShortDescription$1, {
    page: content.page,
    text: content.text,
    variant: variant,
    className: "tw-absolute tw-bottom-0 tw-left-0"
  }));
};

var Post$8 = function Post(_ref) {
  var content = _ref.content,
    style = _ref.style;
  return React__default.createElement(PostWrapper$8, {
    style: style,
    variant: "desktop",
    contentType: content.type,
    contentSubtype: content.subtype
  }, React__default.createElement("div", {
    className: modules_4e180e43$2.content
  }, React__default.createElement("div", {
    className: modules_4e180e43$2.aspectRatio
  }, React__default.createElement(Post$7, {
    variant: "desktop",
    content: content
  }))));
};

var img$8 = "data:image/png;base64,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";

var AppLayout$8 = function AppLayout(props) {
  return React__default.createElement("div", {
    className: "tw-flex tw-flex-col tw-overflow-hidden tw-h-full"
  }, React__default.createElement("div", {
    className: "tw-flex-1 tw-overflow-auto tw-scrollbar-hide"
  }, props.children), React__default.createElement("img", {
    src: img$8,
    className: "tw-w-full tw-h-auto"
  }));
};

var MobilePost$7 = function MobilePost(_ref) {
  var content = _ref.content,
    style = _ref.style;
  return React__default.createElement(Phone, {
    statusBarClassName: "tw-bg-transparent tw-text-white tw-absolute tw-z-10 tw-w-full",
    contentBackground: "tiktok",
    style: style
  }, React__default.createElement(AppLayout$8, null, React__default.createElement(PostWrapper$8, {
    variant: "mobile",
    contentType: content.type,
    contentSubtype: content.subtype
  }, React__default.createElement(Post$7, {
    variant: "mobile",
    content: content
  }))));
};

var getMobilePostPreview = function getMobilePostPreview(props) {
  switch (props.content.page.type) {
    case TYPE.FACEBOOK:
    case TYPE.FACEBOOK_AD:
      if (isStory(props.content)) {
        return React__default.createElement(MobileStoryPost, Object.assign({}, props));
      }
      if (isReel(props.content)) {
        return React__default.createElement(MobileReelPost, Object.assign({}, props));
      }
      if (isCarouselPost(props.content)) {
        return React__default.createElement(MobileCarouselPost, Object.assign({}, props));
      }
      if (isLinkPost(props.content)) {
        return React__default.createElement(MobileLinkPost, Object.assign({}, props));
      }
      return React__default.createElement(MobilePost, Object.assign({}, props));
    case TYPE.GOOGLE_MY_BUSINESS:
      return React__default.createElement(MobilePost$5, Object.assign({}, props));
    case TYPE.INSTAGRAM:
      if (isStory(props.content)) {
        return React__default.createElement(MobileStoryPost$1, Object.assign({}, props));
      }
      if (isReel(props.content)) {
        return React__default.createElement(MobileReelPost$1, Object.assign({}, props));
      }
      return React__default.createElement(MobilePost$1, Object.assign({}, props));
    case TYPE.TWITTER:
      if (isLinkPost(props.content)) {
        return React__default.createElement(MobileLinkPost$1, Object.assign({}, props));
      }
      return React__default.createElement(MobilePost$2, Object.assign({}, props));
    case TYPE.LINKEDIN:
      if (isCarouselPost(props.content)) {
        return React__default.createElement(MobileCarouselPost$1, Object.assign({}, props));
      }
      if (isLinkPost(props.content)) {
        return React__default.createElement(MobileLinkPost$3, Object.assign({}, props));
      }
      return React__default.createElement(MobilePost$4, Object.assign({}, props));
    case TYPE.PINTEREST:
      return React__default.createElement(MobilePost$6, Object.assign({}, props));
    case TYPE.TIKTOK:
      return React__default.createElement(MobilePost$7, Object.assign({}, props));
    case TYPE.YOUTUBE:
      return React__default.createElement(MobileShortPost, Object.assign({}, props));
    case TYPE.THREADS:
      if (isLinkPost(props.content, {
        autoLink: true
      })) {
        return React__default.createElement(MobileLinkPost$2, Object.assign({}, props));
      }
      return React__default.createElement(MobilePost$3, Object.assign({}, props));
    default:
      return null;
  }
};
var getRightColumnPreview = function getRightColumnPreview(props) {
  switch (props.content.page.type) {
    case TYPE.FACEBOOK:
    case TYPE.FACEBOOK_AD:
      return React__default.createElement(RightColumn, Object.assign({}, props));
    default:
      return null;
  }
};
var getDesktopPreview = function getDesktopPreview(props) {
  switch (props.content.page.type) {
    case TYPE.FACEBOOK:
    case TYPE.FACEBOOK_AD:
      if (isStory(props.content)) {
        return React__default.createElement(StoryPost, Object.assign({}, props));
      }
      if (isReel(props.content)) {
        return React__default.createElement(ReelPost, Object.assign({}, props));
      }
      if (isCarouselPost(props.content)) {
        return React__default.createElement(CarouselPost, Object.assign({}, props));
      }
      if (isLinkPost(props.content)) {
        return React__default.createElement(LinkPost, Object.assign({}, props));
      }
      return React__default.createElement(Post, Object.assign({}, props));
    case TYPE.GOOGLE_MY_BUSINESS:
      return React__default.createElement(Post$5, Object.assign({}, props));
    case TYPE.INSTAGRAM:
      if (isStory(props.content)) {
        return React__default.createElement(StoryPost$1, Object.assign({}, props));
      }
      if (isReel(props.content)) {
        return React__default.createElement(ReelPost$1, Object.assign({}, props));
      }
      return React__default.createElement(Post$1, Object.assign({}, props));
    case TYPE.TWITTER:
      if (isLinkPost(props.content)) {
        return React__default.createElement(LinkPost$1, Object.assign({}, props));
      }
      return React__default.createElement(Post$2, Object.assign({}, props));
    case TYPE.LINKEDIN:
      if (isCarouselPost(props.content)) {
        return React__default.createElement(CarouselPost$1, Object.assign({}, props));
      }
      if (isLinkPost(props.content)) {
        return React__default.createElement(LinkPost$3, Object.assign({}, props));
      }
      return React__default.createElement(Post$4, Object.assign({}, props));
    case TYPE.PINTEREST:
      return React__default.createElement(Post$6, Object.assign({}, props));
    case TYPE.TIKTOK:
      return React__default.createElement(Post$8, Object.assign({}, props));
    case TYPE.YOUTUBE:
      return React__default.createElement(ShortPost, Object.assign({}, props));
    case TYPE.THREADS:
      if (isLinkPost(props.content, {
        autoLink: true
      })) {
        return React__default.createElement(LinkPost$2, Object.assign({}, props));
      }
      return React__default.createElement(Post$3, Object.assign({}, props));
    default:
      return null;
  }
};

var PostPreview = function PostPreview(props) {
  function getPostPreview() {
    switch (props.variant) {
      case 'desktop':
        return getDesktopPreview(props);
      case 'mobile':
        return getMobilePostPreview(props);
      case 'rightColumn':
        return getRightColumnPreview(props);
      default:
        return null;
    }
  }
  return React__default.createElement(PostPreviewProvider, {
    value: props
  }, getPostPreview());
};

var AppLayout$9 = function AppLayout$3(props) {
  switch (props.type) {
    case TYPE.FACEBOOK:
    case TYPE.FACEBOOK_AD:
      return React__default.createElement(AppLayout, Object.assign({}, props));
    case TYPE.INSTAGRAM:
      return React__default.createElement(AppLayout$1, Object.assign({}, props));
    case TYPE.TWITTER:
      return React__default.createElement(AppLayout$2, Object.assign({}, props));
    case TYPE.LINKEDIN:
      return React__default.createElement(AppLayout$4, Object.assign({}, props));
    case TYPE.GOOGLE_MY_BUSINESS:
      return React__default.createElement(AppLayout$5, Object.assign({}, props));
    default:
      return null;
  }
};

export default PostPreview;
export { AppLayout$9 as AppLayout, HyperText, Phone, getSegmentedAttachments };
//# sourceMappingURL=kontentino-post-previews.esm.js.map
